var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApplicationRef, ChangeDetectionStrategy, ChangeDetectorRef, Compiler, Component, ComponentFactoryResolver, Directive, ElementRef, EventEmitter, Injectable, Injector, Input, NgModule, Output, Pipe, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Subject as Subject$1 } from 'rxjs/Subject';
import { Observable as Observable$1 } from 'rxjs/Observable';
import { BehaviorSubject as BehaviorSubject$1 } from 'rxjs/BehaviorSubject';
import tableDragger from 'table-dragger';
import { ActivatedRoute, Router } from '@angular/router';
import { DaterangePickerComponent, Daterangepicker, DaterangepickerConfig } from 'ng2-daterangepicker';
import 'rxjs/add/operator/merge';
import { DataTablesModule } from 'angular-datatables';
import { TooltipModule } from 'ng2-tooltip-directive';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TagInputModule } from 'ngx-chips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
var ModalService = /** @class */ (function () {
    /**
     * @param {?} resolver
     * @param {?} injector
     * @param {?} appRef
     */
    function ModalService(resolver, injector, appRef) {
        this.resolver = resolver;
        this.injector = injector;
        this.appRef = appRef;
    }
    /**
     * @param {?} message
     * @param {?} callback
     * @return {?}
     */
    ModalService.prototype.openModal = function (message, callback) {
        if ($('util-modal').length > 0) {
            return;
        }
        var /** @type {?} */ factory = this.resolver.resolveComponentFactory(ModalComponent);
        // 1. Create a component reference from the component
        this.componentRef = factory.create(this.injector);
        this.componentRef.instance.message = message;
        // 2. Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(this.componentRef.hostView);
        // 3. Get DOM element from component
        var /** @type {?} */ domElem = /** @type {?} */ (( /** @type {?} */(this.componentRef.hostView))
            .rootNodes[0]);
        // 4. Append DOM element to the body
        $('.page-content')[0].appendChild(domElem);
        this.callback = callback;
    };
    /**
     * @param {?} operation
     * @return {?}
     */
    ModalService.prototype.closeModal = function (operation) {
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
        this.callback(operation);
    };
    return ModalService;
}());
ModalService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ModalService.ctorParameters = function () { return [
    { type: ComponentFactoryResolver, },
    { type: Injector, },
    { type: ApplicationRef, },
]; };
var ModalComponent = /** @class */ (function () {
    /**
     * @param {?} modalService
     */
    function ModalComponent(modalService) {
        this.modalService = modalService;
    }
    Object.defineProperty(ModalComponent.prototype, "message", {
        /**
         * @return {?}
         */
        get: function () {
            return this._message;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._message = value;
            this.messageLines = Array.isArray(value) ? this.escapeEmptyLines(value) : [value];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ModalComponent.prototype.confirm = function () {
        this.modalService.closeModal(true);
    };
    /**
     * @return {?}
     */
    ModalComponent.prototype.reject = function () {
        this.modalService.closeModal(false);
    };
    /**
     * @return {?}
     */
    ModalComponent.prototype.ngOnInit = function () {
    };
    /**
     * @param {?} lines
     * @return {?}
     */
    ModalComponent.prototype.escapeEmptyLines = function (lines) {
        return lines.map(function (line) { return line === null || line.trim().length === 0 ? '\xa0' : line; });
    };
    return ModalComponent;
}());
ModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-modal',
                template: "\n      <div class=\"message-box animated fadeIn\" data-sound=\"alert\" id=\"mb-dialog\">\n          <div class=\"mb-container\" id=\"mb-container-custom\">\n              <div class=\"mb-middle\">\n                  <div class=\"mb-title\"> Potvrdi </div>\n                  <div class=\"mb-content\">\n                      <p class=\"message-line\" *ngFor=\"let line of messageLines\">{{line}}</p>\n                  </div>\n                  <div class=\"mb-footer\">\n                      <div class=\"pull-right\">\n                          <button class=\"btn btn-success btn-lg mb-control-yes\"\n                                  (click)=\"confirm()\">Da\n                          </button>\n                          <button class=\"btn btn-default btn-lg mb-control-close\"\n                                  (click)=\"reject()\">Ne</button>\n                      </div>\n                  </div>\n              </div>\n          </div>\n      </div>\n    ",
                styles: ["\n      .message-line + .message-line {\n        margin-top: 0.5em; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
ModalComponent.ctorParameters = function () { return [
    { type: ModalService, },
]; };
var ModalModule = /** @class */ (function () {
    function ModalModule() {
    }
    return ModalModule;
}());
ModalModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                ],
                declarations: [
                    ModalComponent
                ],
                providers: [
                    ModalService
                ],
                exports: [
                    ModalComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
ModalModule.ctorParameters = function () { return []; };
var CustomModalService = /** @class */ (function () {
    function CustomModalService() {
        this.modals = [];
    }
    /**
     * @param {?} modal
     * @return {?}
     */
    CustomModalService.prototype.add = function (modal) {
        // add modal to array of active modals
        this.modals.push(modal);
    };
    /**
     * @param {?} id
     * @return {?}
     */
    CustomModalService.prototype.remove = function (id) {
        // remove modal from array of active modals
        this.modals = this.modals.filter(function (x) { return x.id !== id; });
    };
    /**
     * @param {?} id
     * @return {?}
     */
    CustomModalService.prototype.open = function (id) {
        // open modal specified by id
        var /** @type {?} */ modal = this.modals.filter(function (x) { return x.id === id; })[0];
        modal.open();
    };
    /**
     * @param {?} id
     * @return {?}
     */
    CustomModalService.prototype.close = function (id) {
        // close modal specified by id
        var /** @type {?} */ modal = this.modals.filter(function (x) { return x.id === id; })[0];
        modal.close();
    };
    return CustomModalService;
}());
CustomModalService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
CustomModalService.ctorParameters = function () { return []; };
var CustomModalComponent = /** @class */ (function () {
    /**
     * @param {?} modalService
     * @param {?} eRef
     */
    function CustomModalComponent(modalService, eRef) {
        this.modalService = modalService;
        this.eRef = eRef;
        this.element = eRef.nativeElement;
        this.element.style.display = 'none';
    }
    /**
     * @return {?}
     */
    CustomModalComponent.prototype.ngOnInit = function () {
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }
        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);
        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    };
    /**
     * @return {?}
     */
    CustomModalComponent.prototype.ngOnDestroy = function () {
        this.modalService.remove(this.id);
        this.element.remove();
    };
    /**
     * @return {?}
     */
    CustomModalComponent.prototype.open = function () {
        this.element.style.display = 'block';
        document.body.classList.add('util-custom-modal-open');
    };
    /**
     * @return {?}
     */
    CustomModalComponent.prototype.close = function () {
        this.element.style.display = 'none';
        document.body.classList.remove('util-custom-modal-open');
    };
    return CustomModalComponent;
}());
CustomModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-custom-modal',
                template: "<div class=\"util-custom-modal\">\n            <div class=\"util-custom-modal-body\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n        <div class=\"util-custom-modal-background\"></div>",
                styles: ["\n      .util-custom-modal {\n        position: fixed;\n        top: 5%;\n        right: 0;\n        bottom: 5%;\n        left: 0;\n        z-index: 1000000;\n        overflow: auto; }\n        .util-custom-modal .util-custom-modal-body {\n          padding: 20px;\n          width: 850px;\n          margin: auto; }\n\n      .util-custom-modal-background {\n        position: fixed;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: #000;\n        opacity: 0.75;\n        z-index: 100000; }\n\n      body.util-custom-modal-open {\n        overflow: hidden; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
CustomModalComponent.ctorParameters = function () { return [
    { type: CustomModalService, },
    { type: ElementRef, },
]; };
CustomModalComponent.propDecorators = {
    'id': [{ type: Input },],
};
var CustomModalModule = /** @class */ (function () {
    function CustomModalModule() {
    }
    return CustomModalModule;
}());
CustomModalModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                ],
                declarations: [
                    CustomModalComponent
                ],
                providers: [
                    CustomModalService
                ],
                exports: [
                    CustomModalComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
CustomModalModule.ctorParameters = function () { return []; };
var DocumentLayoutTypeEnum = {};
DocumentLayoutTypeEnum.Main = /** @type {?} */ ('main');
DocumentLayoutTypeEnum.Custom = /** @type {?} */ ('custom');
DocumentLayoutTypeEnum[DocumentLayoutTypeEnum.Main] = "Main";
DocumentLayoutTypeEnum[DocumentLayoutTypeEnum.Custom] = "Custom";
var ModalSettingsService = /** @class */ (function () {
    /**
     * @param {?} resolver
     * @param {?} injector
     * @param {?} appRef
     */
    function ModalSettingsService(resolver, injector, appRef) {
        this.resolver = resolver;
        this.injector = injector;
        this.appRef = appRef;
    }
    /**
     * @param {?} settings
     * @param {?} callback
     * @return {?}
     */
    ModalSettingsService.prototype.openModal = function (settings, callback) {
        var /** @type {?} */ factoryModalSettings = this.resolver.resolveComponentFactory(ModalSettingsComponent);
        var /** @type {?} */ factory = this.resolver.resolveComponentFactory(ModalSettingsComponent);
        // 1. Create a component reference from the component
        this.componentRef = factoryModalSettings.create(this.injector);
        if (settings.type === DocumentLayoutTypeEnum.Custom) {
            this.componentRef.instance.settingsAll.push(settings);
        }
        // 2. Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(this.componentRef.hostView);
        // 3. Get DOM element from component
        var /** @type {?} */ domElem = /** @type {?} */ (( /** @type {?} */(this.componentRef.hostView))
            .rootNodes[0]);
        // 4. Append DOM element to the body
        $('.page-content')[0].appendChild(domElem);
        this.callback = callback;
    };
    /**
     * @param {?} operation
     * @return {?}
     */
    ModalSettingsService.prototype.closeModal = function (operation) {
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
        this.callback(operation);
    };
    return ModalSettingsService;
}());
ModalSettingsService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ModalSettingsService.ctorParameters = function () { return [
    { type: ComponentFactoryResolver, },
    { type: Injector, },
    { type: ApplicationRef, },
]; };
var LoggerService = /** @class */ (function () {
    function LoggerService() {
    }
    /**
     * @param {?=} message
     * @param {?=} object
     * @return {?}
     */
    LoggerService.log = function (message, object) {
        if (LoggerService.logMessages) {
            console.log(message, object);
        }
    };
    return LoggerService;
}());
LoggerService.logMessages = false;
var PathParts = /** @class */ (function () {
    /**
     * @param {?=} parts
     */
    function PathParts(parts) {
        if (parts === void 0) { parts = []; }
        this._parts = parts;
    }
    Object.defineProperty(PathParts.prototype, "all", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parts;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PathParts.prototype, "withoutFirst", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parts.slice(1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PathParts.prototype, "withoutLast", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parts.slice(0, this._parts.length - 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PathParts.prototype, "first", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parts[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PathParts.prototype, "last", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parts[this._parts.length - 1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PathParts.prototype, "length", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parts.length;
        },
        enumerable: true,
        configurable: true
    });
    return PathParts;
}());
var FieldTypeEnum = {};
FieldTypeEnum.Input = /** @type {?} */ ('input');
FieldTypeEnum.Date = /** @type {?} */ ('date');
FieldTypeEnum.DateTime = /** @type {?} */ ('datetime');
FieldTypeEnum.Time = /** @type {?} */ ('time');
FieldTypeEnum.Check = /** @type {?} */ ('check');
FieldTypeEnum.Combo = /** @type {?} */ ('combo');
FieldTypeEnum.ComboFixed = /** @type {?} */ ('comboFixed');
FieldTypeEnum.Completer = /** @type {?} */ ('completer');
FieldTypeEnum.Tags = /** @type {?} */ ('tags');
FieldTypeEnum.Complex = /** @type {?} */ ('complex');
FieldTypeEnum.Select = /** @type {?} */ ('select');
FieldTypeEnum[FieldTypeEnum.Input] = "Input";
FieldTypeEnum[FieldTypeEnum.Date] = "Date";
FieldTypeEnum[FieldTypeEnum.DateTime] = "DateTime";
FieldTypeEnum[FieldTypeEnum.Time] = "Time";
FieldTypeEnum[FieldTypeEnum.Check] = "Check";
FieldTypeEnum[FieldTypeEnum.Combo] = "Combo";
FieldTypeEnum[FieldTypeEnum.ComboFixed] = "ComboFixed";
FieldTypeEnum[FieldTypeEnum.Completer] = "Completer";
FieldTypeEnum[FieldTypeEnum.Tags] = "Tags";
FieldTypeEnum[FieldTypeEnum.Complex] = "Complex";
FieldTypeEnum[FieldTypeEnum.Select] = "Select";
var FormModeEnum = {};
FormModeEnum.View = /** @type {?} */ ('view');
FormModeEnum.Add = /** @type {?} */ ('add');
FormModeEnum.Edit = /** @type {?} */ ('edit');
FormModeEnum.Copy = /** @type {?} */ ('copy');
FormModeEnum.Table = /** @type {?} */ ('table');
FormModeEnum.Aneks = /** @type {?} */ ('aneks');
FormModeEnum.Podugovor = /** @type {?} */ ('podugovor');
FormModeEnum[FormModeEnum.View] = "View";
FormModeEnum[FormModeEnum.Add] = "Add";
FormModeEnum[FormModeEnum.Edit] = "Edit";
FormModeEnum[FormModeEnum.Copy] = "Copy";
FormModeEnum[FormModeEnum.Table] = "Table";
FormModeEnum[FormModeEnum.Aneks] = "Aneks";
FormModeEnum[FormModeEnum.Podugovor] = "Podugovor";
var UtilService = /** @class */ (function () {
    function UtilService() {
    }
    /**
     * @return {?}
     */
    UtilService.generateGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var /** @type {?} */ r = (Math.random() * 16) | 0, /** @type {?} */ v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    /**
     * @param {?} date
     * @param {?=} format
     * @return {?}
     */
    UtilService.formatDate = function (date, format) {
        if (date == null || date === '') {
            return '';
        }
        var /** @type {?} */ formated;
        if (format) {
            formated = moment(date).format(format);
            if (format.includes('dddd')) {
                var /** @type {?} */ toReplace = formated.split(' ')[0];
                formated = formated.replace(toReplace, this.daysEnSr[toReplace]);
            }
        }
        else {
            formated = moment(date).format(UtilService.dateFormatDefault);
        }
        return formated;
    };
    /**
     * @param {?} date
     * @return {?}
     */
    UtilService.formatDateTime = function (date) {
        if (date == null || date === '') {
            return '';
        }
        var /** @type {?} */ formated = moment(date).format(UtilService.dateTimeFormatDefault);
        return formated;
    };
    /**
     * @param {?} time
     * @return {?}
     */
    UtilService.formatTime = function (time) {
        if (moment.isMoment(time)) {
            time = time.format(UtilService.dateFormatDefaultTime);
        }
        else if (( /** @type {?} */(time)).length > 5) {
            time = moment(time).format(UtilService.dateFormatDefaultTime);
        }
        if (time != null && time !== '' && this.regex_hhmm.test((( /** @type {?} */(time)).trim()))) {
            return time;
        }
        return 'invalid time';
    };
    /**
     * @param {?} date
     * @return {?}
     */
    UtilService.formatTimeToTimestamp = function (date) {
        return moment(date).format(UtilService.dateFormatDefaultTime);
    };
    /**
     * @param {?} amount
     * @param {?=} decimalCount
     * @return {?}
     */
    UtilService.deformatDecimal = function (amount, decimalCount) {
        if (decimalCount === void 0) { decimalCount = 2; }
        if (amount.toString().indexOf(',') !== -1) {
            var /** @type {?} */ sAmount = amount.toString().replace(/\./g, '');
            sAmount = sAmount.replace(/,/g, '.');
            amount = parseFloat(parseFloat(sAmount).toFixed(decimalCount));
        }
        else if (amount.toString().indexOf('.') !== -1 &&
            decimalCount === 0) {
            var /** @type {?} */ sAmount = amount.toString().replace(/\./g, '');
            amount = parseFloat(parseFloat(sAmount).toFixed(decimalCount));
        }
        else {
            amount = parseFloat(parseFloat(amount).toFixed(decimalCount));
        }
        return amount;
    };
    /**
     * @param {?} amount
     * @param {?=} decimalCount
     * @param {?=} decimal
     * @param {?=} thousands
     * @return {?}
     */
    UtilService.formatBigNumber = function (amount, decimalCount, decimal, thousands) {
        if (decimalCount === void 0) { decimalCount = 2; }
        if (decimal === void 0) { decimal = ','; }
        if (thousands === void 0) { thousands = '.'; }
        var /** @type {?} */ formatedDecimal = this.formatDecimal(amount, decimalCount, decimal, thousands);
        if (formatedDecimal) {
            return formatedDecimal.substring(0, formatedDecimal.length - 3);
        }
    };
    /**
     * @param {?} amount
     * @param {?=} decimalCount
     * @param {?=} decimal
     * @param {?=} thousands
     * @return {?}
     */
    UtilService.formatDecimal = function (amount, decimalCount, decimal, thousands) {
        if (decimalCount === void 0) { decimalCount = 2; }
        if (decimal === void 0) { decimal = ','; }
        if (thousands === void 0) { thousands = '.'; }
        if (amount.toString().indexOf(',') !== -1) {
            var /** @type {?} */ sAmount = amount.toString().replace(/\./g, '');
            sAmount = sAmount.replace(/\,/g, '.');
            amount = parseFloat(parseFloat(sAmount).toFixed(decimalCount));
        }
        else if (amount.toString().indexOf('.') !== -1 &&
            decimalCount === 0) {
            var /** @type {?} */ sAmount = amount.toString().replace(/\./g, '');
            amount = parseFloat(parseFloat(sAmount).toFixed(decimalCount));
        }
        else {
            amount = parseFloat(parseFloat(amount).toFixed(decimalCount));
        }
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
            var /** @type {?} */ negativeSign = amount < 0 ? '-' : '';
            var /** @type {?} */ i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)), 0).toString();
            var /** @type {?} */ j = i.length > 3 ? i.length % 3 : 0;
            var /** @type {?} */ toReturn = negativeSign +
                (j ? i.substr(0, j) + thousands : '') +
                i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
                (decimalCount
                    ? decimal +
                        Math.abs(amount - parseInt(i, 0))
                            .toFixed(decimalCount)
                            .slice(2)
                    : '');
            var /** @type {?} */ index = toReturn.indexOf(',');
            if (decimalCount === 0 && index !== -1) {
                return toReturn.substring(0, toReturn.length - index);
            }
            return toReturn;
        }
        catch ( /** @type {?} */e) {
            console.log(e);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    UtilService.parsePickerMoment = function (value) {
        return moment(value, UtilService.dateFormatDefault);
    };
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    UtilService.getFieldValue = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldObject(documentData, fieldMap.propertyPath.all);
        if (retVal == null) {
            return null;
        }
        retVal = retVal[fieldMap.fieldKey];
        return retVal;
    };
    /**
     * @param {?} data
     * @param {?} pathParts
     * @param {?=} maxTraverseDepth
     * @return {?}
     */
    UtilService.getFieldObject = function (data, pathParts, maxTraverseDepth) {
        if (maxTraverseDepth === void 0) { maxTraverseDepth = Number.MAX_VALUE; }
        if (data == null) {
            return null;
        }
        var /** @type {?} */ retVal = data;
        var /** @type {?} */ traverseDepth = Math.min(pathParts.length, maxTraverseDepth);
        for (var /** @type {?} */ i = 0; i < traverseDepth; i++) {
            if (retVal == null) {
                return null;
            }
            if (retVal) {
                retVal = retVal[pathParts[i]];
            }
        }
        return retVal;
    };
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @param {?} newValue
     * @return {?}
     */
    UtilService.fieldUpdateValue = function (documentData, fieldMap, newValue) {
        if (documentData == null || fieldMap == null) {
            return;
        }
        switch (fieldMap.type) {
            case FieldTypeEnum.Input:
                UtilService.fieldUpdateText(documentData, fieldMap, newValue);
                break;
            case FieldTypeEnum.Date:
                UtilService.fieldUpdateDate(documentData, fieldMap, newValue);
                break;
            case FieldTypeEnum.Time:
                UtilService.fieldUpdateTime(documentData, fieldMap, newValue);
                break;
            case FieldTypeEnum.Check:
                UtilService.fieldUpdateText(documentData, fieldMap, newValue);
                break;
            case FieldTypeEnum.Combo:
                UtilService.fieldUpdateCompleter(documentData, fieldMap, newValue);
                break;
            case FieldTypeEnum.ComboFixed:
                UtilService.fieldUpdateText(documentData, fieldMap, newValue);
                break;
            case FieldTypeEnum.Completer:
                UtilService.fieldUpdateCompleter(documentData, fieldMap, newValue);
                break;
            case FieldTypeEnum.Select:
                UtilService.fieldUpdateSelect(documentData, fieldMap, newValue);
                break;
        }
    };
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @param {?} newValue
     * @return {?}
     */
    UtilService.fieldUpdateText = function (documentData, fieldMap, newValue) {
        LoggerService.log('fieldUpdateText', newValue);
        if (documentData == null || fieldMap == null) {
            return;
        }
        var /** @type {?} */ retVal = documentData;
        for (var /** @type {?} */ i = 0; i < fieldMap.propertyPath.length; i++) {
            retVal = retVal[fieldMap.propertyPath.all[i]];
            return;
        }
        // TODO: Check data type
        retVal[fieldMap.fieldKey] = newValue;
    };
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @param {?} newValue
     * @return {?}
     */
    UtilService.fieldUpdateTime = function (documentData, fieldMap, newValue) {
        if (documentData == null || fieldMap == null) {
            return;
        }
        var /** @type {?} */ retVal = documentData;
        for (var /** @type {?} */ i = 0; i < fieldMap.propertyPath.length; i++) {
            retVal = retVal[fieldMap.propertyPath[i]];
        }
        if (newValue !== null) {
            newValue = newValue.toString();
        }
        retVal[fieldMap.fieldKey] = newValue;
    };
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @param {?} newValue
     * @return {?}
     */
    UtilService.fieldUpdateDate = function (documentData, fieldMap, newValue) {
        LoggerService.log('fieldUpdateDate', newValue);
        if (documentData == null || fieldMap == null) {
            return;
        }
        var /** @type {?} */ retVal = documentData;
        for (var /** @type {?} */ i = 0; i < fieldMap.propertyPath.length; i++) {
            retVal = retVal[fieldMap.propertyPath[i]];
        }
        // picker.setStartDate(event.start);
        // TODO: Check data type
        // Why END I don't know
        retVal[fieldMap.fieldKey] = newValue;
    };
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @param {?} newValue
     * @return {?}
     */
    UtilService.fieldUpdateCompleter = function (documentData, fieldMap, newValue) {
        LoggerService.log('fieldUpdateCompleter', newValue);
        if (fieldMap == null || documentData == null) {
            return;
        }
        var /** @type {?} */ objectToUpdate = UtilService.getFieldObject(documentData, fieldMap.propertyPath.withoutLast);
        if (newValue != null) {
            if (fieldMap.propertyPath.length === 1) {
                objectToUpdate[fieldMap.propertyPath.last] = newValue;
            }
            else if (fieldMap.propertyPath.length === 2) {
                objectToUpdate = documentData;
                if (!objectToUpdate.hasOwnProperty(fieldMap.propertyPath.first)) {
                    objectToUpdate[fieldMap.propertyPath.first] = {};
                }
                objectToUpdate[fieldMap.propertyPath.first][fieldMap.propertyPath.last] = newValue;
            }
        }
        else {
            // Set id to null to clear the property by the service
            if (fieldMap.relationKey.length > 1) {
                // Fix for fields with relationKey located in depth. Will only traverse one level. TODO: Make more general
                if (fieldMap.propertyPath.length === 1) {
                    if (objectToUpdate[fieldMap.propertyPath.first] == null) {
                        return;
                    }
                    objectToUpdate[fieldMap.propertyPath.first] = UtilService.createEmptyEntity();
                    objectToUpdate[fieldMap.propertyPath.first][fieldMap.relationKey.first] = UtilService.createEmptyEntity();
                }
                else if (fieldMap.propertyPath.length === 2) {
                    if (!objectToUpdate) {
                        return;
                    }
                    objectToUpdate[fieldMap.propertyPath.first] = UtilService.createEmptyEntity();
                    objectToUpdate[fieldMap.propertyPath.first][fieldMap.propertyPath.first] = UtilService.createEmptyEntity();
                    objectToUpdate[fieldMap.propertyPath.first][fieldMap.propertyPath.first][fieldMap.propertyPath.last] = UtilService.createEmptyEntity();
                }
            }
            else {
                objectToUpdate[fieldMap.propertyPath.last] = UtilService.createEmptyEntity();
            }
        }
    };
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @param {?} newValue
     * @return {?}
     */
    UtilService.fieldUpdateSelect = function (documentData, fieldMap, newValue) {
        if (documentData === null || newValue === null) {
            return;
        }
        documentData[fieldMap.fieldKey] = newValue;
    };
    /**
     * Updates the `field`'s `lookupList` to the `list` (see example).
     * If `entity` is specified it also sets the corresponding property to the following:
     * - null item - if the list is empty (null item is an object with `id` set to `null`),
     * - only item - if the list has only one item and `preselect` is `true`.
     *
     * \@example
     * ```js
     * onValueChanged(event: ValueChangeParams): void {
     * if (event.fieldMap === this.fieldAuthor) {
     * UtilService.fieldSetLookupList(this.fieldBookToCheckOut, event.newValue.books, this.checkoutRequest);
     * }
     * }
     * ```
     * Where the "author" object could look like this:
     * ```json
     * "author": {
     * "id": 123,
     * "name": "Alexandre Dumas",
     * "books": [
     * { "id": 512, "name": "The Count of Monte Cristo" },
     * { "id": 513, "name": "The Three Musketeers" }
     * ]
     * }
     * ```
     * @param {?} field the look-up ("completer") field to update.
     * @param {?} list the list of items available for selection/look-up.
     * @param {?=} entity the object whose property/field to set (optional).
     * @param {?=} preselect automatically select the only item in the list or not (optional, defaults to true).
     *
     * @return {?}
     */
    UtilService.fieldSetLookupList = function (field, list, entity, preselect) {
        if (entity === void 0) { entity = null; }
        if (preselect === void 0) { preselect = true; }
        if (field == null || field.type !== FieldTypeEnum.Completer) {
            return;
        }
        var /** @type {?} */ items = list || [];
        field.lookupList = items;
        var /** @type {?} */ enabled = list.length > 0;
        // TODO field.mandatory = enabled;
        field.additableOverride = enabled ? null : false;
        field.editableOverride = enabled ? null : false;
        if (entity == null) {
            return;
        }
        if (!enabled) {
            UtilService.fieldUpdateCompleter(entity, field, UtilService.createEmptyEntity());
            return;
        }
        if (items.length < 1) {
            // No items to (pre)select.
            return;
        }
        if (preselect && items.length === 1) {
            UtilService.fieldUpdateCompleter(entity, field, items[0]);
            return;
        }
    };
    /**
     * Removes the limitation on the `field`'s `lookupList`, i.e. the user
     * will be able to search and look up values from the service (a.k.a. the server).
     * If `entity` is specified it also sets the corresponding property to the
     * *null item* if `deselect` is `true`.
     *
     * @see fieldSetLookupList
     * @param {?} field the look-up ("completer") field to cancel.
     * @param {?=} entity the object whose property/field to set (optional).
     * @param {?=} deselect automatically remove the currently selected item (if any) or not (optional, defaults to true).
     * @return {?}
     */
    UtilService.fieldCancelLookupList = function (field, entity, deselect) {
        if (entity === void 0) { entity = null; }
        if (deselect === void 0) { deselect = true; }
        if (field == null || field.type !== FieldTypeEnum.Completer) {
            return;
        }
        field.lookupList = null;
        field.additableOverride = null;
        field.editableOverride = null;
        if (entity != null && deselect) {
            UtilService.fieldUpdateCompleter(entity, field, UtilService.createEmptyEntity());
        }
    };
    /**
     * @param {?} text
     * @return {?}
     */
    UtilService.lowerCaseStart = function (text) {
        return text.substr(0, 1).toLowerCase() + text.substr(1);
    };
    /**
     * @param {?} text
     * @return {?}
     */
    UtilService.upperCaseStart = function (text) {
        return text.substr(0, 1).toUpperCase() + text.substr(1);
    };
    /**
     * @param {?} relations
     * @param {?} entityType
     * @return {?}
     */
    UtilService.findRelation = function (relations, entityType) {
        if (entityType == null) {
            return null;
        }
        for (var /** @type {?} */ i = 0; i < relations.length; i++) {
            if (relations[i]['group'].toLowerCase() === entityType.toLowerCase()) {
                return relations[i];
            }
        }
        return null;
    };
    /**
     * @param {?} relation
     * @param {?} fieldName
     * @return {?}
     */
    UtilService.getRelationPathParts = function (relation, fieldName) {
        if (relation == null || fieldName == null) {
            return new PathParts();
        }
        var /** @type {?} */ path = relation[fieldName];
        if (path == null) {
            return new PathParts();
        }
        return UtilService.getPathParts(path);
    };
    /**
     * @param {?} propertyPath
     * @param {?=} startingIndex
     * @return {?}
     */
    UtilService.getPathParts = function (propertyPath, startingIndex) {
        if (startingIndex === void 0) { startingIndex = 0; }
        if (propertyPath == null) {
            return new PathParts();
        }
        var /** @type {?} */ retVal = [];
        var /** @type {?} */ pathParts = propertyPath.split('.');
        // Skiping first element of the path, should always be the name of the entity
        for (var /** @type {?} */ i = startingIndex; i < pathParts.length; i++) {
            var /** @type {?} */ pathPart = pathParts[i];
            retVal.push(pathPart);
        }
        return new PathParts(retVal);
    };
    /**
     * @param {?} pathParts1
     * @param {?} pathParts2
     * @return {?}
     */
    UtilService.combinePathParts = function (pathParts1, pathParts2) {
        if (typeof pathParts1 === 'string') {
            return [pathParts1].concat(pathParts2);
        }
        else {
            return pathParts1.concat(pathParts2);
        }
    };
    /**
     * @param {?} pathParts
     * @return {?}
     */
    UtilService.renderPath = function (pathParts) {
        return pathParts.join('.');
    };
    /**
     * @param {?} pathParts
     * @return {?}
     */
    UtilService.capitalizePathParts = function (pathParts) {
        var /** @type {?} */ retVal = [];
        for (var /** @type {?} */ i = 0; i < pathParts.length; i++) {
            retVal.push(UtilService.upperCaseStart(pathParts[i]));
        }
        return retVal;
    };
    /**
     * @param {?} relations
     * @param {?} filterFieldData
     * @return {?}
     */
    UtilService.getFieldMapItem = function (relations, filterFieldData) {
        var /** @type {?} */ relation = UtilService.findRelation(relations, filterFieldData.entityType);
        return UtilService.getFieldDataSingle(filterFieldData, relation);
    };
    /**
     * @param {?} fieldData
     * @param {?} relation
     * @return {?}
     */
    UtilService.getFieldDataSingle = function (fieldData, relation) {
        var /** @type {?} */ documentType = null;
        if (relation && relation.hasOwnProperty('vrstaDokumenta')) {
            documentType = relation.vrstaDokumenta;
        }
        var /** @type {?} */ retVal = {
            id: fieldData.id,
            type: fieldData.type,
            dbType: fieldData.dbType,
            fieldName: fieldData.name,
            sortable: Boolean(fieldData.sortable),
            entityType: fieldData.entityType,
            fieldKey: fieldData.fieldKey,
            propertyPath: UtilService.getPathParts(fieldData.path, 1),
            relationKey: UtilService.getRelationPathParts(relation, 'completerMainField'),
            relationValue: UtilService.getRelationPathParts(relation, 'completerSecondField'),
            path: fieldData.path,
            label: fieldData.label,
            mandatory: fieldData.mandatory,
            width: fieldData.width,
            validator: fieldData.validator,
            editable: fieldData.editable,
            additable: fieldData.additable,
            title: fieldData.title,
            relation: relation,
            visible: true,
            editableOverride: null,
            additableOverride: null,
            lookupFilter: null,
            lookupList: null,
            documentType: documentType,
            multiline: fieldData.multiline,
            decimalCount: fieldData.decimalCount,
            color: fieldData.color,
            errorMessage: '',
            lookupFormCode: fieldData.lookupFormCode,
            lookupFormName: fieldData.lookupFormName,
            lookupInitFilter: fieldData.lookupFormParam,
            tooltipText: fieldData.tooltipText
        };
        return retVal;
    };
    /**
     * @param {?} settings
     * @return {?}
     */
    UtilService.checkSettingValidity = function (settings) {
        // Check that there are no id duplicates
        var /** @type {?} */ fieldIdList = $.map(settings.allFields, function (it) { return it.id; });
        var /** @type {?} */ fieldIdListSorted = fieldIdList.sort();
        var /** @type {?} */ idDuplicateList = [];
        for (var /** @type {?} */ i = 0; i < fieldIdListSorted.length - 1; i++) {
            if (fieldIdListSorted[i + 1] === fieldIdListSorted[i]) {
                idDuplicateList.push(fieldIdListSorted[i]);
            }
        }
        if (idDuplicateList.length > 0) {
            console.error('Duplicate ids detected in settings', idDuplicateList);
        }
    };
    /**
     * @param {?} fieldMap
     * @param {?} formMode
     * @return {?}
     */
    UtilService.getColumnDisabled = function (fieldMap, formMode) {
        var /** @type {?} */ isEditable = formMode === FormModeEnum.Add || formMode === FormModeEnum.Edit
            ? fieldMap.additableOverride != null
                ? fieldMap.additableOverride
                : fieldMap.additable
            : fieldMap.editableOverride != null
                ? fieldMap.editableOverride
                : fieldMap.editable;
        if (isEditable) {
            return null;
        }
        else {
            return true;
        }
    };
    /**
     * @param {?} string
     * @return {?}
     */
    UtilService.replaceCharacters = function (string) {
        string = string.replace(/Š/g, 'S');
        string = string.replace(/š/g, 's');
        string = string.replace(/Đ/g, 'Dj');
        string = string.replace(/đ/g, 'dj');
        string = string.replace(/Ž/g, 'Z');
        string = string.replace(/ž/g, 'z');
        string = string.replace(/Č/g, 'C');
        string = string.replace(/č/g, 'c');
        string = string.replace(/Ć/g, 'C');
        string = string.replace(/ć/g, 'c');
        string = string.replace(/А/g, 'A');
        string = string.replace(/а/g, 'a');
        string = string.replace(/Б/g, 'B');
        string = string.replace(/б/g, 'b');
        string = string.replace(/В/g, 'V');
        string = string.replace(/в/g, 'v');
        string = string.replace(/Г/g, 'G');
        string = string.replace(/г/g, 'g');
        string = string.replace(/Д/g, 'D');
        string = string.replace(/д/g, 'd');
        string = string.replace(/Ђ/g, 'Dj');
        string = string.replace(/ђ/g, 'dj');
        string = string.replace(/Е/g, 'E');
        string = string.replace(/е/g, 'e');
        string = string.replace(/Ж/g, 'Z');
        string = string.replace(/ж/g, 'z');
        string = string.replace(/З/g, 'Z');
        string = string.replace(/з/g, 'z');
        string = string.replace(/И/g, 'I');
        string = string.replace(/и/g, 'i');
        string = string.replace(/Ј/g, 'J');
        string = string.replace(/ј/g, 'j');
        string = string.replace(/К/g, 'K');
        string = string.replace(/к/g, 'k');
        string = string.replace(/Л/g, 'L');
        string = string.replace(/л/g, 'l');
        string = string.replace(/Љ/g, 'lj');
        string = string.replace(/љ/g, 'lj');
        string = string.replace(/М/g, 'M');
        string = string.replace(/м/g, 'm');
        string = string.replace(/Н/g, 'N');
        string = string.replace(/н/g, 'n');
        string = string.replace(/Њ/g, 'Nj');
        string = string.replace(/њ/g, 'nj');
        string = string.replace(/О/g, 'O');
        string = string.replace(/о/g, 'o');
        string = string.replace(/П/g, 'P');
        string = string.replace(/п/g, 'p');
        string = string.replace(/Р/g, 'R');
        string = string.replace(/р/g, 'r');
        string = string.replace(/С/g, 'S');
        string = string.replace(/с/g, 's');
        string = string.replace(/Т/g, 'T');
        string = string.replace(/т/g, 't');
        string = string.replace(/Ћ/g, 'C');
        string = string.replace(/ћ/g, 'c');
        string = string.replace(/У/g, 'U');
        string = string.replace(/у/g, 'u');
        string = string.replace(/Ф/g, 'F');
        string = string.replace(/ф/g, 'f');
        string = string.replace(/Х/g, 'H');
        string = string.replace(/х/g, 'h');
        string = string.replace(/Ц/g, 'C');
        string = string.replace(/ц/g, 'c');
        string = string.replace(/Ч/g, 'C');
        string = string.replace(/ч/g, 'c');
        string = string.replace(/Џ/g, 'Dz');
        string = string.replace(/џ/g, 'dz');
        string = string.replace(/Ш/g, 'S');
        string = string.replace(/ш/g, 's');
        return string;
    };
    /**
     * @param {?} totalLength
     * @param {?} numOfColumns
     * @return {?}
     */
    UtilService.getNumberOfRows = function (totalLength, numOfColumns) {
        if (totalLength % numOfColumns === 0) {
            return numOfColumns / numOfColumns;
        }
        if (totalLength % numOfColumns !== 0) {
            if (totalLength / numOfColumns < 1) {
                return 1;
            }
            else {
                var /** @type {?} */ rest = Math.trunc(totalLength / numOfColumns);
                return rest + 1;
            }
        }
    };
    /**
     * @return {?}
     */
    UtilService.recalculateCss = function () {
        // const numOfVisibleFilters =
        //     this.getNumberOfRows($('.field-to-filter:visible').length, 4) + 1;
        // const defaultTopPagination = 150;
        // const defaultTopHeader = 200;
        // const topPagination =
        //     numOfVisibleFilters > 1
        //         ? defaultTopPagination + 40 * (numOfVisibleFilters - 1)
        //         : defaultTopPagination;
        // const topHeader =
        //     numOfVisibleFilters > 1
        //         ? defaultTopHeader + 40 * (numOfVisibleFilters - 1)
        //         : defaultTopHeader;
        // $('.sticking .pagination-main-table.sticked.table').css(
        //     'top',
        //     topPagination + 'px'
        // );
        // $('.sticking .pagination-main-table.sticked.table.filter-closed').css(
        //     'top',
        //     '150px'
        // ); // 150
        // $('.sticking .thead-wrapper-main-table.sticked').css(
        //     'top',
        //     topHeader + 'px'
        // );
        // $('.sticking .thead-wrapper-main-table.sticked.filter-closed').css(
        //     'top',
        //     '200px'
        // );
        // // $('.sticking .tbody-wrapper-main-table.sticked').css('margin-top', topHeader - 60 + 'px');
        // $('.sticking .tbody-wrapper-main-table.sticked.filter-closed').css(
        //     'margin-top',
        //     '140px'
        // );
        // const paginationElement = $('.sticking .pagination-main-table.table');
        // if (paginationElement.length > 0) {
        //     paginationElement.attr(
        //         'class',
        //         paginationElement.get(0).className.replace(/\bfilter\S+/g, '')
        //     );
        //     paginationElement.addClass('filter' + numOfVisibleFilters);
        // }
        // const theadElement = $('.sticking .thead-wrapper-main-table');
        // if (theadElement.length > 0) {
        //     theadElement.attr(
        //         'class',
        //         theadElement.get(0).className.replace(/\bfilter\S+/g, '')
        //     );
        //     theadElement.addClass('filter' + numOfVisibleFilters);
        // }
        // const tbodyElement = $('.sticking .tbody-wrapper-main-table');
        // if (tbodyElement.length > 0) {
        //     tbodyElement.attr(
        //         'class',
        //         tbodyElement.get(0).className.replace(/\bfilter\S+/g, '')
        //     );
        //     tbodyElement.addClass('filter' + numOfVisibleFilters);
        // }
        // const tableElement2 = $('.sticking .wrapper-main-table');
        // if (tableElement2.length > 0) {
        //     tableElement2.attr(
        //         'class',
        //         tableElement2.get(0).className.replace(/\bfilter\S+/g, '')
        //     );
        //     tableElement2.addClass('filter' + numOfVisibleFilters);
        // }
    };
    /**
     * @return {?}
     */
    UtilService.resetCss = function () {
        // $('.filter-row').removeClass('closed');
        // $('.filter-row').addClass('opened');
        // $('.sticking .pagination-main-table').removeClass('filter-closed');
        // $('.sticking .pagination-main-table').removeClass('up');
        // $('.sticking .pagination-main-table').addClass('down');
        // $('.sticking .pagination-main-table').removeClass('sticked');
        // $('.sticking .pagination-main-table').css('top', '');
        // $('.sticking .pagination-main-table.sticked.table').css('top', '150px');
        // $('.filter-row').removeClass('sticked');
        // $('.sticking .thead-wrapper-main-table').removeClass('filter-closed');
        // $('.sticking .thead-wrapper-main-table').removeClass('up');
        // $('.sticking .thead-wrapper-main-table').addClass('down');
        // $('.sticking .thead-wrapper-main-table').removeClass('sticked');
        // $('.sticking .tbody-wrapper-main-table').removeClass('sticked');
        // $('.sticking .thead-wrapper-main-table').css('top', '');
        // $('.sticking .thead-wrapper-main-table.sticked').css('top', '200px');
        // $('.sticking .tbody-wrapper-main-table').css('margin-top', '');
        // $('.sticking .tbody-wrapper-main-table.sticked').css(
        //     'margin-top',
        //     '140px'
        // );
        // $('.filter-row').removeClass('sticked');
        // $('.sticking .wrapper-main-table').removeClass('sticked');
        // $('.sticking .wrapper-main-table').css('margin-top', '0');
    };
    /**
     * @param {?} num
     * @return {?}
     */
    UtilService.formatNumber = function (num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    };
    /**
     * @param {?} order
     * @param {?} fieldMap
     * @return {?}
     */
    UtilService.getCompleterValue = function (order, fieldMap) {
        if (order == null || fieldMap == null) {
            return '';
        }
        var /** @type {?} */ data = UtilService.getFieldObject(order, fieldMap.propertyPath.all);
        var /** @type {?} */ mainAndSecond = fieldMap.relation != null &&
            fieldMap.relation['completerMainAndSecond'];
        if (!mainAndSecond) {
            return UtilService.getFieldObject(data, fieldMap.relationValue.all);
        }
        // XXX In case the field in question has no relation - show "--INVALID--" (to the tester/QA).
        var /** @type {?} */ value = fieldMap.relationValue.all.length === 0
            ? '--INVALID--'
            : UtilService.getFieldObject(data, fieldMap.relationValue.all);
        var /** @type {?} */ key = fieldMap.relationKey.all.length === 0
            ? ''
            : UtilService.getFieldObject(data, fieldMap.relationKey.all);
        if (key && key !== '' && value) {
            return key + '\xa0' + value;
        }
        if (key && key !== '') {
            return key;
        }
        if (value) {
            return value;
        }
        return '';
    };
    /**
     * Creates an empty entity object, i.e. an empty document with `{ id: null }`.
     * NOTE: This is usually used to mark "nothing is selected" in the look-up control (AutocompleteComponent or "completer").
     *
     * @return {?} a new empty object with its `id` property set to `null`.
     */
    UtilService.createEmptyEntity = function () {
        return { id: null };
    };
    /**
     * Creates an empty "poslovni partner (pravno lice)" object, i.e. `{ pravnoLice: { id: null } }`.
     * NOTE: This is usually used to mark "nothing is selected" in the look-up control (AutocompleteComponent or "completer").
     *
     * @return {?} a new empty object with its `pravnoLice` property set to `createEmptyEntity()`.
     */
    UtilService.createEmptyPoslovniPartner = function () {
        return { pravnoLice: this.createEmptyEntity() };
    };
    /**
     * Determines if the specified value exists or not, i.e. equals the JavaScript's `if (value)`.
     * NOTE: This is NOT to be used to check existence of entities or documents (i.e. objects having the `id` property).
     *
     * @see entityExists
     * @param {?} value the property or variable to check.
     * @return {?} `true` if the `value` is not `null` or `undefined`, `false` otherwise.
     */
    UtilService.valueExists = function (value) {
        return typeof value !== 'undefined' && value !== null;
        // TODO Shorter form, needs testing: return value != null;
    };
    /**
     * Determines if the specified entity exists or not, i.e. equals the JavaScript's `if (value)`.
     * NOTE: Use it to check existence of entities or documents (i.e. objects having the `id` property).
     *
     * @param {?} entity the entity or document object to check.
     * @return {?} `true` if both the `entity` and its `id` are not `null`, `false` otherwise.
     */
    UtilService.entityExists = function (entity) {
        return entity != null && entity.id != null;
    };
    /**
     * Returns the full path for the specified `field` (or property or column) descriptor.
     *
     * @see TableSettings.relations
     * @param {?} field the field descriptor to use.
     * @param {?=} relations the collection of `settings` objects related to the `field`.
     * @return {?} the full path of the `field`.
     */
    UtilService.getFieldFullPath = function (field, relations) {
        if (relations === void 0) { relations = []; }
        var /** @type {?} */ pathStart = field.path.split('.');
        var /** @type {?} */ relation = relations.find(function (rel) { return rel.group === field.entityType; });
        if (relation != null) {
            return pathStart.concat(relation.completerSecondField.split('.'));
        }
        return pathStart.concat([field.fieldName]);
    };
    return UtilService;
}());
UtilService.dateFormatDefault = 'DD.MM.YYYY';
UtilService.dateTimeFormatDefault = 'DD.MM.YYYY HH:mm:ss';
UtilService.dateFormatDefaultTime = 'HH:mm z';
UtilService.regex_hhmm = /^([2][0-3]|[01]?[0-9])([.:][0-5][0-9])?$/;
UtilService.daysEnSr = { Monday: 'Ponedeljak', Tuesday: 'Utorak', Wednesday: 'Sreda', Thursday: 'Četvrtak', Friday: 'Petak', Saturday: 'Subota', Sunday: 'Nedelja' };
UtilService.datePickerOptionsDefault = {
    autoUpdateInput: false,
    format: UtilService.dateFormatDefault,
    locale: { format: UtilService.dateFormatDefault },
    singleDatePicker: true
};
var TableModeEnum = {};
TableModeEnum.Details = /** @type {?} */ ('details');
TableModeEnum.Table = /** @type {?} */ ('table');
TableModeEnum.Popup = /** @type {?} */ ('popup');
TableModeEnum[TableModeEnum.Details] = "Details";
TableModeEnum[TableModeEnum.Table] = "Table";
TableModeEnum[TableModeEnum.Popup] = "Popup";
var environment = {
    production: true,
    apiRemoteUrlAuth: 'http://ppu.mi-system.rs:8080/BeyondIdentity',
    apiRemoteUrlBeyondPartners: 'http://tiaclab.com:4200',
    apiRemoteUrlBeyondBasic: 'http://tiaclab.com:4201',
    apiRemoteUrlBeyondIdentity: 'http://tiaclab.com:4202',
    apiRemoteUrlBeyondManufacturing: 'http://tiaclab.com:4206',
    apiRemoteUrlBeyondOffice: 'http://80.74.163.204:8181/BeyondSuite/BeyondSuite.html',
    //DEVELOPMENT-DO-NOT-MODIFY//apiRemoteUrlApi: 'http://localhost:8080/mis4/rest/'
    apiRemoteUrlApi: 'http://ppu.mi-system.rs:8080/mis4/rest/',
    // build
    // loginService: 'http://192.168.1.94:44401/api',
    // gatewayBase: 'http://192.168.1.94:44300/api',
    // rtsApiGatewayGet: 'http://192.168.1.94:44300/api/GatewayGet',
    // rtsProdLogout: 'http://192.168.1.94/login',
    loginService: 'http://192.168.1.93:44401/api',
    rtsProdLogout: 'http://192.168.1.93/login',
    gatewayBase: 'http://192.168.1.93:44300/api',
    rtsApiGatewayGet: 'http://192.168.1.93:44300/api/GatewayGet',
    // gatewayBase: 'https://localhost:44300/api',
    // rtsApiGatewayGet: 'https://localhost:44300/api/GatewayGet',
    // loginService: 'http://192.168.145.50:44401/api',
    // gatewayBase: 'http://192.168.145.50:44300/api',
    // rtsApiGatewayGet: 'http://192.168.145.50:44300/api/GatewayGet',
    // rtsProdLogout: 'http://192.168.145.50/login',
    // loginService: 'http://192.168.145.52:44401/api',
    // gatewayBase: 'http://192.168.145.52:44300/api',
    // rtsApiGatewayGet: 'http://192.168.145.52:44300/api/GatewayGet',
    // rtsProdLogout: 'http://192.168.145.52/login',
    // nasLocal: 'http://smarts:4200/login',\
    envName: 'DEV',
};
var ServiceFilterBase = /** @class */ (function () {
    function ServiceFilterBase() {
    }
    return ServiceFilterBase;
}());
var ServiceFilterGenerated = /** @class */ (function () {
    /**
     * @param {?} expression
     * @param {?} symbols
     */
    function ServiceFilterGenerated(expression, symbols) {
        this.expression = '';
        this.symbols = [];
        this.expression = expression;
        this.symbols = symbols;
    }
    /**
     * @return {?}
     */
    ServiceFilterGenerated.prototype.prepareForService = function () {
        if (this.symbols.length > 1) {
            return this.symbols.concat([
                {
                    name: 'kontrolni',
                    propertyName: '',
                    operand: this.expression,
                    beanName: '',
                    value: ''
                }
            ]);
        }
        else {
            return this.symbols;
        }
    };
    return ServiceFilterGenerated;
}());
var ServiceFilterSymbol = /** @class */ (function (_super) {
    __extends(ServiceFilterSymbol, _super);
    /**
     * @param {?} beanName
     * @param {?} propertyName
     * @param {?} operand
     * @param {?} value
     * @param {?=} forcedName
     * @param {?=} type
     */
    function ServiceFilterSymbol(beanName, propertyName, operand, value, forcedName, type) {
        if (forcedName === void 0) { forcedName = null; }
        if (type === void 0) { type = null; }
        var _this = _super.call(this) || this;
        _this.isExpression = false;
        _this.propertyName = propertyName;
        _this.operand = operand;
        _this.beanName = beanName;
        _this.value = value;
        _this.forcedName = forcedName;
        _this.type = type;
        return _this;
    }
    /**
     * Creates a filter symbol containing an expression, e.g. a mathetmatical formula combining multiple properties.
     * @param {?} beanName
     * @param {?} propertyName
     * @param {?} operand
     * @param {?} value
     * @param {?=} forcedName
     * @param {?=} type
     * @return {?}
     */
    ServiceFilterSymbol.createExpression = function (beanName, propertyName, operand, value, forcedName, type) {
        if (forcedName === void 0) { forcedName = null; }
        if (type === void 0) { type = null; }
        var /** @type {?} */ expr = new ServiceFilterSymbol(beanName, propertyName, operand, value, forcedName, type);
        expr.isExpression = true;
        return expr;
    };
    return ServiceFilterSymbol;
}(ServiceFilterBase));
var ServiceFilterOperandEnum = {};
ServiceFilterOperandEnum.AND = /** @type {?} */ ('AND');
ServiceFilterOperandEnum.OR = /** @type {?} */ ('OR');
ServiceFilterOperandEnum[ServiceFilterOperandEnum.AND] = "AND";
ServiceFilterOperandEnum[ServiceFilterOperandEnum.OR] = "OR";
var ServiceFilterTerm = /** @class */ (function (_super) {
    __extends(ServiceFilterTerm, _super);
    /**
     * @param {?=} operand
     * @param {?=} children
     */
    function ServiceFilterTerm(operand, children) {
        if (operand === void 0) { operand = ServiceFilterOperandEnum.AND; }
        if (children === void 0) { children = []; }
        var _this = _super.call(this) || this;
        _this.operand = ServiceFilterOperandEnum.AND;
        _this.symbolNamePrefix = '';
        _this.operand = operand;
        _this.children = children.filter(function (item) { return item != null; });
        return _this;
    }
    /**
     * @param {?=} symbolNamePrefix
     * @return {?}
     */
    ServiceFilterTerm.prototype.generateResult = function (symbolNamePrefix) {
        if (symbolNamePrefix === void 0) { symbolNamePrefix = 'S'; }
        this.symbolNamePrefix = symbolNamePrefix;
        var /** @type {?} */ symbols = [];
        var /** @type {?} */ expressionParts = [];
        for (var /** @type {?} */ i = 0; i < this.children.length; i++) {
            var /** @type {?} */ childName = this.symbolNamePrefix + '_' + i.toString();
            if (this.children[i] instanceof ServiceFilterTerm) {
                var /** @type {?} */ term = (this.children[i]);
                var /** @type {?} */ termResult = term.generateResult(childName);
                for (var /** @type {?} */ j = 0; j < termResult.symbols.length; j++) {
                    symbols.push(termResult.symbols[j]);
                }
                if (termResult.expression != null) {
                    expressionParts.push(termResult.expression);
                }
            }
            if (this.children[i] instanceof ServiceFilterSymbol) {
                var /** @type {?} */ symbol = (this.children[i]);
                if (symbol.forcedName == null) {
                    symbol.name = childName;
                    expressionParts.push(childName);
                }
                else {
                    // A specific filter is used
                    // Use it's exact name, and don't add it to the expressionParts list
                    symbol.name = symbol.forcedName;
                }
                symbols.push(symbol);
            }
        }
        var /** @type {?} */ expression = expressionParts.length === 0 ? null : '(' + expressionParts.join(' ' + this.operand.toString() + ' ') + ')';
        return new ServiceFilterGenerated(expression, symbols);
    };
    return ServiceFilterTerm;
}(ServiceFilterBase));
var DocumentIdentity = /** @class */ (function () {
    function DocumentIdentity() {
    }
    /**
     * @param {?} compareInstance
     * @return {?}
     */
    DocumentIdentity.prototype.isEqual = function (compareInstance) {
        return this.documentId === compareInstance.documentId &&
            this.documentType === compareInstance.documentType &&
            this.documentSecurityCode === compareInstance.documentSecurityCode;
    };
    return DocumentIdentity;
}());
var DynamicComponent = /** @class */ (function () {
    function DynamicComponent() {
    }
    return DynamicComponent;
}());
var OpenTabData = /** @class */ (function () {
    /**
     * @param {?} documentId
     * @param {?} documentCode
     * @param {?} documentType
     * @param {?} documentSecurityCode
     * @param {?} documentLabel
     * @param {?} componentClass
     * @param {?=} params
     * @param {?=} documentId2
     */
    function OpenTabData(documentId, documentCode, documentType, documentSecurityCode, documentLabel, componentClass, params, documentId2) {
        if (params === void 0) { params = null; }
        this.identity = new DocumentIdentity();
        this.identity.documentId = documentId;
        this.identity.documentType = documentType;
        this.identity.documentSecurityCode = documentSecurityCode;
        this.identity.documentLabel = documentLabel;
        this.identity.documentCode = documentCode;
        this.component = new DynamicComponent();
        this.component.componentClass = componentClass;
        this.identity.documentId2 = documentId2;
        this.params = params;
    }
    return OpenTabData;
}());
var ApplicationService = /** @class */ (function () {
    function ApplicationService() {
        this.tabOpenEvent = new EventEmitter();
        this.tabCloseEvent = new EventEmitter();
        this.tabSwitchEvent = new EventEmitter();
        this.sidebarItemOpenEvent = new EventEmitter();
        this.menuDataChangeEvent = new EventEmitter();
        this.openMessageEvent = new EventEmitter();
        this.openMessageModeEvent = new EventEmitter();
        this.sacuvajMontazu = new EventEmitter();
        this.sacuvajMontazu$ = this.sacuvajMontazu.asObservable();
        this.sacuvajVerifikaciju = new EventEmitter();
        this.sacuvajVerifikaciju$ = this.sacuvajVerifikaciju.asObservable();
        this.sacuvajKopijuVerifikacije = new EventEmitter();
        this.sacuvajKopijuVerifikacije$ = this.sacuvajKopijuVerifikacije.asObservable();
        this.currentTabIdentity = null;
        this.viewInfosByName = {};
    }
    /**
     * @param {?} tabComponent
     * @return {?}
     */
    ApplicationService.prototype.openTab = function (tabComponent) {
        var _this = this;
        // BUGFIX Just in case the same tab was just closed give it some time to "recover".
        // "ERROR ViewDestroyedError: Attempt to use a destroyed view: detectChanges ..."
        setTimeout(function () {
            _this.tabOpenEvent.next(tabComponent);
        }, 0);
    };
    /**
     * @param {?} documentIdentity
     * @return {?}
     */
    ApplicationService.prototype.closeTab = function (documentIdentity) {
        if (documentIdentity == null) {
            return;
        }
        this.tabCloseEvent.next(documentIdentity);
    };
    /**
     * @param {?} openTabData
     * @return {?}
     */
    ApplicationService.prototype.tabSwitchNotify = function (openTabData) {
        var /** @type {?} */ haveTab = openTabData != null;
        this.currentTabIdentity = haveTab ? openTabData.identity : null;
        if (haveTab) {
            this.tabSwitchEvent.next(openTabData);
        }
    };
    /**
     * @param {?} itemData
     * @return {?}
     */
    ApplicationService.prototype.sidebarItemOpen = function (itemData) {
        this.sidebarItemOpenEvent.next(itemData);
    };
    /**
     * @param {?} menuData
     * @return {?}
     */
    ApplicationService.prototype.setMenu = function (menuData) {
        this.menuDataChangeEvent.next(menuData);
    };
    /**
     * @param {?} settingsSingle
     * @return {?}
     */
    ApplicationService.prototype.settingsSingleLoaded = function (settingsSingle) {
    };
    /**
     * @param {?} message
     * @return {?}
     */
    ApplicationService.prototype.openMessage = function (message) {
        this.openMessageEvent.next(message);
    };
    /**
     * @param {?} messageMode
     * @return {?}
     */
    ApplicationService.prototype.openMessageMode = function (messageMode) {
        this.openMessageModeEvent.next(messageMode);
    };
    /**
     * Associate a document class with a corresponding view component.
     *
     * \@example this.applicationService.registerViewComponent('PlanProizvodnje', 'PPR', DocumentTypeEnum.Dokument,
     *           'Z201', 'Plan proizvodnje', PlanProizvodnjeComponent);
     * @param {?} documentName unique document name (a.k.a. "documentId"), e.g. "PlanProizvodnje"
     * @param {?} documentCode document code (a.k.a. "vrstaDokumenta"), e.g. "PPR"
     * @param {?} documentType type of document, i.e. "sifarnik", "dokument", or "izvestaj"
     * @param {?} securityCode unique security code (a.k.a. "formCode"), e.g. "Z201"
     * @param {?} label user friendly document name, e.g. "Plan proizvodnje"
     * @param {?} componentClass class reference to an Angular view responsible for viewing/editing the document
     *
     * @param {?=} documentId2
     * @return {?}
     */
    ApplicationService.prototype.registerViewComponent = function (documentName, documentCode, documentType, securityCode, label, componentClass, documentId2) {
        this.viewInfosByName[documentName] = new ViewInfo(documentName, documentCode, documentType, securityCode, label, componentClass, documentId2);
    };
    /**
     * Returns a list of names of all registered documents.
     * The names can be used to access corresponding document details and view classes.
     *
     * @see findDocumentIdentityByName
     * @see findOpenTabDataByName
     * @see openDocument
     *
     * \@example const docNames = this.applicationService.allRegisteredNames(); // [ 'PlanProizvodnje', ... ]
     * @return {?} list of names of all registered documents.
     */
    ApplicationService.prototype.allRegisteredNames = function () {
        return Object.keys(this.viewInfosByName);
    };
    /**
     * Returns the named document's identity descriptor.
     *
     * \@example this.applicationService.closeTab(this.applicationService.findDocumentIdentityByName('PlanProizvodnje'));
     * @param {?} documentName document name, e.g. "PlanProizvodnje"
     * @return {?} named document's identity if found, {\@code null} otherwise.
     *
     */
    ApplicationService.prototype.findDocumentIdentityByName = function (documentName) {
        var /** @type {?} */ viewInfo = this.viewInfosByName[documentName];
        if (viewInfo) {
            return viewInfo.toDocumentIdentity();
        }
        return null;
    };
    /**
     * Returns the named document's open-in-tab descriptor.
     *
     * \@example Opens a tab listing all PlanProizvodnje documents:
     * this.applicationService.openTab(this.applicationService.findOpenTabDataByName('PlanProizvodnje'));
     * @param {?} documentName document name, e.g. "PlanProizvodnje"
     * @return {?} named document's open-in-tab descriptor if found, {\@code null} otherwise.
     *
     */
    ApplicationService.prototype.findOpenTabDataByName = function (documentName) {
        var /** @type {?} */ viewInfo = this.viewInfosByName[documentName];
        if (viewInfo) {
            return viewInfo.toOpenTabData();
        }
        return null;
    };
    /**
     * Opens the specified document instance for viewing (in a new tab).
     *
     * \@example this.applicationService.openDocument('PlanProizvodnje', { id: 123 });
     * @param {?} documentName document name, e.g. "PlanProizvodnje"
     * @param {?} params additional parameters identifying the specific document instance,
     *         e.g. `{ id: this.selectedPlanProizvodnje.id }`
     *
     * @return {?}
     */
    ApplicationService.prototype.openDocument = function (documentName, params) {
        var /** @type {?} */ tabData = this.findOpenTabDataByName(documentName);
        if (tabData === null) {
            throw new Error("Dokument vrste \"" + documentName + "\" nije prona\u0111en.");
        }
        tabData.params = params;
        this.openTab(tabData);
    };
    return ApplicationService;
}());
ApplicationService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ApplicationService.ctorParameters = function () { return []; };
var ViewInfo = /** @class */ (function () {
    /**
     * @param {?} documentName
     * @param {?} documentCode
     * @param {?} documentType
     * @param {?} securityCode
     * @param {?} label
     * @param {?} componentClass
     * @param {?=} documentId2
     */
    function ViewInfo(documentName, documentCode, documentType, securityCode, label, componentClass, documentId2) {
        this._name = documentName;
        this._documentCode = documentCode;
        this._documentType = documentType;
        this._securityCode = securityCode;
        this._label = label;
        this._componentClass = componentClass;
        this._documentId2 = documentId2;
    }
    Object.defineProperty(ViewInfo.prototype, "name", {
        /**
         * @return {?}
         */
        get: function () { return this._name; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewInfo.prototype, "documentId2", {
        /**
         * @return {?}
         */
        get: function () { return this._documentId2; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewInfo.prototype, "documentCode", {
        /**
         * @return {?}
         */
        get: function () { return this._documentCode; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewInfo.prototype, "documentType", {
        /**
         * @return {?}
         */
        get: function () { return this._documentType; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewInfo.prototype, "securityCode", {
        /**
         * @return {?}
         */
        get: function () { return this._securityCode; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewInfo.prototype, "label", {
        /**
         * @return {?}
         */
        get: function () { return this._label; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewInfo.prototype, "componentClass", {
        /**
         * @return {?}
         */
        get: function () { return this._componentClass; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ViewInfo.prototype.toDocumentIdentity = function () {
        return /** @type {?} */ ({
            documentId: this.name,
            documentType: this.documentType,
            documentCode: this.documentCode,
            documentSecurityCode: this.securityCode,
            documentLabel: this.label
        });
    };
    /**
     * @return {?}
     */
    ViewInfo.prototype.toOpenTabData = function () {
        return new OpenTabData(this.name, this.documentCode, this.documentType, this.securityCode, this.label, this.componentClass, null, this.documentId2);
    };
    return ViewInfo;
}());
var DocumentTypeEnum = {};
DocumentTypeEnum.Dokument = /** @type {?} */ ('dokument');
DocumentTypeEnum.Sifarnik = /** @type {?} */ ('sifarnik');
DocumentTypeEnum.Izvestaj = /** @type {?} */ ('izvestaj');
DocumentTypeEnum[DocumentTypeEnum.Dokument] = "Dokument";
DocumentTypeEnum[DocumentTypeEnum.Sifarnik] = "Sifarnik";
DocumentTypeEnum[DocumentTypeEnum.Izvestaj] = "Izvestaj";
var MessageStatusEnum = {};
MessageStatusEnum.Sent = 0;
MessageStatusEnum.Delivered = 1;
MessageStatusEnum.Opened = 2;
MessageStatusEnum.Deleted = 3;
MessageStatusEnum[MessageStatusEnum.Sent] = "Sent";
MessageStatusEnum[MessageStatusEnum.Delivered] = "Delivered";
MessageStatusEnum[MessageStatusEnum.Opened] = "Opened";
MessageStatusEnum[MessageStatusEnum.Deleted] = "Deleted";
var MessageService = /** @class */ (function () {
    /**
     * @param {?} backendService
     * @param {?} http
     */
    function MessageService(backendService, http$$1) {
        this.backendService = backendService;
        this.http = http$$1;
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json;charset=utf-8'
        });
        this.messages = [];
        this.messageLeftEvent = new EventEmitter();
        this.messageChangedEvent = new EventEmitter();
        this.messageStatusEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    MessageService.prototype.getMessages = function () {
        return this.messages;
    };
    /**
     * @param {?} message
     * @param {?} user
     * @return {?}
     */
    MessageService.prototype.create = function (message, user) {
        var _this = this;
        return this.http.post(environment.apiRemoteUrlApi + 'api/messages', message, { headers: this.headers }).do(function (data) {
            _this.messages = data;
            _this.messageLeftEvent.emit(data);
        }, function (error) {
            console.log('error');
        });
    };
    /**
     * @param {?} user
     * @return {?}
     */
    MessageService.prototype.getMessage = function (user) {
        var _this = this;
        return this.http.get(environment.apiRemoteUrlApi + 'api/messages?user=' + user.username, { headers: { ignoreLoadingBar: '' } }).do(function (data) {
            _this.messages = data;
            _this.messageLeftEvent.emit(data);
        }, function (error) {
            console.log('error');
        });
    };
    /**
     * @param {?} messagesID
     * @param {?} user
     * @param {?} status
     * @return {?}
     */
    MessageService.prototype.updateStatus = function (messagesID, user, status) {
        var _this = this;
        var /** @type {?} */ params = {
            'messagesID': messagesID,
            'username': user.username,
            'status': status
        };
        return this.http.post(environment.apiRemoteUrlApi + 'api/messages/updateStatus', params, { headers: this.headers }).do(function (data) {
            _this.messages = data;
            _this.messageLeftEvent.emit(data);
            if (messagesID.length === 1 && status === MessageStatusEnum.Opened) {
                _this.messageStatusEvent.emit(messagesID[0]);
            }
        }, function (error) {
            console.log('error');
        });
    };
    /**
     * @param {?} message
     * @param {?} user
     * @return {?}
     */
    MessageService.prototype.createReply = function (message, user) {
        var _this = this;
        return this.http.post(environment.apiRemoteUrlApi + 'api/messages/replay', message).do(function (data) {
            _this.messages = data;
            _this.messageLeftEvent.emit(data);
        }, function (error) {
            console.log('error');
        });
    };
    /**
     * @return {?}
     */
    MessageService.prototype.getAllUsers = function () {
        return this.http.get(environment.apiRemoteUrlApi + 'api/users').do(function (data) {
            console.log('data ', data);
        }, function (error) {
            console.log('error');
        });
    };
    return MessageService;
}());
MessageService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
MessageService.ctorParameters = function () { return [
    { type: BackendService, },
    { type: HttpClient, },
]; };
MessageService.propDecorators = {
    'messageLeftEvent': [{ type: Output },],
    'messageChangedEvent': [{ type: Output },],
    'messageStatusEvent': [{ type: Output },],
};
var User = /** @class */ (function () {
    function User() {
    }
    return User;
}());
var AuthenticationService = /** @class */ (function () {
    /**
     * @param {?} http
     */
    function AuthenticationService(http$$1) {
        this.http = http$$1;
        this.userSaved = new EventEmitter();
        this.loginError = new EventEmitter();
        this.loginError$ = this.loginError.asObservable();
        this.maintenanceModeChecked = new EventEmitter();
    }
    /**
     * @param {?} incomingUserData
     * @return {?}
     */
    AuthenticationService.prototype.setUser = function (incomingUserData) {
        this.user = new User();
        this.user.username = incomingUserData.KorisnickoIme;
        this.user.fullName = incomingUserData.ImePrezime;
        this.user.uloge = incomingUserData.Uloge;
        sessionStorage.setItem('currentUser', JSON.stringify(this.user));
    };
    /**
     * @param {?} serviceData
     * @return {?}
     */
    AuthenticationService.prototype.setToken = function (serviceData) {
        this.token = serviceData['Token'];
        sessionStorage.setItem('token', this.token);
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.getUser = function () {
        return this.user ? this.user : JSON.parse(sessionStorage.getItem('currentUser'));
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.getUloge = function () {
        return this.getUser().uloge;
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.getToken = function () {
        return sessionStorage.getItem('token');
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.getFullName = function () {
        return this.getUser().fullName;
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.isAuthenticated = function () {
        if (this.getToken()) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.checkMaintenanceMode = function () {
        var _this = this;
        this.http.get(environment.loginService + '/isMaintenanceMode')
            .subscribe(function (isMaintenanceMode) { return _this.maintenanceModeChecked.next(isMaintenanceMode); });
    };
    /**
     * @param {?} korisnik
     * @return {?}
     */
    AuthenticationService.prototype.login = function (korisnik) {
        var _this = this;
        // TODO: Ubaciti loader = true; ovde
        var /** @type {?} */ retVal = new Subject$1();
        this.http.post(environment.loginService + '/Login', korisnik)
            .subscribe(function (data) {
            _this.setToken(data);
            var /** @type {?} */ headers = new HttpHeaders({ 'Content-Type': 'application-json', 'token': _this.token });
            _this.http.get(environment.gatewayBase + '/User', { headers: headers })
                .subscribe(function (user) {
                _this.setUser(user);
                retVal.next(true);
            });
            // TODO: Ubaciti loader = false; ovde
        }, function (err) {
            if (err.error.hasOwnProperty('Errors') && err.error.Errors[0].Value) {
                _this.loginError.emit(err.error.Errors[0].Value);
            }
        });
        return retVal;
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.emitLogout = function () {
        return Observable$1.of(this.getToken());
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.logout = function () {
        return this.http.get(environment.loginService + '/logout' + ("?token=" + this.getToken()));
    };
    return AuthenticationService;
}());
AuthenticationService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
AuthenticationService.ctorParameters = function () { return [
    { type: HttpClient, },
]; };
var ToolbarOptions = /** @class */ (function () {
    function ToolbarOptions() {
    }
    /**
     * @param {?} options
     * @return {?}
     */
    ToolbarOptions.populate = function (options) {
        if (options.toolbarVisible == null) {
            options.toolbarVisible = true;
        }
        if (options.items == null) {
            options.items = new Array();
        }
        if (options.showComments == null) {
            options.showComments = false;
        }
        if (options.showAttachments == null) {
            options.showAttachments = false;
        }
        if (options.showExport == null) {
            options.showExport = false;
        }
        if (options.showPrethodnici == null) {
            options.showPrethodnici = false;
        }
        if (options.showPrint == null) {
            options.showPrint = false;
        }
        if (options.showClose == null) {
            options.showClose = true;
        }
        if (options.leftEnabled == null) {
            options.leftEnabled = false;
        }
        if (options.rightEnabled == null) {
            options.rightEnabled = false;
        }
    };
    /**
     * @param {?} options
     * @param {?} extension
     * @return {?}
     */
    ToolbarOptions.extend = function (options, extension) {
        if (extension.toolbarVisible != null) {
            options.toolbarVisible = extension.toolbarVisible;
        }
        if (extension.items != null) {
            options.items = extension.items;
        }
        if (extension.showComments != null) {
            options.showComments = extension.showComments;
        }
        if (extension.showAttachments != null) {
            options.showAttachments = extension.showAttachments;
        }
        if (extension.showExport != null) {
            options.showExport = extension.showExport;
        }
        if (extension.showPrethodnici != null) {
            options.showPrethodnici = extension.showPrethodnici;
        }
        if (extension.showPrint != null) {
            options.showPrint = extension.showPrint;
        }
        if (extension.showClose != null) {
            options.showClose = extension.showClose;
        }
        if (extension.leftEnabled != null) {
            options.leftEnabled = extension.leftEnabled;
        }
        if (extension.rightEnabled != null) {
            options.rightEnabled = extension.rightEnabled;
        }
        return options;
    };
    /**
     * @return {?}
     */
    ToolbarOptions.getDefault = function () {
        var /** @type {?} */ retVal = new ToolbarOptions();
        ToolbarOptions.populate(retVal);
        return retVal;
    };
    return ToolbarOptions;
}());
var SecurityEnum = {};
SecurityEnum.Add = 1;
SecurityEnum.Update = 2;
SecurityEnum.List = 3;
SecurityEnum.Embed = 7;
SecurityEnum.SelectOnly = 9;
SecurityEnum.Lookpu = 10;
SecurityEnum.Config = 12;
SecurityEnum.Delete = 101;
SecurityEnum.Print = 102;
SecurityEnum.Accept = 104;
SecurityEnum.Storno = 105;
SecurityEnum.Notification = 200;
SecurityEnum.Approve = 210;
SecurityEnum.ChangeStatus = 213;
SecurityEnum.Export = 1;
SecurityEnum[SecurityEnum.Add] = "Add";
SecurityEnum[SecurityEnum.Update] = "Update";
SecurityEnum[SecurityEnum.List] = "List";
SecurityEnum[SecurityEnum.Embed] = "Embed";
SecurityEnum[SecurityEnum.SelectOnly] = "SelectOnly";
SecurityEnum[SecurityEnum.Lookpu] = "Lookpu";
SecurityEnum[SecurityEnum.Config] = "Config";
SecurityEnum[SecurityEnum.Delete] = "Delete";
SecurityEnum[SecurityEnum.Print] = "Print";
SecurityEnum[SecurityEnum.Accept] = "Accept";
SecurityEnum[SecurityEnum.Storno] = "Storno";
SecurityEnum[SecurityEnum.Notification] = "Notification";
SecurityEnum[SecurityEnum.Approve] = "Approve";
SecurityEnum[SecurityEnum.ChangeStatus] = "ChangeStatus";
SecurityEnum[SecurityEnum.Export] = "Export";
var ToolbarAction = /** @class */ (function () {
    function ToolbarAction() {
    }
    return ToolbarAction;
}());
ToolbarAction.Add = 'add';
ToolbarAction.Save = 'save';
ToolbarAction.Cancel = 'cancel';
ToolbarAction.Edit = 'edit';
ToolbarAction.Delete = 'delete';
ToolbarAction.Copy = 'copy';
ToolbarAction.Accept = 'accept';
ToolbarAction.Settings = 'settings';
ToolbarAction.Back = 'back';
ToolbarAction.Close = 'close';
ToolbarAction.Left = 'left';
ToolbarAction.Right = 'right';
ToolbarAction.Print = 'print';
ToolbarAction.Export = 'export';
ToolbarAction.Filter = 'filter';
ToolbarAction.Prethodnik = 'prethodnik';
ToolbarAction.Aneksiraj = 'aneksiraj';
ToolbarAction.Podugovor = 'podugovor';
ToolbarAction.PreuzmiIzSapa = 'sap';
ToolbarAction.ProveriVideoServer = 'proveriVS';
ToolbarAction.PogledajSpot = 'PogledajSpot';
var PageBase = /** @class */ (function () {
    /**
     * @param {?} backendService
     */
    function PageBase(backendService) {
        this.backendService = backendService;
        this.identity = null;
        this.params = null;
        this.isActiveTab = false;
        this.nameSubject = new BehaviorSubject$1('');
        this.modeSubject = new BehaviorSubject$1(FormModeEnum.Table);
        this.toolbarOptionsSubject = new BehaviorSubject$1(ToolbarOptions.getDefault());
        this.infobarVisibleSubject = new BehaviorSubject$1(false);
        this.infobarDocumentSubject = new BehaviorSubject$1(null);
        this.infobarPodugovorSubject = new BehaviorSubject$1(null);
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(PageBase.prototype, "name", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nameSubject.getValue();
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.nameSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageBase.prototype, "mode", {
        /**
         * @return {?}
         */
        get: function () {
            return this.modeSubject.getValue();
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.modeSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PageBase.prototype.overrideBySecurity = function () {
        this.security = this.backendService.getSecurity();
        if (this.identity && this.security) {
            var /** @type {?} */ hasAdd = true;
            var /** @type {?} */ hasUpdate = true;
            var /** @type {?} */ hasDeleteStorno = true;
            var /** @type {?} */ hasAccept = true;
            var /** @type {?} */ hasPrint = true;
            var /** @type {?} */ hasApprove = true;
            var /** @type {?} */ securityDeleteStorno = SecurityEnum.Delete;
            if (this.identity.hasOwnProperty('documentType') && this.identity.documentType === DocumentTypeEnum.Dokument) {
                securityDeleteStorno = SecurityEnum.Storno;
            }
            for (var /** @type {?} */ i = 0; i < this.security.length; i++) {
                if (this.security[i].formCode === this.identity.documentSecurityCode) {
                    hasAdd = false;
                    hasUpdate = false;
                    hasDeleteStorno = false;
                    hasAccept = false;
                    hasPrint = false;
                    hasApprove = false;
                    for (var /** @type {?} */ j = 0; j < this.security[i].allowedModes.length; j++) {
                        if (this.security[i].allowedModes[j] === SecurityEnum.Add) {
                            hasAdd = true;
                        }
                        if (this.security[i].allowedModes[j] === SecurityEnum.Update) {
                            hasUpdate = true;
                        }
                        if (this.security[i].allowedModes[j] === securityDeleteStorno) {
                            hasDeleteStorno = true;
                        }
                        if (this.security[i].allowedModes[j] === SecurityEnum.Accept) {
                            hasAccept = true;
                        }
                        if (this.security[i].allowedModes[j] === SecurityEnum.Print) {
                            hasPrint = true;
                        }
                        if (this.security[i].allowedModes[j] === SecurityEnum.Approve) {
                            hasApprove = true;
                        }
                    }
                }
            }
            if (this.options && this.options.hasOwnProperty('items')) {
                if (!hasAdd) {
                    this.options.items = this.options.items.filter(function (item) { return item.action !== ToolbarAction.Add; });
                }
                if (!hasUpdate) {
                    this.options.items = this.options.items.filter(function (item) { return item.action !== ToolbarAction.Edit; });
                }
                if (!hasDeleteStorno) {
                    this.options.items = this.options.items.filter(function (item) { return item.action !== ToolbarAction.Delete; });
                }
                if (!hasAccept) {
                    this.options.items = this.options.items.filter(function (item) { return item.action !== ToolbarAction.Accept; });
                }
                if (!hasPrint) {
                    this.options.items = this.options.items.filter(function (item) { return item.action !== ToolbarAction.Print; });
                }
                if (!hasApprove) {
                    this.options.items = this.options.items.filter(function (item) { return item.action !== 'odobri'; });
                }
            }
        }
    };
    /**
     * @param {?} options
     * @param {?=} extenstion
     * @return {?}
     */
    PageBase.prototype.setToolbarOptions = function (options, extenstion) {
        if (extenstion != null) {
            options = ToolbarOptions.extend(options, extenstion);
        }
        this.options = options;
        // this.overrideBySecurity();
        ToolbarOptions.populate(options);
        this.toolbarOptionsSubject.next(options);
    };
    Object.defineProperty(PageBase.prototype, "infobarVisible", {
        /**
         * @return {?}
         */
        get: function () {
            return this.infobarVisibleSubject.getValue();
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.infobarVisibleSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageBase.prototype, "infobarDocument", {
        /**
         * @return {?}
         */
        get: function () {
            return this.infobarDocumentSubject.getValue();
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.infobarDocumentSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageBase.prototype, "infobarPodugovor", {
        /**
         * @return {?}
         */
        get: function () {
            return this.infobarPodugovorSubject.getValue();
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.infobarPodugovorSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    PageBase.prototype.onToolbarAction = function (event) {
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PageBase.prototype.onInfoAction = function (event) {
    };
    /**
     * @param {?} identity
     * @return {?}
     */
    PageBase.prototype.setIdentity = function (identity) {
        this.identity = identity;
        this.overrideBySecurity();
    };
    /**
     * @param {?} params
     * @return {?}
     */
    PageBase.prototype.setParams = function (params) {
        this.params = params;
    };
    /**
     * @param {?} isActiveTab
     * @return {?}
     */
    PageBase.prototype.setIsActiveTab = function (isActiveTab) {
        this.isActiveTab = isActiveTab;
    };
    return PageBase;
}());
var MessageStateEnum = {};
MessageStateEnum.Inbox = /** @type {?} */ ('inbox');
MessageStateEnum.Compose = /** @type {?} */ ('compose');
MessageStateEnum.Read = /** @type {?} */ ('read');
MessageStateEnum[MessageStateEnum.Inbox] = "Inbox";
MessageStateEnum[MessageStateEnum.Compose] = "Compose";
MessageStateEnum[MessageStateEnum.Read] = "Read";
var MessagesComponent = /** @class */ (function (_super) {
    __extends(MessagesComponent, _super);
    /**
     * @param {?} _applicationService
     * @param {?} messageService
     * @param {?} applicationService
     * @param {?} authenticationService
     * @param {?} backendService
     * @param {?} notificationService
     */
    function MessagesComponent(_applicationService, messageService, applicationService, authenticationService, backendService, notificationService) {
        var _this = _super.call(this, backendService) || this;
        _this._applicationService = _applicationService;
        _this.messageService = messageService;
        _this.applicationService = applicationService;
        _this.authenticationService = authenticationService;
        _this.backendService = backendService;
        _this.notificationService = notificationService;
        _this.MessageStatusEnum = MessageStatusEnum;
        _this.MessageStateEnum = MessageStateEnum;
        _this.pageCurrent = 1;
        _this.checkedAll = {};
        _this.newMessage = {
            id: null,
            senderUsername: '',
            title: '',
            message: '',
            senderEmail: '',
            recipientsUsername: [''],
            recipientsEmail: [''],
            status: MessageStatusEnum.Sent,
            date: UtilService.formatDate(new Date().toString()),
            messageReplays: [],
            checked: false
        };
        _this.replays = [];
        _this.newTextMessage = '';
        _this.selectedMessage = {
            id: null,
            senderUsername: '',
            title: '',
            message: '',
            senderEmail: '',
            recipientsUsername: [''],
            recipientsEmail: [''],
            status: MessageStatusEnum.Sent,
            date: UtilService.formatDate(new Date().toString()),
            messageReplays: [],
            checked: false
        };
        _this.userEmail = 'john.doe@example.com';
        _this.allUsers = [];
        _this.selectedUsers = [];
        _this.allMessages = [];
        _this.filteredMessages = [];
        return _this;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    MessagesComponent.prototype.page = function (event) {
        this.pageCurrent = event;
        this.recalculatePages();
    };
    /**
     * @param {?} message
     * @return {?}
     */
    MessagesComponent.prototype.checkMessage = function (message) {
        message.checked = !message.checked;
        if (!message.checked) {
            this.checkedAll[this.pageCurrent] = false;
        }
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.unreadCheckedMessages = function () {
        var _this = this;
        var /** @type {?} */ messagesIDs = [];
        for (var /** @type {?} */ i = 0; i < this.filteredMessages.length; i++) {
            if (this.filteredMessages[i].checked) {
                messagesIDs.push(this.filteredMessages[i].id);
            }
        }
        if (messagesIDs.length === 0) {
            return;
        }
        this.messageService.updateStatus(messagesIDs, this.currentUser, MessageStatusEnum.Sent).subscribe(function (data) {
            if (data) {
                if (_this.checkedAll[_this.pageCurrent]) {
                    for (var /** @type {?} */ key in _this.checkedAll) {
                        if (parseInt(key, 0) > _this.pageCurrent && _this.totalPages > 0) {
                            if (_this.checkedAll.hasOwnProperty(key)) {
                                _this.checkedAll[parseInt(key, 0) - 1] = _this.checkedAll[key];
                            }
                            else {
                                _this.checkedAll[parseInt(key, 0) - 1] = false;
                            }
                        }
                    }
                    if (_this.totalPages > 0) {
                        delete _this.checkedAll[_this.totalPages];
                    }
                }
                _this.allMessages = data;
                _this.pageCurrent = 1;
                _this.recalculatePages();
                _this.mailboxState = MessageStateEnum.Inbox;
                if (_this.checkedAll[_this.pageCurrent]) {
                    for (var /** @type {?} */ i = 0; i < _this.filteredMessages.length; i++) {
                        _this.filteredMessages[i].checked = _this.checkedAll[_this.pageCurrent];
                    }
                }
            }
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.deleteCheckedMessages = function () {
        var _this = this;
        var /** @type {?} */ messagesIDs = [];
        for (var /** @type {?} */ i = 0; i < this.filteredMessages.length; i++) {
            if (this.filteredMessages[i].checked) {
                messagesIDs.push(this.filteredMessages[i].id);
            }
        }
        if (messagesIDs.length === 0) {
            return;
        }
        this.messageService.updateStatus(messagesIDs, this.currentUser, MessageStatusEnum.Deleted).subscribe(function (data) {
            if (data) {
                if (_this.checkedAll[_this.pageCurrent]) {
                    for (var /** @type {?} */ key in _this.checkedAll) {
                        if (parseInt(key, 0) > _this.pageCurrent && _this.totalPages > 0) {
                            if (_this.checkedAll.hasOwnProperty(key)) {
                                _this.checkedAll[parseInt(key, 0) - 1] = _this.checkedAll[key];
                            }
                            else {
                                _this.checkedAll[parseInt(key, 0) - 1] = false;
                            }
                        }
                    }
                    if (_this.totalPages > 0) {
                        delete _this.checkedAll[_this.totalPages];
                    }
                }
                _this.allMessages = data;
                _this.pageCurrent = 1;
                _this.recalculatePages();
                _this.mailboxState = MessageStateEnum.Inbox;
                if (_this.checkedAll[_this.pageCurrent]) {
                    for (var /** @type {?} */ i = 0; i < _this.filteredMessages.length; i++) {
                        _this.filteredMessages[i].checked = _this.checkedAll[_this.pageCurrent];
                    }
                }
            }
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.deleteSelectedMessage = function () {
        var _this = this;
        this.messageService.updateStatus([this.selectedMessage], this.currentUser, MessageStatusEnum.Deleted).subscribe(function (data) {
            if (data) {
                _this.allMessages = data;
            }
            _this.recalculatePages();
            _this.mailboxState = MessageStateEnum.Inbox;
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @param {?} selected
     * @return {?}
     */
    MessagesComponent.prototype.setMailbox = function (selected) {
        this.mailboxState = selected;
    };
    /**
     * @param {?} message
     * @return {?}
     */
    MessagesComponent.prototype.onMessageOpen = function (message) {
        this.selectedMessage = message;
        if (this.selectedMessage.messageReplays.length === 0) {
            this.selectedMessage.status = MessageStatusEnum.Opened;
        }
        else {
            this.selectedMessage.messageReplays[this.selectedMessage.messageReplays.length - 1].status = MessageStatusEnum.Opened;
        }
        this.replays = [];
        for (var /** @type {?} */ i = 0; i < message.recipientsUsername.length; i++) {
            this.replays.push({
                username: message.recipientsUsername[i]
            });
        }
        for (var /** @type {?} */ i = 0; i < message.recipientsEmail.length; i++) {
            this.replays[i]['email'] = message.recipientsEmail[i];
            this.replays[i]['newMessage'] = '';
            this.replays[i]['messages'] = [];
            for (var /** @type {?} */ j = 0; j < message.messageReplays.length; j++) {
                if (message.messageReplays[j].recipientUsername === this.replays[i]['username'] ||
                    message.messageReplays[j].senderUsername === this.replays[i]['username']) {
                    this.replays[i]['messages'].push({
                        'message': message.messageReplays[j].message,
                        'date': message.messageReplays[j].date,
                        'email': message.messageReplays[j].senderEmail,
                        'username': message.messageReplays[j].senderUsername
                    });
                }
            }
        }
        this.setMailbox(MessageStateEnum.Read);
    };
    /**
     * @param {?} message
     * @return {?}
     */
    MessagesComponent.prototype.openMessage = function (message) {
        var _this = this;
        this.onMessageOpen(message);
        this.messageService.updateStatus([this.selectedMessage.id], this.currentUser, MessageStatusEnum.Opened).subscribe(function (data) {
            if (data) {
                _this.allMessages = data;
                for (var /** @type {?} */ i = 0; i < _this.allMessages.length; i++) {
                    if (_this.allMessages[i].id === message.id) {
                        _this.selectedMessage = _this.allMessages[i];
                    }
                }
                _this.recalculatePages();
            }
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.checkAll = function () {
        if (!this.checkedAll.hasOwnProperty(this.pageCurrent)) {
            this.checkedAll[this.pageCurrent] = true;
        }
        else {
            this.checkedAll[this.pageCurrent] = !this.checkedAll[this.pageCurrent];
        }
        for (var /** @type {?} */ i = 0; i < this.filteredMessages.length; i++) {
            this.filteredMessages[i].checked = this.checkedAll[this.pageCurrent];
        }
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.newEmptyMessage = function () {
        if (this.newMessage.hasOwnProperty('id')) {
            delete this.newMessage['id'];
        }
        this.newMessage.recipientsUsername = [''];
        this.newMessage.recipientsEmail = [''];
        this.newMessage.message = '';
        this.newMessage.title = '';
        this.newMessage.status = MessageStatusEnum.Sent;
        this.newMessage.date = UtilService.formatDate(new Date().toString());
        this.mailboxState = MessageStateEnum.Compose;
        this.selectedUsers = [];
    };
    /**
     * @param {?} replay
     * @return {?}
     */
    MessagesComponent.prototype.sendReply = function (replay) {
        var _this = this;
        var /** @type {?} */ recipientEmail = this.selectedMessage.senderEmail;
        var /** @type {?} */ recipientUsername = this.selectedMessage.senderUsername;
        if (this.currentUser.username === this.selectedMessage.senderUsername) {
            recipientEmail = this.selectedMessage.recipientsEmail[0];
            recipientUsername = this.selectedMessage.recipientsUsername[0];
        }
        if (typeof replay === 'undefined') {
            replay = {
                email: recipientEmail,
                username: recipientUsername,
                newMessage: this.newTextMessage
            };
        }
        var /** @type {?} */ reply = {
            id: null,
            parentMessageId: this.selectedMessage.id,
            senderUsername: this.currentUser.username,
            senderEmail: this.currentUser.email,
            recipientUsername: recipientUsername,
            recipientEmail: recipientEmail,
            message: replay.newMessage,
            status: MessageStatusEnum.Sent,
            date: UtilService.formatDate(new Date().toString())
        };
        this.messageService.createReply(reply, this.currentUser).subscribe(function (data) {
            if (data) {
                _this.notificationService.openNoty('Poruka poslata');
                _this.mailboxState = MessageStateEnum.Inbox;
                _this.allMessages = data;
                _this.recalculatePages();
            }
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.send = function () {
        var _this = this;
        var /** @type {?} */ mail;
        mail = this.newMessage;
        mail.checked = false;
        mail.senderUsername = this.currentUser.username;
        mail.senderEmail = this.currentUser.email;
        mail.date = UtilService.formatDate(new Date().toString());
        delete mail['checked'];
        var /** @type {?} */ usersEmails = this.selectedUsers.map(function (item) { return item.display; });
        var /** @type {?} */ usersNames = this.selectedUsers.map(function (item) { return item.value; });
        mail.recipientsEmail = usersEmails;
        mail.recipientsUsername = usersNames;
        mail.status = MessageStatusEnum.Sent;
        if (mail.recipientsEmail.length === 0) {
            this.notificationService.openNoty('Pošiljalac je obavezan!');
            return;
        }
        this.messageService.create(mail, this.currentUser).subscribe(function (data) {
            if (data) {
                _this.notificationService.openNoty('Poruka poslata');
                _this.allMessages = data;
            }
            _this.recalculatePages();
            _this.mailboxState = MessageStateEnum.Inbox;
            _this.checkedAll[_this.totalPages] = false;
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.recalculatePages = function () {
        this.totalPages = Math.ceil(this.allMessages.length / 10);
        var /** @type {?} */ from = (this.pageCurrent - 1) * 10;
        this.filteredMessages = this.allMessages.slice(from, 10 * this.pageCurrent);
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.registerHandlers = function () {
        var _this = this;
        this.unsubscribeListeners();
        this.messagesSubscription = this.messageService.messageLeftEvent.subscribe(function (data) {
            if (data) {
                _this.allMessages = data;
                _this.recalculatePages();
            }
            _this.recalculatePages();
        }, function (error) {
        });
        this.messageStatusSubscription = this.messageService.messageStatusEvent.subscribe(function (messageID) {
            var /** @type {?} */ message = _this.allMessages.filter(function (item) { return item.id === messageID; })[0];
            _this.onMessageOpen(message);
        }, function (error) {
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    MessagesComponent.prototype.openedFromOtherTab = function (params) {
        var _this = this;
        if (params !== null) {
            setTimeout(function () {
                _this.mailboxState = params.messageState;
            }, 0);
        }
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentUser = this.authenticationService.getUser();
        var /** @type {?} */ params = (this.params);
        if (params !== null) {
            this.mailboxState = params.messageState;
        }
        else {
            this.mailboxState = MessageStateEnum.Inbox;
        }
        this.tabSwitchSubscription = this.applicationService.tabSwitchEvent.subscribe(function (data) {
            if (data.params && data.identity.documentType === _this.identity.documentType) {
                _this.openedFromOtherTab(data.params);
            }
        });
        this._applicationService.openMessageModeEvent.subscribe(function (mode) {
            _this.setMailbox(mode);
        });
        this._applicationService.openMessageEvent.subscribe(function (msg) {
            _this.openMessage(msg);
        });
        this.messageService.getAllUsers().subscribe(function (data) {
            if (data) {
                _this.allUsers = [];
                for (var /** @type {?} */ i = 0; i < data.length; i++) {
                    if (data[i].email && data[i].korisnickoIme && data[i].korisnickoIme !== _this.currentUser.username) {
                        _this.allUsers.push({ display: data[i].email, value: data[i].korisnickoIme });
                    }
                }
            }
            _this.recalculatePages();
        }, function (error) {
            console.log(error);
        });
        this.allMessages = this.messageService.getMessages();
        if (this.allMessages) {
            this.recalculatePages();
        }
        this.registerHandlers();
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeListeners();
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.unsubscribeListeners = function () {
        if (this.messagesSubscription) {
            this.messagesSubscription.unsubscribe();
        }
        if (this.messageStatusSubscription) {
            this.messageStatusSubscription.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    MessagesComponent.prototype.ngAfterViewInit = function () {
        var /** @type {?} */ params = (this.params);
        if (params !== null && params.newMessage) {
            this.newMessage.recipientsUsername = params.newMessage.recipientsUsername;
            this.newMessage.recipientsEmail = params.newMessage.recipientsEmail;
            this.newMessage.title = params.newMessage.title;
            this.newMessage.message = params.newMessage.message;
            this.selectedUsers.push({ display: params.newMessage.recipientsEmail, value: params.newMessage.recipientsUsername });
        }
    };
    return MessagesComponent;
}(PageBase));
MessagesComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-messages',
                template: "\n      <div class=\"content-frame-body messages-wrapper\">\n          <div class=\"panel panel-default read-wrapper\" *ngIf=\"mailboxState === MessageStateEnum.Inbox\">\n\n              <div class=\"panel-heading\">\n                  <div class=\"pull-left\">\n                      <label class=\"check mail-checkall\">\n                          <div class=\"icheckbox_minimal-grey\" style=\"position: relative;\">\n                              <input type=\"checkbox\" class=\"icheckbox\" [ngModel]=\"checkedAll[pageCurrent]\" (change)=\"checkAll()\">\n                          </div>\n                      </label>\n\n                      <button class=\"btn btn-warning\" (click)=\"unreadCheckedMessages()\">\n                          <span class=\"fa fa-warning\"> </span>\n                          Nepro\u010Ditano\n                      </button>\n\n                      <button class=\"btn btn-danger\" (click)=\"deleteCheckedMessages()\">\n                          <span class=\"fa fa-trash-o\"> </span>\n                          Obri\u0161i\n                      </button>\n                  </div>\n                  <div class=\"pull-right\">\n                      <button class=\"btn btn-info\" (click)=\"newEmptyMessage()\">\n                          <span class=\"fa fa-edit\"> </span>\n                          Nova poruka\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"panel-body mail\">\n                  <div class=\"mail-item mail-info\"\n                       [ngClass]=\"{'mail-unread': email | MessageUnread : currentUser?.username}\"\n                       *ngFor=\"let email of filteredMessages; let i = index\">\n                      <div class=\"mail-checkbox starred\">\n                          <input type=\"checkbox\" class=\"icheckbox\" [ngModel]=\"email.checked\" (ngModelChange)=\"checkMessage(email)\"/>\n                      </div>\n                      <div class=\"mail-star\">\n                          <!-- starred -->\n                          <span class=\"fa fa-star-o\"></span>\n                      </div>\n                      <div class=\"inbox-clickable\" (click)=\"openMessage(email)\">\n                          <div class=\"mail-user\">{{email.senderUsername}}</div>\n                          <span class=\"mail-text\">{{email.title}}</span>\n                          <div class=\"mail-date\">{{email.date}}</div>\n                      </div>\n                  </div>\n\n              </div>\n              <div class=\"panel-footer\">\n                  <util-pagination class=\"pull-right\"\n                                   *ngIf=\"filteredMessages\"\n                                   [pageCurrent]=\"pageCurrent\"\n                                   [pageTotal]=\"totalPages\"\n                                   (page)=\"page($event)\"></util-pagination>\n\n              </div>\n          </div>\n          <div class=\"panel panel-default read-wrapper\" *ngIf=\"mailboxState === MessageStateEnum.Read && openMessage\">\n              <div class=\"panel-heading\">\n                  <div class=\"pull-left\">\n                      <h3 class=\"panel-title\">Naslov: {{selectedMessage.title}}</h3>\n                  </div>\n                  <div class=\"pull-right\">\n                      <button class=\"btn btn-default\" (click)=\"setMailbox('inbox')\">\n                          <span class=\"fa fa-inbox\"> </span>\n                          Inbox\n                      </button>\n                      <button class=\"btn btn-info\" (click)=\"newEmptyMessage()\">\n                          <span class=\"fa fa-edit\"> </span>\n                          Nova poruka\n                      </button>\n                      <button class=\"btn btn-danger\" (click)=\"deleteSelectedMessage()\">\n                          <span class=\"fa fa-trash-o\"> </span>\n                          Obri\u0161i\n                      </button>\n                  </div>\n              </div>\n              <div class=\"panel-body\">\n                  <!--<img src=\"assets/images/users/user2.jpg\" class=\"panel-title-image\" alt=\"John Doe\"/>-->\n                  <h4>Primalac: {{selectedMessage.recipientsUsername}}\n                      <small>{{selectedMessage.recipientsEmail}}</small>\n                  </h4>\n                  <h4>Po\u0161iljalac: {{selectedMessage.senderUsername}}\n                      <small>{{selectedMessage.senderEmail}}</small>\n                  </h4>\n                  <small class=\"pull-left text-muted\">\n                      {{selectedMessage.senderEmail}}\n                  </small>\n                  <small class=\"pull-right text-muted\">\n                      <span class=\"fa fa-clock-o\"></span> {{selectedMessage.date}}\n                  </small>\n                  <div class=\"panel-body-message\">{{selectedMessage.message}}\n                  </div>\n              </div>\n              <div *ngFor=\"let replay of replays\">\n                  <div class=\"panel-body\">\n                      <div *ngIf=\"replays.length > 1\">\n                          <h4>Korisnik: {{replay.username}}\n                              <small>{{replay.email}}</small>\n                          </h4>\n                      </div>\n                      <div *ngFor=\"let replayMessage of replay.messages\">\n                          <small class=\"pull-left text-muted\">\n                              {{replayMessage.email}}\n                          </small>\n                          <small class=\"pull-right text-muted\">\n                              <span class=\"fa fa-clock-o\"></span> {{replayMessage.date}}\n                          </small>\n                          <div class=\"panel-body-message\">{{replayMessage.message}}\n                          </div>\n                      </div>\n                      <div class=\"form-group push-up-20\">\n                          <label>Brzi odgovor</label>\n                          <textarea class=\"form-control summernote_lite\" rows=\"3\" placeholder=\"Tekst poruke\"\n                                    [(ngModel)]=\"replay.newMessage\"></textarea>\n                      </div>\n                  </div>\n                  <div class=\"panel-footer\">\n                      <button class=\"btn btn-success pull-right\" (click)=\"sendReply(replay)\">\n                          <span class=\"fa fa-mail-reply\"></span>Po\u0161alji\n                      </button>\n                  </div>\n              </div>\n          </div>\n          <div class=\"panel panel-default compose-wrapper\" *ngIf=\"mailboxState === MessageStateEnum.Compose\">\n              <div class=\"panel-heading\">\n                  <div class=\"pull-left\">\n                      <button class=\"btn btn-default\" (click)=\"setMailbox('inbox')\">\n                          <span class=\"fa fa-inbox\"></span>\n                          Inbox\n                      </button>\n                  </div>\n              </div>\n              <div class=\"panel-body\">\n                  <div class=\"form-horizontal\">\n                      <div class=\"form-group\" [hidden]=\"true\">\n                          <label class=\"col-md-2 control-label\">Od:</label>\n                          <div class=\"col-md-10\">\n                              <select class=\"form-control select\">\n                                  <option>{{userEmail}}</option>\n                              </select>\n                          </div>\n                      </div>\n                      <div class=\"form-group\">\n                          <label class=\"col-md-2 control-label\">Za:</label>\n                          <div class=\"col-md-10\">\n                              <tag-input [(ngModel)]=\"selectedUsers\"\n                                         [placeholder]=\"'dodaj email'\"\n                                         [secondaryPlaceholder]=\"'email'\"\n                                         [onlyFromAutocomplete]=\"true\" theme='minimal'>\n                                  <tag-input-dropdown [autocompleteItems]=\"allUsers\">\n                                      <ng-template let-item=\"item\" let-index=\"index\">\n                                          {{ item.value }}: {{ item.display }}\n                                      </ng-template>\n                                  </tag-input-dropdown>\n                              </tag-input>\n                          </div>\n                      </div>\n                      <div class=\"form-group\">\n                          <label class=\"col-md-2 control-label\">Naslov:</label>\n                          <div class=\"col-md-10\">\n                              <input type=\"text\" class=\"form-control\" [(ngModel)]=\"newMessage.title\"/>\n                          </div>\n                      </div>\n                      <div class=\"form-group\">\n                          <div class=\"col-md-12\">\n                              <label class=\"col-md-2 control-label\">Poruka:</label>\n                              <textarea class=\"summernote_email col-md-10\" [(ngModel)]=\"newMessage.message\"></textarea>\n                          </div>\n                      </div>\n                      <div class=\"form-group\">\n                          <div class=\"col-md-12\">\n                              <div class=\"pull-right\">\n                                  <button class=\"btn btn-success\" (click)=\"send()\">\n                                      <span class=\"fa fa-envelope\"></span>Po\u0161alji\n                                  </button>\n                              </div>\n                          </div>\n                      </div>\n                  </div>\n\n              </div>\n          </div>\n\n\n\n          <!-- INBOX -->\n          <!--   <button (click)=\"setMailbox('inbox')\">Inbox</button>\n          <button (click)=\"setMailbox('read')\">Read</button>\n          <button (click)=\"setMailbox('compose')\">Compose</button> -->\n\n\n\n      </div>\n    ",
                styles: ["\n      .messages-wrapper {\n        margin: 2.5%; }\n        .messages-wrapper .panel.panel-default {\n          border: 1px solid rgba(0, 0, 0, 0.1) !important; }\n          .messages-wrapper .panel.panel-default .panel-heading {\n            background: #f5f5f5 !important; }\n          .messages-wrapper .panel.panel-default .panel-footer {\n            background: #f5f5f5 !important; }\n\n      .summernote_email {\n        height: 40vh;\n        border-radius: 6px;\n        border: 1px solid rgba(0, 0, 0, 0.2);\n        font-size: 14px !important; }\n\n      .inbox-clickable {\n        cursor: pointer; }\n\n      .mail-text {\n        width: 250px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        color: #999; }\n\n      .panel.panel-default.read-wrapper .panel-body .panel-body-message {\n        white-space: pre-wrap;\n        line-height: 25px; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
MessagesComponent.ctorParameters = function () { return [
    { type: ApplicationService, },
    { type: MessageService, },
    { type: ApplicationService, },
    { type: AuthenticationService, },
    { type: BackendService, },
    { type: NotificationService, },
]; };
var EmailObject = /** @class */ (function () {
    function EmailObject() {
        this.checked = false;
    }
    return EmailObject;
}());
var OpenTabParamBase = /** @class */ (function () {
    function OpenTabParamBase() {
    }
    return OpenTabParamBase;
}());
var MessagesParams = /** @class */ (function (_super) {
    __extends(MessagesParams, _super);
    /**
     * @param {?} messageState
     * @param {?=} newMessage
     */
    function MessagesParams(messageState, newMessage) {
        var _this = _super.call(this) || this;
        _this.messageState = MessageStateEnum.Inbox;
        _this.messageState = messageState;
        if (newMessage) {
            _this.newMessage = newMessage;
        }
        return _this;
    }
    return MessagesParams;
}(OpenTabParamBase));
var NotificationService = /** @class */ (function () {
    /**
     * @param {?} applicationService
     */
    function NotificationService(applicationService) {
        this.applicationService = applicationService;
    }
    /**
     * @param {?} message
     * @param {?=} timeout
     * @return {?}
     */
    NotificationService.prototype.openNoty = function (message, timeout) {
        if (timeout === void 0) { timeout = true; }
        noty({
            text: message,
            layout: 'center',
            force: true,
            maxVisible: 1,
            dismissQueue: true,
            timeout: this.getInterval(message.length)
        });
    };
    /**
     * Shows a sticky pop-up message to the user with a red background.
     *
     * The "sticky" means that the message will not go away on its own,
     * the user has to confirm (i.e. close) it manually.
     * @param {?} message
     * @return {?}
     */
    NotificationService.prototype.notyError = function (message) {
        noty({
            text: message,
            type: 'error',
            timeout: this.getInterval(message.length),
            closeWith: ['button', 'click'],
            layout: 'center',
            force: true,
            dismissQueue: true
        });
    };
    /**
     * @param {?} messageLength
     * @return {?}
     */
    NotificationService.prototype.getInterval = function (messageLength) {
        return messageLength < 50 ? 3000 : messageLength > 250 ? 20000 : 7000;
    };
    /**
     * @param {?} error
     * @param {?=} message
     * @return {?}
     */
    NotificationService.prototype.notifyError = function (error, message) {
        var _this = this;
        if (error == null ||
            error.error == null ||
            error.error.content == null) {
            return this.openNoty(message);
        }
        noty({
            text: error.error.content +
                '<br><br>Da li želite da prijavite grešku administratoru?',
            layout: 'center',
            force: true,
            maxVisible: 1,
            buttons: [
                {
                    addClass: 'btn btn-primary',
                    text: 'Da',
                    onClick: function ($noty) {
                        $noty.close();
                        _this.showErrorMessage(error.error);
                    }
                },
                {
                    addClass: 'btn btn-danger',
                    text: 'Ne',
                    onClick: function ($noty) {
                        $noty.close();
                    }
                }
            ]
        });
    };
    /**
     * @param {?} error
     * @return {?}
     */
    NotificationService.prototype.showErrorMessage = function (error) {
        var /** @type {?} */ errorMessage = new EmailObject();
        errorMessage.recipientsUsername = ['admin'];
        errorMessage.recipientsEmail = ['admin@example.com'];
        errorMessage.title = 'Greška: ' + error.content;
        errorMessage.message = error.additionalDescription;
        var /** @type {?} */ params = new MessagesParams(MessageStateEnum.Compose, errorMessage);
        this.applicationService.openTab(new OpenTabData('Messages', 'Messages', DocumentTypeEnum.Sifarnik, 'Messages', 'Poruke', MessagesComponent, params));
    };
    return NotificationService;
}());
NotificationService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NotificationService.ctorParameters = function () { return [
    { type: ApplicationService, },
]; };
var BackendService = /** @class */ (function () {
    /**
     * @param {?} http
     * @param {?} notificationService
     * @param {?} authenticationService
     */
    function BackendService(http$$1, notificationService, authenticationService) {
        this.http = http$$1;
        this.notificationService = notificationService;
        this.authenticationService = authenticationService;
        this.settingsLoadedForOrders = new EventEmitter(); // TODO: Rework, probably move to application service or similar
        this.settingsChanged = new EventEmitter();
        this.orderList = [];
        this.order = {};
        this.settings = [];
        this.columnsSizes = new Map();
        this.columnsOrders = [];
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json;charset=utf-8'
        });
    }
    /**
     * @return {?}
     */
    BackendService.prototype.getColumnsSizes = function () {
        return this.columnsSizes;
    };
    /**
     * @return {?}
     */
    BackendService.prototype.getColumnsOrders = function () {
        return this.columnsOrders;
    };
    /**
     * @return {?}
     */
    BackendService.prototype.getSecurity = function () {
        return this.security;
    };
    /**
     * @return {?}
     */
    BackendService.prototype.getLabSecurity = function () {
        return this.labSecurity;
    };
    /**
     * @param {?} group
     * @return {?}
     */
    BackendService.prototype.getSettings = function (group) {
        return this.settings[group];
    };
    /**
     * @return {?}
     */
    BackendService.prototype.getOrderList = function () {
        return this.orderList;
    };
    /**
     * @return {?}
     */
    BackendService.prototype.getOrder = function () {
        return this.order;
    };
    /**
     * @param {?} data
     * @param {?} message
     * @return {?}
     */
    BackendService.prototype.isStatusOk = function (data, message) {
        if ((data && data.hasOwnProperty('status') && data.status !== 200 && !Number.isNaN(data.status)) &&
            data.hasOwnProperty('message')) {
            this.notificationService.openNoty(message);
            return false;
        }
        else {
            return true;
        }
    };
    /**
     * @param {?} documentId
     * @param {?} order
     * @param {?} user
     * @return {?}
     */
    BackendService.prototype.addOrder = function (documentId, order, user) {
        var _this = this;
        order['korisnik'] = user;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'sifarnik': order
        };
        return this.http.post(environment.apiRemoteUrlApi + 'api/addSifarnik', params, { headers: this.headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dodavanju')) {
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dodavanju');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} vrstaDokumenta
     * @param {?} order
     * @param {?} user
     * @return {?}
     */
    BackendService.prototype.addDocument = function (documentId, vrstaDokumenta, order, user) {
        var _this = this;
        order['vrstaDokumenta'] = vrstaDokumenta;
        order['korisnik'] = user;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'vrstaDokumenta': vrstaDokumenta,
            'dokument': order
        };
        return this.http.post(environment.apiRemoteUrlApi + 'doc/add', params, { headers: this.headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dodavanju')) {
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dodavanju');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} vrstaDokumenta
     * @param {?} orderId
     * @param {?} user
     * @return {?}
     */
    BackendService.prototype.fetchDocument = function (documentId, vrstaDokumenta, orderId, user) {
        var _this = this;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'vrstaDokumenta': vrstaDokumenta,
            'dokument': {
                'vrstaDokumenta': vrstaDokumenta,
                'id': orderId,
                'korisnik': user
            }
        };
        return this.http.post(environment.apiRemoteUrlApi + 'doc/get', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška')) {
                _this.order = data;
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} orderId
     * @param {?} user
     * @return {?}
     */
    BackendService.prototype.fetchOrder = function (documentId, orderId, user) {
        var _this = this;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'sifarnik': {
                'id': orderId,
                'korisnik': user
            }
        };
        return this.http.post(environment.apiRemoteUrlApi + 'api/getSifarnikOnly', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška')) {
                _this.order = data;
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} order
     * @param {?} user
     * @return {?}
     */
    BackendService.prototype.editOrder = function (documentId, order, user) {
        var _this = this;
        order['korisnik'] = user;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'sifarnik': order
        };
        return this.http.put(environment.apiRemoteUrlApi + 'api/editSifarnik', params, { headers: this.headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri editovanju')) {
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri editovanju');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} vrstaDokumenta
     * @param {?} order
     * @param {?} user
     * @return {?}
     */
    BackendService.prototype.editDocument = function (documentId, vrstaDokumenta, order, user) {
        var _this = this;
        order['vrstaDokumenta'] = vrstaDokumenta;
        order['korisnik'] = user;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'vrstaDokumenta': vrstaDokumenta,
            'dokument': order
        };
        return this.http.put(environment.apiRemoteUrlApi + 'doc/update', params, { headers: this.headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri editovanju')) {
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri editovanju');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} vrstaDokumenta
     * @param {?} order
     * @param {?} user
     * @return {?}
     */
    BackendService.prototype.deleteDocument = function (documentId, vrstaDokumenta, order, user) {
        var _this = this;
        order['vrstaDokumenta'] = vrstaDokumenta;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'vrstaDokumenta': vrstaDokumenta,
            'dokument': order,
            'korisnik': user
        };
        return this.http.put(environment.apiRemoteUrlApi + 'doc/cancel', params, { headers: this.headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri storniranju dokumenta')) {
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} vrstaDokumenta
     * @param {?} order
     * @param {?} user
     * @return {?}
     */
    BackendService.prototype.acceptDocument = function (documentId, vrstaDokumenta, order, user) {
        var _this = this;
        order['vrstaDokumenta'] = vrstaDokumenta;
        order['korisnik'] = user;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'vrstaDokumenta': vrstaDokumenta,
            'dokument': order
        };
        return this.http.put(environment.apiRemoteUrlApi + 'doc/accept', params, { headers: this.headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri prihvatanju')) {
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri prihvatanju');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} orderId
     * @param {?} user
     * @return {?}
     */
    BackendService.prototype.deleteOrder = function (documentId, orderId, user) {
        var _this = this;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'sifarnik': {
                'id': orderId,
                'korisnik': user
            }
        };
        return this.http.post(environment.apiRemoteUrlApi + 'api/deleteSifarnik', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri brisanju šifrarnika')) {
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} tableActionFilterParams
     * @param {?=} menuCalled
     * @return {?}
     */
    BackendService.prototype.fetchOrderListWithFilter = function (documentId, tableActionFilterParams, menuCalled) {
        if (menuCalled === void 0) { menuCalled = false; }
        return this.fetchOrderList(documentId, tableActionFilterParams ? tableActionFilterParams.filterCombined : null, tableActionFilterParams ? tableActionFilterParams.pageCurrent : null, tableActionFilterParams ? tableActionFilterParams.rowsOnPage : null, tableActionFilterParams ? tableActionFilterParams.sortOrder : null, tableActionFilterParams ? tableActionFilterParams.direction : null, tableActionFilterParams ? tableActionFilterParams.relations : null, menuCalled);
    };
    /**
     * TODO Explain this method and its parameters.
     *
     * @param {?} documentId
     * @param {?} filter
     * @param {?} page
     * @param {?} rowsOnPage
     * @param {?} sort
     * @param {?} direction
     * @param {?} relations
     * @param {?=} menuCalled
     * @return {?}
     */
    BackendService.prototype.fetchOrderList = function (documentId, filter, page, rowsOnPage, sort, direction, relations, menuCalled) {
        var _this = this;
        if (menuCalled === void 0) { menuCalled = false; }
        var /** @type {?} */ params = {
            'documentId': documentId,
            'menuCalled': menuCalled
        };
        if (rowsOnPage !== null) {
            params['pageSize'] = rowsOnPage + '';
        }
        if (page !== null) {
            params['pageNumber'] = page + '';
        }
        if (filter) {
            params['filterWrapper'] = filter;
        }
        // TODO Refactor `fetchOrderList` and `fetchDocumentList` into a single method that accepts the URL and payload/body parameters.
        if (sort != null && Object.keys(sort).length > 0) {
            var /** @type {?} */ fullPath = UtilService.getFieldFullPath(sort, relations);
            // DO NOT reorder the following two lines.
            var /** @type {?} */ propertyName = fullPath.pop();
            var /** @type {?} */ beanName = fullPath.join('.');
            params.sortWrapper = [{
                    'beanName': beanName,
                    'propertyName': propertyName,
                    'sortType': direction === 'asc' ? 0 : 1
                }];
        }
        return this.http.post(environment.apiRemoteUrlApi + 'api/getSifarnik', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobavljanju podataka')) {
                _this.orderList = data.result;
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobavljanju podataka');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} vrstaDocumenta
     * @param {?} tableActionFilterParams
     * @param {?=} menuCalled
     * @return {?}
     */
    BackendService.prototype.fetchDocumentListWithFilter = function (documentId, vrstaDocumenta, tableActionFilterParams, menuCalled) {
        if (menuCalled === void 0) { menuCalled = false; }
        return this.fetchDocumentList(documentId, vrstaDocumenta, tableActionFilterParams ? tableActionFilterParams.filterCombined : null, tableActionFilterParams ? tableActionFilterParams.pageCurrent : null, tableActionFilterParams ? tableActionFilterParams.rowsOnPage : null, tableActionFilterParams ? tableActionFilterParams.sortOrder : null, tableActionFilterParams ? tableActionFilterParams.direction : null, tableActionFilterParams ? tableActionFilterParams.relations : null, menuCalled);
    };
    /**
     * TODO Explain this method and its parameters.
     *
     * @param {?} documentId
     * @param {?} vrstaDocumenta
     * @param {?} filter
     * @param {?} page
     * @param {?} rowsOnPage
     * @param {?} sort
     * @param {?} direction
     * @param {?} relations
     * @param {?=} menuCalled
     * @return {?}
     */
    BackendService.prototype.fetchDocumentList = function (documentId, vrstaDocumenta, filter, page, rowsOnPage, sort, direction, relations, menuCalled) {
        var _this = this;
        if (menuCalled === void 0) { menuCalled = false; }
        var /** @type {?} */ username = this.authenticationService.getUser().username;
        var /** @type {?} */ params = {
            'vrstaDokumenta': vrstaDocumenta,
            'documentId': documentId,
            'menuCalled': menuCalled,
            korisnik: username
        };
        if (rowsOnPage !== null) {
            // TODO Does it really have to be string?!
            params.pageSize = rowsOnPage + '';
        }
        if (page !== null) {
            // TODO Does it really have to be string?!
            params.pageNumber = page + '';
        }
        if (filter) {
            params.filterWrapper = filter;
        }
        if (sort != null && Object.keys(sort).length > 0) {
            var /** @type {?} */ fullPath = UtilService.getFieldFullPath(sort, relations);
            // DO NOT reorder the following two lines.
            var /** @type {?} */ propertyName = fullPath.pop();
            var /** @type {?} */ beanName = fullPath.join('.');
            params.sortWrapper = [{
                    'beanName': beanName,
                    'propertyName': propertyName,
                    'sortType': direction === 'asc' ? 0 : 1
                }];
        }
        return this.http.post(environment.apiRemoteUrlApi + 'doc/find', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobavljanju podataka')) {
                _this.orderList = data.result;
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobavljanju podataka');
        });
    };
    /**
     * @param {?} vrstaDokumenta
     * @return {?}
     */
    BackendService.prototype.fetchSettingsForDocumentType = function (vrstaDokumenta) {
        var _this = this;
        return this.http.get(environment.apiRemoteUrlApi + 'api/settings?vrstaDokumenta=' + vrstaDokumenta).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobavljanju podešavanja')) {
                _this.settings[vrstaDokumenta] = data;
                _this.settingsLoadedForOrders.emit(data);
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobavljanju podešavanja');
        });
    };
    /**
     * @param {?} username
     * @param {?} documentId
     * @return {?}
     */
    BackendService.prototype.fetchSettingForOrders = function (username, documentId) {
        var _this = this;
        var /** @type {?} */ headers = new HttpHeaders({
            'Content-Type': 'application/json;charset=utf-8',
            'X-User': username
        });
        return this.http.get(environment.apiRemoteUrlApi + 'api/settings/' + documentId, { headers: headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobavljanju podešavanja')) {
                _this.settings[documentId] = data;
                _this.settingsLoadedForOrders.emit(data);
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobavljanju podešavanja');
        });
    };
    /**
     * @param {?} username
     * @param {?} params
     * @param {?} reorder
     * @param {?} documentId
     * @return {?}
     */
    BackendService.prototype.saveSettings = function (username, params, reorder, documentId) {
        var _this = this;
        var /** @type {?} */ headers = new HttpHeaders({
            'Content-Type': 'application/json;charset=utf-8',
            'X-User': username
        });
        return this.http.put(environment.apiRemoteUrlApi + 'api/settings/' + documentId, params, { headers: headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri čuvanju')) {
                _this.settings[documentId] = data[0];
                if (!reorder) {
                    _this.fetchSettingForOrders(username, documentId);
                }
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri čuvanju');
        });
    };
    /**
     * @param {?} username
     * @param {?} params
     * @param {?} documentId
     * @return {?}
     */
    BackendService.prototype.addSettings = function (username, params, documentId) {
        var _this = this;
        var /** @type {?} */ headers = new HttpHeaders({
            'Content-Type': 'application/json;charset=utf-8',
            'X-User': username
        });
        return this.http.post(environment.apiRemoteUrlApi + 'api/settings/' + documentId, params, { headers: headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dodavanju')) {
                _this.settings[documentId] = data;
                _this.settingsLoadedForOrders.emit(_this.settings[documentId]);
                _this.settingsChanged.emit(data[0]);
                _this.fetchSettingForOrders(username, documentId);
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dodavanju');
        });
    };
    /**
     * @param {?} username
     * @param {?} reorder
     * @param {?} documentId
     * @return {?}
     */
    BackendService.prototype.deleteSettings = function (username, reorder, documentId) {
        var _this = this;
        var /** @type {?} */ headers = new HttpHeaders({
            'Content-Type': 'application/json;charset=utf-8',
            'X-User': username
        });
        return this.http.delete(environment.apiRemoteUrlApi + 'api/settings/' + documentId, { headers: headers }).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri brisanju')) {
                _this.settings[documentId][0] = data;
                _this.settingsLoadedForOrders.emit(_this.settings[documentId]);
                if (!reorder) {
                    _this.settingsChanged.emit(data);
                    _this.fetchSettingForOrders(username, documentId);
                }
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri brisanju');
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    BackendService.prototype.getMenu = function (params) {
        var _this = this;
        return this.http.post(environment.apiRemoteUrlApi + 'control/getMeni', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobijanju menija')) {
                _this.menu = data;
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobijanju menija');
        });
    };
    /**
     * @param {?} name
     * @return {?}
     */
    BackendService.prototype.getParametar = function (name) {
        var _this = this;
        return this.http.get(environment.apiRemoteUrlApi + 'api/parameters?name=' + name).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobijanju parametra')) {
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobijanju parametra');
        });
    };
    /**
     * @param {?} username
     * @return {?}
     */
    BackendService.prototype.getMisUser = function (username) {
        var _this = this;
        return this.http.get(environment.apiRemoteUrlApi + 'api/misuser?username=' + username).do(function (data) {
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobavljanju korisnika');
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    BackendService.prototype.getParametriKorisnika = function (params) {
        var _this = this;
        return this.http.post(environment.apiRemoteUrlApi + 'api/getParametriKorisnika', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobijanju security podataka')) {
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobijanju security podataka');
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    BackendService.prototype.loadSecurity = function (params) {
        var _this = this;
        return this.http.post(environment.apiRemoteUrlApi + 'control/getSecurity', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobijanju security-ja')) {
                _this.menu = data;
                _this.security = data;
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobijanju security-ja');
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    BackendService.prototype.loadLabSecurity = function (params) {
        var _this = this;
        return this.http.post(environment.apiRemoteUrlApi + 'control/getLabSecurity', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobijanju security-ja za laboratorije')) {
                _this.menu = data;
                _this.labSecurity = data;
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobijanju security-ja za laboratorije');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} tableActionFilterParams
     * @param {?} actionName
     * @return {?}
     */
    BackendService.prototype.fetchIzvestajiWithFilter = function (documentId, tableActionFilterParams, actionName) {
        return this.fetchIzvestaji(tableActionFilterParams.pageCurrent, documentId, tableActionFilterParams.filterObjects, tableActionFilterParams.rowsOnPage, tableActionFilterParams.sortOrder, tableActionFilterParams.direction, tableActionFilterParams.relations, actionName);
    };
    /**
     * @param {?} page
     * @param {?} documentId
     * @param {?} filterObjects
     * @param {?} rowsOnPage
     * @param {?} sort
     * @param {?} direction
     * @param {?} relations
     * @param {?} actionName
     * @return {?}
     */
    BackendService.prototype.fetchIzvestaji = function (page, documentId, filterObjects, rowsOnPage, sort, direction, relations, actionName) {
        var _this = this;
        var /** @type {?} */ beanName = documentId;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'pageSize': rowsOnPage + '',
            'pageNumber': page + '',
            'actionName': actionName + ''
        };
        if (typeof filterObjects !== 'undefined' && filterObjects.length > 0) {
            var /** @type {?} */ filterObjectsMapped = filterObjects.map(function (propertyItem) {
                var /** @type {?} */ path = propertyItem.path;
                if (propertyItem.type === FieldTypeEnum.Completer || propertyItem.type === FieldTypeEnum.Combo) {
                    for (var /** @type {?} */ j = 0; j < propertyItem['fieldMapItem'].relationValue.withoutLast.length; j++) {
                        path = propertyItem.path + '.' + propertyItem['fieldMapItem'].relationValue.withoutLast[j].charAt(0).toUpperCase() +
                            propertyItem['fieldMapItem'].relationValue.withoutLast[j].slice(1);
                    }
                    if (propertyItem['fieldMapItem'].relation.completerMainAndSecond) {
                        for (var /** @type {?} */ j = 0; j < propertyItem['fieldMapItem'].relationKey.withoutLast.length; j++) {
                            path = propertyItem.path + '.' + propertyItem['fieldMapItem'].relationKey.withoutLast[j].charAt(0).toUpperCase() +
                                propertyItem['fieldMapItem'].relationKey.withoutLast[j].slice(1);
                        }
                    }
                }
                return new ServiceFilterSymbol(path, propertyItem.name, propertyItem.operation, propertyItem.value);
            });
            params['filterWrapper'] = new ServiceFilterTerm(ServiceFilterOperandEnum.AND, filterObjectsMapped).generateResult().prepareForService();
        }
        if (typeof sort !== 'undefined' && Object.keys(sort).length > 0) {
            if (direction === 'asc') {
                direction = 0;
            }
            else {
                direction = 1;
            }
            var /** @type {?} */ relation = void 0;
            for (var /** @type {?} */ i = 0; i < relations.length; i++) {
                if (relations[i].group === sort.fieldName) {
                    relation = relations[i];
                }
            }
            if (typeof relation !== 'undefined') {
                var /** @type {?} */ completerSecondFieldParts = relation.completerSecondField.split('.');
                var /** @type {?} */ firstParts = completerSecondFieldParts[completerSecondFieldParts.length - 1];
                var /** @type {?} */ lastParts = beanName + '.' + relation.group;
                for (var /** @type {?} */ i = 0; i < completerSecondFieldParts.length; i++) {
                    if (completerSecondFieldParts.length > 1) {
                        if (i !== completerSecondFieldParts.length - 1) {
                            lastParts = lastParts + '.' + completerSecondFieldParts[i];
                        }
                    }
                }
                params['sortWrapper'] = [
                    {
                        'propertyName': firstParts,
                        'sortType': direction,
                        'beanName': lastParts,
                    }
                ];
            }
            else {
                params['sortWrapper'] = [
                    {
                        'propertyName': sort.fieldName,
                        'sortType': direction,
                        'beanName': beanName
                    }
                ];
            }
        }
        if (params.hasOwnProperty('filterWrapper')) {
            params['filterWrapper'] = params['filterWrapper'].filter(function (item) { return item.name !== 'kontrolni'; });
            var /** @type {?} */ filterWrapper = [];
            for (var /** @type {?} */ i = 0; i < params['filterWrapper'].length; i++) {
                if (params['filterWrapper'][i].propertyName !== 'kontrolni') {
                    filterWrapper.push(params['filterWrapper'][i]);
                }
                if (params['filterWrapper'][i].propertyName === 'datum') {
                    if (params['filterWrapper'][i].operand === '<=') {
                        params['filterWrapper'][i].name = 'datumDo';
                    }
                    else {
                        params['filterWrapper'][i].name = 'datumOd';
                    }
                }
            }
            params['filterWrapper'] = filterWrapper;
        }
        return this.http.post(environment.apiRemoteUrlApi + 'api/getIzvestaj', params).do(function (data) {
            if (_this.isStatusOk(data, 'Desila se neočekivana greška pri dobavljanju podataka')) {
                _this.orderList = data.result;
            }
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobavljanju podataka');
        });
    };
    /**
     * @param {?} callParams
     * @param {?} tableActionFilterParams
     * @return {?}
     */
    BackendService.prototype.executeCustomActionOrderWithFilter = function (callParams, tableActionFilterParams) {
        var _this = this;
        var /** @type {?} */ page = tableActionFilterParams.pageCurrent;
        var /** @type {?} */ filterObjects = tableActionFilterParams.filterObjects;
        var /** @type {?} */ rowsOnPage = tableActionFilterParams.rowsOnPage;
        var /** @type {?} */ sort = tableActionFilterParams.sortOrder;
        var /** @type {?} */ direction = tableActionFilterParams.direction;
        var /** @type {?} */ relations = tableActionFilterParams.relations;
        var /** @type {?} */ params = {
            'parts': {
                'documentId': callParams.documentId,
                'action': callParams.action,
                'korisnik': callParams.user
            }
        };
        if (typeof filterObjects !== 'undefined' && filterObjects.length > 0) {
            var /** @type {?} */ filterObjectsMapped = filterObjects.map(function (propertyItem) {
                var /** @type {?} */ path = propertyItem.path;
                if (propertyItem.type === FieldTypeEnum.Completer || propertyItem.type === FieldTypeEnum.Combo) {
                    for (var /** @type {?} */ j = 0; j < propertyItem['fieldMapItem'].relationValue.withoutLast.length; j++) {
                        path = propertyItem.path + '.' + propertyItem['fieldMapItem'].relationValue.withoutLast[j].charAt(0).toUpperCase() +
                            propertyItem['fieldMapItem'].relationValue.withoutLast[j].slice(1);
                    }
                    if (propertyItem['fieldMapItem'].relation.completerMainAndSecond) {
                        for (var /** @type {?} */ j = 0; j < propertyItem['fieldMapItem'].relationKey.withoutLast.length; j++) {
                            path = propertyItem.path + '.' + propertyItem['fieldMapItem'].relationKey.withoutLast[j].charAt(0).toUpperCase() +
                                propertyItem['fieldMapItem'].relationKey.withoutLast[j].slice(1);
                        }
                    }
                }
                return new ServiceFilterSymbol(path, propertyItem.name, propertyItem.operation, propertyItem.value);
            });
            params['parts']['FilterData'] = new ServiceFilterTerm(ServiceFilterOperandEnum.AND, filterObjectsMapped).generateResult().prepareForService();
        }
        if (typeof sort !== 'undefined' && Object.keys(sort).length > 0) {
            if (direction === 'asc') {
                direction = 0;
            }
            else {
                direction = 1;
            }
            var /** @type {?} */ relation = void 0;
            for (var /** @type {?} */ i = 0; i < relations.length; i++) {
                if (relations[i].group === sort.fieldName) {
                    relation = relations[i];
                }
            }
            if (typeof relation !== 'undefined') {
                var /** @type {?} */ completerSecondFieldParts = relation.completerSecondField.split('.');
                var /** @type {?} */ firstParts = completerSecondFieldParts[completerSecondFieldParts.length - 1];
                var /** @type {?} */ lastParts = callParams.documentId + '.' + relation.group;
                for (var /** @type {?} */ i = 0; i < completerSecondFieldParts.length; i++) {
                    if (completerSecondFieldParts.length > 1) {
                        if (i !== completerSecondFieldParts.length - 1) {
                            lastParts = lastParts + '.' + completerSecondFieldParts[i];
                        }
                    }
                }
                params['parts']['sortWrapper'] = [
                    {
                        'propertyName': firstParts,
                        'sortType': direction,
                        'beanName': lastParts,
                    }
                ];
            }
            else {
                params['parts']['sortWrapper'] = [
                    {
                        'propertyName': sort.fieldName,
                        'sortType': direction,
                        'beanName': callParams.documentId
                    }
                ];
            }
        }
        if (params['parts'].hasOwnProperty('FilterData')) {
            params['parts']['FilterData'] = params['parts']['FilterData'].filter(function (item) { return item.name !== 'kontrolni'; });
            var /** @type {?} */ FilterData = [];
            for (var /** @type {?} */ i = 0; i < params['parts']['FilterData'].length; i++) {
                if (params['parts']['FilterData'][i].propertyName !== 'kontrolni') {
                    FilterData.push(params['parts']['FilterData'][i]);
                }
                if (params['parts']['FilterData'][i].propertyName === 'datum') {
                    if (params['parts']['FilterData'][i].operand === '<=') {
                        params['parts']['FilterData'][i].name = 'datumDo';
                    }
                    else {
                        params['parts']['FilterData'][i].name = 'datumOd';
                    }
                }
            }
            params['parts']['FilterData'] = FilterData;
        }
        if (callParams.additionalParams != null) {
            $.extend(true, params.parts, callParams.additionalParams);
        }
        return this.http.post(environment.apiRemoteUrlApi + 'api/customAction', params, { headers: this.headers }).do(function (data) {
            _this.isStatusOk(data, 'Desila se neočekivana greška pri izvršavanju akcije');
        }, function (error) {
            if (!callParams.suppressErrorMessage) {
                _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri izvršavanju akcije');
            }
        });
    };
    /**
     * @param {?} callParams
     * @return {?}
     */
    BackendService.prototype.executeCustomActionOrder = function (callParams) {
        var _this = this;
        var /** @type {?} */ params = {
            'parts': {
                'documentId': callParams.documentId,
                'action': callParams.action,
                'korisnik': callParams.user
            }
        };
        if (callParams.additionalParams != null) {
            $.extend(true, params.parts, callParams.additionalParams);
        }
        return this.http.post(environment.apiRemoteUrlApi + 'api/customAction', params, { headers: this.headers }).do(function (data) {
            _this.isStatusOk(data, 'Desila se neočekivana greška pri izvršavanju akcije');
        }, function (error) {
            if (!callParams.suppressErrorMessage) {
                _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri izvršavanju akcije');
            }
        });
    };
    /**
     * @param {?} callParams
     * @return {?}
     */
    BackendService.prototype.printPDFCustom = function (callParams) {
        var _this = this;
        var /** @type {?} */ params = {
            'parts': {
                'documentId': callParams.documentId,
                'action': callParams.action,
                'korisnik': callParams.user
            }
        };
        if (callParams.additionalParams != null) {
            $.extend(true, params.parts, callParams.additionalParams);
        }
        return this.http.post(environment.apiRemoteUrlApi + 'api/printPDFCustom', params, { headers: this.headers, responseType: 'blob' }).do(function (data) {
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri izvršavanju akcije');
        });
    };
    /**
     * @param {?} callParams
     * @return {?}
     */
    BackendService.prototype.executeCustomActionDocument = function (callParams) {
        var _this = this;
        var /** @type {?} */ params = {
            'parts': {
                'documentId': callParams.documentId,
                'vd': callParams.documentType,
                'action': callParams.action,
                'korisnik': callParams.user
            }
        };
        if (callParams.additionalParams != null) {
            $.extend(true, params.parts, callParams.additionalParams);
        }
        return this.http.post(environment.apiRemoteUrlApi + 'doc/customAction', params, { headers: this.headers }).do(function (data) {
            _this.isStatusOk(data, 'Desila se neočekivana greška pri izvršavanju akcije');
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri izvršavanju akcije');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} vrstaDokumenta
     * @param {?} id
     * @param {?} user
     * @param {?=} params
     * @return {?}
     */
    BackendService.prototype.printDocument = function (documentId, vrstaDokumenta, id, user, params) {
        var _this = this;
        if (params === void 0) { params = null; }
        var /** @type {?} */ paramsString = '';
        if (params) {
            Object.keys(params)
                .forEach(function eachKey(key) {
                paramsString = '&' + key + '=' + params[key];
            });
        }
        return this.http.get(environment.apiRemoteUrlApi + 'doc/printPDF?documentId=' + documentId + '&vrstaDokumenta=' + vrstaDokumenta
            + '&id=' + id + '&korisnik=' + user + paramsString, { responseType: 'blob' }).do(function (data) {
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri štampanju');
        });
    };
    /**
     * @param {?} documentCode
     * @return {?}
     */
    BackendService.prototype.getPrintTemplate = function (documentCode) {
        var _this = this;
        return this.http.get(environment.apiRemoteUrlApi + 'print/templates?documentCode=' + documentCode).do(function (data) {
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri vraćanju štampi!');
        });
    };
    /**
     * @param {?} documentCode
     * @param {?} documentId
     * @return {?}
     */
    BackendService.prototype.getTemplateFields = function (documentCode, documentId) {
        var _this = this;
        return this.http.get(environment.apiRemoteUrlApi + 'print/fields?documentCode=' + documentCode + '&documentId=' + documentId).do(function (data) {
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri vraćanju štampi!');
        });
    };
    /**
     * @param {?} documentId
     * @param {?} vrstaDokumenta
     * @param {?} orderId
     * @param {?} user
     * @param {?} blobId
     * @param {?} opis
     * @return {?}
     */
    BackendService.prototype.printPDF = function (documentId, vrstaDokumenta, orderId, user, blobId, opis) {
        var _this = this;
        var /** @type {?} */ params = {
            'documentId': documentId,
            'vrstaDokumenta': vrstaDokumenta,
            'dokument': {
                'vrstaDokumenta': vrstaDokumenta,
                'id': orderId,
                'korisnik': user
            },
            'blobId': blobId,
            'printName': opis
        };
        return this.http.post(environment.apiRemoteUrlApi + 'print/printPDF', params, { headers: this.headers, responseType: 'blob' }).do(function (data) {
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri izvršavanju akcije');
        });
    };
    Object.defineProperty(BackendService.prototype, "apiUrl", {
        /**
         * The base URL for most of the API (REST) points.
         * @return {?}
         */
        get: function () {
            return environment.apiRemoteUrlApi;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} vrstaDokumenta
     * @param {?} prethodnici
     * @return {?}
     */
    BackendService.prototype.copyPredecessors = function (vrstaDokumenta, prethodnici) {
        var /** @type {?} */ predecessors = prethodnici || [];
        var /** @type {?} */ params = { document: { vrstaDokumenta: vrstaDokumenta } };
        params.predecessors = predecessors.map(function (doc) {
            return {
                vrstaDokumenta: doc.vrstaDokumenta,
                id: doc.id
            };
        });
        return this.http.post(environment.apiRemoteUrlApi + 'doc/copyPredecessors', params);
    };
    /**
     * @param {?} columnsSizes
     * @return {?}
     */
    BackendService.prototype.setColumnsSizes = function (columnsSizes) {
        this.columnsSizes = columnsSizes;
    };
    /**
     * @param {?} columnsOrders
     * @return {?}
     */
    BackendService.prototype.setColumnsOrders = function (columnsOrders) {
        this.columnsOrders = columnsOrders;
    };
    return BackendService;
}());
BackendService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
BackendService.ctorParameters = function () { return [
    { type: HttpClient, },
    { type: NotificationService, },
    { type: AuthenticationService, },
]; };
var TableActionEnum = {};
TableActionEnum.View = /** @type {?} */ ('view');
TableActionEnum.Update = /** @type {?} */ ('update');
TableActionEnum.Delete = /** @type {?} */ ('delete');
TableActionEnum.Filter = /** @type {?} */ ('filter');
TableActionEnum.Add = /** @type {?} */ ('add');
TableActionEnum.Copy = /** @type {?} */ ('copy');
TableActionEnum.Select = /** @type {?} */ ('select');
TableActionEnum.Click = /** @type {?} */ ('click');
TableActionEnum.EditCancel = /** @type {?} */ ('editCancel');
TableActionEnum.Edit = /** @type {?} */ ('edit');
TableActionEnum.AddCustom = /** @type {?} */ ('addCustom');
TableActionEnum.Save = /** @type {?} */ ('save');
TableActionEnum.BeforeSave = /** @type {?} */ ('beforeSave');
TableActionEnum.AddCancel = /** @type {?} */ ('addCancel');
TableActionEnum[TableActionEnum.View] = "View";
TableActionEnum[TableActionEnum.Update] = "Update";
TableActionEnum[TableActionEnum.Delete] = "Delete";
TableActionEnum[TableActionEnum.Filter] = "Filter";
TableActionEnum[TableActionEnum.Add] = "Add";
TableActionEnum[TableActionEnum.Copy] = "Copy";
TableActionEnum[TableActionEnum.Select] = "Select";
TableActionEnum[TableActionEnum.Click] = "Click";
TableActionEnum[TableActionEnum.EditCancel] = "EditCancel";
TableActionEnum[TableActionEnum.Edit] = "Edit";
TableActionEnum[TableActionEnum.AddCustom] = "AddCustom";
TableActionEnum[TableActionEnum.Save] = "Save";
TableActionEnum[TableActionEnum.BeforeSave] = "BeforeSave";
TableActionEnum[TableActionEnum.AddCancel] = "AddCancel";
var TableSettings = /** @class */ (function () {
    /**
     * @param {?} settings
     * @param {?} tableSettingsSection
     */
    function TableSettings(settings, tableSettingsSection) {
        this.relations = [];
        this.fieldList = this.getAllFields(settings);
        this.group = UtilService.lowerCaseStart(settings.group);
        this.inlineAdding = settings.inlineAdding;
        this.inlineEditing = settings.inlineEditing;
        this.listAdditable = settings.additable;
        this.listEditable = settings.editable;
        this.listDeletable = settings.deletable;
        this.listBoxersType = settings.type;
        this.listBoxersId = settings._id;
        this.documentId = settings.group;
        this.listBoxersName = settings.name;
        this.relations = settings.relations;
        this.documentType = settings.documentType;
        this.title = settings.title;
        this.columns = this.getColumnFields(settings.formSettings[tableSettingsSection]);
    }
    /**
     * @param {?} settings
     * @return {?}
     */
    TableSettings.prototype.getColumnFields = function (settings) {
        var /** @type {?} */ retVal = [];
        for (var /** @type {?} */ i = 0; i < settings.length; i++) {
            var /** @type {?} */ fieldData = this.getFieldById(settings[i]);
            if (fieldData != null) {
                retVal.push(fieldData);
            }
        }
        return retVal;
    };
    /**
     * @param {?} settings
     * @return {?}
     */
    TableSettings.prototype.getAllFields = function (settings) {
        var /** @type {?} */ retVal = [];
        for (var /** @type {?} */ i = 0; i < settings.allFields.length; i++) {
            var /** @type {?} */ fieldData = settings.allFields[i];
            var /** @type {?} */ relation = UtilService.findRelation(settings.relations, fieldData.entityType);
            retVal.push(UtilService.getFieldDataSingle(fieldData, relation));
        }
        return retVal;
    };
    /**
     * @param {?} settings
     * @return {?}
     */
    TableSettings.prototype.getTableFields = function (settings) {
        var /** @type {?} */ retVal = [];
        for (var /** @type {?} */ i = 0; i < settings.allFields.length; i++) {
            for (var /** @type {?} */ j = 0; j < settings.formSettings.table.length; j++) {
                if (settings.formSettings.table[j] === settings.allFields[i]['id']) {
                    var /** @type {?} */ fieldData = settings.allFields[i];
                    var /** @type {?} */ relation = UtilService.findRelation(settings.relations, fieldData.entityType);
                    retVal.push(UtilService.getFieldDataSingle(fieldData, relation));
                }
            }
        }
        return retVal;
    };
    /**
     * @param {?} settings
     * @return {?}
     */
    TableSettings.prototype.getLookupTableFields = function (settings) {
        var /** @type {?} */ retVal = [];
        for (var /** @type {?} */ i = 0; i < settings.allFields.length; i++) {
            for (var /** @type {?} */ j = 0; j < settings.formSettings.lookupTable.length; j++) {
                if (settings.formSettings.lookupTable[j] === settings.allFields[i]['id']) {
                    var /** @type {?} */ fieldData = settings.allFields[i];
                    var /** @type {?} */ relation = UtilService.findRelation(settings.relations, fieldData.entityType);
                    retVal.push(UtilService.getFieldDataSingle(fieldData, relation));
                }
            }
        }
        return retVal;
    };
    /**
     * @param {?} fieldName
     * @return {?}
     */
    TableSettings.prototype.getFieldByName = function (fieldName) {
        var /** @type {?} */ results = this.fieldList.filter(function (it) { return it.fieldName === fieldName; });
        if (results.length === 0) {
            return null;
        }
        else {
            return results[0];
        }
    };
    /**
     * @param {?} fieldId
     * @return {?}
     */
    TableSettings.prototype.getFieldById = function (fieldId) {
        var /** @type {?} */ results = this.fieldList.filter(function (it) { return it.id === fieldId; });
        if (results.length === 0) {
            return null;
        }
        else {
            return results[0];
        }
    };
    return TableSettings;
}());
var ModalSettingsComponent = /** @class */ (function () {
    /**
     * @param {?} backendService
     * @param {?} authenticationService
     * @param {?} modalService
     * @param {?} applicationService
     * @param {?} notificationService
     */
    function ModalSettingsComponent(backendService, authenticationService, modalService, applicationService, notificationService) {
        this.backendService = backendService;
        this.authenticationService = authenticationService;
        this.modalService = modalService;
        this.applicationService = applicationService;
        this.notificationService = notificationService;
        this.FormModeEnum = FormModeEnum;
        this.TableModeEnum = TableModeEnum;
        this.title = 'Podešavanja';
        this.mode = FormModeEnum.Table;
        this.panels = [];
        this.settingsAll = [];
        this.componentGuid = UtilService.generateGuid();
    }
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.prepareData = function () {
        var /** @type {?} */ columnsOrders = this.backendService.getColumnsOrders();
        var /** @type {?} */ columnsSizes = this.backendService.getColumnsSizes();
        var /** @type {?} */ sizeChanges = [];
        columnsSizes.forEach(function (value, key) {
            sizeChanges.push({
                id: key,
                size: value
            });
        });
        var /** @type {?} */ params = {};
        var /** @type {?} */ documentId = this.getDocumentId();
        params['changes'] = {};
        params['changes'][documentId] = {
            'fieldsOrder': columnsOrders,
            'sizeChanges': sizeChanges
        };
        return params;
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.addSettingsLayout = function () {
        var _this = this;
        var /** @type {?} */ params = this.prepareData();
        this.backendService.addSettings('test', params, this.getDocumentId()).subscribe(function (data) {
            _this.settingsAll = data;
            _this.notificationService.openNoty('Uspešno dodavanje');
            _this.mode = FormModeEnum.Table;
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.saveSettingsLayout = function () {
        var _this = this;
        var /** @type {?} */ params = this.prepareData();
        this.backendService.saveSettings('test', params, false, this.getDocumentId()).subscribe(function (data) {
            _this.notificationService.openNoty('Uspešno čuvanje');
            _this.mode = FormModeEnum.Table;
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.deleteSettingsLayout = function () {
        var _this = this;
        var /** @type {?} */ params = this.prepareData();
        this.backendService.deleteSettings(this.authenticationService.getUser().username, false, this.getDocumentId()).subscribe(function (data) {
            _this.settingsAll = [];
            _this.notificationService.openNoty('Uspešno brisanje');
            _this.mode = FormModeEnum.Table;
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ModalSettingsComponent.prototype.listTableAction = function (event) {
        switch (event.action) {
            case TableActionEnum.Filter:
                break;
            case TableActionEnum.View:
                this.mode = FormModeEnum.View;
                break;
            case TableActionEnum.Update:
                this.mode = FormModeEnum.View;
                break;
            case TableActionEnum.Add:
                this.mode = FormModeEnum.Add;
                break;
            case TableActionEnum.Delete:
                this.mode = FormModeEnum.Table;
                break;
            case TableActionEnum.Select:
                this.mode = FormModeEnum.View;
                break;
        }
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.getDocumentId = function () {
        return this.applicationService.currentTabIdentity.documentId;
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.settingsLoadSingle = function () {
        var _this = this;
        this.backendService.fetchSettingForOrders(this.authenticationService.getUser().username, this.getDocumentId()).subscribe(function (data) {
            _this.selectedSettings = data[0];
        }, function (error) {
            _this.notificationService.notifyError(error, 'Desila se neočekivana greška pri dobavljanju podešavanja');
        });
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.cancelEdit = function () {
        this.mode = FormModeEnum.View;
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.cancelAddView = function () {
        this.mode = FormModeEnum.Table;
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.confirm = function () {
        if (this.mode === FormModeEnum.Add) {
            this.addSettingsLayout();
        }
        else {
            this.saveSettingsLayout();
        }
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.reject = function () {
        this.mode = FormModeEnum.View;
        this.modalService.closeModal(false);
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.settingsLoadSingle();
        this.settingsLoadedForOrdersSubscription = this.backendService.settingsLoadedForOrders.subscribe(function (data) {
            _this.selectedSettings = data[0];
        });
        if (this.settingsAll != null) {
            for (var /** @type {?} */ i = 0; i < this.settingsAll.length; i++) {
                this.settingsAll[i]['rbr'] = this.settingsAll[i]['id'];
            }
            this.settingsTable = new TableSettings({
                'additable': true,
                'allFields': [{ 'additable': true,
                        'dbType': 'VARCHAR(20)',
                        'editable': true,
                        'fieldKey': 'name',
                        'id': '1',
                        'label': 'Naziv',
                        'mandatory': true,
                        'name': 'name',
                        'path': '',
                        'type': 'input',
                        'width': 'large' }],
                'deletable': false,
                'editable': false,
                'fetchLazy': false,
                'filter': [],
                'formSettings': {
                    'header': [],
                    'table': [
                        '1'
                    ],
                    'lookupTable': []
                },
                'group': 'Main',
                'inlineAdding': false,
                'name': 'Main',
                'title': '',
                'type': DocumentLayoutTypeEnum.Main
            }, 'table');
        }
    };
    /**
     * @return {?}
     */
    ModalSettingsComponent.prototype.ngOnDestroy = function () {
        if (this.settingsLoadedForOrdersSubscription) {
            this.settingsLoadedForOrdersSubscription.unsubscribe();
        }
    };
    return ModalSettingsComponent;
}());
ModalSettingsComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-modal-settings',
                template: "\n      <div class=\"message-box animated fadeIn\" data-sound=\"alert\" id=\"mb-dialog\">\n          <div class=\"mb-container white\" id=\"mb-container-custom\">\n              <div class=\"mb-middle\">\n                  <div class=\"panel panel-default view\">\n                      <div class=\"panel-heading\">\n                          <h3 class=\"panel-title\">{{title}}</h3>\n                          <ul class=\"panel-controls\">\n                              <li>\n                                  <a href=\"javascript:void(0)\" (click)=\"reject()\">\n                                      <span class=\"fa fa-times\"></span>\n                                  </a>\n                              </li>\n                          </ul>\n                      </div>\n                      <div class=\"panel-body view\">\n                          <div *ngIf=\"mode === FormModeEnum.Table\" class=\"row\">\n                              <util-table\n                                      [ident]=\"'rbr'\"\n                                      [tableMode]=\"TableModeEnum.Details\"\n                                      [mode]=\"FormModeEnum.Table\"\n                                      [settings]=\"settingsTable\"\n                                      [maxRows]=\"1\"\n                                      [paging]=\"false\"\n                                      [resizable]=\"false\"\n                                      [reordable]=\"false\"\n                                      [orderList]=\"settingsAll\"\n                                      (tableAction)=\"listTableAction($event)\">\n                              </util-table>\n                          </div>\n                          <div *ngIf=\"mode === FormModeEnum.View || mode === FormModeEnum.Add\"\n                               class=\"pull-right\">\n                              <button *ngIf=\"mode === FormModeEnum.Add\"\n                                      class=\"btn btn-success btn-lg mb-control-yes\"\n                                      (click)=\"confirm()\">Sa\u010Duvaj\n                              </button>\n                              <button *ngIf=\"mode === FormModeEnum.View\"\n                                      class=\"btn btn-danger btn-lg mb-control-close\"\n                                      (click)=\"deleteSettingsLayout()\">Obri\u0161i\n                              </button>\n                              <button *ngIf=\"mode === FormModeEnum.View\"\n                                      class=\"btn btn-warning btn-lg mb-control-close\"\n                                      (click)=\"confirm()\">Sa\u010Duvaj izmene\n                              </button>\n                              <button *ngIf=\"mode === FormModeEnum.Add || mode === FormModeEnum.View\"\n                                      class=\"btn btn-default btn-lg mb-control-close\"\n                                      (click)=\"cancelAddView()\">Nazad\n                              </button>\n                          </div>\n                          <div *ngIf=\"mode === FormModeEnum.View || mode === FormModeEnum.Add\"\n                               class=\"row\">\n                          </div>\n                          <div class=\"row\">\n                              <div class=\"col-md-6\"\n                                   *ngIf=\"mode === FormModeEnum.Add || mode === FormModeEnum.View\">\n                                  <div class=\"form-group layout-name\">\n                                      <label class=\"control-label\">Custom layout</label>\n                                  </div>\n                              </div>\n                          </div>\n                          <div class=\"row\" *ngIf=\"mode === FormModeEnum.Add || mode === FormModeEnum.View\">\n                              <div class=\"clearfix\"></div>\n                          </div>\n                      </div>\n                  </div>\n              </div>\n          </div>\n      </div>\n    "
            },] },
];
/**
 * @nocollapse
 */
ModalSettingsComponent.ctorParameters = function () { return [
    { type: BackendService, },
    { type: AuthenticationService, },
    { type: ModalSettingsService, },
    { type: ApplicationService, },
    { type: NotificationService, },
]; };
/**
 * Check and return true if an object is type of string
 */
/**
 * Check and return true if an object is type of string
 */ function isString(obj) {
    return typeof obj === "string";
}
/**
 * Check and return true if an object not undefined or null
 */
function isPresent(obj) {
    return obj !== undefined && obj !== null;
}
/**
 * Check and return true if an object is type of Function
 */
function isFunction(obj) {
    return typeof obj === "function";
}
/**
 * Create Image element with specified url string
 */
function createImage(src) {
    var img = new HTMLImageElement();
    img.src = src;
    return img;
}
/**
 * Call the function
 */
function callFun(fun) {
    return fun();
}
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
var DataTransferEffect = (function () {
    function DataTransferEffect(name) {
        this.name = name;
    }
    return DataTransferEffect;
}());
DataTransferEffect.COPY = new DataTransferEffect('copy');
DataTransferEffect.LINK = new DataTransferEffect('link');
DataTransferEffect.MOVE = new DataTransferEffect('move');
DataTransferEffect.NONE = new DataTransferEffect('none');
var DragDropConfig = (function () {
    function DragDropConfig() {
        this.onDragStartClass = "dnd-drag-start";
        this.onDragEnterClass = "dnd-drag-enter";
        this.onDragOverClass = "dnd-drag-over";
        this.onSortableDragClass = "dnd-sortable-drag";
        this.dragEffect = DataTransferEffect.MOVE;
        this.dropEffect = DataTransferEffect.MOVE;
        this.dragCursor = "move";
        this.defaultCursor = "pointer";
    }
    return DragDropConfig;
}());
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
function dragDropServiceFactory() {
    return new DragDropService();
}
var DragDropService = (function () {
    function DragDropService() {
        this.allowedDropZones = [];
    }
    return DragDropService;
}());
DragDropService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DragDropService.ctorParameters = function () { return []; };
function dragDropSortableServiceFactory(config) {
    return new DragDropSortableService(config);
}
var DragDropSortableService = (function () {
    function DragDropSortableService(_config) {
        this._config = _config;
    }
    Object.defineProperty(DragDropSortableService.prototype, "elem", {
        get: function () {
            return this._elem;
        },
        enumerable: true,
        configurable: true
    });
    DragDropSortableService.prototype.markSortable = function (elem) {
        if (isPresent(this._elem)) {
            this._elem.classList.remove(this._config.onSortableDragClass);
        }
        if (isPresent(elem)) {
            this._elem = elem;
            this._elem.classList.add(this._config.onSortableDragClass);
        }
    };
    return DragDropSortableService;
}());
DragDropSortableService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DragDropSortableService.ctorParameters = function () {
    return [
        { type: DragDropConfig, },
    ];
};
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
var AbstractComponent = (function () {
    function AbstractComponent(elemRef, _dragDropService, _config, _cdr) {
        var _this = this;
        this._dragDropService = _dragDropService;
        this._config = _config;
        this._cdr = _cdr;
        /**
         * Whether the object is draggable. Default is true.
         */
        this._dragEnabled = false;
        /**
         * Allows drop on this element
         */
        this.dropEnabled = false;
        this.dropZones = [];
        this.cloneItem = false;
        // Assign default cursor unless overridden
        this._defaultCursor = _config.defaultCursor;
        this._elem = elemRef.nativeElement;
        this._elem.style.cursor = this._defaultCursor; // set default cursor on our element
        //
        // DROP events
        //
        this._elem.ondragenter = function (event) {
            _this._onDragEnter(event);
        };
        this._elem.ondragover = function (event) {
            _this._onDragOver(event);
            //
            if (event.dataTransfer != null) {
                event.dataTransfer.dropEffect = _this._config.dropEffect.name;
            }
            return false;
        };
        this._elem.ondragleave = function (event) {
            _this._onDragLeave(event);
        };
        this._elem.ondrop = function (event) {
            _this._onDrop(event);
        };
        //
        // Drag events
        //
        this._elem.onmousedown = function (event) {
            _this._target = event.target;
        };
        this._elem.ondragstart = function (event) {
            if (_this._dragHandle) {
                if (!_this._dragHandle.contains(_this._target)) {
                    event.preventDefault();
                    return;
                }
            }
            _this._onDragStart(event);
            //
            if (event.dataTransfer != null) {
                event.dataTransfer.setData('text', '');
                // Change drag effect
                event.dataTransfer.effectAllowed = _this.effectAllowed || _this._config.dragEffect.name;
                // Change drag image
                if (isPresent(_this.dragImage)) {
                    if (isString(_this.dragImage)) {
                        event.dataTransfer.setDragImage(createImage(_this.dragImage));
                    }
                    else if (isFunction(_this.dragImage)) {
                        event.dataTransfer.setDragImage(callFun(_this.dragImage));
                    }
                    else {
                        var img = _this.dragImage;
                        event.dataTransfer.setDragImage(img.imageElement, img.x_offset, img.y_offset);
                    }
                }
                else if (isPresent(_this._config.dragImage)) {
                    var dragImage = _this._config.dragImage;
                    event.dataTransfer.setDragImage(dragImage.imageElement, dragImage.x_offset, dragImage.y_offset);
                }
                else if (_this.cloneItem) {
                    _this._dragHelper = _this._elem.cloneNode(true);
                    _this._dragHelper.classList.add('dnd-drag-item');
                    _this._dragHelper.style.position = "absolute";
                    _this._dragHelper.style.top = "0px";
                    _this._dragHelper.style.left = "-1000px";
                    _this._elem.parentElement.appendChild(_this._dragHelper);
                    event.dataTransfer.setDragImage(_this._dragHelper, event.offsetX, event.offsetY);
                }
                // Change drag cursor
                var cursorelem = (_this._dragHandle) ? _this._dragHandle : _this._elem;
                if (_this._dragEnabled) {
                    cursorelem.style.cursor = _this.effectCursor ? _this.effectCursor : _this._config.dragCursor;
                }
                else {
                    cursorelem.style.cursor = _this._defaultCursor;
                }
            }
        };
        this._elem.ondragend = function (event) {
            if (_this._elem.parentElement && _this._dragHelper) {
                _this._elem.parentElement.removeChild(_this._dragHelper);
            }
            // console.log('ondragend', event.target);
            _this._onDragEnd(event);
            // Restore style of dragged element
            var cursorelem = (_this._dragHandle) ? _this._dragHandle : _this._elem;
            cursorelem.style.cursor = _this._defaultCursor;
        };
    }
    Object.defineProperty(AbstractComponent.prototype, "dragEnabled", {
        get: function () {
            return this._dragEnabled;
        },
        set: function (enabled) {
            this._dragEnabled = !!enabled;
            this._elem.draggable = this._dragEnabled;
        },
        enumerable: true,
        configurable: true
    });
    AbstractComponent.prototype.setDragHandle = function (elem) {
        this._dragHandle = elem;
    };
    /******* Change detection ******/
    AbstractComponent.prototype.detectChanges = function () {
        var _this = this;
        // Programmatically run change detection to fix issue in Safari
        setTimeout(function () {
            _this._cdr.detectChanges();
        }, 250);
    };
    //****** Droppable *******//
    AbstractComponent.prototype._onDragEnter = function (event) {
        // console.log('ondragenter._isDropAllowed', this._isDropAllowed);
        if (this._isDropAllowed(event)) {
            // event.preventDefault();
            this._onDragEnterCallback(event);
        }
    };
    AbstractComponent.prototype._onDragOver = function (event) {
        // // console.log('ondragover._isDropAllowed', this._isDropAllowed);
        if (this._isDropAllowed(event)) {
            // The element is over the same source element - do nothing
            if (event.preventDefault) {
                // Necessary. Allows us to drop.
                event.preventDefault();
            }
            this._onDragOverCallback(event);
        }
    };
    AbstractComponent.prototype._onDragLeave = function (event) {
        // console.log('ondragleave._isDropAllowed', this._isDropAllowed);
        if (this._isDropAllowed(event)) {
            // event.preventDefault();
            this._onDragLeaveCallback(event);
        }
    };
    AbstractComponent.prototype._onDrop = function (event) {
        // Necessary. Allows us to drop.
        this._preventAndStop(event);
        // console.log('ondrop._isDropAllowed', this._isDropAllowed);
        if (this._isDropAllowed(event)) {
            this._onDropCallback(event);
            this.detectChanges();
        }
    };
    AbstractComponent.prototype._isDropAllowed = function (event) {
        if ((this._dragDropService.isDragged || (event.dataTransfer && event.dataTransfer.files)) && this.dropEnabled) {
            // First, if `allowDrop` is set, call it to determine whether the
            // dragged element can be dropped here.
            if (this.allowDrop) {
                return this.allowDrop(this._dragDropService.dragData);
            }
            // Otherwise, use dropZones if they are set.
            if (this.dropZones.length === 0 && this._dragDropService.allowedDropZones.length === 0) {
                return true;
            }
            for (var i = 0; i < this._dragDropService.allowedDropZones.length; i++) {
                var dragZone = this._dragDropService.allowedDropZones[i];
                if (this.dropZones.indexOf(dragZone) !== -1) {
                    return true;
                }
            }
        }
        return false;
    };
    AbstractComponent.prototype._preventAndStop = function (event) {
        if (event.preventDefault) {
            event.preventDefault();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
    };
    //*********** Draggable **********//
    AbstractComponent.prototype._onDragStart = function (event) {
        //console.log('ondragstart.dragEnabled', this._dragEnabled);
        if (this._dragEnabled) {
            this._dragDropService.allowedDropZones = this.dropZones;
            // console.log('ondragstart.allowedDropZones', this._dragDropService.allowedDropZones);
            this._onDragStartCallback(event);
        }
    };
    AbstractComponent.prototype._onDragEnd = function (event) {
        this._dragDropService.allowedDropZones = [];
        // console.log('ondragend.allowedDropZones', this._dragDropService.allowedDropZones);
        this._onDragEndCallback(event);
    };
    //**** Drop Callbacks ****//
    AbstractComponent.prototype._onDragEnterCallback = function (event) { };
    AbstractComponent.prototype._onDragOverCallback = function (event) { };
    AbstractComponent.prototype._onDragLeaveCallback = function (event) { };
    AbstractComponent.prototype._onDropCallback = function (event) { };
    //**** Drag Callbacks ****//
    AbstractComponent.prototype._onDragStartCallback = function (event) { };
    AbstractComponent.prototype._onDragEndCallback = function (event) { };
    return AbstractComponent;
}());
AbstractComponent.decorators = [
    { type: Injectable },
];
/** @nocollapse */
AbstractComponent.ctorParameters = function () {
    return [
        { type: ElementRef, },
        { type: DragDropService, },
        { type: DragDropConfig, },
        { type: ChangeDetectorRef, },
    ];
};
var AbstractHandleComponent = (function () {
    function AbstractHandleComponent(elemRef, _dragDropService, _config, _Component, _cdr) {
        this._dragDropService = _dragDropService;
        this._config = _config;
        this._Component = _Component;
        this._cdr = _cdr;
        this._elem = elemRef.nativeElement;
        this._Component.setDragHandle(this._elem);
    }
    return AbstractHandleComponent;
}());
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DraggableComponent = (function (_super) {
    __extends(DraggableComponent, _super);
    function DraggableComponent(elemRef, dragDropService, config, cdr) {
        var _this = _super.call(this, elemRef, dragDropService, config, cdr) || this;
        /**
         * Callback function called when the drag actions happened.
         */
        _this.onDragStart = new EventEmitter();
        _this.onDragEnd = new EventEmitter();
        /**
         * Callback function called when the drag action ends with a valid drop action.
         * It is activated after the on-drop-success callback
         */
        _this.onDragSuccessCallback = new EventEmitter();
        _this._defaultCursor = _this._elem.style.cursor;
        _this.dragEnabled = true;
        return _this;
    }
    Object.defineProperty(DraggableComponent.prototype, "draggable", {
        set: function (value) {
            this.dragEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggableComponent.prototype, "dropzones", {
        set: function (value) {
            this.dropZones = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggableComponent.prototype, "effectallowed", {
        /**
         * Drag allowed effect
         */
        set: function (value) {
            this.effectAllowed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggableComponent.prototype, "effectcursor", {
        /**
         * Drag effect cursor
         */
        set: function (value) {
            this.effectCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    DraggableComponent.prototype._onDragStartCallback = function (event) {
        this._dragDropService.isDragged = true;
        this._dragDropService.dragData = this.dragData;
        this._dragDropService.onDragSuccessCallback = this.onDragSuccessCallback;
        this._elem.classList.add(this._config.onDragStartClass);
        //
        this.onDragStart.emit({ dragData: this.dragData, mouseEvent: event });
    };
    DraggableComponent.prototype._onDragEndCallback = function (event) {
        this._dragDropService.isDragged = false;
        this._dragDropService.dragData = null;
        this._dragDropService.onDragSuccessCallback = null;
        this._elem.classList.remove(this._config.onDragStartClass);
        //
        this.onDragEnd.emit({ dragData: this.dragData, mouseEvent: event });
    };
    return DraggableComponent;
}(AbstractComponent));
DraggableComponent.decorators = [
    { type: Directive, args: [{ selector: '[dnd-draggable]' },] },
];
/** @nocollapse */
DraggableComponent.ctorParameters = function () {
    return [
        { type: ElementRef, },
        { type: DragDropService, },
        { type: DragDropConfig, },
        { type: ChangeDetectorRef, },
    ];
};
DraggableComponent.propDecorators = {
    'draggable': [{ type: Input, args: ["dragEnabled",] },],
    'onDragStart': [{ type: Output },],
    'onDragEnd': [{ type: Output },],
    'dragData': [{ type: Input },],
    'onDragSuccessCallback': [{ type: Output, args: ["onDragSuccess",] },],
    'dropzones': [{ type: Input, args: ["dropZones",] },],
    'effectallowed': [{ type: Input, args: ["effectAllowed",] },],
    'effectcursor': [{ type: Input, args: ["effectCursor",] },],
    'dragImage': [{ type: Input },],
    'cloneItem': [{ type: Input },],
};
var DraggableHandleComponent = (function (_super) {
    __extends(DraggableHandleComponent, _super);
    function DraggableHandleComponent(elemRef, dragDropService, config, _Component, cdr) {
        return _super.call(this, elemRef, dragDropService, config, _Component, cdr) || this;
    }
    return DraggableHandleComponent;
}(AbstractHandleComponent));
DraggableHandleComponent.decorators = [
    { type: Directive, args: [{ selector: '[dnd-draggable-handle]' },] },
];
/** @nocollapse */
DraggableHandleComponent.ctorParameters = function () {
    return [
        { type: ElementRef, },
        { type: DragDropService, },
        { type: DragDropConfig, },
        { type: DraggableComponent, },
        { type: ChangeDetectorRef, },
    ];
};
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
var __extends$1 = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DroppableComponent = (function (_super) {
    __extends$1(DroppableComponent, _super);
    function DroppableComponent(elemRef, dragDropService, config, cdr) {
        var _this = _super.call(this, elemRef, dragDropService, config, cdr) || this;
        /**
         * Callback function called when the drop action completes correctly.
         * It is activated before the on-drag-success callback.
         */
        _this.onDropSuccess = new EventEmitter();
        _this.onDragEnter = new EventEmitter();
        _this.onDragOver = new EventEmitter();
        _this.onDragLeave = new EventEmitter();
        _this.dropEnabled = true;
        return _this;
    }
    Object.defineProperty(DroppableComponent.prototype, "droppable", {
        set: function (value) {
            this.dropEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DroppableComponent.prototype, "allowdrop", {
        set: function (value) {
            this.allowDrop = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DroppableComponent.prototype, "dropzones", {
        set: function (value) {
            this.dropZones = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DroppableComponent.prototype, "effectallowed", {
        /**
         * Drag allowed effect
         */
        set: function (value) {
            this.effectAllowed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DroppableComponent.prototype, "effectcursor", {
        /**
         * Drag effect cursor
         */
        set: function (value) {
            this.effectCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    DroppableComponent.prototype._onDragEnterCallback = function (event) {
        if (this._dragDropService.isDragged) {
            this._elem.classList.add(this._config.onDragEnterClass);
            this.onDragEnter.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
        }
    };
    DroppableComponent.prototype._onDragOverCallback = function (event) {
        if (this._dragDropService.isDragged) {
            this._elem.classList.add(this._config.onDragOverClass);
            this.onDragOver.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
        }
    };
    DroppableComponent.prototype._onDragLeaveCallback = function (event) {
        if (this._dragDropService.isDragged) {
            this._elem.classList.remove(this._config.onDragOverClass);
            this._elem.classList.remove(this._config.onDragEnterClass);
            this.onDragLeave.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
        }
    };
    DroppableComponent.prototype._onDropCallback = function (event) {
        var dataTransfer = event.dataTransfer;
        if (this._dragDropService.isDragged || (dataTransfer && dataTransfer.files)) {
            this.onDropSuccess.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
            if (this._dragDropService.onDragSuccessCallback) {
                this._dragDropService.onDragSuccessCallback.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
            }
            this._elem.classList.remove(this._config.onDragOverClass);
            this._elem.classList.remove(this._config.onDragEnterClass);
        }
    };
    return DroppableComponent;
}(AbstractComponent));
DroppableComponent.decorators = [
    { type: Directive, args: [{ selector: '[dnd-droppable]' },] },
];
/** @nocollapse */
DroppableComponent.ctorParameters = function () {
    return [
        { type: ElementRef, },
        { type: DragDropService, },
        { type: DragDropConfig, },
        { type: ChangeDetectorRef, },
    ];
};
DroppableComponent.propDecorators = {
    'droppable': [{ type: Input, args: ["dropEnabled",] },],
    'onDropSuccess': [{ type: Output },],
    'onDragEnter': [{ type: Output },],
    'onDragOver': [{ type: Output },],
    'onDragLeave': [{ type: Output },],
    'allowdrop': [{ type: Input, args: ["allowDrop",] },],
    'dropzones': [{ type: Input, args: ["dropZones",] },],
    'effectallowed': [{ type: Input, args: ["effectAllowed",] },],
    'effectcursor': [{ type: Input, args: ["effectCursor",] },],
};
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
var __extends$2 = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SortableContainer = (function (_super) {
    __extends$2(SortableContainer, _super);
    function SortableContainer(elemRef, dragDropService, config, cdr, _sortableDataService) {
        var _this = _super.call(this, elemRef, dragDropService, config, cdr) || this;
        _this._sortableDataService = _sortableDataService;
        _this._sortableData = [];
        _this.dragEnabled = false;
        return _this;
    }
    Object.defineProperty(SortableContainer.prototype, "draggable", {
        set: function (value) {
            this.dragEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableContainer.prototype, "sortableData", {
        get: function () {
            return this._sortableData;
        },
        set: function (sortableData) {
            this._sortableData = sortableData;
            //
            this.dropEnabled = !!this._sortableData;
            // console.log("collection is changed, drop enabled: " + this.dropEnabled);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableContainer.prototype, "dropzones", {
        set: function (value) {
            this.dropZones = value;
        },
        enumerable: true,
        configurable: true
    });
    SortableContainer.prototype._onDragEnterCallback = function (event) {
        if (this._sortableDataService.isDragged) {
            var item = this._sortableDataService.sortableContainer._sortableData[this._sortableDataService.index];
            // Check does element exist in sortableData of this Container
            if (this._sortableData.indexOf(item) === -1) {
                // Let's add it
                // console.log('Container._onDragEnterCallback. drag node [' + this._sortableDataService.index.toString() + '] over parent node');
                // Remove item from previouse list
                this._sortableDataService.sortableContainer._sortableData.splice(this._sortableDataService.index, 1);
                if (this._sortableDataService.sortableContainer._sortableData.length === 0) {
                    this._sortableDataService.sortableContainer.dropEnabled = true;
                }
                // Add item to new list
                this._sortableData.unshift(item);
                this._sortableDataService.sortableContainer = this;
                this._sortableDataService.index = 0;
            }
            // Refresh changes in properties of container component
            this.detectChanges();
        }
    };
    return SortableContainer;
}(AbstractComponent));
SortableContainer.decorators = [
    { type: Directive, args: [{ selector: '[dnd-sortable-container]' },] },
];
/** @nocollapse */
SortableContainer.ctorParameters = function () {
    return [
        { type: ElementRef, },
        { type: DragDropService, },
        { type: DragDropConfig, },
        { type: ChangeDetectorRef, },
        { type: DragDropSortableService, },
    ];
};
SortableContainer.propDecorators = {
    'draggable': [{ type: Input, args: ["dragEnabled",] },],
    'sortableData': [{ type: Input },],
    'dropzones': [{ type: Input, args: ["dropZones",] },],
};
var SortableComponent = (function (_super) {
    __extends$2(SortableComponent, _super);
    function SortableComponent(elemRef, dragDropService, config, _sortableContainer, _sortableDataService, cdr) {
        var _this = _super.call(this, elemRef, dragDropService, config, cdr) || this;
        _this._sortableContainer = _sortableContainer;
        _this._sortableDataService = _sortableDataService;
        /**
         * Callback function called when the drag action ends with a valid drop action.
         * It is activated after the on-drop-success callback
         */
        _this.onDragSuccessCallback = new EventEmitter();
        _this.onDragStartCallback = new EventEmitter();
        _this.onDragOverCallback = new EventEmitter();
        _this.onDragEndCallback = new EventEmitter();
        _this.onDropSuccessCallback = new EventEmitter();
        _this.dropZones = _this._sortableContainer.dropZones;
        _this.dragEnabled = true;
        _this.dropEnabled = true;
        return _this;
    }
    Object.defineProperty(SortableComponent.prototype, "draggable", {
        set: function (value) {
            this.dragEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableComponent.prototype, "droppable", {
        set: function (value) {
            this.dropEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableComponent.prototype, "effectallowed", {
        /**
         * Drag allowed effect
         */
        set: function (value) {
            this.effectAllowed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableComponent.prototype, "effectcursor", {
        /**
         * Drag effect cursor
         */
        set: function (value) {
            this.effectCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    SortableComponent.prototype._onDragStartCallback = function (event) {
        // console.log('_onDragStartCallback. dragging elem with index ' + this.index);
        this._sortableDataService.isDragged = true;
        this._sortableDataService.sortableContainer = this._sortableContainer;
        this._sortableDataService.index = this.index;
        this._sortableDataService.markSortable(this._elem);
        // Add dragData
        this._dragDropService.isDragged = true;
        this._dragDropService.dragData = this.dragData;
        this._dragDropService.onDragSuccessCallback = this.onDragSuccessCallback;
        //
        this.onDragStartCallback.emit(this._dragDropService.dragData);
    };
    SortableComponent.prototype._onDragOverCallback = function (event) {
        if (this._sortableDataService.isDragged && this._elem !== this._sortableDataService.elem) {
            // console.log('_onDragOverCallback. dragging elem with index ' + this.index);
            this._sortableDataService.sortableContainer = this._sortableContainer;
            this._sortableDataService.index = this.index;
            this._sortableDataService.markSortable(this._elem);
            this.onDragOverCallback.emit(this._dragDropService.dragData);
        }
    };
    SortableComponent.prototype._onDragEndCallback = function (event) {
        // console.log('_onDragEndCallback. end dragging elem with index ' + this.index);
        this._sortableDataService.isDragged = false;
        this._sortableDataService.sortableContainer = null;
        this._sortableDataService.index = null;
        this._sortableDataService.markSortable(null);
        // Add dragGata
        this._dragDropService.isDragged = false;
        this._dragDropService.dragData = null;
        this._dragDropService.onDragSuccessCallback = null;
        //
        this.onDragEndCallback.emit(this._dragDropService.dragData);
    };
    SortableComponent.prototype._onDragEnterCallback = function (event) {
        if (this._sortableDataService.isDragged) {
            this._sortableDataService.markSortable(this._elem);
            if ((this.index !== this._sortableDataService.index) ||
                (this._sortableDataService.sortableContainer.sortableData !== this._sortableContainer.sortableData)) {
                // console.log('Component._onDragEnterCallback. drag node [' + this.index + '] over node [' + this._sortableDataService.index + ']');
                // Get item
                var item = this._sortableDataService.sortableContainer.sortableData[this._sortableDataService.index];
                // Remove item from previouse list
                this._sortableDataService.sortableContainer.sortableData.splice(this._sortableDataService.index, 1);
                if (this._sortableDataService.sortableContainer.sortableData.length === 0) {
                    this._sortableDataService.sortableContainer.dropEnabled = true;
                }
                // Add item to new list
                this._sortableContainer.sortableData.splice(this.index, 0, item);
                if (this._sortableContainer.dropEnabled) {
                    this._sortableContainer.dropEnabled = false;
                }
                this._sortableDataService.sortableContainer = this._sortableContainer;
                this._sortableDataService.index = this.index;
            }
        }
    };
    SortableComponent.prototype._onDropCallback = function (event) {
        if (this._sortableDataService.isDragged) {
            // console.log('onDropCallback.onDropSuccessCallback.dragData', this._dragDropService.dragData);
            this.onDropSuccessCallback.emit(this._dragDropService.dragData);
            if (this._dragDropService.onDragSuccessCallback) {
                // console.log('onDropCallback.onDragSuccessCallback.dragData', this._dragDropService.dragData);
                this._dragDropService.onDragSuccessCallback.emit(this._dragDropService.dragData);
            }
            // Refresh changes in properties of container component
            this._sortableContainer.detectChanges();
        }
    };
    return SortableComponent;
}(AbstractComponent));
SortableComponent.decorators = [
    { type: Directive, args: [{ selector: '[dnd-sortable]' },] },
];
/** @nocollapse */
SortableComponent.ctorParameters = function () {
    return [
        { type: ElementRef, },
        { type: DragDropService, },
        { type: DragDropConfig, },
        { type: SortableContainer, },
        { type: DragDropSortableService, },
        { type: ChangeDetectorRef, },
    ];
};
SortableComponent.propDecorators = {
    'index': [{ type: Input, args: ['sortableIndex',] },],
    'draggable': [{ type: Input, args: ["dragEnabled",] },],
    'droppable': [{ type: Input, args: ["dropEnabled",] },],
    'dragData': [{ type: Input },],
    'effectallowed': [{ type: Input, args: ["effectAllowed",] },],
    'effectcursor': [{ type: Input, args: ["effectCursor",] },],
    'onDragSuccessCallback': [{ type: Output, args: ["onDragSuccess",] },],
    'onDragStartCallback': [{ type: Output, args: ["onDragStart",] },],
    'onDragOverCallback': [{ type: Output, args: ["onDragOver",] },],
    'onDragEndCallback': [{ type: Output, args: ["onDragEnd",] },],
    'onDropSuccessCallback': [{ type: Output, args: ["onDropSuccess",] },],
};
var SortableHandleComponent = (function (_super) {
    __extends$2(SortableHandleComponent, _super);
    function SortableHandleComponent(elemRef, dragDropService, config, _Component, cdr) {
        return _super.call(this, elemRef, dragDropService, config, _Component, cdr) || this;
    }
    return SortableHandleComponent;
}(AbstractHandleComponent));
SortableHandleComponent.decorators = [
    { type: Directive, args: [{ selector: '[dnd-sortable-handle]' },] },
];
/** @nocollapse */
SortableHandleComponent.ctorParameters = function () {
    return [
        { type: ElementRef, },
        { type: DragDropService, },
        { type: DragDropConfig, },
        { type: SortableComponent, },
        { type: ChangeDetectorRef, },
    ];
};
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
var providers = [
    DragDropConfig,
    { provide: DragDropService, useFactory: dragDropServiceFactory },
    { provide: DragDropSortableService, useFactory: dragDropSortableServiceFactory, deps: [DragDropConfig] }
];
var DndModule = (function () {
    function DndModule() {
    }
    DndModule.forRoot = function () {
        return {
            ngModule: DndModule,
            providers: providers
        };
    };
    return DndModule;
}());
DndModule.decorators = [
    { type: NgModule, args: [{
                declarations: [DraggableComponent, DraggableHandleComponent, DroppableComponent, SortableContainer, SortableComponent, SortableHandleComponent],
                exports: [DraggableComponent, DraggableHandleComponent, DroppableComponent, SortableContainer, SortableComponent, SortableHandleComponent],
            },] },
];
/** @nocollapse */
DndModule.ctorParameters = function () { return []; };
var ListService = /** @class */ (function () {
    /**
     * @param {?} backendService
     */
    function ListService(backendService) {
        this.backendService = backendService;
        this.listsToCache = new Set([]);
        this.cachedLists = new Map();
        this.registeredEnums = new Map();
        this.enumItemsSet = new EventEmitter();
    }
    /**
     * @param {?} listName
     * @param {?} documentType
     * @param {?} filter
     * @param {?} tableActionFilterParams
     * @param {?} settings
     * @param {?=} autocompleter
     * @return {?}
     */
    ListService.prototype.getList = function (listName, documentType, filter, tableActionFilterParams, settings, autocompleter) {
        if (autocompleter === void 0) { autocompleter = false; }
        tableActionFilterParams.filterCombined = this.getFilterCombined(settings, filter, tableActionFilterParams.filterQuery, tableActionFilterParams.filterDate, tableActionFilterParams.filterObjects, autocompleter);
        if (documentType == null) {
            return this.backendService.fetchOrderListWithFilter(listName, tableActionFilterParams, true);
        }
        else {
            return this.backendService.fetchDocumentListWithFilter(listName, documentType, tableActionFilterParams, true);
        }
    };
    /**
     * @param {?} settings
     * @param {?} filter
     * @param {?} filterQuery
     * @param {?} filterDate
     * @param {?} filterObjects
     * @param {?=} autocompleter
     * @return {?}
     */
    ListService.prototype.getFilterCombined = function (settings, filter, filterQuery, filterDate, filterObjects, autocompleter) {
        if (autocompleter === void 0) { autocompleter = false; }
        var /** @type {?} */ that = this;
        var /** @type {?} */ filterCombined;
        if (filter == null) {
            filter = new ServiceFilterTerm();
        }
        var /** @type {?} */ settingsTable;
        var /** @type {?} */ fields;
        if (settings) {
            if (autocompleter) {
                settingsTable = new TableSettings(settings[0], 'lookupTable');
                fields = settingsTable.getLookupTableFields(settings[0]);
            }
            else {
                settingsTable = new TableSettings(settings[0], 'table');
                fields = settingsTable.getTableFields(settings[0]);
            }
        }
        var /** @type {?} */ filterTermQuery = null;
        var /** @type {?} */ filterTermDate = null;
        var /** @type {?} */ filterTermObjects = null;
        if (filterObjects != null && filterObjects.length > 0) {
            var /** @type {?} */ filterObjectsMapped = filterObjects.map(function (propertyItem) {
                var /** @type {?} */ path = propertyItem.path;
                if (propertyItem.type === FieldTypeEnum.Completer ||
                    propertyItem.type === FieldTypeEnum.Combo) {
                    for (var /** @type {?} */ j = 0; j <
                        propertyItem['fieldMapItem'].relationValue
                            .withoutLast.length; j++) {
                        path =
                            propertyItem.path +
                                '.' +
                                propertyItem['fieldMapItem'].relationValue.withoutLast[j]
                                    .charAt(0)
                                    .toUpperCase() +
                                propertyItem['fieldMapItem'].relationValue.withoutLast[j].slice(1);
                    }
                    if (propertyItem['fieldMapItem'].relation
                        .completerMainAndSecond) {
                        for (var /** @type {?} */ j = 0; j <
                            propertyItem['fieldMapItem'].relationKey
                                .withoutLast.length; j++) {
                            path =
                                propertyItem.path +
                                    '.' +
                                    propertyItem['fieldMapItem'].relationKey.withoutLast[j]
                                        .charAt(0)
                                        .toUpperCase() +
                                    propertyItem['fieldMapItem'].relationKey.withoutLast[j].slice(1);
                        }
                    }
                }
                return new ServiceFilterSymbol(path, propertyItem.name, propertyItem.operation, propertyItem.value, null, propertyItem.type);
            });
            filterTermObjects = new ServiceFilterTerm(ServiceFilterOperandEnum.AND, filterObjectsMapped);
            filterCombined = new ServiceFilterTerm(ServiceFilterOperandEnum.AND, [filterTermObjects, filter])
                .generateResult()
                .prepareForService();
        }
        if (settingsTable && filterQuery && filterQuery !== '') {
            var /** @type {?} */ filtersQuery = fields.filter(function (item) { return item.type !== 'date' && item.type !== 'time'; });
            var /** @type {?} */ filtersQueryMapped = [];
            var _loop_1 = function (i) {
                var /** @type {?} */ value = filterQuery;
                var /** @type {?} */ propertyName = filtersQuery[i].fieldName;
                var /** @type {?} */ path = filtersQuery[i].path;
                if (filtersQuery[i].type === FieldTypeEnum.Completer ||
                    filtersQuery[i].type === FieldTypeEnum.Combo) {
                    propertyName = filtersQuery[i].relationValue.last;
                    for (var /** @type {?} */ j = 0; j < filtersQuery[i].relationValue.withoutLast.length; j++) {
                        path =
                            filtersQuery[i].path +
                                '.' +
                                filtersQuery[i].relationValue.withoutLast[j]
                                    .charAt(0)
                                    .toUpperCase() +
                                filtersQuery[i].relationValue.withoutLast[j].slice(1);
                    }
                    filtersQueryMapped.push(new ServiceFilterSymbol(path, propertyName, 'contains', value));
                    if (filtersQuery[i].relation.completerMainAndSecond) {
                        propertyName = filtersQuery[i].relationKey.last;
                        for (var /** @type {?} */ j = 0; j < filtersQuery[i].relationKey.withoutLast.length; j++) {
                            path =
                                filtersQuery[i].path +
                                    '.' +
                                    filtersQuery[i].relationKey.withoutLast[j]
                                        .charAt(0)
                                        .toUpperCase() +
                                    filtersQuery[i].relationKey.withoutLast[j].slice(1);
                        }
                        filtersQueryMapped.push(new ServiceFilterSymbol(path, propertyName, 'contains', value));
                    }
                }
                else if (filtersQuery[i].type === FieldTypeEnum.ComboFixed) {
                    var /** @type {?} */ enumItems = that
                        .getEnum(filtersQuery[i].entityType)
                        .filter(function (item) { return item.label
                        .toLowerCase()
                        .indexOf(value.toLowerCase()) !== -1; });
                    for (var /** @type {?} */ k = 0; k < enumItems.length; k++) {
                        value = enumItems[k].value;
                        filtersQueryMapped.push(new ServiceFilterSymbol(path, propertyName, '=', value));
                    }
                }
                else if (filtersQuery[i].type === FieldTypeEnum.Check) {
                    // Skip
                }
                else {
                    filtersQueryMapped.push(new ServiceFilterSymbol(path, propertyName, 'contains', value));
                }
            };
            for (var /** @type {?} */ i = 0; i < filtersQuery.length; i++) {
                _loop_1(/** @type {?} */ i);
            }
            filterTermQuery = new ServiceFilterTerm(ServiceFilterOperandEnum.OR, filtersQueryMapped);
        }
        if (settingsTable && filterDate && filterDate !== '') {
            var /** @type {?} */ filtersDate = fields.filter(function (item) { return item.type === 'date'; });
            var /** @type {?} */ filtersDateMapped = filtersDate.map(function (propertyItem) {
                return new ServiceFilterSymbol(propertyItem.path, propertyItem.fieldName, '=', filterDate);
            });
            filterTermDate = new ServiceFilterTerm(ServiceFilterOperandEnum.OR, filtersDateMapped);
        }
        if (filterTermQuery !== null || filterTermDate !== null) {
            filterCombined = new ServiceFilterTerm(ServiceFilterOperandEnum.AND, [filterTermQuery, filterTermDate, filter])
                .generateResult()
                .prepareForService();
        }
        // Autocomplete drop down
        if (typeof filterCombined === 'undefined' &&
            filter &&
            filter.hasOwnProperty('children') &&
            filter.children.length > 0) {
            filterCombined = new ServiceFilterTerm(ServiceFilterOperandEnum.AND, [filter])
                .generateResult()
                .prepareForService();
        }
        return filterCombined;
    };
    /**
     * @param {?} group
     * @param {?} value
     * @return {?}
     */
    ListService.prototype.filterById = function (group, value) {
        return new ServiceFilterSymbol(group, 'id', '=', value);
    };
    /**
     * @param {?} group
     * @param {?} propertyName
     * @param {?} value
     * @return {?}
     */
    ListService.prototype.filterByKey = function (group, propertyName, value) {
        return new ServiceFilterSymbol(group, propertyName, 'contains', value);
    };
    /**
     * @param {?} data
     * @param {?} filter
     * @param {?} lastusedFilter
     * @return {?}
     */
    ListService.prototype.applyLocalFilter = function (data, filter, lastusedFilter) {
        var /** @type {?} */ symbols = [];
        if (filter != null) {
            var /** @type {?} */ filterResult = filter.generateResult();
            symbols = filterResult.symbols;
        }
        if (lastusedFilter && lastusedFilter.filterCombined != null) {
            symbols = symbols.concat(lastusedFilter.filterCombined);
        }
        if (symbols.length === 0) {
            return data;
        }
        return data.filter(function (dataItem) {
            var /** @type {?} */ keepItem = false;
            symbols.forEach(function (filterItem) {
                if (!dataItem.hasOwnProperty(filterItem.propertyName)) {
                    return false;
                }
                var /** @type {?} */ propertyValue = dataItem[filterItem.propertyName]
                    .toString()
                    .toLowerCase();
                var /** @type {?} */ filterValue = filterItem.value
                    .toString()
                    .toLowerCase();
                switch (filterItem.operand) {
                    case '=':
                        keepItem = keepItem || propertyValue === filterValue;
                        break;
                    case 'contains':
                        keepItem =
                            keepItem ||
                                propertyValue.indexOf(filterValue) !== -1;
                        break;
                    default:
                        keepItem = true;
                }
            });
            if (keepItem) {
                return true;
            }
        });
    };
    /**
     * @param {?} enumName
     * @return {?}
     */
    ListService.prototype.isEnumRegistered = function (enumName) {
        return this.registeredEnums.has(enumName);
    };
    /**
     * @param {?} enumName
     * @return {?}
     */
    ListService.prototype.getEnum = function (enumName) {
        if (!this.registeredEnums.has(enumName)) {
            return new Array();
        }
        return this.registeredEnums.get(enumName);
    };
    /**
     * @param {?} enumName
     * @param {?} values
     * @return {?}
     */
    ListService.prototype.registerEnum = function (enumName, values) {
        this.registeredEnums.set(enumName, values);
        this.enumItemsSet.emit(enumName);
    };
    return ListService;
}());
ListService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ListService.ctorParameters = function () { return [
    { type: BackendService, },
]; };
var RequestCounter = /** @class */ (function () {
    /**
     * @param {?=} aggressiveMode
     */
    function RequestCounter(aggressiveMode) {
        if (aggressiveMode === void 0) { aggressiveMode = false; }
        this.lastRequestNumber = 0;
        this.lastResponseNumber = 0;
        this.aggressiveMode = aggressiveMode;
    }
    /**
     * @return {?}
     */
    RequestCounter.prototype.nextRequestNumber = function () {
        return ++this.lastRequestNumber;
    };
    /**
     * @param {?} requestNumber
     * @return {?}
     */
    RequestCounter.prototype.markResponse = function (requestNumber) {
        if (requestNumber > this.lastResponseNumber) {
            this.lastResponseNumber = requestNumber;
            if (this.aggressiveMode) {
                // In aggressive mode, the response is only accepted if no new requests were made in the meantime
                if (requestNumber === this.lastRequestNumber) {
                    return true;
                }
            }
            else {
                return true;
            }
        }
        // Response for a subsequent request was already made, ignore this result
        return false;
    };
    return RequestCounter;
}());
var FilterActionEnum = {};
FilterActionEnum.Filter = /** @type {?} */ ('filter');
FilterActionEnum.Export = /** @type {?} */ ('export');
FilterActionEnum.Print = /** @type {?} */ ('print');
FilterActionEnum[FilterActionEnum.Filter] = "Filter";
FilterActionEnum[FilterActionEnum.Export] = "Export";
FilterActionEnum[FilterActionEnum.Print] = "Print";
var FilterSettings = /** @class */ (function () {
    /**
     * @param {?} settings
     */
    function FilterSettings(settings) {
        this.relations = [];
        this.fieldList = settings.filterFields;
        this.relations = settings.relations;
        this.documentType = settings.vrstaDokumenta;
    }
    /**
     * @param {?} fieldName
     * @return {?}
     */
    FilterSettings.prototype.getFieldByName = function (fieldName) {
        var /** @type {?} */ results = this.fieldList.filter(function (it) { return it['name'] === fieldName; });
        if (results.length === 0) {
            return null;
        }
        else {
            return results[0];
        }
    };
    return FilterSettings;
}());
var FieldService = /** @class */ (function () {
    function FieldService() {
    }
    /**
     * @param {?} order
     * @param {?} group
     * @return {?}
     */
    FieldService.prototype.getCompleterItem = function (order, group) {
        if (order) {
            var /** @type {?} */ value = order[group.substr(0, 1).toLowerCase() + group.substr(1)];
            return value;
        }
        return {};
    };
    /**
     * @param {?} entityType
     * @param {?} relations
     * @return {?}
     */
    FieldService.prototype.getRelation = function (entityType, relations) {
        if (entityType == null) {
            return null;
        }
        var /** @type {?} */ relation = relations.filter(function (listItem) { return listItem['group'].toLowerCase() === entityType.toLowerCase(); })[0];
        return relations.filter(function (listItem) { return listItem['group'].toLowerCase() === entityType.toLowerCase(); })[0];
    };
    /**
     * @param {?} order
     * @param {?} column
     * @return {?}
     */
    FieldService.prototype.getInputValue = function (order, column) {
        return order[column];
    };
    return FieldService;
}());
FieldService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
FieldService.ctorParameters = function () { return []; };
var ViewTableComponent = /** @class */ (function () {
    /**
     * @param {?} backendService
     * @param {?} authenticationService
     * @param {?} route
     * @param {?} daterangepickerOptions
     * @param {?} ref
     * @param {?} fieldService
     * @param {?} listService
     * @param {?} applicationService
     * @param {?} eRef
     */
    function ViewTableComponent(backendService, authenticationService, route, daterangepickerOptions, ref, fieldService, listService, applicationService, eRef) {
        this.backendService = backendService;
        this.authenticationService = authenticationService;
        this.route = route;
        this.daterangepickerOptions = daterangepickerOptions;
        this.ref = ref;
        this.fieldService = fieldService;
        this.listService = listService;
        this.applicationService = applicationService;
        this.eRef = eRef;
        this.TableModeEnum = TableModeEnum;
        this.FieldTypeEnum = FieldTypeEnum;
        this.TableActionEnum = TableActionEnum;
        this.ident = 'rbr';
        this.paging = true;
        this.serverPagination = true;
        this.sortingEnabled = true;
        this.sticking = true;
        this.resizable = true;
        this.reordable = true;
        this.reorderRows = false;
        this.showSelectColumn = false;
        this.selectedRows = {};
        this.selectedRowsList = [];
        this.tableMode = TableModeEnum.Table;
        this.tableAction = new EventEmitter();
        this.orderedRowsChange = new EventEmitter();
        this.onRowSelected = new EventEmitter();
        this.columns = [];
        this.orderedRows = [];
        this.initialized = false;
        this._columnsSet = false;
        this.isAdmin = false;
        this.daterange = {};
        this.fieldsByName = []; // TODO: Remove
        this.rowsOnPage = 25;
        this.pageCurrent = 1;
        this.direction = 0;
        this.from = 0;
        this.to = 1000000;
        this.documentListSource = new Subject$1();
        this.documentList$ = this.documentListSource.asObservable();
        this.selectedClass = 'selected';
        this.defaultRowHeight = true;
        this.pageChange = new EventEmitter();
        this.selectedObjectChange = new EventEmitter();
        this._settings = null;
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(ViewTableComponent.prototype, "mode", {
        /**
         * @param {?} mode$
         * @return {?}
         */
        set: function (mode$) {
            var _this = this;
            this.mode$ = mode$;
            mode$.subscribe(function (data) {
                _this._mode = data;
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewTableComponent.prototype, "selectRows", {
        /**
         * @param {?} selectRows$
         * @return {?}
         */
        set: function (selectRows$) {
            var _this = this;
            this.selectedRowsSubscription = selectRows$.subscribe(function (indexes) {
                _this.selectedRows = {};
                if (indexes.length) {
                    indexes.forEach(function (x) {
                        _this.selectedRows[x] = true;
                    });
                }
                _this.ref.detectChanges();
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewTableComponent.prototype, "selectedObject", {
        /**
         * @return {?}
         */
        get: function () {
            return this._selectObject;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (!value) {
                this.selectedRows = {};
            }
            this._selectObject = value;
            this.selectedObjectChange.emit(this._selectObject);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewTableComponent.prototype, "complexSettings", {
        /**
         * @param {?} complexTableSettings$
         * @return {?}
         */
        set: function (complexTableSettings$) {
            var _this = this;
            this.complexTableSettings$ = complexTableSettings$;
            this.complexTableSettingsSubscription = complexTableSettings$.subscribe(function (data) {
                _this._complexSettingsAll = data;
                if (_this.serverPagination && _this._orderListCount > 0) {
                    if (typeof data !== 'undefined') {
                        _this.setComplexPagination();
                        _this.ref.detectChanges();
                    }
                }
                else {
                    if (typeof data !== 'undefined') {
                        _this.setComplexPagination();
                        _this.ref.detectChanges();
                    }
                }
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewTableComponent.prototype, "settings", {
        /**
         * @param {?} tableSettings$
         * @return {?}
         */
        set: function (tableSettings$) {
            var _this = this;
            this.tableSettings$ = tableSettings$;
            this.tableSettingsSubscription = tableSettings$.subscribe(function (data) {
                if (data != null) {
                    _this._settings = data;
                    _this.onOrderListAndRelationsLoaded();
                    _this.ref.detectChanges();
                }
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewTableComponent.prototype, "orderListCount", {
        /**
         * @param {?} orderListCount$
         * @return {?}
         */
        set: function (orderListCount$) {
            var _this = this;
            this.orderListCount$ = orderListCount$;
            this.orderListCountSubscription = orderListCount$.subscribe(function (data) {
                _this._orderListCount = data;
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewTableComponent.prototype, "orderList", {
        /**
         * @return {?}
         */
        get: function () {
            return this._orderList;
        },
        /**
         * @param {?} documentList$
         * @return {?}
         */
        set: function (documentList$) {
            var _this = this;
            this.documentListSubscription = documentList$.subscribe(function (data) {
                if (_this.serverPagination && _this._orderListCount > 0) {
                    if (typeof data !== 'undefined') {
                        if (typeof _this._orderListTotal === 'undefined') {
                            if (!_this.paging) {
                                _this.rowsOnPage = 10000000000;
                            }
                            else {
                                _this.rowsOnPage = 25;
                            }
                            _this.pageCurrent = 1;
                        }
                        _this._orderListTotal = data;
                        _this.setPagination();
                        _this.onOrderListAndRelationsLoaded();
                        _this.ref.detectChanges();
                    }
                }
                else {
                    if (typeof data !== 'undefined') {
                        if (typeof _this._orderListTotal === 'undefined') {
                            if (!_this.paging) {
                                _this.rowsOnPage = 10000000000;
                            }
                            else {
                                _this.rowsOnPage = 25;
                            }
                            _this.pageCurrent = 1;
                        }
                        _this._orderListTotal = data;
                        _this.setPagination();
                        _this.from = (_this.pageCurrent - 1) * _this.rowsOnPage;
                        _this.to = _this.rowsOnPage * _this.pageCurrent;
                        if (typeof _this.sortOrder !== 'undefined' && Object.keys(_this.sortOrder).length > 0) {
                            _this.fieldName = _this.sortOrder.fieldName;
                        }
                        _this.onOrderListAndRelationsLoaded();
                        if (_this.sortColumnName) {
                            _this.filter(_this.fieldsByName[_this.sortColumnName], null);
                        }
                        _this.ref.detectChanges();
                    }
                }
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} order
     * @return {?}
     */
    ViewTableComponent.prototype.updateAktivan = function (order) {
        order.Aktivan = !order.Aktivan;
        this.onRowSelected.next(order);
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.resetData = function () {
        this.rowsOnPage = 25;
        this.pageCurrent = 1;
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ViewTableComponent.prototype.onAction = function (event) {
        this.tableAction.emit(event);
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.setPagination = function () {
        if (this.serverPagination && this._orderListCount > 0) {
            this.totalPages = Math.ceil(this._orderListCount / this.rowsOnPage);
            if (this.totalPages < this.pageCurrent) {
                this.pageCurrent = 1;
            }
            this._orderList = this._orderListTotal;
        }
        else {
            this.totalPages = Math.ceil(this._orderListTotal.length / this.rowsOnPage);
            if (this.totalPages < this.pageCurrent) {
                this.pageCurrent = 1;
            }
            var /** @type {?} */ from = (this.pageCurrent - 1) * this.rowsOnPage;
            this._orderList = this._orderListTotal.slice(from, this.rowsOnPage * this.pageCurrent);
        }
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.setComplexPagination = function () {
        if (this.serverPagination && this._orderListCount > 0) {
            this._complexSettings = this._complexSettingsAll;
        }
        else {
            var /** @type {?} */ from = (this.pageCurrent - 1) * this.rowsOnPage;
            this._complexSettings = this._complexSettingsAll.slice(from, this.rowsOnPage * this.pageCurrent);
        }
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.setViewListener = function () {
        var /** @type {?} */ that = this;
        $('.orderList' + this.componentGuid + this.tableMode).find("tr td").on('click', function (e) {
            $('.orderList' + that.componentGuid + that.tableMode).find("tr td").off('click');
            that.propagateAction($(e.target).closest('td').find('span')[0].dataset.dataId, TableActionEnum.View);
            that.setViewListener();
        });
    };
    /**
     * @param {?} orderId
     * @param {?} mode
     * @return {?}
     */
    ViewTableComponent.prototype.propagateAction = function (orderId, mode) {
        setTimeout(function (self) {
            var /** @type {?} */ action;
            switch (mode) {
                case TableActionEnum.View:
                    this._mode = FormModeEnum.View;
                    action = TableActionEnum.View;
                    break;
            }
            var /** @type {?} */ params = {
                action: action,
                documentId: orderId
            };
            self.tableAction.emit(params);
        }, 0, this);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ViewTableComponent.prototype.page = function (event) {
        this.pageCurrent = event;
        this.filter(this.sortOrder, this.pageCurrent);
    };
    /**
     * @param {?} column
     * @return {?}
     */
    ViewTableComponent.prototype.sortAction = function (column) {
        if (!this.sortingEnabled || !column.sortable) {
            return;
        }
        if (this.sortColumnName !== column.name) {
            this.sortColumnName = column.name;
            this.sortAscending = true;
        }
        else {
            this.sortAscending = !this.sortAscending;
        }
        this.filter(this.fieldsByName[column.name], null);
    };
    /**
     * @param {?} order
     * @param {?} page
     * @return {?}
     */
    ViewTableComponent.prototype.filter = function (order, page) {
        var _this = this;
        this.selectedRows = {};
        if (typeof order !== 'undefined' && Object.keys(order).length === 0 && page === null) {
            this.pageCurrent = 1;
        }
        else {
            this.sortOrder = order;
        }
        var /** @type {?} */ direction = this.sortColumnName != null
            ? (this.sortAscending ? 'asc' : 'desc') : 'asc';
        if (this.serverPagination && this._orderListCount > 0) {
            // Server-side filtering, sorting, pagination, etc.
            var /** @type {?} */ params_1 = {
                action: TableActionEnum.Filter,
                filter: {
                    pageCurrent: this.pageCurrent,
                    filterQuery: '',
                    filterDate: null,
                    filterObjects: [],
                    filterCombined: null,
                    rowsOnPage: this.rowsOnPage,
                    sortOrder: this.sortOrder,
                    direction: direction,
                    relations: this._settings.relations
                }
            };
            this.tableAction.emit(params_1);
            return;
        }
        // Client-side filtering, sorting, pagination, etc.
        if (typeof this.sortOrder !== 'undefined' && Object.keys(this.sortOrder).length > 0) {
            var /** @type {?} */ list = [];
            for (var /** @type {?} */ j = 0; j < this._orderListTotal.length; j++) {
                list.push({ 'orderListTotal': this._orderListTotal[j], 'results': this._complexSettingsAll ? this._complexSettingsAll[j] : null });
            }
            list = list.sort(function (a, b) {
                var /** @type {?} */ x = _this.getTableCellText(order['fieldName'], a.orderListTotal);
                var /** @type {?} */ y = _this.getTableCellText(order['fieldName'], b.orderListTotal);
                if (order.type === FieldTypeEnum.Date) {
                    x = moment(x, 'DD.MM.YYYY').format('YYYYMMDD');
                    y = moment(y, 'DD.MM.YYYY').format('YYYYMMDD');
                }
                var /** @type {?} */ retval = _this.sortCompareFn(x, y, direction);
                if (order.type === FieldTypeEnum.Date) {
                    x = moment(x, 'YYYYMMDD').format('DD.MM.YYYY');
                    y = moment(y, 'YYYYMMDD').format('DD.MM.YYYY');
                }
                return retval;
            });
            for (var /** @type {?} */ j = 0; j < this._orderListTotal.length; j++) {
                this._orderListTotal[j] = list[j].orderListTotal;
                if (this._complexSettingsAll) {
                    this._complexSettingsAll[j] = list[j].results;
                }
            }
        }
        this.totalPages = Math.ceil(this._orderListTotal.length / this.rowsOnPage);
        if (this.totalPages < this.pageCurrent) {
            this.pageCurrent = 1;
        }
        var /** @type {?} */ from = (this.pageCurrent - 1) * this.rowsOnPage;
        this._orderList = this._orderListTotal.slice(from, this.rowsOnPage * this.pageCurrent);
        this.from = (this.pageCurrent - 1) * this.rowsOnPage;
        this.to = this.rowsOnPage * this.pageCurrent;
        this.direction = direction === 'asc' ? 0 : 1;
        if (typeof this.sortOrder !== 'undefined' && Object.keys(this.sortOrder).length > 0) {
            this.fieldName = this.sortOrder.fieldName;
        }
        if (this._complexSettingsAll) {
            this.setComplexPagination();
        }
        var /** @type {?} */ params = {
            action: TableActionEnum.Filter,
            sortedRows: this._orderList
        };
        this.tableAction.emit(params);
        this.ref.detectChanges();
        this.sortOrder = 1;
    };
    /**
     * @param {?} x
     * @param {?} y
     * @param {?} direction
     * @return {?}
     */
    ViewTableComponent.prototype.sortCompareFn = function (x, y, direction) {
        if (direction === 'desc') {
            if (!x && !y) {
                return 0;
            }
            else if (!x) {
                return 1;
            }
            else if (!y) {
                return -1;
            }
            return ((x < y) ? 1 : ((x > y) ? -1 : 0));
        }
        if (!x && !y) {
            return 0;
        }
        else if (!x) {
            return -1;
        }
        else if (!y) {
            return 1;
        }
        return (x < y) ? -1 : ((x > y) ? 1 : 0);
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.setFieldByName = function () {
        if (this._settings != null) {
            for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
                for (var /** @type {?} */ i = 0; i < this._settings.columns.length; i++) {
                    if (this.columns[j].name.toLowerCase() === this._settings.columns[i].fieldName.toLowerCase()) {
                        var /** @type {?} */ fieldByName = this._settings.columns[i];
                        this.fieldsByName[this.columns[j].name] = fieldByName;
                        this.fieldsByName[this.columns[j].name]['sortable'] = this._settings.columns[i].sortable;
                        this.fieldsByName[this.columns[j].name]['resizing'] = false;
                    }
                }
            }
        }
    };
    /**
     * @param {?} order
     * @param {?} column
     * @return {?}
     */
    ViewTableComponent.prototype.getInputValue = function (order, column) {
        return this.fieldService.getInputValue(order, column);
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @param {?=} complexFieldMap
     * @return {?}
     */
    ViewTableComponent.prototype.getComboFixedText = function (order, columnName, complexFieldMap) {
        if (complexFieldMap === void 0) { complexFieldMap = null; }
        var /** @type {?} */ fieldMap = this._settings.getFieldByName(columnName);
        var /** @type {?} */ value = UtilService.getFieldValue(order, fieldMap);
        var /** @type {?} */ enumResult;
        if (complexFieldMap && complexFieldMap.lookupList != null) {
            enumResult = complexFieldMap.lookupList.filter(function (listItem) { return listItem.value === value; });
        }
        else {
            enumResult = this.listService.getEnum(fieldMap.entityType).filter(function (item) { return item.value === value; });
        }
        if (enumResult.length === 0) {
            return null;
        }
        return enumResult[0].label;
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @return {?}
     */
    ViewTableComponent.prototype.getCompleterItem = function (order, columnName) {
        return UtilService.getFieldObject(order, this._settings.getFieldByName(columnName).propertyPath.all);
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @return {?}
     */
    ViewTableComponent.prototype.getComboFixedItem = function (order, columnName) {
        return UtilService.getFieldValue(order, this._settings.getFieldByName(columnName));
    };
    /**
     * @param {?=} callback
     * @return {?}
     */
    ViewTableComponent.prototype.onOrderListAndRelationsLoaded = function (callback) {
        var _this = this;
        if (callback === void 0) { callback = null; }
        var /** @type {?} */ that = this;
        if (!this.initialized || this.orderList == null) {
            return;
        }
        var /** @type {?} */ setColumns = false;
        if (this.columns.length === 0) {
            setColumns = true;
        }
        var /** @type {?} */ columnsTemp = [];
        for (var /** @type {?} */ i = 0; i < this._settings.columns.length; i++) {
            if (Object.keys(this._settings.columns[i]).length !== 0) {
                columnsTemp.push({
                    'name': this._settings.columns[i].fieldName,
                    'label': this._settings.columns[i].label,
                    'dbType': this._settings.columns[i].dbType,
                    'id': this._settings.columns[i].id,
                    'size': this._settings.columns[i].width,
                    'sortable': this._settings.columns[i].sortable,
                });
            }
        }
        this.columns = columnsTemp;
        this.setFieldByName();
        if (setColumns && this.tableMode === TableModeEnum.Table) {
            if (this.resizable) {
                this.setColumnsSizes();
            }
            if (this.reordable) {
                this.setColumnsOrders();
            }
        }
        setTimeout(function () {
            $('.orderList' + _this.componentGuid + that.tableMode).find("tr td").off('click');
            if (_this.tableMode === TableModeEnum.Table) {
                $('.orderList' + _this.componentGuid + _this.tableMode).find("tr td:not('.actions')").off('click');
                _this.setViewListener();
            }
            if (_this.resizable) {
                _this.resizableGrid();
            }
            if (_this.reordable) {
                _this.dropGrid();
            }
            if (_this.reorderRows && _this._orderList && _this._orderList.length) {
                _this.initRowsDragger();
                _this.orderedRows = _this._orderList.slice();
            }
            if (_this._columnsSet) {
                return;
            }
            _this._columnsSet = true;
        }, 0);
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.getSelectedRows = function () {
        return this.selectedRows;
    };
    /**
     * @param {?} selectedDocument
     * @param {?} index
     * @return {?}
     */
    ViewTableComponent.prototype.onInlineViewAndSelect = function (selectedDocument, index) {
        var /** @type {?} */ tableRow = $(this.getItemRef().querySelector('tbody span[data-data-' + this.ident + '=\'' + selectedDocument[this.ident] + '\']')).closest('tr');
        if (this.tableMode === TableModeEnum.Table) {
            if (!tableRow.hasClass('adding') &&
                !tableRow.hasClass('editing')) {
                this.propagateAction(selectedDocument[this.ident], TableActionEnum.View);
            }
        }
        this.onInlineSelect(selectedDocument, index);
    };
    /**
     * @param {?} selectedDocument
     * @param {?} index
     * @param {?=} event
     * @param {?=} columnName
     * @return {?}
     */
    ViewTableComponent.prototype.onInlineSelect = function (selectedDocument, index, event, columnName) {
        var _this = this;
        if (event === void 0) { event = null; }
        if (columnName === void 0) { columnName = null; }
        var /** @type {?} */ multiselect = !!event.ctrlKey;
        var /** @type {?} */ params = {
            action: TableActionEnum.Select,
            document: selectedDocument,
            columnName: columnName
        };
        if (selectedDocument === null) {
            $('.orderList' + this.componentGuid + this.tableMode + ' tbody tr').removeClass('selected');
            this.onAction(params);
        }
        else {
            var /** @type {?} */ tableRow = $(this.getItemRef().querySelector('tbody span[data-data-' + this.ident + '=\'' + selectedDocument[this.ident] + '\']')).closest('tr');
            if (!tableRow.hasClass('selected')) {
                this.selectedObject = selectedDocument;
                this.onAction(params);
            }
            if (!(event && event.ctrlKey)) {
                this.selectedRows = {};
                this.selectedRowsList = [];
            }
            if (this.selectedRows.hasOwnProperty(index)) {
                this.selectedRows[index] = this.selectedRows[index];
            }
            else {
                this.selectedRows[index] = true;
            }
            if (this.selectedRowsList.findIndex(function (sr) { return sr.Id === _this.selectedObject.Id; }) === -1) {
                this.selectedRowsList.push(this.selectedObject);
            }
            this.ref.detectChanges();
        }
        params = {
            action: TableActionEnum.Click,
            document: selectedDocument,
            selectedRows: this.selectedRowsList,
            multiselect: multiselect
        };
        this.onAction(params);
    };
    /**
     * @param {?} columnName
     * @param {?} order
     * @return {?}
     */
    ViewTableComponent.prototype.getTableCellText = function (columnName, order) {
        var /** @type {?} */ val = '';
        if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Input) {
            val = UtilService.getFieldValue(order, this.fieldsByName[columnName]);
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Completer) {
            val = UtilService.getCompleterValue(order, this.fieldsByName[columnName]);
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Date) {
            val = UtilService.formatDate(this.getInputValue(order, columnName));
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Time) {
            val = UtilService.formatTime(this.getInputValue(order, columnName));
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Check) {
            val = this.getInputValue(order, columnName);
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Combo ||
            this.fieldsByName[columnName]['type'] === FieldTypeEnum.ComboFixed) {
            val = this.getComboFixedText(order, columnName);
        }
        return val;
        /* TODO This method, optimized:
        const field = this.fieldsByName[columnName];
        switch (field.type) {
            case FieldTypeEnum.Input: return UtilService.getFieldValue(order, field);
            case FieldTypeEnum.Completer: return UtilService.getCompleterValue(order, field);
            case FieldTypeEnum.Date: return UtilService.formatDate(this.getInputValue(order, columnName));
            case FieldTypeEnum.Time: return UtilService.formatTime(this.getInputValue(order, columnName));
            case FieldTypeEnum.Check: return this.getInputValue(order, columnName);

            case FieldTypeEnum.Combo:
            case FieldTypeEnum.ComboFixed:
                return this.getComboFixedText(order, columnName);
        }
        return '';
        */
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.getTableData = function () {
        var /** @type {?} */ table = [];
        if (this._orderList) {
            for (var /** @type {?} */ i = 0; i < this._orderList.length; i++) {
                var /** @type {?} */ row = {};
                for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
                    var /** @type {?} */ val = this.getTableCellText(this.columns[j].name, this._orderList[i]);
                    if (typeof val !== 'undefined' && val !== null) {
                        row[this.columns[j].label] = val;
                    }
                }
                table.push(row);
            }
        }
        return table;
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.getTotalTableData = function () {
        var /** @type {?} */ table = [];
        if (this._orderListTotal) {
            for (var /** @type {?} */ i = 0; i < this._orderListTotal.length; i++) {
                var /** @type {?} */ row = {};
                for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
                    var /** @type {?} */ val = this.getTableCellText(this.columns[j].name, this._orderListTotal[i]);
                    if (typeof val !== 'undefined' && val !== null) {
                        row[this.columns[j].label] = val;
                    }
                }
                table.push(row);
            }
        }
        return table;
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.setColumnsSizes = function () {
        var /** @type {?} */ columnsSizes = new Map();
        for (var /** @type {?} */ i = 0; i < this.columns.length; i++) {
            columnsSizes.set(this.columns[i].id, parseInt(this.columns[i].size, 0));
        }
        this.backendService.setColumnsSizes(columnsSizes);
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.setColumnsOrders = function () {
        this.backendService.setColumnsOrders(this.columns.map(function (column) { return column.id; }));
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.ngOnInit = function () {
        var /** @type {?} */ that = this;
        this.initialized = true;
        this.onOrderListAndRelationsLoaded();
        if (this.resizable) {
            this.setColumnsSizes();
        }
        if (this.reordable) {
            this.setColumnsOrders();
        }
        this.isAdmin = this.authenticationService.getUser().type === 'admin';
        $('.table-responsive').on('scroll', function (e) {
            $('.popup').removeClass('show');
            $('.combo-component').removeClass('open');
        });
        if (this.tableMode === TableModeEnum.Table) {
            this.tabSwitchSubscription = this.applicationService.tabSwitchEvent.subscribe(function (data) {
                if (that.identity.documentId === data.identity.documentId) {
                    setTimeout(function () {
                        UtilService.resetCss();
                        UtilService.recalculateCss();
                    });
                }
            });
            this.tabOpenSubscription = this.applicationService.tabOpenEvent.subscribe(function (data) {
                setTimeout(function () {
                    UtilService.resetCss();
                    UtilService.recalculateCss();
                });
            });
        }
    };
    /**
     * @param {?} element
     * @return {?}
     */
    ViewTableComponent.prototype.scrollbarVisible = function (element) {
        return element.scrollWidth > element.clientWidth;
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.scrollHeaderEvent$ = Observable$1.fromEvent($(this.getItemRef().querySelector('.tbody-wrapper')), 'scroll').subscribe(function (event) {
            $(_this.getItemRef().querySelector('.thead-wrapper')).scrollLeft($(_this.getItemRef().querySelector('.tbody-wrapper')).get(0).scrollLeft);
        });
        this.scrollBodyEvent$ = Observable$1.fromEvent($(this.getItemRef().querySelector('.thead-wrapper')), 'scroll').subscribe(function (event) {
            $(_this.getItemRef().querySelector('.tbody-wrapper')).scrollLeft($(_this.getItemRef().querySelector('.thead-wrapper')).get(0).scrollLeft);
        });
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.ngOnDestroy = function () {
        if (this.tableSettingsSubscription) {
            this.tableSettingsSubscription.unsubscribe();
        }
        if (this.orderListCountSubscription) {
            this.orderListCountSubscription.unsubscribe();
        }
        if (this.documentListSubscription) {
            this.documentListSubscription.unsubscribe();
        }
        if (this.scrollHeaderEvent$) {
            this.scrollHeaderEvent$.unsubscribe();
        }
        if (this.scrollBodyEvent$) {
            this.scrollBodyEvent$.unsubscribe();
        }
        if (this.resizeEvent$) {
            this.resizeEvent$.unsubscribe();
        }
        if (this.tabSwitchSubscription) {
            this.tabSwitchSubscription.unsubscribe();
        }
        if (this.tabOpenSubscription) {
            this.tabOpenSubscription.unsubscribe();
        }
        if (this.selectedRowsSubscription) {
            this.selectedRowsSubscription.unsubscribe();
        }
        this.ref.detach();
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.resizableGrid = function () {
        var /** @type {?} */ that = this;
        var /** @type {?} */ thHeight = $('table th:first').height();
        var /** @type {?} */ thead = $(this.getItemRef().querySelector('.tbody-wrapper')).find('table');
        var /** @type {?} */ tbody = $(this.getItemRef().querySelector('.tbody-wrapper')).find('table');
        var /** @type {?} */ columnName = '';
        for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
            if (thead.find('th.column_' + that.columns[j].name).is('.ui-resizable')) {
                thead.find('th.column_' + that.columns[j].name).resizable('destroy');
            }
            thead.find('th.column_' + that.columns[j].name).resizable({
                handles: 'e',
                minHeight: thHeight,
                maxHeight: thHeight,
                animate: true,
                resize: function (event, ui) {
                    // Subtract padding
                    var /** @type {?} */ width = (parseInt(ui.size.width, 0) - 40) + '';
                    that.fieldsByName[columnName]['width'] = width;
                    that.ref.detectChanges();
                },
                stop: function (event, ui) {
                    // Subtract padding
                    var /** @type {?} */ width = (parseInt(ui.size.width, 0) - 40) + '';
                    // Prevent flickering
                    for (var /** @type {?} */ i = 0; i < that.columns.length; i++) {
                        that.fieldsByName[that.columns[i].name]['width'] = thead.find('th.column_' + that.columns[i].name).width();
                    }
                    that.ref.detectChanges();
                    that.fieldsByName[columnName]['width'] = width;
                    that.fieldsByName[columnName]['resizing'] = false;
                    that.fieldsByName[columnName]['size'] = ui.size.width;
                    that.ref.detectChanges();
                    if (that.tableMode === TableModeEnum.Table) {
                        // Save columns sizes
                        var /** @type {?} */ columnsSizes = new Map();
                        for (var /** @type {?} */ key in that.fieldsByName) {
                            if (that.fieldsByName.hasOwnProperty(key)) {
                                var /** @type {?} */ field = (that.fieldsByName[key]);
                                if (that.fieldsByName[field.fieldName]['size']) {
                                    columnsSizes.set(field.id, parseInt(that.fieldsByName[field.fieldName]['size'], 0));
                                }
                                else {
                                    columnsSizes.set(field.id, parseInt(field.width, 0));
                                }
                            }
                        }
                        that.backendService.setColumnsSizes(columnsSizes);
                    }
                    // Prevent flickering
                    for (var /** @type {?} */ i = 0; i < that.columns.length; i++) {
                        that.fieldsByName[that.columns[i].name]['width'] = 'auto';
                        that.fieldsByName[that.columns[i].name]['size'] = that.columns[i].size;
                    }
                },
                start: function (event, ui) {
                    columnName = $(event.target)[0].classList[0].substring(7, $(event.target)[0].classList[0].length);
                    that.fieldsByName[columnName]['resizing'] = true;
                    that.ref.detectChanges();
                },
                alsoResize: tbody.find('th.column_' + that.columns[j].name)
            });
        }
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.dropGrid = function () {
        var /** @type {?} */ self = this;
        if (this.columns.length === 0) {
            return;
        }
        var /** @type {?} */ el = $(this.getItemRef().querySelector('.thead-wrapper')).find('table')[0];
        var /** @type {?} */ dragger = tableDragger(el, {
            mode: 'column',
            dragHandler: '.handle',
            animation: 300
        });
        dragger.on('drop', function (from, to) {
            var /** @type {?} */ f = self.columns[from];
            self.columns[from] = self.columns[to];
            self.columns[to] = f;
            self.ref.detectChanges();
            if (self.tableMode === TableModeEnum.Table) {
                // Save orders
                var /** @type {?} */ columnsOrders = self.columns.map(function (column) { return column.id; });
                self.backendService.setColumnsOrders(columnsOrders);
            }
        });
    };
    /**
     * @return {?}
     */
    ViewTableComponent.prototype.initRowsDragger = function () {
        var _this = this;
        var /** @type {?} */ el = $(this.getItemRef().querySelector('.tbody-wrapper')).find('table')[0];
        var /** @type {?} */ dragger = tableDragger(el, {
            mode: 'row',
            dragHandler: '.handle-row',
            animation: 300,
            onlyBody: true,
        });
        dragger.on('drop', function (from, to) {
            _this.orderedRows = _this.move(_this.orderedRows, from - 1, to - 1);
            _this.orderedRowsChange.next(_this.orderedRows);
        });
    };
    /**
     * @param {?} array
     * @param {?} from
     * @param {?} to
     * @return {?}
     */
    ViewTableComponent.prototype.move = function (array, from, to) {
        array.splice(to, 0, array.splice(from, 1)[0]);
        return array;
    };
    return ViewTableComponent;
}());
ViewTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-view-table',
                template: "\n      <div\n          [ngClass]=\"{'main-table': tableMode === TableModeEnum.Table, 'details-table': tableMode === TableModeEnum.Details}\">\n          <div class=\"panel panel-default\">\n              <div class=\"panel-body\">\n                  <div\n                      class=\"table-responsive\"\n                      [ngClass]=\"{'main': tableMode === TableModeEnum.Table, 'paging': paging, 'sticking': sticking}\">\n                      <table\n                          *ngIf=\"paging\"\n                          class=\"dataTable orderList display table-striped\"\n                          [ngClass]=\"{'pagination-main-table': tableMode === TableModeEnum.Table, 'table': tableMode === TableModeEnum.Table, 'details': tableMode !== TableModeEnum.Table}\"\n                          cellspacing=\"0\"\n                          width=\"100%\">\n                          <tfoot>\n                              <tr>\n                                  <td align=\"left\">\n                                      <div\n                                          class=\"dataTables_length\"\n                                          id=\"{{'DataTables_Table_0_length' + componentGuid + tableMode}}\">\n                                          <label>Prika\u017Ei\n                                              <select name=\"DataTables_Table_0_length\"\n                                                      aria-controls=\"DataTables_Table_0\"\n                                                      class=\"\"\n                                                      [(ngModel)]=\"rowsOnPage\"\n                                                      (change)=\"filter({}, null)\">\n                                                  <option [ngValue]=\"10\">10</option>\n                                                  <option [ngValue]=\"25\">25</option>\n                                                  <option [ngValue]=\"50\">50</option>\n                                                  <option [ngValue]=\"100\">100</option>\n                                                  <option [ngValue]=\"1000\">1000</option>\n                                              </select> stavki</label>\n                                      </div>\n                                  </td>\n                                  <td>\n                                      <util-pagination\n                                          *ngIf=\"_orderList\"\n                                          [pageCurrent]=\"pageCurrent\"\n                                          [pageTotal]=\"totalPages\"\n                                          (page)=\"page($event)\">\n                                      </util-pagination>\n                                  </td>\n                              </tr>\n                          </tfoot>\n                      </table>\n                      <div\n                          class=\"dataTables_wrapper no-footer\"\n                          [ngClass]=\"{'wrapper-main-table': tableMode === TableModeEnum.Table}\">\n                          <div\n                              class=\"thead-wrapper\"\n                              [ngClass]=\"{'thead-wrapper-main-table': tableMode === TableModeEnum.Table}\">\n                              <div [ngClass]=\"{\n                                  'sindu-wrapper': reordable,\n                                  'sindu-wrapper-row': reorderRows\n                              }\">\n                                  <table\n                                      class=\"{{'orderList' + componentGuid + tableMode}}\"\n                                      class=\"dataTable orderList view-table orderList display table table-striped row-border hover\"\n                                      [ngClass]=\"{'columns-main-table': tableMode === TableModeEnum.Table}\"\n                                      cellspacing=\"0\"\n                                      width=\"100%\">\n\n                                      <!-- ### THIS (most likely) IS NOT THE REAL TABLE HEADER, LOOK DOWN!!! -->\n                                      <thead>\n                                          <tr>\n                                              <th *ngFor=\"let column of columns\"\n                                                  title=\"{{column.label}}\"\n                                                  class=\"{{'column_' + column.name}}\"\n                                                  [style.width]=\"fieldsByName[column.name]['resizing'] ? fieldsByName[column.name]['width'] + 'px' : 'auto'\"\n                                                  [style.min-width.px]=\"fieldsByName[column.name]['width']\"\n                                                  [style.max-width.px]=\"fieldsByName[column.name]['width']\"\n                                                  [ngClass]=\"{'right-align': fieldsByName[column.name] | NumberPure, 'hidden': !fieldsByName[column.name]['visible']}\">\n                                                  <div class=\"header-flex\"\n                                                       [ngClass]=\"{'sorting': column.sortable === true, 'sorting_asc': column.name === sortColumnName && sortAscending, 'sorting_desc': column.name === sortColumnName && !sortAscending}\">\n                                                      <!-- <i class=\"handle fa fa-arrows\"></i> -->\n                                                      <span class=\"span-text\"\n                                                            [ngClass]=\"{'sorting': column.sortable === true}\"\n                                                            (click)=\"sortAction(column)\"\n                                                            [attr.data-data-name]=\"column.name\">{{column.label}}</span>\n                                                  </div>\n                                              </th>\n                                              <!-- <th class=\"handle-row-td\" *ngIf=\"reorderRows\">&nbsp;</th> -->\n                                          </tr>\n                                      </thead>\n                                  </table>\n                              </div>\n                          </div>\n\n                          <div\n                              class=\"tbody-wrapper\"\n                              [ngClass]=\"{'tbody-wrapper-main-table': tableMode === TableModeEnum.Table}\">\n                              <div\n                                  [ngClass]=\"{\n                                      'sindu-wrapper': reordable,\n                                      'sindu-wrapper-row': reorderRows\n                                  }\"\n                              >\n                                  <table\n                                      class=\"{{'orderList' + componentGuid + tableMode}}\"\n                                      class=\"dataTable orderList view-table orderList display table table-striped row-border hover\"\n                                      [ngClass]=\"{'columns-main-table': tableMode === TableModeEnum.Table}\"\n                                      cellspacing=\"0\"\n                                      width=\"100%\">\n                                      <thead>\n                                          <tr>\n                                              <th\n                                                  *ngIf=\"showSelectColumn\"\n                                                  style=\"width: 30px !important; min-width: 30px; max-width: 30px; padding-right: 2 !important;\">\n                                              </th>\n                                              <th *ngFor=\"let column of columns\"\n                                                  title=\"{{column.label}}\"\n                                                  class=\"{{'column_' + column.name}}\"\n                                                  [style.width]=\"fieldsByName[column.name]['resizing'] ? fieldsByName[column.name]['width'] + 'px' : 'auto'\"\n                                                  [style.min-width.px]=\"fieldsByName[column.name]['width']\"\n                                                  [style.max-width.px]=\"fieldsByName[column.name]['width']\"\n                                                  [ngClass]=\"{'right-align': fieldsByName[column.name] | NumberPure, 'hidden': !fieldsByName[column.name]['visible']}\">\n\n                                                  <div class=\"header-flex\"\n                                                       [ngClass]=\"{'sorting': column.sortable === true, 'sorting_asc': column.name === sortColumnName && sortAscending, 'sorting_desc': column.name === sortColumnName && !sortAscending}\">\n                                                      <i class=\"handle fa fa-arrows\"></i>\n                                                      <span class=\"span-text\"\n                                                            [ngClass]=\"{'sorting': column.sortable === true}\"\n                                                            (click)=\"sortAction(column)\"\n                                                            [attr.data-data-name]=\"column.name\">{{column.label}}</span>\n\n                                                  </div>\n                                              </th>\n                                              <th class=\"handle-row-td\" *ngIf=\"reorderRows\"></th>\n                                          </tr>\n                                      </thead>\n                                      <tbody>\n                                          <tr *ngFor=\"let order of _orderList; let i = index\"\n                                              class=\"{{ this.selectedRows[i] ? selectedClass : '' }} {{ order.color ? order.color : '' }}\"\n                                              [ngClass]=\"{\n                                                  'default-table-row-height': defaultRowHeight\n                                              }\"\n                                              [attr.data-row-identity]=\"'rbr'\">\n                                              <td *ngIf=\"showSelectColumn\"\n                                                  style=\"width: 30px !important; min-width: 30px; max-width: 30px; padding-right: 2 !important;\">\n                                                  <label class=\"switch switch-small\" *ngIf=\"order && !order.Spica\">\n                                                      <input type=\"checkbox\"\n                                                          class=\"icheckbox\"\n                                                          [ngModel]=\"order.Aktivan\"\n                                                          (ngModelChange)=\"updateAktivan(order)\"\n                                                          [attr.data-data-name]=\"selectedColumn\"\n                                                          [attr.data-data-type]=\"'check'\"\n                                                          [disabled]=\"order.Modifikovano\"\n                                                      />\n                                                      <span class=\"checkbox-span\"></span>\n                                                  </label>\n                                              </td>\n                                              <td *ngFor=\"let column of columns\"\n                                                  [style.min-width.px]=\"fieldsByName[column.name]['width']\"\n                                                  [style.max-width.px]=\"fieldsByName[column.name]['width']\"\n                                                  [ngClass]=\"{'right-align': fieldsByName[column.name] | NumberPure, 'hidden': !fieldsByName[column.name]['visible']}\"\n                                                  [attr.data-data-fieldname]=\"fieldsByName[column.name]['fieldName']\"\n                                                  [attr.data-column-type]=\"fieldsByName[column.name]['type']\"\n                                                  [attr.data-data-name]=\"fieldsByName[column.name]['fieldKey']\"\n                                                  [attr.data-data-type]=\"fieldsByName[column.name]['type']\"\n                                                  (click)=\"onInlineSelect(order, i, $event, column.name)\">\n                                                  <span\n                                                      *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Input &&\n                                                          (!!!fieldsByName[column.name]['dbType'] ||\n                                                          (!!fieldsByName[column.name]['dbType'] && fieldsByName[column.name]['dbType'].indexOf('DECIMAL') === -1))\"\n                                                      title=\"{{order | fieldViewText: fieldsByName[column.name]}}\"\n                                                      class='span-text'\n                                                      [attr.data-data-id]=\"order?.id\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewText: fieldsByName[column.name]}}</span>\n\n                                                  <span\n                                                      *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Input &&\n                                                      !!fieldsByName[column.name]['dbType'] &&\n                                                      fieldsByName[column.name]['dbType'].indexOf('DECIMAL') !== -1\"\n                                                      title=\"{{order | fieldViewDecimal: fieldsByName[column.name]}}\"\n                                                      class='span-text'\n                                                      [attr.data-data-id]=\"order?.id\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewDecimal: fieldsByName[column.name]}}</span>\n\n                                                  <span\n                                                      *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Completer\"\n                                                      class='span-text'\n                                                      title=\"{{order | fieldViewCompleter: fieldsByName[column.name]}}\"\n                                                      [attr.data-data-id]=\"order?.id\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCompleter: fieldsByName[column.name]}}</span>\n\n                                                  <span\n                                                      *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.ComboFixed || fieldsByName[column.name]['type'] === FieldTypeEnum.Combo\"\n                                                      class='span-text'\n                                                      title=\"{{getComboFixedText(order, column.name)}}\"\n                                                      [attr.data-data-id]=\"order?.id\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\">{{getComboFixedText(order, column.name)}}</span>\n\n                                                  <span\n                                                      *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Check\"\n                                                      class='span-text'\n                                                      [attr.data-data-id]=\"order?.id\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\"></span>\n                                                  <label\n                                                      *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Check\"\n                                                      class=\"switch switch-small\">\n                                                      <input\n                                                          type=\"checkbox\"\n                                                          class=\"icheckbox\"\n                                                          [ngModel]=\"getInputValue(order, column.name)\"\n                                                          [attr.data-data-name]=\"column.name\"\n                                                          [attr.data-data-type]=\"'check'\"\n                                                          [attr.disabled]=\"true\" />\n                                                      <span class=\"checkbox-span\"></span>\n                                                  </label>\n\n                                                  <span\n                                                      *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Date\"\n                                                      class='span-text'\n                                                      title=\"{{order | fieldViewDate: fieldsByName[column.name]}}\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\"\n                                                      [attr.data-data-id]=\"order?.id\">{{order | fieldViewDate: fieldsByName[column.name] : customDateFormat}}</span>\n\n                                                  <span\n                                                      *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Time\"\n                                                      class='span-text'\n                                                      title=\"{{order | fieldViewTime: fieldsByName[column.name]}}\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\"\n                                                      [attr.data-data-id]=\"order?.id\">{{order | fieldViewTime: fieldsByName[column.name]}}</span>\n                                                  <div\n                                                       *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Complex &&\n                                                  _complexSettings && _complexSettings.length > 0 && _complexSettings.length === _orderList.length\">\n                                                      <div\n                                                          *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Input &&\n                                                          (!!!_complexSettings[i][column.name]['dbType'] ||\n                                                          (!!_complexSettings[i][column.name]['dbType'] && _complexSettings[i][column.name]['dbType'].indexOf('DECIMAL') === -1))\"\n                                                          title=\"{{order | fieldViewText: _complexSettings[i][column.name]}}\">\n                                                          <span\n                                                              title=\"{{order | fieldViewText: _complexSettings[i][column.name]}}\"\n                                                              class='span-text'\n                                                              [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                              [attr.data-data-id]=\"order?.id\"\n                                                              [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewText: _complexSettings[i][column.name]}}\n                                                          </span>\n                                                      </div>\n                                                      <div\n                                                          *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Input &&\n                                                      !!_complexSettings[i][column.name]['dbType'] &&\n                                                      _complexSettings[i][column.name]['dbType'].indexOf('DECIMAL') !== -1\"\n                                                          title=\"{{order | fieldViewText: _complexSettings[i][column.name]}}\">\n                                                          <span\n                                                              title=\"{{order | fieldViewDecimal: _complexSettings[i][column.name]}}\"\n                                                              class='span-text'\n                                                              [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                              [attr.data-data-id]=\"order?.id\"\n                                                              [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewDecimal: _complexSettings[i][column.name]}}</span>\n                                                      </div>\n                                                      <div\n                                                           *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Completer\">\n                                                          <span\n                                                              class='span-text'\n                                                              title=\"{{order | fieldViewCompleter: _complexSettings[i][column.name]}}\"\n                                                              [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                              [attr.data-data-id]=\"order?.id\"\n                                                              [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCompleter: _complexSettings[i][column.name]}}</span>\n                                                      </div>\n                                                      <div\n                                                           *ngIf=\"(_complexSettings[i][column.name]['type'] === FieldTypeEnum.Combo)\">\n                                                          <span\n                                                              class='span-text'\n                                                              title=\"{{order | fieldViewCombo: _complexSettings[i][column.name]}}\"\n                                                              [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                              [attr.data-data-id]=\"order?.id\"\n                                                              [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCombo: _complexSettings[i][column.name]}}</span>\n                                                      </div>\n                                                      <div\n                                                           *ngIf=\"(_complexSettings[i][column.name]['type'] === FieldTypeEnum.ComboFixed)\">\n                                                          <span\n                                                              class='span-text'\n                                                              title=\"{{getComboFixedText(order, column.name, _complexSettings[i][column.name])}}\"\n                                                              [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                              [attr.data-data-id]=\"order?.id\"\n                                                              [attr.data-data-rbr]=\"order?.rbr\">{{getComboFixedText(order, column.name, _complexSettings[i][column.name])}}</span>\n                                                      </div>\n                                                      <div\n                                                           *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Check\">\n                                                          <span\n                                                              class='span-text'\n                                                              [attr.data-data-id]=\"order?.id\"\n                                                              [attr.data-data-rbr]=\"order?.rbr\"></span>\n                                                          <label class=\"switch switch-small\">\n                                                              <input\n                                                                  type=\"checkbox\"\n                                                                  class=\"icheckbox\"\n                                                                  [ngModel]=\"getInputValue(order, column.name)\"\n                                                                  (ngModelChange)=\"fieldUpdateValue(_complexSettings[i], $event, order, i)\"\n                                                                  [attr.data-data-name]=\"column.name\"\n                                                                  [attr.data-data-type]=\"'check'\"\n                                                                  [attr.disabled]=\"true\" />\n                                                              <span class=\"checkbox-span\"></span>\n                                                          </label>\n                                                      </div>\n                                                      <div\n                                                           *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Date\">\n                                                          <span\n                                                              class='span-text'\n                                                              title=\"{{order | fieldViewDate: _complexSettings[i][column.name]}}\"\n                                                              [attr.data-data-rbr]=\"order?.rbr\"\n                                                              [attr.data-data-id]=\"order?.id\">{{order | fieldViewDate: _complexSettings[i][column.name]}}</span>\n                                                      </div>\n                                                      <div\n                                                           *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Time\">\n                                                          <span\n                                                              class='span-text'\n                                                              title=\"{{order | fieldViewTime: _complexSettings[i][column.name]}}\"\n                                                              [attr.data-data-rbr]=\"order?.rbr\"\n                                                              [attr.data-data-id]=\"order?.id\">{{order | fieldViewTime: _complexSettings[i][column.name]}}</span>\n                                                      </div>\n                                                  </div>\n                                              </td>\n                                              <td *ngIf=\"reorderRows\">\n                                                  <div class=\"row-flex\">\n                                                      <i class=\"handle-row fa fa-arrows\"></i>\n                                                  </div>\n                                              </td>\n                                          </tr>\n                                      </tbody>\n                                  </table>\n                              </div>\n                          </div>\n                      </div>\n                  </div>\n              </div>\n          </div>\n      </div>\n    ",
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
/**
 * @nocollapse
 */
ViewTableComponent.ctorParameters = function () { return [
    { type: BackendService, },
    { type: AuthenticationService, },
    { type: ActivatedRoute, },
    { type: DaterangepickerConfig, },
    { type: ChangeDetectorRef, },
    { type: FieldService, },
    { type: ListService, },
    { type: ApplicationService, },
    { type: ElementRef, },
]; };
ViewTableComponent.propDecorators = {
    'ident': [{ type: Input },],
    'identity': [{ type: Input },],
    'paging': [{ type: Input },],
    'serverPagination': [{ type: Input },],
    'sortingEnabled': [{ type: Input },],
    'sticking': [{ type: Input },],
    'resizable': [{ type: Input },],
    'reordable': [{ type: Input },],
    'reorderRows': [{ type: Input },],
    'showSelectColumn': [{ type: Input },],
    'customDateFormat': [{ type: Input },],
    'fieldsResticted': [{ type: Input },],
    'tableMode': [{ type: Input },],
    'mode': [{ type: Input },],
    'tableAction': [{ type: Output, args: ['tableAction',] },],
    'orderedRowsChange': [{ type: Output, args: ['orderedRowsChange',] },],
    'onRowSelected': [{ type: Output, args: ['onRowSelected',] },],
    'pageCurrent': [{ type: Input },],
    'selectedClass': [{ type: Input },],
    'defaultRowHeight': [{ type: Input },],
    'pageChange': [{ type: Output },],
    'selectedObjectChange': [{ type: Output },],
    'selectRows': [{ type: Input },],
    'selectedObject': [{ type: Input },],
    'complexSettings': [{ type: Input },],
    'settings': [{ type: Input },],
    'orderListCount': [{ type: Input },],
    'orderList': [{ type: Input },],
};
var RtsBackendService = /** @class */ (function () {
    /**
     * @param {?} _http
     */
    function RtsBackendService(_http) {
        this._http = _http;
        this._gatewayUrlGet = environment.rtsApiGatewayGet;
    }
    /**
     * @param {?} formCode
     * @param {?} formName
     * @param {?=} skipSettings
     * @param {?=} filter
     * @param {?=} endPointType
     * @return {?}
     */
    RtsBackendService.prototype.fetchSettings = function (formCode, formName, skipSettings, filter, endPointType) {
        if (skipSettings === void 0) { skipSettings = 'false'; }
        if (filter === void 0) { filter = null; }
        if (endPointType === void 0) { endPointType = 'AllEntities'; }
        var /** @type {?} */ params = this.getRequestParams(formCode, formName, endPointType, skipSettings, filter);
        return this._http.get(this._gatewayUrlGet, params);
    };
    /**
     * @param {?} formCode
     * @param {?} formName
     * @param {?} endPointType
     * @param {?} skipSettings
     * @param {?} filter
     * @return {?}
     */
    RtsBackendService.prototype.getRequestParams = function (formCode, formName, endPointType, skipSettings, filter) {
        var /** @type {?} */ params = {
            formCode: formCode,
            formName: formName,
            endPointType: endPointType,
            skipSettings: skipSettings
        };
        if (filter) {
            var /** @type {?} */ headers = new HttpHeaders({
                Filters: filter,
            });
            return { params: params, headers: headers };
        }
        return { params: params };
    };
    return RtsBackendService;
}());
RtsBackendService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
RtsBackendService.ctorParameters = function () { return [
    { type: HttpClient, },
]; };
var AutocompleteComponent = /** @class */ (function () {
    /**
     * @param {?} eRef
     * @param {?} listService
     * @param {?} authenticationService
     * @param {?} backendService
     * @param {?} rtsBackendService
     */
    function AutocompleteComponent(eRef, listService, authenticationService, backendService, rtsBackendService) {
        this.eRef = eRef;
        this.listService = listService;
        this.authenticationService = authenticationService;
        this.backendService = backendService;
        this.rtsBackendService = rtsBackendService;
        this.FormModeEnum = FormModeEnum;
        this.TableModeEnum = TableModeEnum;
        this.lastUsedFilter = {
            pageCurrent: 1,
            filterQuery: '',
            filterDate: '',
            filterObjects: [],
            filterCombined: null,
            rowsOnPage: 25,
            sortOrder: {},
            direction: 'asc',
            relations: null
        };
        this.disabled = false;
        this.placeholder = '';
        this.tag = null; // Used by parent components to tag instances. Not to be used internally
        this.showSpotCheckbox = true;
        this.isMontaza = false;
        this.refreshOnClose = true;
        this.customOrderColumn = null;
        this.help1 = '';
        this.formatedCurrentText = '';
        this.settingsTableSource = new Subject$1();
        this.settingsTable$ = this.settingsTableSource.asObservable();
        this.orderListCountSource = new Subject$1();
        this.orderListCount$ = this.orderListCountSource.asObservable();
        this.documentListSource = new Subject$1();
        this.documentList$ = this.documentListSource.asObservable();
        this.refreshFilterSource = new Subject$1();
        this.refreshFilter$ = this.refreshFilterSource.asObservable();
        this.currentPage = 1;
        this._selectedItem = null;
        this.selectedItemChange = new EventEmitter();
        this.serverPagination = true;
        this.settingsTable = null;
        this.dropdownList = null;
        this.popupRequestCounter = new RequestCounter();
        this.componentGuid = null;
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(AutocompleteComponent.prototype, "selectedItem", {
        /**
         * @return {?}
         */
        get: function () {
            return this._selectedItem;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.setSelectedItem(value, false);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} filter
     * @return {?}
     */
    AutocompleteComponent.prototype.onInitFilter = function (filter) {
        this.lastUsedFilter.filterObjects.push(filter);
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.resetTableData = function () {
        this.tables.forEach(function (child) {
            child.resetData();
        });
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.isSet = function () {
        if (this._selectedItem == null ||
            this.fieldSettings.relation == null ||
            (this._selectedItem.hasOwnProperty('id') &&
                this._selectedItem.id == null)) {
            return false;
        }
        return true;
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.setFormatedCurrentText = function () {
        if (this.isSet()) {
            var /** @type {?} */ value = this.getVal(this._selectedItem);
            var /** @type {?} */ key = '';
            // TODO: What is completerMainAndSecond?
            // It tells should completerMain be shown
            if (this.fieldSettings.relation.hasOwnProperty('completerMainAndSecond') &&
                this.fieldSettings.relation['completerMainAndSecond']) {
                key = this.getKey(this._selectedItem);
            }
            if (key && key !== '' && value) {
                this.formatedCurrentText = key + ': ' + value;
            }
            else if (key && key !== '') {
                this.formatedCurrentText = key;
            }
            else if (value) {
                this.formatedCurrentText = value;
            }
            else {
                this.formatedCurrentText = '';
            }
        }
        else {
            this.formatedCurrentText = '';
        }
    };
    /**
     * @param {?} item
     * @param {?} event
     * @return {?}
     */
    AutocompleteComponent.prototype.itemPicked = function (item, event) {
        var _this = this;
        event.preventDefault();
        event.stopPropagation();
        this.fetchSelectedObject(item).subscribe(function (data) {
            _this.setSelectedItem(data);
            setTimeout(function () {
                $(_this.getItemRef().querySelector('input')).focus();
                $(_this.getItemRef().querySelector('input')).select();
            }, 0);
            _this.hideErrors();
            _this.closePopup();
        });
        // this.setSelectedItem(item);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutocompleteComponent.prototype.currentTextChange = function (event) {
        var _this = this;
        var /** @type {?} */ self = this;
        var /** @type {?} */ filter = $(this.getItemRef().querySelector('input')).val();
        var /** @type {?} */ requestNumber = this.popupRequestCounter.nextRequestNumber();
        if (filter && filter.length) {
            this.getDataObservable(encodeURIComponent(filter), true, true).subscribe(function (data) {
                data = _this.getServiceData(data);
                if (!_this.popupRequestCounter.markResponse(requestNumber)) {
                    return;
                }
                var /** @type {?} */ newData = [];
                if (self.fieldsResticted) {
                    for (var /** @type {?} */ i = 0; i < data.length; i++) {
                        if (self.fieldsResticted.entityType ===
                            self.fieldSettings.entityType) {
                            var /** @type {?} */ val = data[i];
                            for (var /** @type {?} */ k = 0; k < self.fieldsResticted.path.length; k++) {
                                val = val[self.fieldsResticted.path[k]];
                            }
                            if (val === self.fieldsResticted.filterBy) {
                                newData.push(data[i]);
                            }
                        }
                        else {
                            newData.push(data[i]);
                        }
                    }
                }
                else {
                    newData = data;
                }
                _this.dropdownList = data.slice(0, 5);
                _this.closePopup();
                if (_this.dropdownList.length > 0) {
                    _this.showPopup();
                }
            });
        }
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.isPopupVisible = function () {
        return $(this.getItemRef().querySelector('.popup')).hasClass('show');
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.closePopup = function () {
        $(this.getItemRef().querySelector('.popup')).removeClass('show');
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.showPopup = function () {
        var /** @type {?} */ input = $(this.getItemRef().querySelector('input'));
        if (input.parents('.isRowInAction').length) {
            var /** @type {?} */ offsetLeft = $(this.getItemRef().querySelector('input')).offset().left;
            var /** @type {?} */ offsetTop = $(this.getItemRef().querySelector('input')).offset().top +
                30 -
                $(window).scrollTop();
            $(this.getItemRef().querySelector('.popup')).css({
                top: offsetTop,
                left: offsetLeft
            });
        }
        $(this.getItemRef().querySelector('.popup')).addClass('show');
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.blur = function () {
        this.validateCurrentText();
        setTimeout(function (self) {
            self.closePopup();
        }, 0, this);
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @param {?} item
     * @param {?=} raiseChangeEvent
     * @return {?}
     */
    AutocompleteComponent.prototype.setSelectedItem = function (item, raiseChangeEvent) {
        if (raiseChangeEvent === void 0) { raiseChangeEvent = true; }
        var /** @type {?} */ params = {
            columnItem: this.fieldSettings,
            value: item,
            oldValue: this.selectedItem
        };
        this._selectedItem = item;
        this.setFormatedCurrentText();
        if (raiseChangeEvent) {
            this.selectedItemChange.emit(params);
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    AutocompleteComponent.prototype.getKey = function (item) {
        return UtilService.getFieldObject(item, this.fieldSettings.relationKey.all);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    AutocompleteComponent.prototype.getVal = function (item) {
        return UtilService.getFieldObject(item, this.fieldSettings.relationValue.all);
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.setAllFields = function () {
        for (var /** @type {?} */ i = 0; i < this.settingsFilter.fieldList.length; i++) {
            var /** @type {?} */ fieldData = this.settingsFilter.fieldList[i];
            var /** @type {?} */ filterWithItem = JSON.parse(JSON.stringify(fieldData));
            filterWithItem.fieldMapItem = UtilService.getFieldMapItem(this.settingsFilter.relations, fieldData);
            this.settingsFilter.fieldList[i].filterMapItems = [];
            this.settingsFilter.fieldList[i].filterMapItems.push(filterWithItem);
        }
    };
    /**
     * @param {?} filter
     * @param {?=} dropDown
     * @param {?=} skipSettings
     * @return {?}
     */
    AutocompleteComponent.prototype.getDataObservable = function (filter, dropDown, skipSettings) {
        if (dropDown === void 0) { dropDown = false; }
        if (dropDown) {
            this.lastUsedFilter = {
                pageCurrent: 1,
                filterQuery: '',
                filterDate: '',
                filterObjects: [],
                filterCombined: null,
                rowsOnPage: 25,
                sortOrder: {},
                direction: 'asc',
                relations: null
            };
            var /** @type {?} */ lastusedFilter = this.lastUsedFilter;
            lastusedFilter['pageCurrent'] = 1;
            lastusedFilter['rowsOnPage'] = 5;
            return this.rtsBackendService.fetchSettings(this.fieldSettings.lookupFormCode, this.fieldSettings.lookupFormName, 'true', this.getDropDownFilterString(filter, lastusedFilter));
        }
        else if (this.serverPagination) {
            return this.rtsBackendService.fetchSettings(this.fieldSettings.lookupFormCode, this.fieldSettings.lookupFormName, skipSettings ? 'true' : null, this.getFilterString());
        }
    };
    /**
     * @param {?} value
     * @param {?} lastUsedFilter
     * @return {?}
     */
    AutocompleteComponent.prototype.getDropDownFilterString = function (value, lastUsedFilter) {
        var /** @type {?} */ str = '';
        if (value) {
            str = "?completerSearch=" + encodeURIComponent(value) + "&pageNumber=" + lastUsedFilter.pageCurrent + "&pageSize=" + lastUsedFilter.rowsOnPage;
        }
        str += this.getInitFilterString();
        return str;
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.getFilterString = function () {
        var /** @type {?} */ str = '';
        var /** @type {?} */ hasSort = this.lastUsedFilter.sortOrder && this.lastUsedFilter.sortOrder.fieldName;
        str = "?pageNumber=" + this.lastUsedFilter.pageCurrent
            + ("&pageSize=" + this.lastUsedFilter.rowsOnPage)
            + ("" + (hasSort ? "&order=" + this.lastUsedFilter.sortOrder.fieldName : ''))
            + ("" + (hasSort ? "&orderDirection=" + this.lastUsedFilter.direction : ''));
        if (this.lastUsedFilter.filterObjects.length) {
            this.lastUsedFilter.filterObjects.forEach(function (fo) {
                if (fo.type === 'date') {
                    if (typeof (fo.value) !== 'undefined' && fo.value) {
                        str += "&" + fo.name + "=" + moment(fo.value).format('YYYY-MM-DD');
                    }
                }
                else if (fo.type === 'check') {
                    var /** @type {?} */ isTrue = fo.value === 1;
                    str += "&" + fo.name + "=" + isTrue;
                }
                else {
                    str += "&" + fo.name + "=" + encodeURIComponent(fo.value);
                }
            });
        }
        str += this.getInitFilterString();
        return str;
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.getInitFilterString = function () {
        var /** @type {?} */ str = '';
        if (this.fieldSettings.lookupInitFilter) {
            this.fieldSettings.lookupInitFilter.forEach(function (f) { return str += "&" + f.name + "=" + f.value; });
        }
        return str;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutocompleteComponent.prototype.keyDown = function (event) {
        if (this.handleCommandKeys(event) &&
            $(this.getItemRef().querySelector('.popup ul')).length > 0) {
            $(this.getItemRef().querySelector('.popup ul')).focus();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutocompleteComponent.prototype.handleCommandKeys = function (event) {
        switch (event.keyCode) {
            case 38: // Up arrow
                if (typeof this.dropdownSelectedIndex !== 'undefined') {
                    this.dropdownSelectedIndex = this.dropdownSelectedIndex - 1;
                }
                else {
                    if (this.dropdownList) {
                        this.dropdownSelectedIndex =
                            this.dropdownList.length - 1;
                    }
                }
                if (this.dropdownSelectedIndex < 0) {
                    this.dropdownSelectedIndex = 0;
                }
                return true;
            case 40: // Down arrow
                if (typeof this.dropdownSelectedIndex !== 'undefined') {
                    this.dropdownSelectedIndex = this.dropdownSelectedIndex + 1;
                }
                else {
                    this.dropdownSelectedIndex = 0;
                }
                if (this.dropdownList &&
                    this.dropdownSelectedIndex > this.dropdownList.length - 1) {
                    this.dropdownSelectedIndex = this.dropdownList.length - 1;
                }
                return true;
            case 13: // Enter
                var /** @type {?} */ selectedRow = this.eRef.nativeElement.querySelector('li.selected');
                if (selectedRow) {
                    selectedRow.dispatchEvent(new CustomEvent('mousedown'));
                }
                event.preventDefault();
                event.stopPropagation();
                return false;
            case 9: // Tab
            case 16: // Shift - why are we reacting to Shift?!
                if (this.isPopupVisible() &&
                    this.dropdownList &&
                    this.dropdownList.length > 0) {
                    var /** @type {?} */ value = $(this.getItemRef().querySelector('input')).val();
                    var /** @type {?} */ listItemValue = this.getVal(this.dropdownList[0]);
                    var /** @type {?} */ listItemKey = this.getKey(this.dropdownList[0]);
                    // TODO Item selecting logic needs fixing - what if "value" is only a part of the only(!) item-key/value?
                    if (value.toLowerCase() === listItemValue.toLowerCase() ||
                        value.toLowerCase() === listItemKey.toLowerCase()) {
                        this.setSelectedItem(this.dropdownList[0]);
                    }
                }
                return false;
            default:
                return false;
        }
    };
    /**
     * @param {?} help1
     * @return {?}
     */
    AutocompleteComponent.prototype.showErrors = function (help1) {
        $(this.getItemRef().querySelector('input')).addClass('error');
        this.help1 = help1;
        $(this.getItemRef().querySelector('.formError'))
            .show()
            .delay(5000)
            .fadeOut();
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.hideErrors = function () {
        $(this.getItemRef().querySelector('input')).removeClass('error');
        this.help1 = '';
        $(this.getItemRef().querySelector('.formError')).hide();
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.validate = function () {
        var /** @type {?} */ help1;
        var /** @type {?} */ val = $(this.getItemRef().querySelector('input')).val();
        if (this.fieldSettings.mandatory &&
            (typeof val === 'undefined' || val === '')) {
            help1 = '* Vrednost je obavezna';
        }
        if (help1) {
            this.showErrors(help1);
            return false;
        }
        else {
            this.hideErrors();
            return true;
        }
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.validateCurrentText = function () {
        var /** @type {?} */ help1;
        var /** @type {?} */ isValid = true;
        if (this.isSet()) {
            var /** @type {?} */ value = this.getVal(this._selectedItem);
            var /** @type {?} */ key = '';
            // TODO: What is 'completerMainAndSecond'? Probably should be removed
            if (this.fieldSettings.relation.hasOwnProperty('completerMainAndSecond') &&
                this.fieldSettings.relation['completerMainAndSecond']) {
                key = this.getKey(this._selectedItem);
            }
            var /** @type {?} */ forValidation = '';
            if (key && key !== '' && value) {
                forValidation = key + ': ' + value;
            }
            else if (key && key !== '') {
                forValidation = key;
            }
            else if (value) {
                forValidation = value;
            }
            else {
                forValidation = '';
            }
            if (forValidation ===
                $(this.getItemRef().querySelector('input')).val()) {
                this.hideErrors();
            }
            else {
                this.setSelectedItem(null);
                if (this.fieldSettings.mandatory) {
                    help1 = '* Vrednost je obavezna';
                    this.showErrors(help1);
                    isValid = false;
                }
                else {
                    this.hideErrors();
                }
            }
        }
        else {
            this.setSelectedItem(null);
            if (this.fieldSettings.mandatory) {
                help1 = '* Vrednost je obavezna';
                this.showErrors(help1);
                isValid = false;
            }
            else {
                this.hideErrors();
            }
        }
        return isValid;
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.closeModal = function () {
        $("#autocomplete_" + this.componentGuid).append($("#modal > #autocompleteModal_" + this.componentGuid));
        $('#modal-parent').hide();
        if (this.refreshOnClose) {
            this.refreshFilterSource.next();
        }
    };
    /**
     * @param {?} obj
     * @param {?} fields
     * @param {?} val
     * @return {?}
     */
    AutocompleteComponent.prototype.setNestedPropertyValue = function (obj, fields, val) {
        fields = fields.split('.');
        var /** @type {?} */ cur = obj;
        var /** @type {?} */ last = fields.pop();
        fields.forEach(function (field) {
            cur[field] = {};
            cur = cur[field];
        });
        cur[last] = val;
        return obj;
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.resetAllFields = function () {
        if (this.settingsFilter && this.settingsFilter.fieldList.length) {
            var /** @type {?} */ list = this.settingsFilter.fieldList;
            for (var /** @type {?} */ i = 0; i < list.length; i++) {
                switch (list[i].type) {
                    case FieldTypeEnum.Date:
                    case FieldTypeEnum.DateTime:
                    case FieldTypeEnum.Input:
                    case FieldTypeEnum.Combo:
                    case FieldTypeEnum.ComboFixed:
                        if (list[i].hasOwnProperty('value')) {
                            delete list[i].value;
                        }
                        break;
                    case FieldTypeEnum.Check:
                        if (list[i].hasOwnProperty('value')) {
                            list[i].value = 0;
                        }
                }
            }
        }
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.openModal = function () {
        var _this = this;
        this.resetTableData();
        this.resetAllFields();
        this.rtsBackendService
            .fetchSettings(this.fieldSettings.lookupFormCode, this.fieldSettings.lookupFormName, 'false', this.getFilterString())
            .subscribe(function (results) {
            var /** @type {?} */ settingsForLookup = results.Settings;
            var /** @type {?} */ data = _this.getServiceData(results);
            _this.alterSettings(settingsForLookup);
            _this.settingsTable = new TableSettings(settingsForLookup, 'lookupTable');
            _this.settingsTableSource.next(_this.settingsTable);
            _this.settingsFilter = new FilterSettings(settingsForLookup);
            _this.setAllFields();
            // this.getDataObservable(null).subscribe(results2 => {
            if (data) {
                var /** @type {?} */ count = results.ServiceData.DataSumCount;
                if (!$('.autocomplete-modal').is(':not(:hidden)')) {
                    $('#modal-parent').show();
                    $('#modal').append($("#autocomplete_" + _this.componentGuid + " > #autocompleteModal_" + _this.componentGuid));
                    _this.orderListCountSource.next(count);
                    _this.documentListSource.next(data);
                }
            }
            // });
        });
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.showModa = function () {
    };
    /**
     * @param {?} settings
     * @return {?}
     */
    AutocompleteComponent.prototype.alterSettings = function (settings) {
        if (settings.group === 'Spot') {
            var /** @type {?} */ vzIndex = settings.filterFields.findIndex(function (f) { return f.name === 'VrstaZabraneId'; });
            if (!this.showSpotCheckbox) {
                var /** @type {?} */ spotoviIndex = settings.filterFields.findIndex(function (f) { return f.name === 'SviSpotovi'; });
                settings.filterFields.splice(spotoviIndex, 1);
            }
            var /** @type {?} */ vz = settings.filterFields[vzIndex];
            settings.filterFields.splice(vzIndex, 1);
            settings.filterFields.splice(3, 0, vz);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutocompleteComponent.prototype.listTableAction = function (event) {
        var _this = this;
        switch (event.action) {
            case TableActionEnum.Select:
                this.setSelectedItem(event.document);
                setTimeout(function () {
                    _this.hideErrors();
                    _this.closePopup();
                    $(_this.getItemRef().querySelector('input')).focus();
                    $(_this.getItemRef().querySelector('input')).select();
                }, 0);
                this.closeModal();
                break;
            case TableActionEnum.Filter:
                var /** @type {?} */ filterQuery = this.lastUsedFilter.filterQuery;
                var /** @type {?} */ filterDate = this.lastUsedFilter.filterDate;
                this.lastUsedFilter.filterQuery = filterQuery;
                this.lastUsedFilter.filterDate = filterDate;
                this.lastUsedFilter.sortOrder = event.filter.sortOrder;
                this.lastUsedFilter.direction = event.filter.direction;
                this.lastUsedFilter.rowsOnPage = event.filter.rowsOnPage;
                this.lastUsedFilter.pageCurrent = event.filter.pageCurrent;
                this.currentPage = event.filter.pageCurrent;
                // this.lastUsedFilter.filterObjects = [];
                this.lastUsedFilter.filterCombined = this.listService.getFilterCombined(this.backendService.getSettings(this.fieldSettings.entityType), event.filter, this.lastUsedFilter.filterDate, this.lastUsedFilter.filterObjects, true);
                this.refreshTable(true);
                break;
        }
    };
    /**
     * @param {?} entity
     * @return {?}
     */
    AutocompleteComponent.prototype.fetchSelectedObject = function (entity) {
        if (UtilService.valueExists(this.fieldSettings.relation.idProperty)) {
            var /** @type {?} */ idRelation = new PathParts(this.fieldSettings.relation.idProperty.split('.'));
            var /** @type {?} */ id = UtilService.getFieldObject(entity, idRelation.all);
            var /** @type {?} */ username = this.authenticationService.getUser().username;
            if (this.fieldSettings.relation.documentType ===
                DocumentTypeEnum.Sifarnik) {
                return this.backendService.fetchOrder(this.fieldSettings.relation.group, id, username);
            }
            if (this.fieldSettings.relation.documentType ===
                DocumentTypeEnum.Dokument) {
                return this.backendService.fetchDocument(this.fieldSettings.relation.group, this.fieldSettings.relation.vrstaDokumenta, id, username);
            }
        }
        return Observable$1.of(entity);
    };
    /**
     * @param {?} skipSettings
     * @return {?}
     */
    AutocompleteComponent.prototype.refreshTable = function (skipSettings) {
        var _this = this;
        var /** @type {?} */ getList = this.getDataObservable(null, null, true);
        getList.subscribe(function (data) {
            _this.orderListCountSource.next(data.ServiceData.DataSumCount);
            _this.documentListSource.next(_this.getServiceData(data));
        });
    };
    /**
     * @param {?} response
     * @return {?}
     */
    AutocompleteComponent.prototype.getServiceData = function (response) {
        var /** @type {?} */ data = Array.isArray(response.ServiceData)
            ? response.ServiceData
            : response.ServiceData.Data;
        if (this.isMontaza) {
            data.forEach(function (d) {
                if (d.Status === 2) {
                    d.color = 'danger';
                }
            });
        }
        else {
            for (var /** @type {?} */ i = 0; i < data.length; i++) {
                if (data[i].ParentId !== null && data[i].ParentId !== undefined) {
                    data[i].color = 'danger';
                }
            }
        }
        return data;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutocompleteComponent.prototype.filterAction = function (event) {
        switch (event.action) {
            case FilterActionEnum.Filter:
                this.lastUsedFilter.filterQuery = event.filter.filterQuery;
                this.lastUsedFilter.filterDate = event.filter.filterDate;
                this.lastUsedFilter.filterObjects = event.filter.filterObjects;
                this.lastUsedFilter.pageCurrent = 1;
                this.currentPage = 1;
                this.lastUsedFilter.filterCombined = this.listService.getFilterCombined(this.backendService.getSettings(this.fieldSettings.entityType), null, this.lastUsedFilter.filterQuery, this.lastUsedFilter.filterDate, this.lastUsedFilter.filterObjects, true);
                this.refreshTable(true);
                break;
        }
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.ngOnInit = function () {
        if (this.customOrderColumn) {
            this.lastUsedFilter.sortOrder.fieldName = this.customOrderColumn;
            this.lastUsedFilter.direction = 'desc';
        }
        this.setFormatedCurrentText();
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.ngOnDestroy = function () {
    };
    return AutocompleteComponent;
}());
AutocompleteComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-autocomplete',
                template: "\n      <div id=\"autocomplete_{{ componentGuid }}\" class=\"autocomplete util-autocomplete\">\n          <div class=\"input-box\">\n              <input\n                  type=\"text\"\n                  data-data-type=\"completer\"\n                  class=\"form-control autocompleter\"\n                  [ngClass]=\"{ 'bold-autocomplete': isMontaza }\"\n                  [placeholder]=\"placeholder\"\n                  [ngModelOptions]=\"{standalone: true}\"\n                  (blur)=\"blur()\"\n                  (input)=\"currentTextChange($event)\"\n                  (keydown)=\"keyDown($event)\"\n                  [(ngModel)]=\"formatedCurrentText\"\n                  [attr.disabled]=\"disabled ? true : null\"\n              />\n              <a href=\"javascript:void(0)\" tabindex=\"-1\" (click)=\"openModal($event)\" class=\"search-icon\" [attr.hidden]=\"disabled ? true : null\">\n                  <span class=\"fa fa-search\"></span>\n              </a>\n              <div class=\"formError\"\n                  [ngClass]=\"{'show': fieldSettings && fieldSettings?.errorMessage !== ''}\"\n                  (click)=\"hideErrors()\">\n                  <div class=\"formErrorArrow formErrorArrowBottom\">\n                      <div class=\"line1\"><!-- --></div>\n                      <div class=\"line2\"><!-- --></div>\n                      <div class=\"line3\"><!-- --></div>\n                      <div class=\"line4\"><!-- --></div>\n                      <div class=\"line5\"><!-- --></div>\n                      <div class=\"line6\"><!-- --></div>\n                      <div class=\"line7\"><!-- --></div>\n                      <div class=\"line8\"><!-- --></div>\n                      <div class=\"line9\"><!-- --></div>\n                      <div class=\"line10\"><!-- --></div>\n                  </div>\n                  <div class=\"formErrorContent\">\n                      {{help1}}\n                  </div>\n              </div>\n          </div>\n\n          <div class=\"popup\">\n              <ul>\n                  <li *ngFor=\"let item of dropdownList; let i = index\"\n                      [className]=\"(dropdownSelectedIndex === i) ? 'selected' : ''\"\n                      (mousedown)=\"itemPicked(item, $event)\">\n                      <span class=\"id\">{{getKey(item)}}:</span>\n                      <span class=\"text\">{{getVal(item)}}</span>\n                  </li>\n              </ul>\n          </div>\n          <div id=\"autocompleteModal_{{ componentGuid }}\" class=\"autocomplete-modal\">\n              <div class=\"panel panel-default\">\n                  <div class=\"panel-heading\">\n                      <h3 class=\"panel-title\">{{fieldSettings?.label}}</h3>\n                      <ul class=\"panel-controls\">\n                          <li>\n                              <a href=\"javascript:void(0)\" (click)=\"closeModal()\">\n                                  <span class=\"fa fa-times\"></span>\n                              </a>\n                          </li>\n                      </ul>\n                  </div>\n                  <div class=\"panel-body\">\n                      <util-filter\n                          (filterAction)=\"filterAction($event)\"\n                          [settings]=\"settingsFilter\"\n                          [documentId]=\"fieldSettings?.fieldName\"\n                          [refreshFilterOnClose]=\"refreshFilter$\"\n                          [isLookup]=\"true\"\n                      ></util-filter>\n                      <util-view-table\n                          [tableMode]=\"TableModeEnum.Popup\"\n                          [settings]=\"settingsTable$\"\n                          [orderListCount]=\"orderListCount$\"\n                          [orderList]=\"documentList$\"\n                          [pageCurrent]=\"currentPage\"\n                          [serverPagination]=\"serverPagination\"\n                          (tableAction)=\"listTableAction($event)\"\n                          [reordable]=\"false\"\n                          [defaultRowHeight]=\"false\"\n                      ></util-view-table>\n                  </div>\n              </div>\n          </div>\n      </div>\n    ",
                styles: ["\n      .autocomplete {\n        width: 100%;\n        position: relative; }\n        .autocomplete .input-box .hidden {\n          display: none; }\n        .autocomplete .input-box input {\n          width: 100%; }\n        .autocomplete .input-box .search-icon {\n          position: absolute;\n          right: 10px;\n          z-index: 1;\n          line-height: 30px;\n          top: 0;\n          bottom: 0; }\n        .autocomplete .popup {\n          z-index: 100;\n          position: absolute;\n          display: none;\n          clear: both;\n          background-color: white; }\n          .autocomplete .popup ul {\n            clear: both;\n            padding-left: 0;\n            -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);\n                    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08); }\n            .autocomplete .popup ul li {\n              text-decoration: none;\n              list-style: none;\n              height: 30px;\n              line-height: 30px;\n              cursor: pointer;\n              padding-left: 10px;\n              text-overflow: ellipsis;\n              overflow: hidden;\n              white-space: nowrap; }\n              .autocomplete .popup ul li.selected {\n                background-color: #ddd; }\n              .autocomplete .popup ul li:hover {\n                background-color: #ddd; }\n              .autocomplete .popup ul li .id {\n                display: inline-block; }\n              .autocomplete .popup ul li .text {\n                padding-right: 50px; }\n          .autocomplete .popup.show {\n            display: block; }\n        .autocomplete .autocomplete-modal {\n          display: none; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
AutocompleteComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: ListService, },
    { type: AuthenticationService, },
    { type: BackendService, },
    { type: RtsBackendService, },
]; };
AutocompleteComponent.propDecorators = {
    'currentText': [{ type: Input },],
    'fieldsResticted': [{ type: Input },],
    'fieldSettings': [{ type: Input },],
    'disabled': [{ type: Input },],
    'placeholder': [{ type: Input },],
    'tag': [{ type: Input },],
    'showSpotCheckbox': [{ type: Input },],
    'isMontaza': [{ type: Input },],
    'refreshOnClose': [{ type: Input },],
    'customOrderColumn': [{ type: Input },],
    'selectedItemChange': [{ type: Output },],
    'tables': [{ type: ViewChildren, args: [ViewTableComponent,] },],
    'selectedItem': [{ type: Input, args: ['selectedItem',] },],
};
var ComboComponent = /** @class */ (function () {
    /**
     * @param {?} listService
     * @param {?} backendService
     * @param {?} eRef
     */
    function ComboComponent(listService, backendService, eRef) {
        var _this = this;
        this.listService = listService;
        this.backendService = backendService;
        this.eRef = eRef;
        this.disabled = false;
        this.useFixedValues = false;
        this.tag = null; // Used by parent components to tag instances. Not to be used internally
        this.isFilter = false;
        this.help1 = '';
        this.initialized = false;
        this._selectedItem = null;
        this._fieldSettings = null;
        this.selectedItemChange = new EventEmitter();
        this.selectedItemLabel = '';
        this.dropdownList = [];
        this.componentGuid = UtilService.generateGuid();
        $(window).scroll(function () {
            _this.closeDropDown();
        });
    }
    Object.defineProperty(ComboComponent.prototype, "selectedItem", {
        /**
         * @return {?}
         */
        get: function () {
            return this._selectedItem;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selectedItem = value;
            for (var /** @type {?} */ i = 0; i < this.dropdownList.length; i++) {
                if (this.dropdownList[i].itemObject === this.selectedItem) {
                    this.dropdownSelectedIndex = this.dropdownList[i].index;
                }
            }
            this.selectedItemLabel = this.getVal(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboComponent.prototype, "fieldSettings", {
        /**
         * @return {?}
         */
        get: function () {
            return this._fieldSettings;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._fieldSettings = value;
            this.selectedItemLabel = this.getVal(this._selectedItem);
            if (this.initialized) {
                this.setDropDownList();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} item
     * @return {?}
     */
    ComboComponent.prototype.setSelectedItem = function (item) {
        var /** @type {?} */ params = {
            columnItem: this.fieldSettings,
            value: item.itemObject,
            oldValue: this.selectedItem
        };
        this.selectedItem = item.itemObject;
        // FOR CHECK
        if (this.selectedItem && this.selectedItem.hasOwnProperty('index')) {
            this.dropdownSelectedIndex = this.selectedItem.index;
        }
        else if (item.hasOwnProperty('index')) {
            this.dropdownSelectedIndex = item.index;
        }
        this.selectedItemChange.emit(params);
        this.validate();
    };
    /**
     * @return {?}
     */
    ComboComponent.prototype.setFocus = function () {
        $(this.getItemRef().querySelector('.combo-component'))
            .find('button')
            .focus();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ComboComponent.prototype.keyDown = function (event) {
        if (!$(this.getItemRef().querySelector('.combo-component'))
            .find('ul.dropdown-menu')
            .is(':visible')) {
            this.openDropDown();
        }
        setTimeout(function (self) {
            if (self.handleCommandKeys(event) &&
                $(self.getItemRef().querySelector('.combo-component'))
                    .find('ul.dropdown-menu')
                    .is(':visible')) {
                $(self.getItemRef().querySelector('.combo-component'))
                    .find('ul.dropdown-menu')
                    .focus();
            }
        }, 0, this);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ComboComponent.prototype.handleCommandKeys = function (event) {
        switch (event.keyCode) {
            case 38: // Up arrow
                if (typeof this.dropdownSelectedIndex !== 'undefined') {
                    this.dropdownSelectedIndex = this.dropdownSelectedIndex - 1;
                }
                else {
                    if (this.dropdownList) {
                        this.dropdownSelectedIndex =
                            this.dropdownList.length - 1;
                    }
                }
                if (this.dropdownSelectedIndex < 0) {
                    this.dropdownSelectedIndex = 0;
                }
                event.preventDefault();
                event.stopPropagation();
                return true;
            case 40: // Down arrow
                if (typeof this.dropdownSelectedIndex !== 'undefined') {
                    this.dropdownSelectedIndex = this.dropdownSelectedIndex + 1;
                }
                else {
                    this.dropdownSelectedIndex = 0;
                }
                if (this.dropdownList &&
                    this.dropdownSelectedIndex > this.dropdownList.length - 1) {
                    this.dropdownSelectedIndex = this.dropdownList.length - 1;
                }
                event.preventDefault();
                event.stopPropagation();
                return true;
            case 13: // Enter
                var /** @type {?} */ selectedRow = this.eRef.nativeElement.querySelector('li.selected');
                if (selectedRow) {
                    selectedRow.dispatchEvent(new CustomEvent('mousedown'));
                }
                event.preventDefault();
                event.stopPropagation();
                return true;
            case 9: // Tab
                this.closeDropDown();
                event.preventDefault();
                event.stopPropagation();
                return false;
            default:
                return false;
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ComboComponent.prototype.getVal = function (item) {
        if (this._selectedItem === null || this._fieldSettings === null) {
            return;
        }
        if (this.useFixedValues) {
            var /** @type {?} */ enumResult = void 0;
            if (this._fieldSettings.lookupList == null) {
                enumResult = this.listService
                    .getEnum(this._fieldSettings.entityType)
                    .filter(function (listItem) { return listItem.value === item; });
            }
            else {
                enumResult = this._fieldSettings.lookupList.filter(function (listItem) { return listItem.value === item; });
            }
            if (enumResult.length === 0) {
                return null;
            }
            return enumResult[0].label;
        }
        else {
            return UtilService.getFieldObject(item, this._fieldSettings.relationValue.all);
        }
    };
    /**
     * @return {?}
     */
    ComboComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @return {?}
     */
    ComboComponent.prototype.closeDropDown = function () {
        $("#combo_" + this.componentGuid).removeClass('open');
        $("#combo_" + this.componentGuid + " > button").attr('aria-expanded', false);
    };
    /**
     * @param {?} event
     * @param {?} selectedOption
     * @return {?}
     */
    ComboComponent.prototype.onKeydown = function (event, selectedOption) {
        switch (event.keyCode) {
            case 13: // Enter
                this.setSelectedItem(selectedOption);
                this.closeDropDown();
                setTimeout(function (self) {
                    $(self.getItemRef().querySelector('.combo-component'))
                        .find('button')
                        .focus();
                }, 0, this);
                break;
            case 9: // Tab
                this.closeDropDown();
                break;
            default:
                break;
        }
    };
    /**
     * @return {?}
     */
    ComboComponent.prototype.openDropDown = function () {
        // const spaceBelow = $(window).height() - $(this.getItemRef().querySelector('button'))[0].getBoundingClientRect().bottom;
        // const dropDownHeight = this.dropdownList.length * 37;
        // const width = $(
        //     this.getItemRef().querySelector('.combo-component')
        // ).width();
        // const offsetX = $(this.getItemRef().querySelector('button'))[0].getBoundingClientRect().left;
        // let offsetY = $(this.getItemRef().querySelector('button'))[0].getBoundingClientRect().bottom;
        // if (dropDownHeight > spaceBelow) {
        //     offsetY -= dropDownHeight - 32;
        // }
        // $(this.getItemRef().querySelector('.dropdown-menu.open')).css({
        //     top: offsetY,
        //     left: offsetX,
        //     height: dropDownHeight,
        //     'min-width': width
        // });
        var /** @type {?} */ spaceBelow = $(window).height() - $(this.getItemRef().querySelector('button'))[0].getBoundingClientRect().bottom;
        var /** @type {?} */ dropDownHeight = this.dropdownList.length > 7 ? 7 * 37 : this.dropdownList.length * 37;
        var /** @type {?} */ offsetLeft = $(this.getItemRef().querySelector('button')).offset().left;
        var /** @type {?} */ offsetTop = $(this.getItemRef().querySelector('button')).offset().top + 30 - $(window).scrollTop();
        if ($('.filter-row.complex').is(':visible') && $('.filter-row.complex').hasClass('opened')) {
            if ($('.page-sidebar .x-navigation').hasClass('x-navigation-minimized')) {
                offsetLeft = offsetLeft - 50;
            }
            else {
                offsetLeft = offsetLeft - 300;
            }
            offsetTop = offsetTop - 100;
        }
        var /** @type {?} */ width = $(this.getItemRef().querySelector('.combo-component')).width();
        if (dropDownHeight > spaceBelow) {
            offsetTop = offsetTop - dropDownHeight - 32;
        }
        $(this.getItemRef().querySelector('.dropdown-menu.open')).css({ top: offsetTop, left: offsetLeft, 'min-width': width });
    };
    /**
     * @param {?} help1
     * @return {?}
     */
    ComboComponent.prototype.showErrors = function (help1) {
        $(this.getItemRef().querySelector('.combo-component')).addClass('error');
        this.help1 = help1;
        $(this.getItemRef().querySelector('.formError'))
            .show()
            .delay(5000)
            .fadeOut();
    };
    /**
     * @return {?}
     */
    ComboComponent.prototype.hideErrors = function () {
        $(this.getItemRef().querySelector('.combo-component')).removeClass('error');
        this.help1 = '';
        $(this.getItemRef().querySelector('.formError')).hide();
    };
    /**
     * @return {?}
     */
    ComboComponent.prototype.validate = function () {
        var /** @type {?} */ help1;
        var /** @type {?} */ val = this._selectedItem;
        if (this._fieldSettings.mandatory &&
            (typeof val === 'undefined' || val === '' || val === null)) {
            help1 = '* Vrednost je obavezna';
        }
        if (help1) {
            this.showErrors(help1);
            return false;
        }
        else {
            this.hideErrors();
            return true;
        }
    };
    /**
     * @return {?}
     */
    ComboComponent.prototype.getDataObservable = function () {
        if (this._fieldSettings.lookupList == null) {
            var /** @type {?} */ lastUsedFilter = {
                pageCurrent: 1,
                filterQuery: '',
                filterDate: '',
                filterObjects: [],
                filterCombined: null,
                rowsOnPage: 100,
                sortOrder: {},
                direction: 'asc',
                relations: null
            };
            // Get data from the service
            return this.listService.getList(this._fieldSettings.entityType, null, null, lastUsedFilter, this.backendService.getSettings(this._fieldSettings.entityType));
        }
        else {
            // Get data from provided list
            var /** @type {?} */ data = {
                result: this._fieldSettings.lookupList,
                count: 0
            };
            return Observable$1.of(data);
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ComboComponent.prototype.getIndex = function (item) { };
    /**
     * @return {?}
     */
    ComboComponent.prototype.setDropDownList = function () {
        var _this = this;
        if (this.useFixedValues) {
            if (this._fieldSettings.lookupList == null) {
                this.dropdownList = this.listService
                    .getEnum(this._fieldSettings.entityType)
                    .map(function (value, index) {
                    return {
                        label: value.label,
                        itemObject: value.value,
                        index: index
                    };
                });
            }
            else {
                this.dropdownList = this._fieldSettings.lookupList.map(function (value, index) {
                    return {
                        label: value.label,
                        itemObject: value.value,
                        index: index
                    };
                });
            }
        }
        else {
            this.getDataObservable().subscribe(function (data) {
                _this.dropdownList = data.result.map(function (value, index) {
                    return {
                        label: _this.getVal(value),
                        itemObject: value,
                        index: index
                    };
                });
            });
        }
        for (var /** @type {?} */ i = 0; i < this.dropdownList.length; i++) {
            if (this.dropdownList[i].itemObject === this.selectedItem) {
                this.dropdownSelectedIndex = this.dropdownList[i].index;
            }
        }
        this.selectedItemLabel = this.getVal(this.selectedItem);
        if (!this._fieldSettings.mandatory &&
            this.dropdownList &&
            this.dropdownList.length > 0 &&
            this.dropdownList[0].label !== '') {
            this.dropdownList = this.dropdownList.map(function (item) {
                item.index++;
                return item;
            });
            this.dropdownList.unshift({
                label: '',
                itemObject: null,
                index: -1
            });
        }
        this.initialized = true;
    };
    /**
     * @return {?}
     */
    ComboComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setDropDownList();
        this.listService.enumItemsSet.subscribe(function (et) {
            if (_this.fieldSettings.entityType === et) {
                _this.setDropDownList();
            }
        });
    };
    return ComboComponent;
}());
ComboComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-combo',
                template: "\n      <div id=\"combo_{{ componentGuid }}\" class=\"util-combo btn-group bootstrap-select form-control combo-component\">\n          <input (focus)=\"setFocus()\"/>\n          <button type=\"button\"\n                  class=\"btn dropdown-toggle btn-default\"\n                  data-toggle=\"dropdown\"\n                  title=\"{{ selectedItemLabel }}\"\n                  aria-expanded=\"false\"\n                  (keydown)=\"keyDown($event)\"\n                  (click)=\"openDropDown()\"\n                  [ngStyle]=\"{'background-color': _fieldSettings?.color, 'border-color': _fieldSettings?.color, 'color': _fieldSettings?.color && _fieldSettings?.color !== '#ffdf4d' ? 'white' : 'black'}\"\n                  [disabled]=\"disabled\">\n              <span class=\"filter-option pull-left combo-span\">{{ selectedItemLabel }}</span>&nbsp;\n              <span class=\"caret combo-span\"></span>\n          </button>\n          <div class=\"dropdown-menu open\" style=\"max-height: 251.5px; overflow: hidden;\" \n              [ngClass]=\"{ 'dropdown-position-fixed': !isFilter, 'drowdown-positions': isFilter}\">\n              <ul class=\"dropdown-menu inner\" role=\"menu\" style=\"max-height: 249.5px; overflow-y: auto;\">\n                  <li *ngFor=\"let option of dropdownList; let optionIndex = index\"\n                      (keydown)=\"onKeydown($event, option)\"\n                      [className]=\"(dropdownSelectedIndex === optionIndex) ? 'selected' : ''\">\n                      <a tabindex=\"0\" (click)=\"setSelectedItem(option)\">\n                          <span class=\"text combo-span\">{{ option.label }}</span>\n                      </a>\n                  </li>\n              </ul>\n          </div>\n          <div class=\"formError\"\n              [ngClass]=\"{'show': _fieldSettings && _fieldSettings?.errorMessage !== ''}\"\n              (click)=\"hideErrors()\">\n              <div class=\"formErrorArrow formErrorArrowBottom\">\n                  <div class=\"line1\"><!-- --></div>\n                  <div class=\"line2\"><!-- --></div>\n                  <div class=\"line3\"><!-- --></div>\n                  <div class=\"line4\"><!-- --></div>\n                  <div class=\"line5\"><!-- --></div>\n                  <div class=\"line6\"><!-- --></div>\n                  <div class=\"line7\"><!-- --></div>\n                  <div class=\"line8\"><!-- --></div>\n                  <div class=\"line9\"><!-- --></div>\n                  <div class=\"line10\"><!-- --></div>\n              </div>\n              <div class=\"formErrorContent\">\n                  {{help1}}\n              </div>\n          </div>\n      </div>\n    ",
                styles: ["\n      .combo-component .btn-default:disabled {\n        background: #EEE;\n        color: #CCC; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
ComboComponent.ctorParameters = function () { return [
    { type: ListService, },
    { type: BackendService, },
    { type: ElementRef, },
]; };
ComboComponent.propDecorators = {
    'disabled': [{ type: Input },],
    'useFixedValues': [{ type: Input },],
    'tag': [{ type: Input },],
    'isFilter': [{ type: Input },],
    'selectedItem': [{ type: Input },],
    'fieldSettings': [{ type: Input },],
    'selectedItemChange': [{ type: Output },],
};
var InputComponent = /** @class */ (function () {
    /**
     * @param {?} eRef
     */
    function InputComponent(eRef) {
        this.eRef = eRef;
        this._formatedValue = '';
        this.help1 = '';
        this.help2 = '';
        this.help3 = '';
        this.isFilter = false;
        this.valueChanged = new EventEmitter();
        this.valueChangedInput = new EventEmitter();
    }
    Object.defineProperty(InputComponent.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value == null) {
                this._value = '';
            }
            else {
                this._value = value;
            }
            this._formatedValue = this._value;
            if (this._columnItem &&
                this._columnItem.hasOwnProperty('dbType') &&
                this._columnItem.dbType.indexOf('DECIMAL') !== -1 &&
                (value || (value !== null && +value === 0))) {
                if (value !== '') {
                    this._formatedValue = UtilService.formatDecimal(value, this._columnItem.decimalCount);
                }
                else {
                    this._formatedValue = '';
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputComponent.prototype, "columnItem", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._columnItem = value;
            if (this._columnItem) {
                if (this._columnItem.hasOwnProperty('dbType') &&
                    this._columnItem.dbType.indexOf('DECIMAL') !== -1 &&
                    (this._value || (this._value !== null && +this._value === 0))) {
                    if (this._value !== '') {
                        this._formatedValue = UtilService.formatDecimal(this._value, this._columnItem.decimalCount);
                    }
                    else {
                        this._formatedValue = '';
                    }
                }
                if (this._columnItem.errorMessage) {
                    this.showError(this._columnItem.errorMessage);
                }
                else {
                    this.hideErrors();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    InputComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @param {?} help1
     * @return {?}
     */
    InputComponent.prototype.showError = function (help1) {
        $(this.getItemRef().querySelector(this.getSelector())).addClass('error');
        this.help1 = help1;
        $(this.getItemRef().querySelector('.formError')).show();
    };
    /**
     * @param {?} help1
     * @param {?} help2
     * @param {?} help3
     * @return {?}
     */
    InputComponent.prototype.showErrors = function (help1, help2, help3) {
        $(this.getItemRef().querySelector(this.getSelector())).addClass('error');
        this.help1 = help1;
        this.help2 = help2;
        this.help3 = help3;
        $(this.getItemRef().querySelector('.formError')).show().delay(5000).fadeOut();
    };
    /**
     * @return {?}
     */
    InputComponent.prototype.hideErrors = function () {
        $(this.getItemRef().querySelector(this.getSelector())).removeClass('error');
        this.help1 = '';
        this.help2 = '';
        this.help3 = '';
        $(this.getItemRef().querySelector('.formError:not(.show)')).hide();
    };
    /**
     * @return {?}
     */
    InputComponent.prototype.validate = function () {
        var /** @type {?} */ help1, /** @type {?} */ help2, /** @type {?} */ help3;
        var /** @type {?} */ val = $(this.getItemRef().querySelector(this.getSelector())).val();
        if (this._columnItem.mandatory &&
            (typeof val === 'undefined' || val === '')) {
            help1 = '* Vrednost je obavezna';
        }
        if (typeof val !== 'undefined' && val !== '') {
            if (this._columnItem.dbType.indexOf('DECIMAL') !== -1) {
                if (!isNaN(parseInt(val))) {
                    if (this._columnItem.decimalCount === 0) {
                        val = val + ',00';
                    }
                    if (val.toString().indexOf(',') !== -1) {
                        val = val.replace(/\./g, '');
                        val = val.replace(/,/g, '.');
                    }
                    var /** @type {?} */ value = parseFloat(parseFloat(val).toFixed(2));
                    if (isNaN(val) || val.indexOf(',') !== -1) {
                        help2 = '* Dozvoljena je samo decimalna vrednost sa zarezom';
                    }
                }
                else {
                    help2 = '* Dozvoljena je samo decimalna vrednost sa zarezom';
                }
            }
            else if (this._columnItem.dbType.indexOf('INTEGER') !== -1) {
                var /** @type {?} */ value1 = parseInt(val, 0);
                if (isNaN(val)) {
                    help2 = '* Dozvoljena je samo numerička vrednost';
                }
                else {
                    if (value1 > 2147483647) {
                        help2 = '* Unet je broj veći od dozvoljenog';
                    }
                    if (val.indexOf('.') !== -1 || val.indexOf(',') !== -1) {
                        help3 = '* Decimale nisu dozvoljene';
                    }
                }
            }
            else if (this._columnItem.dbType.indexOf('BIGINT') !== -1) {
                var /** @type {?} */ value2 = parseInt(val, 0);
                if (isNaN(val)) {
                    help2 = '* Dozvoljena je samo numerička vrednost';
                }
                else {
                    if (value2 === 9223372036854776000) {
                        help2 = '* Unet je broj veći od dozvoljenog';
                    }
                    if (val.indexOf('.') !== -1 || val.indexOf(',') !== -1) {
                        help3 = '* Decimale nisu dozvoljene';
                    }
                }
            }
            else if (this._columnItem.dbType.indexOf('SMALLINT') !== -1) {
                var /** @type {?} */ value3 = parseInt(val, 0);
                if (isNaN(val)) {
                    help2 = '* Dozvoljena je samo numerička vrednost';
                }
                else {
                    if (value3 > 32767) {
                        help2 = '* Unet je broj veći od dozvoljenog';
                    }
                    if (val.indexOf('.') !== -1 || val.indexOf(',') !== -1) {
                        help3 = '* Decimale nisu dozvoljene';
                    }
                }
            }
            else if (this._columnItem.dbType.indexOf('VARCHAR') !== -1) {
                var /** @type {?} */ size = this._columnItem.dbType.split('(');
                size = size[1].split(')');
                if (val.length > parseInt(size[0], 0)) {
                    help2 = '* Uneto je više karaktera nego što je dozvoljeno';
                }
            }
        }
        if (help1 || help2 || help3) {
            this.showErrors(help1, help2, help3);
            return false;
        }
        else {
            this.hideErrors();
            return true;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputComponent.prototype.blur = function (event) {
        this.validate();
        var /** @type {?} */ newVal = $(this.getItemRef().querySelector(this.getSelector())).val();
        if (this._columnItem.dbType.indexOf('DECIMAL') !== -1) {
            if (newVal !== '') {
                newVal = UtilService.deformatDecimal(newVal, this._columnItem.decimalCount);
                this._formatedValue = UtilService.formatDecimal(newVal, this._columnItem.decimalCount);
            }
            else {
                this._formatedValue = '';
            }
        }
        var /** @type {?} */ params = {
            'columnItem': this._columnItem,
            'value': newVal,
            'oldValue': this._value
        };
        this.valueChanged.emit(params);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputComponent.prototype.textInput = function (event) {
        var /** @type {?} */ newVal = $(this.getItemRef().querySelector(this.getSelector())).val();
        var /** @type {?} */ params = {
            'columnItem': this._columnItem,
            'value': newVal,
            'oldValue': this._value
        };
        this.valueChangedInput.emit(params);
    };
    /**
     * @return {?}
     */
    InputComponent.prototype.getSelector = function () {
        return this._columnItem.multiline ? 'textarea' : 'input';
    };
    /**
     * @return {?}
     */
    InputComponent.prototype.ngOnInit = function () {
    };
    /**
     * @return {?}
     */
    InputComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            var /** @type {?} */ newVal = $(_this.getItemRef().querySelector(_this.getSelector())).val();
            if (_this._columnItem.dbType.indexOf('DECIMAL') !== -1) {
                if (newVal !== '') {
                    newVal = UtilService.deformatDecimal(newVal, _this._columnItem.decimalCount);
                    _this._formatedValue = UtilService.formatDecimal(newVal, _this._columnItem.decimalCount);
                }
                else {
                    _this._formatedValue = '';
                }
            }
            var /** @type {?} */ params = {
                'columnItem': _this._columnItem,
                'value': newVal,
                'oldValue': null
            };
            _this.valueChanged.emit(params);
        });
    };
    return InputComponent;
}());
InputComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-input',
                template: "\n      <div class=\"util-input\">\n          <input\n              *ngIf=\"!_columnItem?.multiline\"\n              class=\"form-control validate[input]\"\n              [ngClass]=\"{\n                  'filter-width': isFilter\n              }\"\n              type=\"text\"\n              name=\"input\"\n              [(ngModel)]=\"_formatedValue\"\n              (blur)=\"blur($event)\"\n              (input)=\"textInput($event)\"\n              [attr.data-data-name]=\"_columnItem?.fieldName\"\n              [attr.data-data-type]=\"'input'\"\n              [attr.disabled]=\"_columnItem?.editable ? null : ''\"\n              [ngClass]=\"{'error': _columnItem && _columnItem?.errorMessage !== ''}\"\n              [ngStyle]=\"{'background-color': _columnItem?.color, 'border-color': _columnItem?.color, 'color': _columnItem?.color && _columnItem?.color !== '#ffdf4d' ? 'white' : 'black'}\"\n              autocomplete=\"off\"\n          />\n          <textarea\n              *ngIf=\"_columnItem?.multiline\"\n              class=\"form-control validate[input] textarea-edit\"\n              type=\"text\"\n              name=\"input\"\n              [value]=\"_value\"\n              (blur)=\"blur($event)\"\n              [attr.data-data-name]=\"_columnItem?.fieldName\"\n              [attr.data-data-type]=\"'input'\"\n              [attr.disabled]=\"_columnItem?.editable ? null : ''\"\n              autocomplete=\"off\">\n          </textarea>\n          <div class=\"formError\"\n              [ngClass]=\"{'show': _columnItem && _columnItem?.errorMessage !== ''}\"\n              (click)=\"hideErrors()\">\n              <div class=\"formErrorArrow formErrorArrowBottom\">\n                  <div class=\"line1\"><!-- TODO: Remove these lines--></div>\n                  <div class=\"line2\"><!-- --></div>\n                  <div class=\"line3\"><!-- --></div>\n                  <div class=\"line4\"><!-- --></div>\n                  <div class=\"line5\"><!-- --></div>\n                  <div class=\"line6\"><!-- --></div>\n                  <div class=\"line7\"><!-- --></div>\n                  <div class=\"line8\"><!-- --></div>\n                  <div class=\"line9\"><!-- --></div>\n                  <div class=\"line10\"><!-- --></div>\n              </div>\n              <div class=\"formErrorContent\">\n                  <span *ngIf=\"!help1 && !help2 && !help3\">{{_columnItem?.errorMessage}}</span>\n                  {{help1}}\n                  <br *ngIf=\"help1 && help2\">{{help2}}\n                  <br *ngIf=\"(help1 && help3) || (help2 && help3)\">{{help3}}<br>\n              </div>\n          </div>\n      </div>\n    ",
                styles: ["\n      .util-input textarea {\n        height: 6rem;\n        min-height: 3rem; }\n        .util-input textarea:disabled {\n          background: #F9F9F9;\n          color: #555555; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
InputComponent.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
InputComponent.propDecorators = {
    'isFilter': [{ type: Input },],
    'value': [{ type: Input },],
    'columnItem': [{ type: Input },],
    'valueChanged': [{ type: Output, args: ['valueChanged',] },],
    'valueChangedInput': [{ type: Output, args: ['valueChangedInput',] },],
};
var TimepickerComponent = /** @class */ (function () {
    /**
     * @param {?} eRef
     */
    function TimepickerComponent(eRef) {
        this.eRef = eRef;
        this.help1 = '';
        this.timeChanged = new EventEmitter();
    }
    Object.defineProperty(TimepickerComponent.prototype, "entity", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._entity = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimepickerComponent.prototype, "columnItem", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._columnItem = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TimepickerComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @return {?}
     */
    TimepickerComponent.prototype.getValue = function () {
        var /** @type {?} */ retVal;
        if (this._entity && this._columnItem) {
            retVal = UtilService.getFieldValue(this._entity, this._columnItem);
        }
        if (typeof retVal === 'undefined' || retVal === null || retVal === '') {
            return '';
        }
        return UtilService.formatTime(retVal);
    };
    /**
     * @return {?}
     */
    TimepickerComponent.prototype.getValueTimestamp = function () {
        var /** @type {?} */ retVal;
        if (this._entity && this._columnItem) {
            retVal = UtilService.getFieldValue(this._entity, this._columnItem);
        }
        return UtilService.formatTimeToTimestamp(retVal);
    };
    /**
     * @param {?} help1
     * @return {?}
     */
    TimepickerComponent.prototype.showErrors = function (help1) {
        $(this.getItemRef().querySelector('input')).addClass('error');
        this.help1 = help1;
        $(this.getItemRef().querySelector('.formError')).show().delay(5000).fadeOut();
    };
    /**
     * @return {?}
     */
    TimepickerComponent.prototype.hideErrors = function () {
        $(this.getItemRef().querySelector('input')).removeClass('error');
        this.help1 = '';
        $(this.getItemRef().querySelector('.formError')).hide();
    };
    /**
     * @return {?}
     */
    TimepickerComponent.prototype.validate = function () {
        var /** @type {?} */ help1;
        var /** @type {?} */ val = $(this.getItemRef().querySelector('input')).val();
        if (this._columnItem.mandatory &&
            (typeof val === 'undefined' || val === '')) {
            help1 = '* Vrednost je obavezna';
        }
        if (help1) {
            this.showErrors(help1);
            return false;
        }
        else {
            this.hideErrors();
            return true;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TimepickerComponent.prototype.keyDown = function (event) {
        if (event.keyCode === 9 || event.keyCode === 16) {
            var /** @type {?} */ timepicker = $(this.getItemRef().querySelector('.timepicker'));
            timepicker.timepicker('hideWidget');
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TimepickerComponent.prototype.blur = function (event) {
        this.validate();
        var /** @type {?} */ newText = $(this.getItemRef().querySelector('input')).val();
        var /** @type {?} */ parts = newText.split(':');
        if (parts.length === 2) {
            var /** @type {?} */ today = new Date();
            var /** @type {?} */ hours = +parts[0];
            var /** @type {?} */ minutes = +parts[1];
            var /** @type {?} */ date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, minutes, 0).toISOString();
            var /** @type {?} */ newTime = UtilService.formatTime(date);
            var /** @type {?} */ params = {
                'columnItem': this._columnItem,
                'value': date,
                'oldValue': this.value
            };
            this.value = newTime;
            this.timeChanged.emit(params);
        }
        else {
            var /** @type {?} */ params = {
                'columnItem': this._columnItem,
                'value': '',
                'oldValue': this.value
            };
            this.timeChanged.emit(params);
            this.value = '';
        }
        this.hideErrors();
    };
    /**
     * @return {?}
     */
    TimepickerComponent.prototype.ngOnInit = function () {
        var /** @type {?} */ that = this;
        var /** @type {?} */ time;
        this.value = this.getValue();
        var /** @type {?} */ exp = this.getValueTimestamp();
        if (exp) {
            time = exp.substring(2, 0) + ':' + exp.substring(5, 3);
        }
        else {
            time = false;
        }
        var /** @type {?} */ timepicker = $(this.getItemRef().querySelector('.timepicker'));
        timepicker.timepicker({ showSeconds: false, showMeridian: false, defaultTime: time, showInputs: false, minuteStep: 1 });
        timepicker.on('hide.timepicker', function (e) {
            that.validate();
            var /** @type {?} */ newText = $(that.getItemRef().querySelector('input')).val();
            var /** @type {?} */ parts = newText.split(':');
            var /** @type {?} */ today = new Date();
            var /** @type {?} */ date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), e.time.hours, e.time.minutes, 0).toISOString();
            var /** @type {?} */ newTime = UtilService.formatTime(date);
            var /** @type {?} */ params = {
                'columnItem': that._columnItem,
                'value': parts.length === 2 ? date : '',
                'oldValue': this.value
            };
            that.timeChanged.emit(params);
            that.value = parts.length === 2 ? newTime : '';
            that.hideErrors();
        });
    };
    return TimepickerComponent;
}());
TimepickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-timepicker',
                template: "\n      <div class=\"util-timepicker input-group bootstrap-timepicker\">\n          <input class=\"form-control timepicker\"\n                 type=\"text\"\n                 [value]=\"value\"\n                 (keydown)=\"keyDown($event)\"\n                 [attr.data-data-name]=\"_columnItem?.fieldName\"\n                 [attr.data-data-type]=\"'time'\"\n                 [attr.disabled]=\"_columnItem?.editable ? null : ''\"\n                 (blur)=\"blur($event)\"\n                 />\n          <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-time\"></span></span>\n          <div class=\"formError\" (click)=\"hideErrors()\">\n              <div class=\"formErrorArrow formErrorArrowBottom\">\n                  <div class=\"line1\"><!-- --></div>\n                  <div class=\"line2\"><!-- --></div>\n                  <div class=\"line3\"><!-- --></div>\n                  <div class=\"line4\"><!-- --></div>\n                  <div class=\"line5\"><!-- --></div>\n                  <div class=\"line6\"><!-- --></div>\n                  <div class=\"line7\"><!-- --></div>\n                  <div class=\"line8\"><!-- --></div>\n                  <div class=\"line9\"><!-- --></div>\n                  <div class=\"line10\"><!-- --></div>\n              </div>\n              <div class=\"formErrorContent\">\n                  {{help1}}\n              </div>\n          </div>\n      </div>\n    ",
                styles: ["\n\n    "]
            },] },
];
/**
 * @nocollapse
 */
TimepickerComponent.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
TimepickerComponent.propDecorators = {
    'entity': [{ type: Input },],
    'columnItem': [{ type: Input },],
    'timeChanged': [{ type: Output, args: ['timeChanged',] },],
};
var DaterangepickerComponent = /** @class */ (function () {
    /**
     * @param {?} eRef
     */
    function DaterangepickerComponent(eRef) {
        this.eRef = eRef;
        this.help1 = '';
        this.help2 = '';
        this.optionsDate = UtilService.datePickerOptionsDefault;
        this.dateSelected = new EventEmitter();
    }
    Object.defineProperty(DaterangepickerComponent.prototype, "value", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._value = value;
            this.updateDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DaterangepickerComponent.prototype, "columnItem", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._columnItem = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    DaterangepickerComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @return {?}
     */
    DaterangepickerComponent.prototype.updateDate = function () {
        if (this.value != null) {
            $(this.getItemRef().querySelector('input')).val(UtilService.formatDate(this.value));
        }
    };
    /**
     * @param {?} startDate
     * @return {?}
     */
    DaterangepickerComponent.prototype.selectDate = function (startDate) {
        if (this.picker != null) {
            this.picker.forEach(function (child) {
                child.datePicker.setStartDate(startDate);
            });
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DaterangepickerComponent.prototype.dateChanged = function (value) {
        this.selectDate(value.start);
        var /** @type {?} */ params = {
            'columnItem': this._columnItem,
            'value': value,
            'oldValue': this._value
        };
        this.dateSelected.emit(params);
        var /** @type {?} */ date = value.start.format(UtilService.dateFormatDefault);
        $(this.getItemRef().querySelector('input')).val(date);
        this.hideErrors();
    };
    /**
     * @param {?} help1
     * @param {?} help2
     * @return {?}
     */
    DaterangepickerComponent.prototype.showErrors = function (help1, help2) {
        $(this.getItemRef().querySelector('input')).addClass('error');
        this.help1 = help1;
        this.help2 = help2;
        $(this.getItemRef().querySelector('.formError')).show().delay(5000).fadeOut();
    };
    /**
     * @return {?}
     */
    DaterangepickerComponent.prototype.hideErrors = function () {
        $(this.getItemRef().querySelector('input')).removeClass('error');
        this.help1 = '';
        this.help2 = '';
        $(this.getItemRef().querySelector('.formError')).hide();
    };
    /**
     * @return {?}
     */
    DaterangepickerComponent.prototype.validate = function () {
        var /** @type {?} */ help1, /** @type {?} */ help2;
        var /** @type {?} */ val = $(this.getItemRef().querySelector('input')).val();
        if (this._columnItem.mandatory &&
            (typeof val === 'undefined' || val === '')) {
            help1 = '* Vrednost je obavezna';
        }
        if (typeof val !== 'undefined' && val !== '') {
            var /** @type {?} */ isValid = moment(val, UtilService.dateFormatDefault, true).isValid();
            if (!isValid) {
                help2 = '* Pogrešan format';
            }
        }
        if (help1 || help2) {
            this.showErrors(help1, help2);
            return false;
        }
        else {
            this.hideErrors();
            return true;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DaterangepickerComponent.prototype.blur = function (event) {
        this.validate();
        var /** @type {?} */ newVal = $(this.getItemRef().querySelector('input')).val();
        if (newVal === '') {
            var /** @type {?} */ params = {
                'columnItem': this._columnItem,
                'value': newVal,
                'oldValue': this._value
            };
            this.dateSelected.emit(params);
        }
    };
    /**
     * @return {?}
     */
    DaterangepickerComponent.prototype.ngOnInit = function () {
        this.updateDate();
    };
    return DaterangepickerComponent;
}());
DaterangepickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-daterangepicker',
                template: "\n      <div class=\"util-datepicker input-group date\">\n          <span class=\"input-group-addon add-on\">\n              <span class=\"glyphicon glyphicon-calendar\"></span>\n          </span>\n          <input type=\"text\"\n                 daterangepicker\n                 [options]=\"optionsDate\"\n                 class=\"form-control date-form-control\"\n                 (selected)=\"dateChanged($event)\"\n                 (blur)=\"blur($event)\"\n                 [attr.data-data-name]=\"_columnItem?.fieldName\"\n                 [attr.data-data-type]=\"'date'\"\n                 [attr.disabled]=\"_columnItem?.editable ? null : ''\"/>\n          <div class=\"formError\"\n              [ngClass]=\"{'show': _columnItem && _columnItem?.errorMessage !== ''}\"\n              (click)=\"hideErrors()\">\n              <div class=\"formErrorArrow formErrorArrowBottom\">\n                  <div class=\"line1\"><!-- --></div>\n                  <div class=\"line2\"><!-- --></div>\n                  <div class=\"line3\"><!-- --></div>\n                  <div class=\"line4\"><!-- --></div>\n                  <div class=\"line5\"><!-- --></div>\n                  <div class=\"line6\"><!-- --></div>\n                  <div class=\"line7\"><!-- --></div>\n                  <div class=\"line8\"><!-- --></div>\n                  <div class=\"line9\"><!-- --></div>\n                  <div class=\"line10\"><!-- --></div>\n              </div>\n              <div class=\"formErrorContent\">\n                  {{help1}}\n                  <br *ngIf=\"help1 && help2\">{{help2}}\n              </div>\n          </div>\n      </div>\n    ",
                styles: ["\n\n    "]
            },] },
];
/**
 * @nocollapse
 */
DaterangepickerComponent.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
DaterangepickerComponent.propDecorators = {
    'picker': [{ type: ViewChildren, args: [DaterangePickerComponent,] },],
    'value': [{ type: Input },],
    'columnItem': [{ type: Input },],
    'dateSelected': [{ type: Output, args: ['dateSelected',] },],
};
var FilterActionEnum$1 = {};
FilterActionEnum$1.Page = /** @type {?} */ ('page');
FilterActionEnum$1.RowsPerPage = /** @type {?} */ ('rowsPerPage');
FilterActionEnum$1.Sort = /** @type {?} */ ('sort');
FilterActionEnum$1[FilterActionEnum$1.Page] = "Page";
FilterActionEnum$1[FilterActionEnum$1.RowsPerPage] = "RowsPerPage";
FilterActionEnum$1[FilterActionEnum$1.Sort] = "Sort";
var TableComponent = /** @class */ (function () {
    /**
     * @param {?} backendService
     * @param {?} authenticationService
     * @param {?} route
     * @param {?} daterangepickerOptions
     * @param {?} ref
     * @param {?} fieldService
     * @param {?} listService
     * @param {?} applicationService
     * @param {?} notificationService
     * @param {?} eRef
     */
    function TableComponent(backendService, authenticationService, route, daterangepickerOptions, ref, fieldService, listService, applicationService, notificationService, eRef) {
        this.backendService = backendService;
        this.authenticationService = authenticationService;
        this.route = route;
        this.daterangepickerOptions = daterangepickerOptions;
        this.ref = ref;
        this.fieldService = fieldService;
        this.listService = listService;
        this.applicationService = applicationService;
        this.notificationService = notificationService;
        this.eRef = eRef;
        this.FormModeEnum = FormModeEnum;
        this.TableModeEnum = TableModeEnum;
        this.TableActionEnum = TableActionEnum;
        this.FilterActionEnum = FilterActionEnum$1;
        this.DocumentTypeEnum = DocumentTypeEnum;
        this.FieldTypeEnum = FieldTypeEnum;
        this.getColumnDisabled = UtilService.getColumnDisabled;
        this.approveTableActions = false;
        this.optionsDate = UtilService.datePickerOptionsDefault;
        this.paging = true;
        this.copyEnabled = false;
        this.sortingEnabled = true;
        this.outside = false;
        this.sticking = true;
        this.resizable = true;
        this.reordable = true;
        /**
         * Determines if the user can edit multiple rows at the sime time or not, defaults to false.
         */
        this.multiedit = false;
        this.rbrCurrentlyEditing = null;
        this.ident = 'id';
        this.tableMode = TableModeEnum.Table;
        this.tag = null; // Used by parent components to tag instances. Not to be used internally
        this.customAddHandling = false;
        this._showDocumentStatusColumn = true;
        this._showSelectColumn = false;
        this.tableAction = new EventEmitter();
        this.valueChanged = new EventEmitter();
        this.onAllSelected = new EventEmitter();
        this.onRowSelected = new EventEmitter();
        this._decrement = 2;
        this.columns = [];
        this.columnsWithActions = [];
        this.shownEditingRows = [];
        this.initialized = false;
        this._columnsSet = false;
        this.disableDrawCallback = false;
        this.isAdmin = false;
        this.daterange = {};
        this.fieldsByName = []; // TODO: Remove
        this.resizing = [];
        this.rowsOnPage = 25;
        this.totalPages = 1;
        this.pageCurrent = 1;
        this.direction = 0;
        this.from = 0;
        this.to = 1000000;
        this.tooltipOptions = {
            placement: 'top',
            'show-delay': '500',
            theme: 'light'
        };
        this.allSelected = false;
        this.allSelectedTooltip = 'Izaberi sve';
        this.selectedClass = 'selected';
        this.defaultRowHeight = true;
        this.serverPagination = false;
        this.customRowsOnPage = null;
        this.hardEditableColumnNames = [];
        this.selectStatuses = [];
        this.selectedObjectChange = new EventEmitter();
        this._settings = null;
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(TableComponent.prototype, "showDocumentStatusColumn", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showDocumentStatusColumn;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._decrement = 2;
            }
            else {
                this._decrement = 1;
            }
            this._showDocumentStatusColumn = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "showSelectColumn", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showSelectColumn;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._decrement = 2;
            }
            else {
                this._decrement = 1;
            }
            this._showSelectColumn = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "selectedObject", {
        /**
         * @return {?}
         */
        get: function () {
            return this._selectObject;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selectObject = value;
            // This we have because it can happen that selection have to be returned after validation
            $('.orderList' + this.componentGuid + this.tableMode + ' tbody tr').removeClass(this.selectedClass);
            this.selectObject();
            this.selectedObjectChange.emit(this._selectObject);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "mode", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._mode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "settings", {
        /**
         * @return {?}
         */
        get: function () {
            return this._settings;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value != null) {
                this._settings = value;
                this.onOrderListAndRelationsLoaded();
                // this.overrideBySecurity();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "orderList", {
        /**
         * @return {?}
         */
        get: function () {
            return this._orderList;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            switch (this.tableMode) {
                case TableModeEnum.Table:
                    if (typeof value !== 'undefined') {
                        if (typeof this._orderListTotal === 'undefined') {
                            if (!this.paging) {
                                this.rowsOnPage = 10000000000;
                            }
                            else {
                                this.rowsOnPage = 25;
                            }
                            this.pageCurrent = 1;
                        }
                        this._orderListTotal = value;
                        this.setPagination();
                        this.onOrderListAndRelationsLoaded();
                        this.ref.detectChanges();
                    }
                    break;
                case TableModeEnum.Details:
                    if (typeof value !== 'undefined') {
                        if (typeof this._orderListTotal === 'undefined') {
                            if (!this.paging) {
                                this.rowsOnPage = 10000000000;
                            }
                            else {
                                this.rowsOnPage = this.customRowsOnPage
                                    ? this.customRowsOnPage
                                    : 10;
                            }
                            this.pageCurrent = 1;
                        }
                        this._orderListTotal = value;
                        this.setPagination();
                        this.from = (this.pageCurrent - 1) * this.rowsOnPage;
                        this.to = this.rowsOnPage * this.pageCurrent;
                        if (typeof this.sortOrder !== 'undefined' &&
                            Object.keys(this.sortOrder).length > 0) {
                            this.fieldName = this.sortOrder.fieldName;
                        }
                        this.onOrderListAndRelationsLoaded();
                        if (this.sortColumnName && !this.serverPagination) {
                            this.filter(FilterActionEnum$1.Sort, this.fieldsByName[this.sortColumnName], null);
                        }
                        if (!this.outside) {
                            this.shownEditingRows = [];
                        }
                        this.ref.detectChanges();
                    }
                    break;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "editSettings", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._editSettings = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "complexSettings", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._complexSettings = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "additable", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.listAdditableOverride != null) {
                return this.listAdditableOverride;
            }
            else {
                return this.settings.listAdditable;
            }
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.listAdditableOverride = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TableComponent.prototype.overrideBySecurity = function () {
        if (this.tableMode === TableModeEnum.Table) {
            var /** @type {?} */ security = this.backendService.getSecurity();
            if (security && this.tableMode === TableModeEnum.Table) {
                var /** @type {?} */ hasAdd = true;
                var /** @type {?} */ hasUpdate = true;
                var /** @type {?} */ hasDeleteStorno = true;
                var /** @type {?} */ securityDeleteStorno = SecurityEnum.Delete;
                security = this.backendService.getSecurity();
                if (this._settings.documentType === DocumentTypeEnum.Dokument) {
                    securityDeleteStorno = SecurityEnum.Storno;
                }
                for (var /** @type {?} */ i = 0; i < security.length; i++) {
                    if (security[i].formCode ===
                        this.identity.documentSecurityCode) {
                        hasAdd = false;
                        hasUpdate = false;
                        hasDeleteStorno = false;
                        for (var /** @type {?} */ j = 0; j < security[i].allowedModes.length; j++) {
                            if (security[i].allowedModes[j] === SecurityEnum.Add) {
                                hasAdd = true;
                            }
                            if (security[i].allowedModes[j] ===
                                SecurityEnum.Update) {
                                hasUpdate = true;
                            }
                            if (security[i].allowedModes[j] ===
                                securityDeleteStorno) {
                                hasDeleteStorno = true;
                            }
                        }
                    }
                }
                if (!hasAdd) {
                    this._settings.inlineAdding = false;
                    this._settings.listAdditable = false;
                }
                if (!hasUpdate) {
                    this._settings.inlineEditing = false;
                    this._settings.listEditable = false;
                }
                if (!hasDeleteStorno) {
                    this._settings.listDeletable = false;
                }
            }
        }
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.setPagination = function () {
        // TODO: PAGINATION
        switch (this.tableMode) {
            case TableModeEnum.Table:
                this.setTableModePagination();
                break;
            case TableModeEnum.Details:
                if (this.serverPagination) {
                    this.setTableModePagination();
                }
                else {
                    this.setDetailsModePagination();
                }
                break;
        }
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.setTableModePagination = function () {
        this.totalPages = Math.ceil(this.orderListCount / this.rowsOnPage);
        if (this.totalPages < this.pageCurrent) {
            this.pageCurrent = 1;
        }
        this._orderList = this._orderListTotal;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.setDetailsModePagination = function () {
        this.totalPages = Math.ceil(this._orderListTotal.length / this.rowsOnPage);
        if (this.totalPages < this.pageCurrent) {
            this.pageCurrent = 1;
        }
        var /** @type {?} */ from = (this.pageCurrent - 1) * this.rowsOnPage;
        this._orderList = this._orderListTotal.slice(from, this.rowsOnPage * this.pageCurrent);
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.selectObject = function () {
        if (this.ident && this._selectObject) {
            var /** @type {?} */ tableRow = $(this.getItemRef().querySelector('tbody span[data-data-' +
                this.ident +
                "='" +
                this._selectObject[this.ident] +
                "']")).closest('tr');
            if (!tableRow.hasClass(this.selectedClass)) {
                $(this.getItemRef().querySelector('tr')).removeClass(this.selectedClass);
                tableRow.addClass(this.selectedClass);
            }
        }
    };
    Object.defineProperty(TableComponent.prototype, "identFromTableMode", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.tableMode === TableModeEnum.Table && this.ident === 'rbr') {
                return 'rbr';
            }
            return this.tableMode === TableModeEnum.Details ? 'rbr' : 'id';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} columnName
     * @param {?=} status
     * @return {?}
     */
    TableComponent.prototype.isHardEditable = function (columnName, status) {
        if (status === void 0) { status = null; }
        var /** @type {?} */ val = this.hardEditableColumnNames &&
            this.hardEditableColumnNames.some(function (x) { return x === columnName; }) &&
            (status === 0 || status === 1);
        return val;
    };
    /**
     * @param {?} orderStatus
     * @return {?}
     */
    TableComponent.prototype.isAbleToEnterEditMode = function (orderStatus) {
        if (!orderStatus) {
            return true;
        }
        return orderStatus === 0 || orderStatus === 1;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.onAction = function (event) {
        this.tableAction.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.inlineUpdateOrAddOrder = function (event) {
        if ($(event.target)
            .closest('tr')
            .hasClass('editing')) {
            this.beforeInlineDetailSave(event.target);
            this.onInlineUpdateOrder(event.target, true);
        }
        else {
            this.beforeInlineDetailSave(event.target);
            this.onInlineAddOrder(event.target);
        }
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?} order
     * @param {?} index
     * @return {?}
     */
    TableComponent.prototype.fieldUpdateCheck = function (fieldMap, newValue, order, index) {
        this.fieldUpdateValue(fieldMap, newValue, null, order);
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?=} oldValue
     * @param {?=} order
     * @param {?=} index
     * @return {?}
     */
    TableComponent.prototype.fieldUpdateDate = function (fieldMap, newValue, oldValue, order, index) {
        if (oldValue === void 0) { oldValue = null; }
        this.fieldUpdateValue(fieldMap, newValue != null ? newValue.end : newValue, oldValue, order);
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?=} oldValue
     * @param {?=} order
     * @param {?=} index
     * @return {?}
     */
    TableComponent.prototype.fieldUpdateTime = function (fieldMap, newValue, oldValue, order, index) {
        if (oldValue === void 0) { oldValue = null; }
        this.fieldUpdateValue(fieldMap, newValue, oldValue, order);
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?=} oldValue
     * @param {?=} order
     * @return {?}
     */
    TableComponent.prototype.fieldUpdateValue = function (fieldMap, newValue, oldValue, order) {
        if (oldValue === void 0) { oldValue = null; }
        this.onInlineSelect(order);
        // if (this.tableMode === TableModeEnum.Table) {
        UtilService.fieldUpdateValue(order, fieldMap, newValue);
        // }
        this.valueChanged.emit({
            fieldMap: fieldMap,
            newValue: newValue,
            oldValue: oldValue,
            order: order
        });
    };
    /**
     * @param {?} order
     * @return {?}
     */
    TableComponent.prototype.updateSelected = function (order) {
        order.selected = !order.selected;
        this.onRowSelected.next(order.selected);
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.updateAllSelected = function () {
        this.allSelected = !this.allSelected;
        this.onAllSelected.next(this.allSelected);
    };
    /**
     * @param {?} row
     * @param {?} operation
     * @return {?}
     */
    TableComponent.prototype.changeRowStatus = function (row, operation) {
        var /** @type {?} */ that = this;
        if (this.tableMode === TableModeEnum.Table) {
            $(this.getItemRef().querySelector('tbody'))
                .find('tr')
                .each(function () {
                $(this).removeClass('editing');
                $(this).removeClass('adding');
            });
        }
        if (operation === '') {
            row.removeClass('editing');
            row.removeClass('adding');
            delete that.shownEditingRows[row[0].dataset.rowIdentity];
            row.find('.icheckbox').each(function () {
                if ($(this).attr('id') !== 'deleteCheckbox') {
                    $(this).prop('disabled', true);
                }
            });
        }
        else {
            row.addClass(operation);
            that.shownEditingRows[row[0].dataset.rowIdentity] = Object.assign({}, this._selectObject);
            row.find('.icheckbox').each(function () {
                if (($(this).attr('id') !== 'deleteCheckbox')) {
                    if (that.fieldsByName[$(this)[0].dataset.dataName]['editable']) {
                        $(this).prop('disabled', false);
                    }
                }
            });
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    TableComponent.prototype.keydownListener = function (e) {
        if (!this.multiedit) {
            return;
        }
        var /** @type {?} */ that = this;
        var /** @type {?} */ index = $(e.target)
            .closest('td')
            .index();
        var /** @type {?} */ rowIndex = $(e.target)
            .closest('tr')
            .index();
        // const table = $('.orderList' + that.componentGuid + this.tableMode).DataTable();
        // const info = table.page.info();
        var /** @type {?} */ thisRow = $(e.target).closest('tr');
        var /** @type {?} */ prevRow = thisRow.prev('tr');
        var /** @type {?} */ nextRow = thisRow.next('tr');
        setTimeout(function () {
            switch (e.keyCode) {
                case 38: // Up arrow
                    if ($(e.target)
                        .closest('td')
                        .find('.popup.show').length === 0 &&
                        $(e.target)
                            .closest('td')
                            .find('.combo-component.open').length === 0) {
                        if (prevRow.length !== 0) {
                            // Move to previous row
                            that.inlineUpdateOrAddOrder(e);
                            if (!prevRow.hasClass('adding')) {
                                that.changeRowStatus(prevRow, 'editing');
                            }
                            setTimeout(function () {
                                prevRow
                                    .find('td:eq(' + index + ') input')
                                    .focus();
                                prevRow
                                    .find('td:eq(' + index + ') input')
                                    .select();
                            }, 0, that);
                        }
                        else {
                            // Previous page
                            if (that.pageCurrent !== 0) {
                                that.inlineUpdateOrAddOrder(e);
                                that.pageCurrent--;
                                that.setPagination();
                                that.addKeyListeners();
                                setTimeout(function (self) {
                                    if ($('.orderList' +
                                        that.componentGuid +
                                        that.tableMode +
                                        ' tbody tr:last td:first button:first')[0].classList.contains('edit') &&
                                        !$('.orderList' +
                                            that.componentGuid +
                                            that.tableMode +
                                            ' tbody tr:last td:first button:first')[0].hasAttribute('disabled')) {
                                        if (!$('.orderList' +
                                            that.componentGuid +
                                            that.tableMode +
                                            ' tbody tr:last').hasClass('adding')) {
                                            self.changeRowStatus($('.orderList' +
                                                that.componentGuid +
                                                that.tableMode +
                                                ' tbody tr:last'), 'editing');
                                        }
                                        setTimeout(function () {
                                            $('.orderList' +
                                                that.componentGuid +
                                                that.tableMode +
                                                ' tbody tr:last')
                                                .find('td:eq(' +
                                                index +
                                                ')')
                                                .each(function () {
                                                $(this)
                                                    .find('input')
                                                    .focus();
                                                $(this)
                                                    .find('input')
                                                    .select();
                                            });
                                        }, 0, self);
                                    }
                                }, 0, that);
                            }
                        }
                    }
                    break;
                case 40: // Down arrow
                    if ($(e.target)
                        .closest('td')
                        .find('.popup.show').length === 0 &&
                        $(e.target)
                            .closest('td')
                            .find('.combo-component.open').length === 0) {
                        if (nextRow.length !== 0) {
                            // Move to next row
                            that.inlineUpdateOrAddOrder(e);
                            if (!nextRow.hasClass('adding')) {
                                that.changeRowStatus(nextRow, 'editing');
                            }
                            setTimeout(function () {
                                nextRow
                                    .find('> td:eq(' + index + ') input')
                                    .focus();
                                nextRow
                                    .find('> td:eq(' + index + ') input')
                                    .select();
                            }, 0, that);
                        }
                        else {
                            if (rowIndex + 1 === that.rowsOnPage &&
                                that.pageCurrent + 1 !== that.totalPages &&
                                that.totalPages !== 0) {
                                that.inlineUpdateOrAddOrder(e);
                                // Move to next page and first row
                                that.disableDrawCallback = true;
                                that.pageCurrent++;
                                that.setPagination();
                                setTimeout(function (self) {
                                    self.addKeyListeners();
                                    if ($('.orderList' +
                                        that.componentGuid +
                                        that.tableMode +
                                        ' tbody tr:first td:first button:first')[0].classList.contains('edit') &&
                                        !$('.orderList' +
                                            that.componentGuid +
                                            that.tableMode +
                                            ' tbody tr:first td:first button:first')[0].hasAttribute('disabled')) {
                                        if (!$('.orderList' +
                                            that.componentGuid +
                                            that.tableMode +
                                            ' tbody tr:first').hasClass('adding')) {
                                            $('.orderList' +
                                                that.componentGuid +
                                                that.tableMode +
                                                ' tbody tr:first').addClass('editing');
                                        }
                                        setTimeout(function () {
                                            $('.orderList' +
                                                that.componentGuid +
                                                that.tableMode +
                                                ' tbody tr:first')
                                                .find('td:eq(' +
                                                index +
                                                ')')
                                                .each(function () {
                                                $(this)
                                                    .find('input')
                                                    .focus();
                                                $(this)
                                                    .find('input')
                                                    .select();
                                            });
                                        }, 0, self);
                                    }
                                }, 0, that);
                            }
                            else {
                                // Add new record on the same page
                                if (that._settings.inlineAdding) {
                                    that.inlineUpdateOrAddOrder(e);
                                    that.onInlineAddOpen(index);
                                }
                            }
                        }
                    }
                    break;
                case 9: // Tab
                    if (e.shiftKey) {
                        e.preventDefault();
                        e.stopPropagation();
                        var /** @type {?} */ found_1 = false;
                        thisRow.find('td').each(function () {
                            if (index > $(this)[0].cellIndex &&
                                $(this).find('input').length > 0 &&
                                !$(this)
                                    .find('input')[0]
                                    .hasAttribute('disabled')) {
                                $(this)
                                    .find('input')
                                    .focus();
                                $(this)
                                    .find('input')
                                    .select();
                                found_1 = true;
                            }
                        });
                        // previous line or move to previous page
                        if (!found_1) {
                            if (prevRow.length === 0) {
                                // jump to previous page
                                if (that.pageCurrent !== 0) {
                                    that.inlineUpdateOrAddOrder(e);
                                    that.pageCurrent--;
                                    that.setPagination();
                                    that.addKeyListeners();
                                    setTimeout(function (self) {
                                        if ($('.orderList' +
                                            that.componentGuid +
                                            that.tableMode +
                                            ' tbody tr:last td:first button:first')[0].classList.contains('edit') &&
                                            !$('.orderList' +
                                                that.componentGuid +
                                                that.tableMode +
                                                ' tbody tr:last td:first button:first')[0].hasAttribute('disabled')) {
                                            if (!$('.orderList' +
                                                that.componentGuid +
                                                that.tableMode +
                                                ' tbody tr:last').hasClass('adding')) {
                                                self.changeRowStatus($('.orderList' +
                                                    that.componentGuid +
                                                    that.tableMode +
                                                    ' tbody tr:last'), 'editing');
                                            }
                                            setTimeout(function () {
                                                $('.orderList' +
                                                    that.componentGuid +
                                                    that.tableMode +
                                                    ' tbody tr:last')
                                                    .find('td')
                                                    .each(function () {
                                                    if ($(this).find('input').length >
                                                        0 &&
                                                        !$(this)
                                                            .find('input')[0]
                                                            .hasAttribute('disabled')) {
                                                        $(this)
                                                            .find('input')
                                                            .focus();
                                                        $(this)
                                                            .find('input')
                                                            .select();
                                                    }
                                                });
                                            }, 0, self);
                                        }
                                    }, 0, that);
                                }
                            }
                            else {
                                // Move to previous line
                                if (prevRow
                                    .find('button')[0]
                                    .classList.contains('edit') &&
                                    !prevRow
                                        .find('button')[0]
                                        .hasAttribute('disabled')) {
                                    that.inlineUpdateOrAddOrder(e);
                                    if (!prevRow.hasClass('adding')) {
                                        that.changeRowStatus(prevRow, 'editing');
                                    }
                                    setTimeout(function () {
                                        prevRow.find('td').each(function () {
                                            if ($(this).find('input')
                                                .length > 0 &&
                                                !$(this)
                                                    .find('input')[0]
                                                    .hasAttribute('disabled')) {
                                                $(this)
                                                    .find('input')
                                                    .focus();
                                                $(this)
                                                    .find('input')
                                                    .select();
                                            }
                                        });
                                    }, 0, that);
                                }
                            }
                        }
                    }
                    else {
                        e.preventDefault();
                        e.stopPropagation();
                        var /** @type {?} */ found_2 = false;
                        thisRow.find('td').each(function () {
                            if (index < $(this)[0].cellIndex &&
                                $(this).find('input').length > 0 &&
                                !$(this)
                                    .find('input')[0]
                                    .hasAttribute('disabled')) {
                                $(this)
                                    .find('input')
                                    .focus();
                                $(this)
                                    .find('input')
                                    .select();
                                found_2 = true;
                                return false;
                            }
                        });
                        // Next line, add or move to next page
                        if (!found_2) {
                            if (rowIndex + 1 === that.rowsOnPage &&
                                that.pageCurrent + 1 !== that.totalPages &&
                                that.totalPages !== 0) {
                                that.inlineUpdateOrAddOrder(e);
                                // Move to next page and first row
                                that.pageCurrent++;
                                that.setPagination();
                                setTimeout(function (self) {
                                    if ($('.orderList' +
                                        that.componentGuid +
                                        that.tableMode +
                                        ' tbody tr:first td:first button:first')[0].classList.contains('edit') &&
                                        !$('.orderList' +
                                            that.componentGuid +
                                            that.tableMode +
                                            ' tbody tr:first td:first button:first')[0].hasAttribute('disabled')) {
                                        if (!$('.orderList' +
                                            that.componentGuid +
                                            that.tableMode +
                                            ' tbody tr:first').hasClass('adding')) {
                                            self.changeRowStatus($('.orderList' +
                                                that.componentGuid +
                                                that.tableMode +
                                                ' tbody tr:first'), 'editing');
                                        }
                                        setTimeout(function () {
                                            $('.orderList' +
                                                that.componentGuid +
                                                that.tableMode +
                                                ' tbody tr:first')
                                                .find('td')
                                                .each(function () {
                                                if ($(this).find('input').length > 0 &&
                                                    !$(this)
                                                        .find('input')[0]
                                                        .hasAttribute('disabled')) {
                                                    $(this)
                                                        .find('input')
                                                        .focus();
                                                    $(this)
                                                        .find('input')
                                                        .select();
                                                    return false;
                                                }
                                            });
                                        }, 0, self);
                                    }
                                }, 0, that);
                            }
                            else {
                                if (nextRow.length === 0) {
                                    // Add new record on the same page
                                    if (that._settings.inlineAdding) {
                                        that.inlineUpdateOrAddOrder(e);
                                        that.onInlineAddOpen(null);
                                    }
                                }
                                else {
                                    // Move to next line
                                    if (nextRow
                                        .find('button')[0]
                                        .classList.contains('edit') &&
                                        !nextRow
                                            .find('button')[0]
                                            .hasAttribute('disabled')) {
                                        that.inlineUpdateOrAddOrder(e);
                                        if (!nextRow.hasClass('adding')) {
                                            that.changeRowStatus(nextRow, 'editing');
                                        }
                                        setTimeout(function () {
                                            nextRow
                                                .find('td')
                                                .each(function () {
                                                if ($(this).find('input').length > 0 &&
                                                    !$(this)
                                                        .find('input')[0]
                                                        .hasAttribute('disabled')) {
                                                    $(this)
                                                        .find('input')
                                                        .focus();
                                                    $(this)
                                                        .find('input')
                                                        .select();
                                                    return false;
                                                }
                                            });
                                        }, 0, that);
                                    }
                                }
                            }
                        }
                    }
                    break;
                default:
            }
        }, 0);
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.addKeyListeners = function () {
        if (!this.multiedit) {
            return;
        }
        // TODO What kind of mangled event handling is this?! And with double redirection of `this`!
        var /** @type {?} */ that = this;
        $('.orderList' + this.componentGuid + this.tableMode)
            .find('td')
            .off('keydown');
        $('.orderList' + this.componentGuid + this.tableMode)
            .find('td')
            .on('keydown', function (e) {
            $('.orderList' + that.componentGuid + that.tableMode)
                .find('td')
                .off('keydown');
            that.keydownListener(e);
            setTimeout(function (self) {
                $('.orderList' + self.componentGuid + that.tableMode)
                    .find('td')
                    .off('keydown');
                $('.orderList' + self.componentGuid + that.tableMode)
                    .find('td')
                    .on('keydown', function (event) {
                    self.keydownListener(event);
                });
            }, 0, that);
        });
    };
    /**
     * Sets the single-row-editing marker to the specified `rbr` (IF no row is already being edited!),
     * and invokes the specified `callback`.
     *
     * @param {?} rbr The `rbr` of the row to edit.
     * @param {?} callback
     * @return {?}
     */
    TableComponent.prototype.markStartItemEditing = function (rbr, callback) {
        if (this.rbrCurrentlyEditing != null && !this.multiedit) {
            this.notificationService.openNoty('Pokušavate menjati postojeću ili dodati novu stavku a niste potvrdili stavku koju trenutno unosite.');
            return;
        }
        this.rbrCurrentlyEditing = rbr;
        callback();
    };
    /**
     * Clears the single-row-editing marker if the specified row IS the one being edited.
     *
     * @param {?} rbr The `rbr` of the currently editing row.
     * @return {?}
     */
    TableComponent.prototype.markStopItemEditing = function (rbr) {
        // HACK Da, ne koristi se "===" jer je "order.rbr" nekako (od broja) postao string!!!
        if (this.rbrCurrentlyEditing == rbr) {
            this.rbrCurrentlyEditing = null;
        }
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.onInlineAddOpenFromHeader = function () {
        var _this = this;
        this.markStartItemEditing(this._orderListTotal.length + 1, function () {
            if (_this.customAddHandling) {
                var /** @type {?} */ params = {
                    action: TableActionEnum.AddCustom,
                    document: document
                };
                _this.onAction(params);
            }
            else {
                // const table = $('.orderList' + this.componentGuid + this.tableMode).DataTable();
                // const info = table.page.info();
                if (_this.pageCurrent !== _this.totalPages) {
                    // Move to last page
                    _this.setPagination();
                    if (_this.totalPages === 0) {
                        _this.totalPages = 1;
                    }
                    _this.pageCurrent = _this.totalPages;
                    _this.setPagination();
                }
                setTimeout(function (self) {
                    self.addKeyListeners();
                    self.onInlineAddOpen(null);
                }, 0, _this);
            }
        });
    };
    /**
     * @param {?} index
     * @param {?=} emitNewEvent
     * @return {?}
     */
    TableComponent.prototype.onInlineAddOpenApproved = function (index, emitNewEvent) {
        if (emitNewEvent === void 0) { emitNewEvent = true; }
        if (this.maxRows && this.maxRows <= this._orderList.length) {
            return;
        }
        this.disableDrawCallback = true;
        $('.orderList' + this.componentGuid + this.tableMode)
            .find('td')
            .off('keydown');
        var /** @type {?} */ that = this;
        var /** @type {?} */ rbr = this._orderListTotal.length + 1;
        this._orderListTotal.push({
            rbr: rbr
        });
        that.setPagination();
        if (this.totalPages === 0) {
            this.totalPages = 1;
        }
        that.pageCurrent = that.totalPages;
        that.setPagination();
        setTimeout(function () {
            that.onInlineSelect(that._orderList[that._orderList.length - 1]);
            that.changeRowStatus($('.orderList' +
                that.componentGuid +
                that.tableMode +
                " button[data-data-rbr='" +
                rbr +
                "']").closest('tr'), 'adding');
            var /** @type {?} */ time = 0;
            if ($('.orderList' +
                that.componentGuid +
                that.tableMode +
                " button[data-data-rbr='" +
                rbr +
                "']")
                .closest('tr')
                .prev('tr').length === 0) {
                that.disableDrawCallback = true;
                time = 500;
            }
            if (index !== null) {
                setTimeout(function () {
                    $('.orderList' +
                        that.componentGuid +
                        that.tableMode +
                        " button[data-data-rbr='" +
                        rbr +
                        "']")
                        .closest('tr')
                        .find('> td:eq(' + index + ')')
                        .each(function () {
                        $(this)
                            .find('input')
                            .focus();
                    });
                }, time);
            }
            else {
                setTimeout(function () {
                    $('.orderList' +
                        that.componentGuid +
                        that.tableMode +
                        " button[data-data-rbr='" +
                        rbr +
                        "']")
                        .closest('tr')
                        .find('> td')
                        .each(function () {
                        if ($(this).find('input').length > 0 &&
                            !$(this)
                                .find('input')[0]
                                .hasAttribute('disabled')) {
                            $(this)
                                .find('input')
                                .focus();
                            return false;
                        }
                    });
                }, time);
            }
            that.addKeyListeners();
            that.addListenersToNewlyAddedRow();
            if (emitNewEvent) {
                var /** @type {?} */ params = {
                    action: TableActionEnum.Add,
                    document: that._orderList[that._orderList.length - 1]
                };
                that.tableAction.emit(params);
            }
        }, 0);
    };
    /**
     * @param {?} index
     * @return {?}
     */
    TableComponent.prototype.onInlineAddOpen = function (index) {
        if (!this.approveTableActions) {
            this.onInlineAddOpenApproved(index);
        }
        else {
            var /** @type {?} */ params = {
                action: TableActionEnum.Add,
                index: index
            };
            this.tableAction.emit(params);
        }
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.addListenersToNewlyAddedRow = function () {
        var /** @type {?} */ that = this;
        $('.orderList' + that.componentGuid + that.tableMode)
            .find('tr.adding td.actions')
            .off('click');
        $('.orderList' + that.componentGuid + that.tableMode)
            .find('tr.adding td.actions')
            .on('click', function (e) {
            if ($(e.target)
                .closest('button')[0]
                .classList.contains('add-check')) {
                that.beforeInlineDetailSave(e.target);
                that.onInlineAddOrder(e.target);
            }
            else if ($(e.target)
                .closest('button')[0]
                .classList.contains('add-cancel')) {
                if (that.tableMode === TableModeEnum.Details) {
                    that.onInlineAddCancel(e);
                }
                if (that.tableMode === TableModeEnum.Table) {
                    that.onInlineAddCancel(e);
                }
            }
        });
    };
    /**
     * @param {?} order
     * @return {?}
     */
    TableComponent.prototype.removeRowApproved = function (order) {
        var _this = this;
        this.markStopItemEditing(order.rbr);
        this._orderListTotal.splice(this._orderList.indexOf(order), 1);
        this.setPagination();
        for (var /** @type {?} */ i = 0; i < this._orderListTotal.length; i++) {
            this._orderListTotal[i]['rbr'] = i + 1;
        }
        if (this._complexSettings) {
            this._complexSettings.splice(this._orderList.indexOf(order), 1);
        }
        if (order.rbr) {
            delete this.shownEditingRows[order['rbr']];
            Object.keys(this.shownEditingRows).forEach(function (key) {
                if (order.rbr < key) {
                    delete _this.shownEditingRows[+key];
                    _this.shownEditingRows[+key - 1] = { rbr: +key - 1 };
                }
            });
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.removeRow = function (event) {
        var /** @type {?} */ order = this._orderList.filter(function (listItem) { return listItem['rbr'].toString() ===
            $(event.target).closest('button')[0].dataset.dataRbr; })[0];
        if (!this.approveTableActions) {
            this.removeRowApproved(order);
        }
        var /** @type {?} */ params = {
            action: TableActionEnum.Delete,
            document: order
        };
        this.tableAction.emit(params);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.onInlineAddCancel = function (event) {
        var /** @type {?} */ order = this._orderList.filter(function (listItem) { return listItem['rbr'].toString() ===
            $(event.target).closest('button')[0].dataset.dataRbr; })[0];
        if (!this.approveTableActions) {
            this.removeRowApproved(order);
        }
        var /** @type {?} */ params = {
            action: TableActionEnum.AddCancel,
            document: order
        };
        this.tableAction.emit(params);
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.getTableWidth = function () {
        return 100 / this.settings.columns.length + '%';
    };
    /**
     * @param {?} obj
     * @param {?} fields
     * @param {?} val
     * @return {?}
     */
    TableComponent.prototype.setNestedPropertyValue = function (obj, fields, val) {
        fields = fields.split('.');
        var /** @type {?} */ cur = obj;
        var /** @type {?} */ last = fields.pop();
        fields.forEach(function (field) {
            cur[field] = {};
            cur = cur[field];
        });
        cur[last] = val;
        return obj;
    };
    /**
     * @param {?} eventTarget
     * @return {?}
     */
    TableComponent.prototype.beforeInlineDetailSave = function (eventTarget) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ row = $(eventTarget).closest('tr');
        if ((!row.hasClass('adding') && !row.hasClass('editing')) ||
            row.hasClass('disabled')) {
            return;
        }
        if (row.find('.error').length > 0) {
            return;
        }
        var /** @type {?} */ rowIdentity = row[0].dataset.rowIdentity.toString();
        var /** @type {?} */ orderToUpdate = {};
        orderToUpdate[this.identFromTableMode] = rowIdentity;
        var /** @type {?} */ document = {};
        var /** @type {?} */ index;
        for (var /** @type {?} */ i = 0; i < self._orderList.length; i++) {
            if (self._orderList[i].rbr.toString() === orderToUpdate['rbr']) {
                document = self._orderList[i];
                index = i;
            }
        }
        var /** @type {?} */ beforeSaveParams = {
            action: TableActionEnum.BeforeSave,
            document: document,
            index: index
        };
        this.tableAction.emit(beforeSaveParams);
    };
    /**
     * @param {?} eventTarget
     * @param {?} notify
     * @return {?}
     */
    TableComponent.prototype.onInlineUpdateOrder = function (eventTarget, notify) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ row = $(eventTarget).closest('tr');
        if ((!row.hasClass('adding') && !row.hasClass('editing')) ||
            row.hasClass('disabled')) {
            return;
        }
        var /** @type {?} */ rowIdentity = row[0].dataset.rowIdentity.toString();
        var /** @type {?} */ orderToUpdate = {};
        orderToUpdate[this.identFromTableMode] = rowIdentity;
        var /** @type {?} */ index;
        if (this.tableMode === TableModeEnum.Details) {
            for (var /** @type {?} */ i = 0; i < self._orderList.length; i++) {
                if (self._orderList[i].rbr.toString() === orderToUpdate['rbr']) {
                    index = i;
                }
            }
        }
        var /** @type {?} */ rowOrder = self.tableMode === TableModeEnum.Details
            ? self._orderList[index]
            : orderToUpdate;
        var /** @type {?} */ isValid = self.doValidationOfRow(eventTarget);
        if (notify && !isValid) {
            this.notificationService.notyError('Nisu sva polja validna!');
        }
        else if (rowOrder.cantUpdateMessage) {
            this.notificationService.notyError(rowOrder.cantUpdateMessage);
            return;
        }
        if (row.find('.error').length > 0) {
            return;
        }
        this.markStopItemEditing(rowOrder.rbr);
        row.find('> td').each(function () {
            var /** @type {?} */ key = $(this)[0].dataset.dataName;
            var /** @type {?} */ type = $(this)[0].dataset.dataType;
            var /** @type {?} */ fieldName = $(this)[0].dataset.dataFieldname;
            if (fieldName == null) {
                return;
            }
            var /** @type {?} */ textArea = $(this).find('textarea').length;
            var /** @type {?} */ input = $(this).find('input');
            if (textArea > 0) {
                input = $(this).find('textarea');
            }
            var /** @type {?} */ val = input != null ? input.val() : null;
            var /** @type {?} */ value = input != null ? input.val() : null;
            if (type === 'date' ||
                (type === 'complex' &&
                    self._complexSettings[index][key]['type'] === 'date')) {
                var /** @type {?} */ parts = val.split('.');
                var /** @type {?} */ date = '';
                if (parts[0] !== '') {
                    date = moment(new Date(parts[2], parts[1] - 1, parts[0])).format('YYYY-MM-DD');
                }
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = date;
                }
                else {
                    orderToUpdate[key] = date;
                }
            }
            else if (type === 'time' ||
                (type === 'complex' &&
                    self._complexSettings[index][key]['type'] === 'time')) {
                var /** @type {?} */ parts = val.split(':');
                var /** @type {?} */ date = '';
                if (parts[0] !== '') {
                    var /** @type {?} */ today = new Date();
                    date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parts[0], parts[1], 0).toISOString();
                }
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = date;
                }
                else {
                    orderToUpdate[key] = date;
                }
            }
            else if (type === 'input' ||
                (type === 'complex' &&
                    self._complexSettings[index][key]['type'] === 'input')) {
                for (var /** @type {?} */ i = 0; i < self.columns.length; i++) {
                    var /** @type {?} */ shouldBeNumber = false;
                    var /** @type {?} */ dbType = '';
                    var /** @type {?} */ isDbTypeDefined = false;
                    if (type === 'complex') {
                        if (self._complexSettings[index][key].hasOwnProperty('dbType')) {
                            isDbTypeDefined = true;
                            dbType =
                                self._complexSettings[index][key]['dbType'];
                        }
                    }
                    else {
                        if (self.fieldsByName[self.columns[i].name].hasOwnProperty('dbType')) {
                            isDbTypeDefined = true;
                            dbType =
                                self.fieldsByName[self.columns[i].name]['dbType'];
                        }
                    }
                    if (self.columns[i].name === key && isDbTypeDefined) {
                        if (dbType.indexOf('DECIMAL') !== -1) {
                            var /** @type {?} */ fieldMap = self.fieldsByName[key];
                            value = UtilService.deformatDecimal(val, fieldMap.decimalCount);
                            shouldBeNumber = true;
                            if (isNaN(value)) {
                                if (self.tableMode === TableModeEnum.Details) {
                                    delete self._orderList[index][key];
                                }
                            }
                        }
                        else if (dbType.indexOf('INTEGER') !== -1 ||
                            dbType.indexOf('BIGINT') !== -1 ||
                            dbType.indexOf('SMALLINT') !== -1) {
                            value = parseInt(val, 0);
                            shouldBeNumber = true;
                            if (isNaN(value)) {
                                if (self.tableMode === TableModeEnum.Details) {
                                    delete self._orderList[index][key];
                                }
                            }
                        }
                        if (!(shouldBeNumber && isNaN(value))) {
                            if (self.tableMode === TableModeEnum.Details) {
                                self._orderList[index][key] = value;
                            }
                            else {
                                orderToUpdate[key] = value;
                            }
                        }
                    }
                }
            }
            else if (type === 'check' ||
                (type === 'complex' &&
                    self._complexSettings[index][key]['type'] === 'check')) {
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = input.is(':checked');
                }
                else {
                    orderToUpdate[key] = input.is(':checked');
                }
            }
            else if (type === 'completer' ||
                (type === 'complex' &&
                    self._complexSettings[index][key]['type'] === 'completer')) {
                self.autocomplete.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName &&
                        child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
            else if (type === 'combo' ||
                (type === 'complex' &&
                    self._complexSettings[index][key]['type'] === 'combo')) {
                self.combo.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName &&
                        child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
            else if (type === 'comboFixed' ||
                (type === 'complex' &&
                    self._complexSettings[index][key]['type'] === 'comboFixed')) {
                self.combo.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName &&
                        child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
        });
        this.changeRowStatus(row, '');
        if (this.tableMode === TableModeEnum.Table) {
            var /** @type {?} */ params = {
                action: TableActionEnum.Update,
                document: orderToUpdate
            };
            this.tableAction.emit(params);
        }
        if (this.tableMode === TableModeEnum.Details) {
            var /** @type {?} */ params = {
                action: TableActionEnum.Update,
                document: rowOrder
            };
            this.tableAction.emit(params);
        }
    };
    /**
     * @param {?} eventTarget
     * @return {?}
     */
    TableComponent.prototype.onInlineAddOrder = function (eventTarget) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ row = $(eventTarget).closest('tr');
        var /** @type {?} */ isValid = self.doValidationOfRow(eventTarget);
        if (!isValid) {
            this.notificationService.notyError('Nisu sva polja validna!');
        }
        if (row.hasClass('disabled')) {
            return;
        }
        if (row.find('.error').length > 0) {
            return;
        }
        var /** @type {?} */ rowIdentity = row[0].dataset.rowIdentity.toString();
        var /** @type {?} */ orderToAdd = {};
        orderToAdd[this.identFromTableMode] = rowIdentity;
        if (this.tableMode === TableModeEnum.Details) {
            orderToAdd['rbr'] = row.find('button')[0].dataset.dataRbr;
        }
        var /** @type {?} */ index;
        if (this.tableMode === TableModeEnum.Details) {
            for (var /** @type {?} */ i = 0; i < self._orderList.length; i++) {
                if (self._orderList[i].rbr.toString() === orderToAdd['rbr']) {
                    index = i;
                }
            }
        }
        var /** @type {?} */ rowOrder = self.tableMode === TableModeEnum.Details
            ? self._orderList[index]
            : orderToAdd;
        this.markStopItemEditing(rowOrder.rbr);
        row.find('> td').each(function () {
            var /** @type {?} */ key = $(this)[0].dataset.dataName;
            var /** @type {?} */ type = $(this)[0].dataset.dataType;
            var /** @type {?} */ fieldName = $(this)[0].dataset.dataFieldname;
            if (fieldName == null) {
                return;
            }
            var /** @type {?} */ textArea = $(this).find('textarea').length;
            var /** @type {?} */ input = $(this).find('input');
            if (textArea > 0) {
                input = $(this).find('textarea');
            }
            var /** @type {?} */ val = input != null ? input.val() : null;
            var /** @type {?} */ value = input != null ? input.val() : null;
            if (type === 'date') {
                var /** @type {?} */ parts = val.split('.');
                var /** @type {?} */ date = '';
                if (parts[0] !== '') {
                    date = moment(new Date(parts[2], parts[1] - 1, parts[0])).format('YYYY-MM-DD');
                }
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = date;
                }
                else {
                    orderToAdd[key] = date;
                }
            }
            else if (type === 'time') {
                var /** @type {?} */ parts = val.split(':');
                var /** @type {?} */ date = '';
                if (parts[0] !== '') {
                    var /** @type {?} */ today = new Date();
                    date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parts[0], parts[1], 0).toISOString();
                }
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = date;
                }
                else {
                    orderToAdd[key] = date;
                }
            }
            else if (type === 'input') {
                for (var /** @type {?} */ i = 0; i < self.columns.length; i++) {
                    var /** @type {?} */ shouldBeNumber = false;
                    var /** @type {?} */ dbType = '';
                    var /** @type {?} */ isDbTypeDefined = false;
                    if (type === 'complex') {
                        if (self._complexSettings[index][key].hasOwnProperty('dbType')) {
                            isDbTypeDefined = true;
                            dbType =
                                self._complexSettings[index][key]['dbType'];
                        }
                    }
                    else {
                        if (self.fieldsByName[self.columns[i].name].hasOwnProperty('dbType')) {
                            isDbTypeDefined = true;
                            dbType =
                                self.fieldsByName[self.columns[i].name]['dbType'];
                        }
                    }
                    if (self.columns[i].name === key && isDbTypeDefined) {
                        if (dbType.indexOf('DECIMAL') !== -1) {
                            var /** @type {?} */ fieldMap = self.fieldsByName[key];
                            value = UtilService.deformatDecimal(val, fieldMap.decimalCount);
                            shouldBeNumber = true;
                            if (isNaN(value)) {
                                if (self.tableMode === TableModeEnum.Details) {
                                    delete self._orderList[index][key];
                                }
                            }
                        }
                        else if (dbType.indexOf('INTEGER') !== -1 ||
                            dbType.indexOf('BIGINT') !== -1 ||
                            dbType.indexOf('SMALLINT') !== -1) {
                            value = parseInt(val, 0);
                            shouldBeNumber = true;
                            if (isNaN(value)) {
                                if (self.tableMode === TableModeEnum.Details) {
                                    delete self._orderList[index][key];
                                }
                            }
                        }
                        if (!(shouldBeNumber && isNaN(value))) {
                            if (self.tableMode === TableModeEnum.Details) {
                                self._orderList[index][key] = value;
                            }
                            else {
                                orderToAdd[key] = value;
                            }
                        }
                    }
                }
            }
            else if (type === 'check') {
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = input.is(':checked');
                }
                else {
                    orderToAdd[key] = input.is(':checked');
                }
            }
            else if (type === 'completer' || type === 'combo') {
                self.autocomplete.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName &&
                        child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
            else if (type === 'comboFixed') {
                self.combo.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName &&
                        child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
        });
        if (this.tableMode === TableModeEnum.Details) {
            var /** @type {?} */ params = {
                action: TableActionEnum.Save,
                document: rowOrder
            };
            this.tableAction.emit(params);
        }
        if (this.tableMode === TableModeEnum.Table) {
            var /** @type {?} */ params = {
                action: TableActionEnum.Save
            };
            this.tableAction.emit(params);
        }
        this.changeRowStatus(row, '');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.onKeyDown = function (event) {
        if (($('.popup').is(':visible') && event.keyCode === 13) ||
            ($('.combo-component').is(':visible') && event.keyCode === 13)) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    /**
     * @param {?} orderId
     * @param {?} mode
     * @return {?}
     */
    TableComponent.prototype.propagateAction = function (orderId, mode) {
        setTimeout(function (self) {
            var /** @type {?} */ action;
            switch (mode) {
                case TableActionEnum.View:
                    this._mode = FormModeEnum.View;
                    action = TableActionEnum.View;
                    break;
                case TableActionEnum.Delete:
                    action = TableActionEnum.Delete;
                    break;
                case TableActionEnum.Add:
                    this._mode = FormModeEnum.Add;
                    action = TableActionEnum.Add;
                    break;
                case TableActionEnum.Copy:
                    this._mode = FormModeEnum.Copy;
                    action = TableActionEnum.Copy;
                    break;
            }
            var /** @type {?} */ params = {
                action: action,
                documentId: orderId
            };
            self.tableAction.emit(params);
        }, 0, this);
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.ordersTableCommon = function () {
        var /** @type {?} */ that = this;
        if (this.tableMode === TableModeEnum.Table) {
            this.totalPages = Math.ceil(this.orderListCount / this.rowsOnPage);
        }
        if (this.tableMode === TableModeEnum.Details) {
            this.addKeyListeners();
            this.addListenersToNewlyAddedRow();
        }
        if (this.tableMode === TableModeEnum.Table) {
            $('.orderList' + this.componentGuid + this.tableMode)
                .find("tr td:not('.actions')")
                .off('click');
            this.setViewListener();
        }
        if (this.tableMode === TableModeEnum.Details) {
            $('.orderList' + this.componentGuid + this.tableMode).on('page.dt length.dt', function () {
                that.doValidationAndSaveOfCurrentPage();
                setTimeout(function (self) {
                    self.addKeyListeners();
                }, 0, that);
            });
        }
        if (this.resizable) {
            this.resizableGrid();
        }
        if (this.reordable) {
            this.dropGrid();
        }
        if (this._columnsSet) {
            return;
        }
        this._columnsSet = true;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.setViewListener = function () {
        var _this = this;
        // TODO This method needs an explanation!
        $('.orderList' + this.componentGuid + this.tableMode)
            .find("tr td:not('.actions')")
            .on('click', function (e) {
            $('.orderList' + _this.componentGuid + _this.tableMode)
                .find("tr td:not('.actions')")
                .off('click');
            var /** @type {?} */ $row = $(e.target).closest('tr');
            if (!$row.hasClass('adding') && !$row.hasClass('editing')) {
                var /** @type {?} */ $childrenWithData = $row.find('td span[data-data-id]');
                _this.propagateAction($childrenWithData[0].dataset.dataId, TableActionEnum.View);
            }
            _this.setViewListener();
        });
    };
    /**
     * @param {?} column
     * @return {?}
     */
    TableComponent.prototype.sortAction = function (column) {
        if (!this.sortingEnabled || !column.sortable) {
            return;
        }
        if (this.sortColumnName !== column.name) {
            this.sortColumnName = column.name;
            this.sortAscending = true;
        }
        else {
            this.sortAscending = !this.sortAscending;
        }
        this.filter(FilterActionEnum$1.Sort, this.fieldsByName[column.name], null);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.page = function (event) {
        this.filter(FilterActionEnum$1.Page, this.sortOrder, event);
    };
    /**
     * @param {?} action
     * @param {?} order
     * @param {?} page
     * @return {?}
     */
    TableComponent.prototype.filter = function (action, order, page) {
        var _this = this;
        if (action === FilterActionEnum$1.Sort && !this.isTableValid()) {
            return;
        }
        if (action === FilterActionEnum$1.Page) {
            this.pageCurrent = page;
        }
        if (typeof order !== 'undefined' &&
            Object.keys(order).length === 0 &&
            page === null) {
            this.pageCurrent = 1;
        }
        else {
            this.sortOrder = order;
        }
        var /** @type {?} */ direction = this.sortColumnName != null
            ? this.sortAscending
                ? 'asc'
                : 'desc'
            : 'asc';
        if (this.tableMode === TableModeEnum.Table ||
            (this.tableMode === TableModeEnum.Details && this.serverPagination)) {
            // Server-side filtering, sorting, pagination, etc.
            var /** @type {?} */ params = {
                action: TableActionEnum.Filter,
                filter: {
                    pageCurrent: this.pageCurrent,
                    filterQuery: '',
                    filterDate: null,
                    filterObjects: [],
                    filterCombined: null,
                    rowsOnPage: this.rowsOnPage,
                    sortOrder: this.sortOrder,
                    direction: direction,
                    relations: this._settings.relations
                }
            };
            this.tableAction.emit(params);
            return;
        }
        if (this.tableMode === TableModeEnum.Details &&
            !this.serverPagination) {
            // Client-side filtering, sorting, pagination, etc.
            if (typeof this.sortOrder !== 'undefined' &&
                Object.keys(this.sortOrder).length > 0) {
                this._orderListTotal = this._orderListTotal.sort(function (a, b) {
                    var /** @type {?} */ x = _this.getTableCellText(order['fieldName'], a);
                    var /** @type {?} */ y = _this.getTableCellText(order['fieldName'], b);
                    if (order.type === FieldTypeEnum.Date) {
                        x = moment(x, 'DD.MM.YYYY').format('YYYYMMDD');
                        y = moment(y, 'DD.MM.YYYY').format('YYYYMMDD');
                    }
                    var /** @type {?} */ retval = _this.sortCompareFn(x, y, direction);
                    if (order.type === FieldTypeEnum.Date) {
                        x = moment(x, 'YYYYMMDD').format('DD.MM.YYYY');
                        y = moment(y, 'YYYYMMDD').format('DD.MM.YYYY');
                    }
                    return retval;
                });
            }
            this.totalPages = Math.ceil(this._orderListTotal.length / this.rowsOnPage);
            if (this.totalPages < this.pageCurrent) {
                this.pageCurrent = 1;
            }
            var /** @type {?} */ from = (this.pageCurrent - 1) * this.rowsOnPage;
            this._orderList = this._orderListTotal.slice(from, this.rowsOnPage * this.pageCurrent);
            this.from = (this.pageCurrent - 1) * this.rowsOnPage;
            this.to = this.rowsOnPage * this.pageCurrent;
            this.direction = direction === 'asc' ? 0 : 1;
            if (typeof this.sortOrder !== 'undefined' &&
                Object.keys(this.sortOrder).length > 0) {
                this.fieldName = this.sortOrder.fieldName;
            }
            this.ref.detectChanges();
            this.addKeyListeners();
            this.addListenersToNewlyAddedRow();
            this.sortOrder = undefined;
            return;
        }
    };
    /**
     * @param {?} x
     * @param {?} y
     * @param {?} direction
     * @return {?}
     */
    TableComponent.prototype.sortCompareFn = function (x, y, direction) {
        if (direction === 'desc') {
            if (!x && !y) {
                return 0;
            }
            else if (!x) {
                return 1;
            }
            else if (!y) {
                return -1;
            }
            return x < y ? 1 : x > y ? -1 : 0;
        }
        if (!x && !y) {
            return 0;
        }
        else if (!x) {
            return -1;
        }
        else if (!y) {
            return 1;
        }
        return x < y ? -1 : x > y ? 1 : 0;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.updateCurrentPage = function () {
        var /** @type {?} */ from = (this.pageCurrent - 1) * this.rowsOnPage;
        this._orderList = this._orderListTotal.slice(from, this.rowsOnPage * this.pageCurrent);
    };
    /**
     * @param {?} fieldName
     * @return {?}
     */
    TableComponent.prototype.isFieldDisabled = function (fieldName) {
        if (fieldName === 'id') {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @param {?} columnName
     * @param {?} eventTarget
     * @return {?}
     */
    TableComponent.prototype.doValidationOfInput = function (columnName, eventTarget) {
        // TODO Add validation from validator field
        var /** @type {?} */ isValid = true;
        if (eventTarget) {
            if (this.settings.getFieldByName(columnName).mandatory) {
                if ($(eventTarget).val() === '') {
                    $(eventTarget.querySelector('.combo-component')).addClass('error');
                    $(eventTarget.querySelector('input')).addClass('error');
                    isValid = false;
                }
                else {
                    $(eventTarget.querySelector('.combo-component')).removeClass('error');
                    $(eventTarget.querySelector('input')).removeClass('error');
                }
            }
            else {
                $(eventTarget.querySelector('.combo-component')).removeClass('error');
                $(eventTarget.querySelector('input')).removeClass('error');
            }
        }
        return isValid;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.isTableValid = function () {
        this.doValidationAndSaveOfCurrentPage();
        var /** @type {?} */ isValid = true;
        if (typeof this._orderList !== 'undefined' &&
            this._orderList !== null) {
            for (var /** @type {?} */ i = 0; i < this._orderList.length; i++) {
                if (this._orderList[i].hasOwnProperty('isValid') &&
                    !this._orderList[i].isValid) {
                    isValid = false;
                    break;
                }
            }
            if (isValid) {
                for (var /** @type {?} */ i = 0; i < this._orderList.length; i++) {
                    if (this._orderList[i].hasOwnProperty('isValid')) {
                        delete this._orderList[i].isValid;
                    }
                }
            }
        }
        return isValid;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.doValidationAndSaveOfCurrentPage = function () {
        var /** @type {?} */ that = this;
        $('.orderList' + this.componentGuid + TableModeEnum.Details)
            .find('tbody tr')
            .each(function () {
            if ($(this).is(':visible')) {
                that.beforeInlineDetailSave($(this));
                that.onInlineUpdateOrder($(this), false);
            }
        });
        if ($('.orderList' + this.componentGuid + TableModeEnum.Details).find('.error').length > 0) {
            this.notificationService.notyError('Nisu sva polja validna!');
            return false;
        }
        return true;
    };
    /**
     * @param {?} tableRow
     * @return {?}
     */
    TableComponent.prototype.isRowValid = function (tableRow) {
        var /** @type {?} */ isValid = true;
        this.timePicker.forEach(function (child) {
            if (tableRow &&
                tableRow.length > 0 &&
                tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        this.datePicker.forEach(function (child) {
            if (tableRow &&
                tableRow.length > 0 &&
                tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        this.input.forEach(function (child) {
            if (tableRow &&
                tableRow.length > 0 &&
                tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        this.combo.forEach(function (child) {
            if (tableRow &&
                tableRow.length > 0 &&
                tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        this.autocomplete.forEach(function (child) {
            if (tableRow &&
                tableRow.length > 0 &&
                tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        if (!isValid) {
            return false;
        }
        return true;
    };
    /**
     * @param {?} eventTarget
     * @return {?}
     */
    TableComponent.prototype.doValidationOfRow = function (eventTarget) {
        var /** @type {?} */ tableRow = $(eventTarget).closest('tr');
        var /** @type {?} */ isValid = this.isRowValid(tableRow);
        if (this.tableMode === this.TableModeEnum.Details) {
            var /** @type {?} */ rbr = tableRow.find('button')[0].dataset.dataRbr;
            for (var /** @type {?} */ i = 0; i < this._orderList.length; i++) {
                if (this._orderList[i]['rbr'].toString() === rbr) {
                    this._orderList[i]['isValid'] = isValid;
                    break;
                }
            }
        }
        return isValid;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.setFieldByName = function () {
        if (this.settings != null) {
            for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
                for (var /** @type {?} */ i = 0; i < this.settings.columns.length; i++) {
                    if (this.columns[j].name.toLowerCase() ===
                        this.settings.columns[i].fieldName.toLowerCase()) {
                        var /** @type {?} */ fieldByName = this.settings.columns[i];
                        this.fieldsByName[this.columns[j].name] = fieldByName;
                        this.fieldsByName[this.columns[j].name]['sortable'] = this.settings.columns[i].sortable;
                        this.fieldsByName[this.columns[j].name]['resizing'] = false;
                    }
                }
            }
        }
    };
    /**
     * @param {?} order
     * @param {?} column
     * @return {?}
     */
    TableComponent.prototype.getInputValue = function (order, column) {
        return this.fieldService.getInputValue(order, column);
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @param {?=} complexFieldMap
     * @return {?}
     */
    TableComponent.prototype.getComboFixedText = function (order, columnName, complexFieldMap) {
        if (complexFieldMap === void 0) { complexFieldMap = null; }
        var /** @type {?} */ fieldMap = this.settings.getFieldByName(columnName);
        var /** @type {?} */ value = UtilService.getFieldValue(order, fieldMap);
        var /** @type {?} */ enumResult;
        if (complexFieldMap && complexFieldMap.lookupList != null) {
            enumResult = complexFieldMap.lookupList.filter(function (listItem) { return listItem.value === value; });
        }
        else {
            enumResult = this.listService
                .getEnum(fieldMap.entityType)
                .filter(function (item) { return item.value === value; });
        }
        if (enumResult.length === 0) {
            return null;
        }
        return enumResult[0].label;
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @return {?}
     */
    TableComponent.prototype.getCompleterItem = function (order, columnName) {
        return UtilService.getFieldObject(order, this.settings.getFieldByName(columnName).propertyPath.all);
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @return {?}
     */
    TableComponent.prototype.getComboFixedItem = function (order, columnName) {
        return UtilService.getFieldValue(order, this.settings.getFieldByName(columnName));
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.onOrderListAndRelationsLoaded = function () {
        var _this = this;
        if (!this.initialized ||
            this.tableMode == null ||
            this.orderList == null) {
            return;
        }
        var /** @type {?} */ setColumns = false;
        if (this.columns.length === 0) {
            setColumns = true;
        }
        // TODO Refactor it to use `this.settings.columns.map()`.
        var /** @type {?} */ columnsTemp = [];
        for (var /** @type {?} */ i = 0; i < this.settings.columns.length; i++) {
            if (Object.keys(this.settings.columns[i]).length !== 0) {
                columnsTemp.push({
                    name: this.settings.columns[i].fieldName,
                    label: this.settings.columns[i].label,
                    dbType: this.settings.columns[i].dbType,
                    id: this.settings.columns[i].id,
                    size: this.settings.columns[i].width,
                    sortable: this.settings.columns[i].sortable
                });
            }
        }
        this.columns = columnsTemp;
        this.columnsWithActions = this.columns.slice();
        this.columnsWithActions.splice(0, 0, {
            name: '',
            label: '',
            dbType: '',
            id: '',
            size: ''
        });
        this.setFieldByName();
        if (setColumns && this.tableMode === TableModeEnum.Table) {
            if (this.resizable) {
                this.setColumnsSizes();
            }
            if (this.reordable) {
                this.setColumnsOrders();
            }
        }
        setTimeout(function () {
            _this.ordersTableCommon();
        }, 0);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.onInlineDeleteOpen = function (event) {
        if (this.tableMode === TableModeEnum.Table) {
            this.propagateAction($(event.target).closest('button')[0].dataset.dataId, TableActionEnum.Delete);
        }
        else {
            this.removeRow(event);
        }
    };
    /**
     * @param {?} event
     * @param {?} document
     * @return {?}
     */
    TableComponent.prototype.onInlineEditOpen = function (event, document) {
        var _this = this;
        if (!$(event.target)
            .closest('tr')
            .hasClass('adding')) {
            this.markStartItemEditing(document.rbr, function () {
                _this.changeRowStatus($(event.target).closest('tr'), 'editing');
            });
        }
        var /** @type {?} */ params = {
            action: TableActionEnum.Edit,
            document: document
        };
        this.onAction(params);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TableComponent.prototype.onInlineEditCancel = function (event) {
        var _this = this;
        var /** @type {?} */ element = event;
        if (event.target) {
            element = $(event.target).closest('button.edit-cancel');
        }
        else {
            element = event.find('button.edit-cancel');
        }
        var /** @type {?} */ index = this._orderList.findIndex(function (listItem) { return listItem['rbr'].toString() === element[0].dataset.dataRbr; });
        this.markStopItemEditing(this.orderList[index].rbr);
        var /** @type {?} */ row = element.closest('tr');
        this.orderList[index] = this.shownEditingRows[row[0].dataset.rowIdentity];
        this.changeRowStatus(row, '');
        var /** @type {?} */ params = {
            action: TableActionEnum.EditCancel,
            document: this.orderList[index],
            index: index
        };
        this.onAction(params);
        setTimeout(function () {
            _this.setViewListener();
        });
    };
    /**
     * @param {?} selectedDocument
     * @return {?}
     */
    TableComponent.prototype.onInlineViewAndSelect = function (selectedDocument) {
        var /** @type {?} */ tableRow = $(this.getItemRef().querySelector('tbody span[data-data-' +
            this.ident +
            "='" +
            selectedDocument[this.ident] +
            "']")).closest('tr');
        if (this.tableMode === TableModeEnum.Table) {
            if (!tableRow.hasClass('adding') && !tableRow.hasClass('editing')) {
                this.propagateAction(selectedDocument[this.ident], TableActionEnum.View);
            }
        }
        this.onInlineSelect(selectedDocument);
    };
    /**
     * @param {?} selectedDocument
     * @return {?}
     */
    TableComponent.prototype.onInlineSelect = function (selectedDocument) {
        var /** @type {?} */ params = {
            action: TableActionEnum.Select,
            document: selectedDocument
        };
        if (selectedDocument === null) {
            $('.orderList' + this.componentGuid + this.tableMode + ' tbody tr').removeClass(this.selectedClass);
            this.onAction(params);
        }
        else {
            var /** @type {?} */ tableRow = $(this.getItemRef().querySelector('tbody span[data-data-' +
                this.ident +
                "='" +
                selectedDocument[this.ident] +
                "']")).closest('tr');
            if (!tableRow.hasClass(this.selectedClass)) {
                this.selectedObject = selectedDocument;
                $('.orderList' +
                    this.componentGuid +
                    this.tableMode +
                    ' tbody tr').removeClass(this.selectedClass);
                tableRow.addClass(this.selectedClass);
                this.onAction(params);
            }
        }
        params = {
            action: TableActionEnum.Click,
            document: selectedDocument
        };
        this.onAction(params);
    };
    /**
     * @param {?} columnName
     * @param {?} order
     * @return {?}
     */
    TableComponent.prototype.getTableCellText = function (columnName, order) {
        // let val = ''; -ovako je bilo;
        var /** @type {?} */ val;
        if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Input) {
            val = UtilService.getFieldValue(order, this.fieldsByName[columnName]);
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Completer) {
            val = UtilService.getCompleterValue(order, this.fieldsByName[columnName]);
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Date) {
            val = UtilService.formatDate(this.getInputValue(order, columnName));
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Time) {
            val = UtilService.formatTime(this.getInputValue(order, columnName));
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Check) {
            val = this.getInputValue(order, columnName);
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Combo ||
            this.fieldsByName[columnName]['type'] === FieldTypeEnum.ComboFixed) {
            val = this.getComboFixedText(order, columnName);
        }
        return val;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.getTableData = function () {
        var /** @type {?} */ table = [];
        if (this._orderList) {
            for (var /** @type {?} */ i = 0; i < this._orderList.length; i++) {
                var /** @type {?} */ row = {};
                for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
                    var /** @type {?} */ val = this.getTableCellText(this.columns[j].name, this._orderList[i]);
                    if (typeof val !== 'undefined' && val !== null) {
                        row[this.columns[j].label] = val;
                    }
                }
                table.push(row);
            }
        }
        return table;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.setColumnsSizes = function () {
        var /** @type {?} */ columnsSizes = new Map();
        for (var /** @type {?} */ i = 0; i < this.columns.length; i++) {
            columnsSizes.set(this.columns[i].id, parseInt(this.columns[i].size, 0));
        }
        this.backendService.setColumnsSizes(columnsSizes);
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.setColumnsOrders = function () {
        this.backendService.setColumnsOrders(this.columns.map(function (column) { return column.id; }));
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.ngOnInit = function () {
        var _this = this;
        var /** @type {?} */ that = this;
        this.initialized = true;
        this.onOrderListAndRelationsLoaded();
        this.isAdmin = this.authenticationService.getUser().type === 'admin';
        $('.table-responsive').on('scroll', function () {
            $('.popup').removeClass('show');
            $('.combo-component').removeClass('open');
        });
        if (this.tableMode === TableModeEnum.Table) {
            this.tabSwitchSubscription = this.applicationService.tabSwitchEvent.subscribe(function (data) {
                if (that.identity.documentId === data.identity.documentId) {
                    setTimeout(function () {
                        UtilService.resetCss();
                        UtilService.recalculateCss();
                    });
                }
            });
            this.tabOpenSubscription = this.applicationService.tabOpenEvent.subscribe(function () {
                setTimeout(function () {
                    UtilService.resetCss();
                    UtilService.recalculateCss();
                });
            });
        }
        if (this.objectSelected) {
            this.objectSelectedSubscrption = this.objectSelected.subscribe(function (value) { return _this.onInlineSelect(value); });
        }
    };
    /**
     * @param {?} element
     * @return {?}
     */
    TableComponent.prototype.scrollbarVisible = function (element) {
        return element.scrollWidth > element.clientWidth;
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.scrollHeaderEvent$ = Observable$1.fromEvent($(this.getItemRef().querySelector('.tbody-wrapper')), 'scroll').subscribe(function () {
            $(_this.getItemRef().querySelector('.thead-wrapper')).scrollLeft($(_this.getItemRef().querySelector('.tbody-wrapper')).get(0)
                .scrollLeft);
        });
        this.scrollBodyEvent$ = Observable$1.fromEvent($(this.getItemRef().querySelector('.thead-wrapper')), 'scroll').subscribe(function () {
            $(_this.getItemRef().querySelector('.tbody-wrapper')).scrollLeft($(_this.getItemRef().querySelector('.thead-wrapper')).get(0)
                .scrollLeft);
        });
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.ngOnDestroy = function () {
        if ($('.editing .edit-cancel').length > 0) {
            var /** @type {?} */ element = $(this.getItemRef().querySelector('.editing'));
            this.onInlineEditCancel(element);
        }
        $('.adding .add-cancel').trigger('click');
        this.ref.detach();
        if (this.scrollHeaderEvent$) {
            this.scrollHeaderEvent$.unsubscribe();
        }
        if (this.scrollBodyEvent$) {
            this.scrollBodyEvent$.unsubscribe();
        }
        if (this.resizeEvent$) {
            this.resizeEvent$.unsubscribe();
        }
        if (this.tabSwitchSubscription) {
            this.tabSwitchSubscription.unsubscribe();
        }
        if (this.tabOpenSubscription) {
            this.tabOpenSubscription.unsubscribe();
        }
        if (this.objectSelectedSubscrption) {
            this.objectSelectedSubscrption.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.resizableGrid = function () {
        var /** @type {?} */ that = this;
        var /** @type {?} */ tbody = $(this.getItemRef().querySelector('.tbody-wrapper')).find('table');
        var /** @type {?} */ table = $(this.getItemRef().querySelector('.thead-wrapper')).find('table');
        if (this.tableMode !== TableModeEnum.Table) {
            table = $(this.getItemRef().querySelector('.tbody-wrapper')).find('table');
        }
        var /** @type {?} */ thHeight = table.find('th:first').height();
        var /** @type {?} */ columnName = '';
        for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
            if (table
                .find('th.column_' + that.columns[j].name)
                .is('.ui-resizable')) {
                table
                    .find('th.column_' + that.columns[j].name)
                    .resizable('destroy');
            }
            var /** @type {?} */ options = {
                handles: 'e',
                minHeight: thHeight,
                maxHeight: thHeight,
                animate: true,
                resize: function (event, ui) {
                    // Subtract padding
                    var /** @type {?} */ width = parseInt(ui.size.width, 0) - 40 + '';
                    that.fieldsByName[columnName]['width'] = width;
                    that.ref.detectChanges();
                },
                stop: function (event, ui) {
                    // Subtract padding
                    var /** @type {?} */ width = parseInt(ui.size.width, 0) - 40 + '';
                    // Prevent flickering
                    for (var /** @type {?} */ i = 0; i < that.columns.length; i++) {
                        that.fieldsByName[that.columns[i].name]['width'] = table
                            .find('th.column_' + that.columns[i].name)
                            .width();
                    }
                    that.ref.detectChanges();
                    that.fieldsByName[columnName]['width'] = width;
                    that.fieldsByName[columnName]['resizing'] = false;
                    that.fieldsByName[columnName]['size'] = ui.size.width;
                    that.ref.detectChanges();
                    if (that.tableMode === TableModeEnum.Table) {
                        // Save columns sizes
                        var /** @type {?} */ columnsSizes = new Map();
                        for (var /** @type {?} */ key in that.fieldsByName) {
                            if (that.fieldsByName.hasOwnProperty(key)) {
                                var /** @type {?} */ field = (that.fieldsByName[key]);
                                if (that.fieldsByName[field.fieldName]['size']) {
                                    columnsSizes.set(field.id, parseInt(that.fieldsByName[field.fieldName]['size'], 0));
                                }
                                else {
                                    columnsSizes.set(field.id, parseInt(field.width, 0));
                                }
                            }
                        }
                        that.backendService.setColumnsSizes(columnsSizes);
                    }
                    // Prevent flickering
                    for (var /** @type {?} */ i = 0; i < that.columns.length; i++) {
                        that.fieldsByName[that.columns[i].name]['width'] =
                            'auto';
                        that.fieldsByName[that.columns[i].name]['size'] =
                            that.columns[i].size;
                    }
                },
                start: function (event) {
                    columnName = $(event.target)[0].classList[0].substring(7, $(event.target)[0].classList[0].length);
                    that.fieldsByName[columnName]['resizing'] = true;
                    that.ref.detectChanges();
                }
            };
            if (this.tableMode === TableModeEnum.Table) {
                options['alsoResize'] = tbody.find('th.column_' + that.columns[j].name);
            }
            table.find('th.column_' + that.columns[j].name).resizable(options);
        }
    };
    /**
     * @return {?}
     */
    TableComponent.prototype.dropGrid = function () {
        var /** @type {?} */ self = this;
        var /** @type {?} */ table = $(this.getItemRef().querySelector('.thead-wrapper')).find('table');
        if (this.tableMode !== TableModeEnum.Table) {
            table = $(this.getItemRef().querySelector('.tbody-wrapper')).find('table');
        }
        var /** @type {?} */ el = table[0];
        var /** @type {?} */ dragger = tableDragger(el, {
            mode: 'column',
            dragHandler: '.handle',
            animation: 300
        });
        dragger.on('drop', function (from, to) {
            var /** @type {?} */ decrement = self._decrement;
            if (self.tableMode !== TableModeEnum.Table) {
                decrement--;
            }
            var /** @type {?} */ f = self.columns[from - decrement];
            self.columns[from - decrement] = self.columns[to - decrement];
            self.columns[to - decrement] = f;
            self.ref.detectChanges();
            if (self.tableMode === TableModeEnum.Table) {
                // Save columns orders
                var /** @type {?} */ columnsOrders = self.columns.map(function (column) { return column.id; });
                self.backendService.setColumnsOrders(columnsOrders);
            }
        });
    };
    return TableComponent;
}());
TableComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-table',
                template: "\n      <div\n           [ngClass]=\"{'main-table': tableMode === TableModeEnum.Table, 'details-table': tableMode === TableModeEnum.Details}\">\n          <div class=\"panel panel-default\">\n              <div class=\"panel-body\">\n                  <div class=\"table-responsive\"\n                       [ngClass]=\"{'main': tableMode === TableModeEnum.Table, 'paging': paging, 'sticking': sticking}\">\n                      <table *ngIf=\"paging\"\n                             class=\"dataTable orderList display table-striped\"\n                             [ngClass]=\"{'pagination-main-table': tableMode === TableModeEnum.Table, 'table': tableMode === TableModeEnum.Table, 'details': tableMode !== TableModeEnum.Table}\"\n                             cellspacing=\"0\"\n                             width=\"100%\">\n                          <tfoot>\n                              <tr>\n                                  <td>\n                                      <div class=\"dataTables_length\"\n                                           id=\"{{'DataTables_Table_0_length' + componentGuid + tableMode}}\">\n                                          <label>Prika\u017Ei\n                                              <select name=\"DataTables_Table_0_length\"\n                                                      aria-controls=\"DataTables_Table_0\"\n                                                      class=\"\"\n                                                      [(ngModel)]=\"rowsOnPage\"\n                                                      (change)=\"filter(FilterActionEnum.RowsPerPage, {}, null, null)\">\n                                                  <option [ngValue]=\"10\">10</option>\n                                                  <option [ngValue]=\"25\">25</option>\n                                                  <option [ngValue]=\"50\">50</option>\n                                                  <option [ngValue]=\"100\">100</option>\n                                                  <option [ngValue]=\"1000\">1000</option>\n                                              </select> stavki</label>\n                                      </div>\n                                  </td>\n                                  <td>\n                                      <util-pagination *ngIf=\"_orderList\"\n                                                       [pageCurrent]=\"pageCurrent\"\n                                                       [pageTotal]=\"totalPages\"\n                                                       (page)=\"page($event)\"></util-pagination>\n                                  </td>\n                              </tr>\n                          </tfoot>\n                      </table>\n                      <div class=\"thead-wrapper thead-wrapper-main-table\"\n                           *ngIf=\"tableMode === TableModeEnum.Table\">\n                          <div class=\"sindu-wrapper\">\n                              <table class=\"{{'orderList' + componentGuid + tableMode}}\"\n                                     class=\"thead-main-table dataTable orderList display table table-striped row-border hover\"\n                                     [ngClass]=\"{'columns-main-table': tableMode === TableModeEnum.Table, 'hide-actions': tableMode !== TableModeEnum.Table && _mode === FormModeEnum.View}\"\n                                     cellspacing=\"0\"\n                                     width=\"100%\">\n                                  <!-- ### This is the header for the TABLE mode, i.e. the \"main\" document list!!! -->\n                                  <thead>\n                                      <tr>\n                                          <th *ngIf=\"columns.length !== 0\"\n                                              class=\"actions dt-head-center\"\n                                              [ngClass]=\"{'wide': copyEnabled}\">\n                                              <button *ngIf=\"settings.inlineAdding && additable &&\n                                                      (!maxRows || maxRows > _orderList.length)\"\n                                                      title=\"Dodaj\"\n                                                      (click)=\"onInlineAddOpenFromHeader(); $event.stopPropagation(); $event.preventDefault()\"\n                                                      class=\"actions btn btn-info btn-rounded btn-condensed btn-sm\">\n                                                  <span class=\"fa fa-plus\"></span>\n                                              </button>\n                                              <button *ngIf=\"!settings.inlineAdding && additable &&\n                                                      (!maxRows || maxRows > _orderList.length)\"\n                                                      (click)=\"propagateAction(null, TableActionEnum.Add); $event.stopPropagation(); $event.preventDefault()\"\n                                                      title=\"Dodaj\"\n                                                      class=\"actions btn btn-info btn-rounded btn-condensed btn-sm\">\n                                                  <span class=\"fa fa-plus\"></span>\n                                              </button>\n                                          </th>\n                                          <th\n                                              *ngIf=\"tableMode === TableModeEnum.Table && showDocumentStatusColumn\"\n                                              style=\"width: 80px; min-width: 80px; max-width: 80px;\"\n                                          >\n                                              <span>Status</span>\n                                          </th>\n                                          <th\n                                              *ngIf=\"tableMode === TableModeEnum.Table && showSelectColumn\"\n                                              style=\"width: 80px; min-width: 80px; max-width: 80px;\"\n                                          >\n                                              <label\n                                                  class=\"switch switch-small\"\n                                                  [tooltip]=\"'Izaberi sve rezervacije'\"\n                                                  [options]=\"tooltipOptions\"\n                                              >\n                                                  <input\n                                                      type=\"checkbox\"\n                                                      class=\"icheckbox\"\n                                                      [ngModel]=\"allSelected\"\n                                                      (ngModelChange)=\"updateAllSelected()\"\n                                                      [attr.data-data-name]=\"'allSelected'\"\n                                                      [attr.data-data-type]=\"'check'\"\n                                                  />\n                                                  <span class=\"checkbox-span\" style=\"display: block;\"></span>\n                                              </label>\n                                          </th>\n                                          <th *ngFor=\"let column of columns\"\n                                              class=\"{{'column_' + column.name}}\"\n                                              [style.width]=\"fieldsByName[column.name]['resizing'] ? fieldsByName[column.name]['width'] + 'px' : 'auto'\"\n                                              [style.min-width.px]=\"fieldsByName[column.name]['width']\"\n                                              [style.max-width.px]=\"fieldsByName[column.name]['width']\"\n                                              title=\"{{column.label}}\"\n                                              [ngStyle]=\"tableMode === TableModeEnum.Table && {'width': fieldsByName[column.name]['resizing'] ? fieldsByName[column.name]['width'] + 'px' : 'auto'}\"\n                                              [ngClass]=\"{'hidden': !fieldsByName[column.name]['visible']}\">\n                                              <div class=\"header-flex\"\n                                                   [ngClass]=\"{'sorting': column.sortable === true, 'sorting_asc': column.name === sortColumnName && sortAscending, 'sorting_desc': column.name === sortColumnName && !sortAscending}\">\n                                                  <i *ngIf=\"tableMode === TableModeEnum.Table\"\n                                                     class=\"handle fa fa-arrows\"></i>\n                                                  <span class=\"span-text\"\n                                                        [ngClass]=\"{'sorting': column.sortable === true}\"\n                                                        (click)=\"sortAction(column)\"\n                                                        [attr.data-data-name]=\"column.name\">{{column.label}}</span>\n                                              </div>\n                                          </th>\n                                      </tr>\n                                  </thead>\n                              </table>\n                          </div>\n                      </div>\n                      <div class=\"tbody-wrapper\"\n                           [ngClass]=\"{'tbody-wrapper-main-table': tableMode === TableModeEnum.Table}\">\n                          <div class=\"sindu-wrapper\">\n                              <table class=\"{{'orderList' + componentGuid + tableMode}}\"\n                                     class=\"dataTable orderList display table table-striped row-border hover table-padding-bottom\"\n                                     [ngClass]=\"{'hide-actions': tableMode !== TableModeEnum.Table && _mode === FormModeEnum.View}\"\n                                     cellspacing=\"0\"\n                                     width=\"100%\">\n\n                                  <!-- ### This is the header for the DETAILS mode, i.e. the document items!!! -->\n                                  <thead>\n                                      <tr>\n                                          <th *ngIf=\"columns.length !== 0\"\n                                              class=\"actions dt-head-center\"\n                                              [ngClass]=\"{'wide': copyEnabled}\">\n                                              <button *ngIf=\"settings.inlineAdding && additable &&\n                                                  (!maxRows || maxRows > _orderList.length)\"\n                                                      title=\"Dodaj\"\n                                                      (click)=\"onInlineAddOpenFromHeader(); $event.stopPropagation(); $event.preventDefault()\"\n                                                      class=\"actions btn btn-info btn-rounded btn-condensed btn-sm\">\n                                                  <span class=\"fa fa-plus\"></span>\n                                              </button>\n                                              <button *ngIf=\"!settings.inlineAdding && additable &&\n                                                  (!maxRows || maxRows > _orderList.length)\"\n                                                      (click)=\"propagateAction(null, TableActionEnum.Add); $event.stopPropagation(); $event.preventDefault()\"\n                                                      title=\"Dodaj\"\n                                                      class=\"actions btn btn-info btn-rounded btn-condensed btn-sm\">\n                                                  <span class=\"fa fa-plus\"></span>\n                                              </button>\n                                          </th>\n                                          <th\n                                              *ngIf=\"tableMode === TableModeEnum.Details && showSelectColumn\"\n                                              style=\"width: 80px; min-width: 80px; max-width: 30px;\"\n                                          >\n                                              <label\n                                                  class=\"switch switch-small\"\n                                                  [tooltip]=\"allSelectedTooltip\"\n                                                  [options]=\"tooltipOptions\"\n                                              >\n                                                  <input\n                                                      type=\"checkbox\"\n                                                      class=\"icheckbox\"\n                                                      [ngModel]=\"allSelected\"\n                                                      (ngModelChange)=\"updateAllSelected()\"\n                                                      [attr.data-data-name]=\"'allSelected'\"\n                                                      [attr.data-data-type]=\"'check'\"\n                                                  />\n                                                  <span class=\"checkbox-span\" style=\"display: block;\"></span>\n                                              </label>\n                                          </th>\n                                          <th *ngIf=\"tableMode === TableModeEnum.Table && showDocumentStatusColumn\"\n                                              style=\"width: 80px; min-width: 80px; max-width: 80px;\"><span>Status</span></th>\n                                          <th *ngFor=\"let column of columns\"\n                                              class=\"{{'column_' + column.name}}\"\n                                              [style.width]=\"fieldsByName[column.name]['resizing'] ? fieldsByName[column.name]['width'] + 'px' : 'auto'\"\n                                              [style.min-width.px]=\"fieldsByName[column.name]['width']\"\n                                              [style.max-width.px]=\"fieldsByName[column.name]['width']\"\n                                              title=\"{{column.label}}\"\n                                              [ngStyle]=\"tableMode !== TableModeEnum.Table && {'width': fieldsByName[column.name]['resizing'] ? fieldsByName[column.name]['width'] + 'px' : 'auto'}\"\n                                              [ngClass]=\"{'hidden': !fieldsByName[column.name]['visible']}\"\n                                              [tooltip]=\"fieldsByName[column.name]['tooltipText']\"\n                                              [options]=\"tooltipOptions\"\n                                              [display]=\"!!fieldsByName[column.name]['tooltipText']\"\n                                          >\n                                              <div class=\"header-flex\"\n                                                   [ngClass]=\"{'sorting': column.sortable === true, 'sorting_asc': column.name === sortColumnName && sortAscending, 'sorting_desc': column.name === sortColumnName && !sortAscending}\">\n                                                  <i *ngIf=\"tableMode !== TableModeEnum.Table\"\n                                                     class=\"handle fa fa-arrows\"></i>\n                                                  <span class=\"span-text\"\n                                                        [ngClass]=\"{'sorting': column.sortable}\"\n                                                        (click)=\"sortAction(column)\"\n                                                        [attr.data-data-name]=\"column.name\">{{column.label}}</span>\n                                              </div>\n                                          </th>\n                                      </tr>\n                                  </thead>\n\n                                  <tbody>\n                                      <tr *ngFor=\"let order of _orderList; let i = index\"\n                                          (click)=\"onInlineSelect(order)\"\n                                          [attr.data-row-identity]=\"order[identFromTableMode]\"\n                                          class=\"{{ order.color ? order.color : '' }}\"\n                                          [ngClass]=\"{\n                                              'default-table-row-height': defaultRowHeight\n                                          }\">\n                                          <td class=\"actions\"\n                                              [ngClass]=\"{\n                                                  'wide': copyEnabled,\n                                                  'actions-small': !defaultRowHeight\n                                              }\">\n                                              <button\n                                                  *ngIf=\"isAbleToEnterEditMode(order.Status) && settings.listEditable && settings.documentType !== DocumentTypeEnum.Dokument && settings.inlineEditing && (_editSettings === undefined || (_editSettings && _editSettings[i]))\"\n                                                  title=\"Izmeni\"\n                                                  (click)=\"onInlineSelect(order); onInlineEditOpen($event, order); $event.stopPropagation(); $event.preventDefault()\"\n                                                  [attr.data-data-id]=\"order?.id\"\n                                                  [attr.data-data-rbr]=\"order?.rbr\"\n                                                  [attr.disabled]=\"tableMode === TableModeEnum.Details || (tableMode === TableModeEnum.Table &&\n                                                  (!order.hasOwnProperty(fieldSayingIsEditable) ||\n                                                  (order.hasOwnProperty(fieldSayingIsEditable) &&\n                                                  !order[fieldSayingIsEditable]))) ? null : ''\"\n                                                  class=\"btn btn-info btn-rounded btn-condensed btn-sm edit\"\n                                                  [ngClass]=\"{\n                                                      'button-round-small': !defaultRowHeight\n                                                  }\">\n                                                  <span class=\"fa fa-pencil\"></span>\n                                              </button>\n                                              <button *ngIf=\"settings.listEditable && settings.documentType !== DocumentTypeEnum.Dokument && settings.inlineEditing\"\n                                                      title=\"Potvrdi\"\n                                                      [attr.data-data-id]=\"order?.id\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\"\n                                                      (click)=\"beforeInlineDetailSave($event.target); onInlineUpdateOrder($event.target); $event.stopPropagation(); $event.preventDefault()\"\n                                                      class=\"btn btn-success btn-rounded btn-condensed btn-sm edit-check\"\n                                                      [ngClass]=\"{\n                                                          'button-round-small': !defaultRowHeight\n                                                      }\">\n                                                  <span class=\"fa fa-check\"></span>\n                                              </button>\n                                              <button *ngIf=\"settings.listDeletable\"\n                                                      title=\"{{(settings.documentType === DocumentTypeEnum.Dokument) ? 'Storniraj' : 'Obri\u0161i'}}\"\n                                                      [attr.data-data-id]=\"order?.id\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\"\n                                                      (click)=\"onInlineSelect(order); onInlineDeleteOpen($event); $event.stopPropagation(); $event.preventDefault()\"\n                                                      class=\"btn btn-danger btn-rounded btn-condensed btn-sm delete\"\n                                                      [ngClass]=\"{\n                                                          'button-round-small': !defaultRowHeight\n                                                      }\">\n                                                  <span class=\"fa fa-times\"></span>\n                                              </button>\n                                              <button *ngIf=\"settings.listEditable && settings.documentType !== DocumentTypeEnum.Dokument && settings.inlineEditing\"\n                                                      title=\"Otka\u017Ei\"\n                                                      [attr.data-data-id]=\"order?.id\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\"\n                                                      (click)=\"onInlineEditCancel($event); $event.stopPropagation(); $event.preventDefault()\"\n                                                      class=\"btn btn-warning btn-rounded btn-condensed btn-sm edit-cancel\"\n                                                      [ngClass]=\"{\n                                                          'button-round-small': !defaultRowHeight\n                                                      }\">\n                                                  <span class=\"fa fa-times\"></span>\n                                              </button>\n                                              <button title=\"Potvrdi\"\n                                                      [attr.data-data-id]=\"\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\"\n                                                      class=\"btn btn-success btn-rounded btn-condensed btn-sm add-check\"\n                                                      [ngClass]=\"{\n                                                          'button-round-small': !defaultRowHeight\n                                                      }\">\n                                                  <span class=\"fa fa-check\"></span>\n                                              </button>\n                                              <button title=\"Otka\u017Ei\"\n                                                      [attr.data-data-id]=\"\"\n                                                      [attr.data-data-rbr]=\"order?.rbr\"\n                                                      class=\"btn btn-warning btn-rounded btn-condensed btn-sm add-cancel\"\n                                                      [ngClass]=\"{\n                                                          'button-round-small': !defaultRowHeight\n                                                      }\">\n                                                  <span class=\"fa fa-times\"></span>\n                                              </button>\n                                              <button title=\"Kopiraj\"\n                                                      *ngIf=\"settings.listEditable && tableMode === TableModeEnum.Details && copyEnabled && settings.documentType !== DocumentTypeEnum.Dokument\"\n                                                      (click)=\"onInlineSelect(order); propagateAction(order.rbr, TableActionEnum.Copy); $event.stopPropagation(); $event.stopPropagation(); $event.preventDefault()\"\n                                                      class=\"actions btn btn-default btn-rounded btn-condensed btn-sm\"\n                                                      [ngClass]=\"{\n                                                          'button-round-small': !defaultRowHeight\n                                                      }\">\n                                                  <span class=\"fa fa-copy\"></span>\n                                              </button>\n                                          </td>\n                                          <td\n                                              *ngIf=\"showSelectColumn\"\n                                              style=\"width: 80px; min-width: 80px; max-width: 80px;\"\n                                          >\n                                              <label class=\"switch switch-small\" *ngIf=\"order && (selectStatuses.includes(order.Status) || selectStatuses.length === 0)\">\n                                                  <input type=\"checkbox\"\n                                                         class=\"icheckbox\"\n                                                         id='deleteCheckbox'\n                                                         [ngModel]=\"order.selected\"\n                                                         (ngModelChange)=\"updateSelected(order)\"\n                                                         [attr.data-data-name]=\"'selectedColumn'\"\n                                                         [attr.data-data-type]=\"'check'\" />\n                                                  <span class=\"checkbox-span\"></span>\n                                              </label>\n                                          </td>\n                                          <td *ngIf=\"tableMode === TableModeEnum.Table && showDocumentStatusColumn\"\n                                              style=\"width: 80px; min-width: 80px; max-width: 80px;\">\n                                              <util-status-lozenge [target]=\"order\"></util-status-lozenge>\n                                          </td>\n                                          <td *ngFor=\"let column of columns\"\n                                              [ngClass]=\"{\n                                                  'hidden': !fieldsByName[column.name]['visible']\n                                              }\"\n                                              [style.min-width.px]=\"fieldsByName[column.name]['width']\"\n                                              [style.max-width.px]=\"fieldsByName[column.name]['width']\"\n                                              [attr.data-data-fieldname]=\"fieldsByName[column.name]['fieldName']\"\n                                              [attr.data-column-type]=\"fieldsByName[column.name]['type']\"\n                                              [attr.data-data-name]=\"fieldsByName[column.name]['fieldKey']\"\n                                              [attr.data-data-type]=\"fieldsByName[column.name]['type']\"\n                                          >\n                                              <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Input &&\n                                              (!!!fieldsByName[column.name]['dbType'] ||\n                                              (!!fieldsByName[column.name]['dbType'] && fieldsByName[column.name]['dbType'].indexOf('DECIMAL') === -1))\"\n                                                   title=\"{{order | fieldViewText: fieldsByName[column.name]}}\">\n                                                  <span title=\"{{order | fieldViewText: fieldsByName[column.name]}}\"\n                                                        class='span-text'\n                                                        [ngClass]=\"{\n                                                          'danger-font': order.NijeNaUgovoru\n                                                        }\"\n                                                        [attr.data-data-id]=\"order?.id\"\n                                                        [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                                        [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewText: fieldsByName[column.name]}}</span>\n                                                  <util-input *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                              class=\"isRowInAction\"\n                                                              [value]=\"order | fieldViewText: fieldsByName[column.name]\"\n                                                              [columnItem]=\"fieldsByName[column.name]\"\n                                                              (valueChanged)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i); doValidationOfInput(column.name, $event.target)\">\n                                                  </util-input>\n                                              </div>\n                                              <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Input &&\n                                              !!fieldsByName[column.name]['dbType'] &&\n                                              fieldsByName[column.name]['dbType'].indexOf('DECIMAL') !== -1\"\n                                                   title=\"{{order | fieldViewDecimal: fieldsByName[column.name]}}\">\n                                                  <span title=\"{{order | fieldViewDecimal: fieldsByName[column.name]}}\"\n                                                        class='span-text'\n                                                        [attr.data-data-id]=\"order?.id\"\n                                                        [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                                        [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewDecimal: fieldsByName[column.name]}}</span>\n                                                  <util-input *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                              class=\"isRowInAction\"\n                                                              [value]=\"order | fieldViewDecimal: fieldsByName[column.name]\"\n                                                              [columnItem]=\"fieldsByName[column.name]\"\n                                                              (valueChanged)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i); doValidationOfInput(column.name, $event.target)\">\n                                                  </util-input>\n                                              </div>\n                                              <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Completer\">\n                                                  <span class='span-text'\n                                                        title=\"{{order | fieldViewCompleter: fieldsByName[column.name]}}\"\n                                                        [attr.data-data-id]=\"order?.id\"\n                                                        [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                                        [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCompleter: fieldsByName[column.name]}}</span>\n                                                  <util-autocomplete *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                     class=\"isRowInAction\"\n                                                                     [fieldsResticted]=\"fieldsResticted\"\n                                                                     [selectedItem]=\"order | fieldEditCompleter: fieldsByName[column.name]\"\n                                                                     (selectedItemChange)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\"\n                                                                     [fieldSettings]=\"fieldsByName[column.name]\"\n                                                                     [disabled]=\"getColumnDisabled(fieldsByName[column.name], _mode)\"\n                                                                     [tag]=\"order[identFromTableMode]\">\n                                                  </util-autocomplete>\n                                              </div>\n                                              <div *ngIf=\"(fieldsByName[column.name]['type'] === FieldTypeEnum.Combo)\">\n                                                  <span class='span-text'\n                                                        title=\"{{order | fieldViewCombo: fieldsByName[column.name]}}\"\n                                                        [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                                        [attr.data-data-id]=\"order?.id\"\n                                                        [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCombo: fieldsByName[column.name]}}</span>\n                                                  <util-combo *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                              class=\"isRowInAction\"\n                                                              [selectedItem]=\"getComboFixedItem(order, column.name)\"\n                                                              [fieldSettings]=\"fieldsByName[column.name]\"\n                                                              (selectedItemChange)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\"\n                                                              [useFixedValues]=\"false\"\n                                                              [disabled]=\"getColumnDisabled(fieldsByName[column.name], _mode)\"\n                                                              [tag]=\"order[identFromTableMode]\">\n                                                  </util-combo>\n                                              </div>\n                                              <div *ngIf=\"(fieldsByName[column.name]['type'] === FieldTypeEnum.ComboFixed)\">\n                                                  <span *ngIf=\"!isHardEditable(column.name, order.Status)\" class='span-text'\n                                                        title=\"{{getComboFixedText(order, column.name)}}\"\n                                                        [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                                        [attr.data-data-id]=\"order?.id\"\n                                                        [attr.data-data-rbr]=\"order?.rbr\">{{getComboFixedText(order, column.name)}}</span>\n                                                  <util-combo *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode]) || isHardEditable(column.name, order.Status)\"\n                                                              class=\"isRowInAction\"\n                                                              [selectedItem]=\"getComboFixedItem(order, column.name)\"\n                                                              [fieldSettings]=\"fieldsByName[column.name]\"\n                                                              (selectedItemChange)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\"\n                                                              [useFixedValues]=\"true\"\n                                                              [disabled]=\"!isHardEditable(column.name, order.Status) && getColumnDisabled(fieldsByName[column.name], _mode)\"\n                                                              [tag]=\"order[identFromTableMode]\">\n                                                  </util-combo>\n                                              </div>\n                                              <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Check\">\n                                                  <span class='span-text'\n                                                        [attr.data-data-id]=\"order?.id\"\n                                                        [attr.data-data-rbr]=\"order?.rbr\"></span>\n                                                  <label class=\"switch switch-small\">\n                                                      <input type=\"checkbox\"\n                                                             class=\"icheckbox\"\n                                                             [ngModel]=\"getInputValue(order, column.name)\"\n                                                             (ngModelChange)=\"fieldUpdateCheck(fieldsByName[column.name], $event, order, i)\"\n                                                             [attr.data-data-name]=\"column.name\"\n                                                             [attr.data-data-type]=\"'check'\"\n                                                             [attr.disabled]=\"true\" />\n                                                      <span class=\"checkbox-span\"></span>\n                                                  </label>\n                                              </div>\n                                              <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Date\">\n                                                  <span class='span-text'\n                                                        title=\"{{order | fieldViewDate: fieldsByName[column.name]}}\"\n                                                        [attr.data-data-rbr]=\"order?.rbr\"\n                                                        [attr.data-data-id]=\"order?.id\">{{order | fieldViewDate: fieldsByName[column.name]}}</span>\n                                                  <util-daterangepicker class=\"isRowInAction\"\n                                                                        *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                        [value]=\"order | fieldEditDate: fieldsByName[column.name]\"\n                                                                        [columnItem]=\"fieldsByName[column.name]\"\n                                                                        (dateSelected)=\"fieldUpdateDate(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\">\n                                                  </util-daterangepicker>\n                                              </div>\n                                              <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Time\">\n                                                  <span class='span-text'\n                                                        title=\"{{order | fieldViewTime: fieldsByName[column.name]}}\"\n                                                        [attr.data-data-rbr]=\"order?.rbr\"\n                                                        [attr.data-data-id]=\"order?.id\">{{order | fieldViewTime: fieldsByName[column.name]}}</span>\n                                                  <util-timepicker class=\"isRowInAction\"\n                                                                   *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                   [entity]=\"order\"\n                                                                   [columnItem]=\"fieldsByName[column.name]\"\n                                                                   (timeChanged)=\"fieldUpdateTime(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\">\n                                                  </util-timepicker>\n                                              </div>\n\n                                              <div\n                                                   *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Complex && _complexSettings && _complexSettings.length > 0 && _complexSettings.length === _orderList.length\">\n                                                  <div *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Input &&\n                                                  (!!!_complexSettings[i][column.name]['dbType'] ||\n                                                  (!!_complexSettings[i][column.name]['dbType'] && _complexSettings[i][column.name]['dbType'].indexOf('DECIMAL') === -1))\"\n                                                       title=\"{{order | fieldViewText: _complexSettings[i][column.name]}}\">\n                                                      <span title=\"{{order | fieldViewText: _complexSettings[i][column.name]}}\"\n                                                            class='span-text'\n                                                            [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                            [attr.data-data-id]=\"order?.id\"\n                                                            [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewText: _complexSettings[i][column.name]}}</span>\n                                                      <util-input *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                  class=\"isRowInAction\"\n                                                                  [value]=\"order | fieldViewText: _complexSettings[i][column.name]\"\n                                                                  [columnItem]=\"_complexSettings[i][column.name]\"\n                                                                  (valueChanged)=\"fieldUpdateValue(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i); doValidationOfInput(column.name, $event.target)\">\n                                                      </util-input>\n                                                  </div>\n                                                  <div *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Input &&\n                                              !!_complexSettings[i][column.name]['dbType'] &&\n                                              _complexSettings[i][column.name]['dbType'].indexOf('DECIMAL') !== -1\"\n                                                       title=\"{{order | fieldViewDecimal: _complexSettings[i][column.name]}}\">\n                                                      <span title=\"{{order | fieldViewDecimal: _complexSettings[i][column.name]}}\"\n                                                            class='span-text'\n                                                            [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                            [attr.data-data-id]=\"order?.id\"\n                                                            [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewDecimal: _complexSettings[i][column.name]}}</span>\n                                                      <util-input *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                  class=\"isRowInAction\"\n                                                                  [value]=\"order | fieldViewDecimal: _complexSettings[i][column.name]\"\n                                                                  [columnItem]=\"_complexSettings[i][column.name]\"\n                                                                  (valueChanged)=\"fieldUpdateValue(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i); doValidationOfInput(column.name, $event.target)\">\n                                                      </util-input>\n                                                  </div>\n                                                  <div\n                                                       *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Completer\">\n                                                      <span class='span-text'\n                                                            title=\"{{order | fieldViewCompleter: _complexSettings[i][column.name]}}\"\n                                                            [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                            [attr.data-data-id]=\"order?.id\"\n                                                            [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCompleter: _complexSettings[i][column.name]}}</span>\n                                                      <util-autocomplete *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                         class=\"isRowInAction\"\n                                                                         [fieldsResticted]=\"fieldsResticted\"\n                                                                         [selectedItem]=\"order | fieldEditCompleter: _complexSettings[i][column.name]\"\n                                                                         (selectedItemChange)=\"fieldUpdateValue(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i)\"\n                                                                         [fieldSettings]=\"_complexSettings[i][column.name]\"\n                                                                         [disabled]=\"getColumnDisabled(_complexSettings[i][column.name], _mode)\"\n                                                                         [tag]=\"order[identFromTableMode]\">\n                                                      </util-autocomplete>\n                                                  </div>\n                                                  <div\n                                                       *ngIf=\"(_complexSettings[i][column.name]['type'] === FieldTypeEnum.Combo)\">\n                                                      <span class='span-text'\n                                                            title=\"{{order | fieldViewCombo: _complexSettings[i][column.name]}}\"\n                                                            [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                            [attr.data-data-id]=\"order?.id\"\n                                                            [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCombo: _complexSettings[i][column.name]}}</span>\n                                                      <util-combo *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                  class=\"isRowInAction\"\n                                                                  [selectedItem]=\"getComboFixedItem(order, column.name)\"\n                                                                  [fieldSettings]=\"_complexSettings[i][column.name]\"\n                                                                  (selectedItemChange)=\"fieldUpdateValue(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i)\"\n                                                                  [useFixedValues]=\"false\"\n                                                                  [disabled]=\"getColumnDisabled(_complexSettings[i][column.name], _mode)\"\n                                                                  [tag]=\"order[identFromTableMode]\">\n                                                      </util-combo>\n                                                  </div>\n                                                  <div\n                                                       *ngIf=\"(_complexSettings[i][column.name]['type'] === FieldTypeEnum.ComboFixed)\">\n                                                      <span class='span-text'\n                                                            title=\"{{getComboFixedText(order, column.name, _complexSettings[i][column.name])}}\"\n                                                            [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                            [attr.data-data-id]=\"order?.id\"\n                                                            [attr.data-data-rbr]=\"order?.rbr\">{{getComboFixedText(order, column.name, _complexSettings[i][column.name])}}</span>\n                                                      <util-combo *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                  class=\"isRowInAction\"\n                                                                  [selectedItem]=\"getComboFixedItem(order, column.name)\"\n                                                                  [fieldSettings]=\"_complexSettings[i][column.name]\"\n                                                                  (selectedItemChange)=\"fieldUpdateValue(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i)\"\n                                                                  [useFixedValues]=\"true\"\n                                                                  [disabled]=\"getColumnDisabled(_complexSettings[i][column.name], _mode)\"\n                                                                  [tag]=\"order[identFromTableMode]\">\n                                                      </util-combo>\n                                                  </div>\n                                                  <div\n                                                       *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Check\">\n                                                      <span class='span-text'\n                                                            [attr.data-data-id]=\"order?.id\"\n                                                            [attr.data-data-rbr]=\"order?.rbr\"></span>\n                                                      <label class=\"switch switch-small\">\n                                                          <input type=\"checkbox\"\n                                                                 class=\"icheckbox\"\n                                                                 [ngModel]=\"getInputValue(order, column.name)\"\n                                                                 (ngModelChange)=\"fieldUpdateCheck(_complexSettings[i][column.name], $event, order, i)\"\n                                                                 [attr.data-data-name]=\"column.name\"\n                                                                 [attr.data-data-type]=\"'check'\"\n                                                                 [attr.disabled]=\"true\" />\n                                                          <span class=\"checkbox-span\"></span>\n                                                      </label>\n                                                  </div>\n                                                  <div\n                                                       *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Date\">\n                                                      <span class='span-text'\n                                                            title=\"{{order | fieldViewDate: _complexSettings[i][column.name]}}\"\n                                                            [attr.data-data-rbr]=\"order?.rbr\"\n                                                            [attr.data-data-id]=\"order?.id\">{{order | fieldViewDate: _complexSettings[i][column.name]}}</span>\n                                                      <util-daterangepicker class=\"isRowInAction\"\n                                                                            *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                            [value]=\"order | fieldEditDate: _complexSettings[i][column.name]\"\n                                                                            [columnItem]=\"_complexSettings[i][column.name]\"\n                                                                            (dateSelected)=\"fieldUpdateDate(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i)\">\n                                                      </util-daterangepicker>\n                                                  </div>\n                                                  <div\n                                                       *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Time\">\n                                                      <span class='span-text'\n                                                            title=\"{{order | fieldViewTime: _complexSettings[i][column.name]}}\"\n                                                            [attr.data-data-rbr]=\"order?.rbr\"\n                                                            [attr.data-data-id]=\"order?.id\">{{order | fieldViewTime: _complexSettings[i][column.name]}}</span>\n                                                      <util-timepicker class=\"isRowInAction\"\n                                                                       *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                       [entity]=\"order\"\n                                                                       [columnItem]=\"_complexSettings[i][column.name]\"\n                                                                       (timeChanged)=\"fieldUpdateTime(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i)\">\n                                                      </util-timepicker>\n                                                  </div>\n                                              </div>\n                                          </td>\n                                      </tr>\n                                  </tbody>\n                              </table>\n                          </div>\n                      </div>\n                  </div>\n              </div>\n          </div>\n      </div>\n    "
            },] },
];
/**
 * @nocollapse
 */
TableComponent.ctorParameters = function () { return [
    { type: BackendService, },
    { type: AuthenticationService, },
    { type: ActivatedRoute, },
    { type: DaterangepickerConfig, },
    { type: ChangeDetectorRef, },
    { type: FieldService, },
    { type: ListService, },
    { type: ApplicationService, },
    { type: NotificationService, },
    { type: ElementRef, },
]; };
TableComponent.propDecorators = {
    'timePicker': [{ type: ViewChildren, args: [TimepickerComponent,] },],
    'datePicker': [{ type: ViewChildren, args: [DaterangepickerComponent,] },],
    'autocomplete': [{ type: ViewChildren, args: [AutocompleteComponent,] },],
    'combo': [{ type: ViewChildren, args: [ComboComponent,] },],
    'input': [{ type: ViewChildren, args: [InputComponent,] },],
    'approveTableActions': [{ type: Input },],
    'identity': [{ type: Input },],
    'orderListCount': [{ type: Input },],
    'paging': [{ type: Input },],
    'copyEnabled': [{ type: Input },],
    'sortingEnabled': [{ type: Input },],
    'outside': [{ type: Input },],
    'maxRows': [{ type: Input },],
    'sticking': [{ type: Input },],
    'resizable': [{ type: Input },],
    'reordable': [{ type: Input },],
    'multiedit': [{ type: Input },],
    'ident': [{ type: Input },],
    'tableMode': [{ type: Input },],
    'tag': [{ type: Input },],
    'fieldsResticted': [{ type: Input },],
    'customAddHandling': [{ type: Input },],
    'showDocumentStatusColumn': [{ type: Input, args: ['showDocumentStatusColumn',] },],
    'showSelectColumn': [{ type: Input, args: ['showSelectColumn',] },],
    'tableAction': [{ type: Output, args: ['tableAction',] },],
    'valueChanged': [{ type: Output },],
    'onAllSelected': [{ type: Output, args: ['onAllSelected',] },],
    'onRowSelected': [{ type: Output, args: ['onRowSelected',] },],
    'pageCurrent': [{ type: Input },],
    'allSelected': [{ type: Input },],
    'allSelectedTooltip': [{ type: Input },],
    'objectSelected': [{ type: Input },],
    'selectedClass': [{ type: Input },],
    'defaultRowHeight': [{ type: Input },],
    'serverPagination': [{ type: Input },],
    'customRowsOnPage': [{ type: Input },],
    'hardEditableColumnNames': [{ type: Input },],
    'selectStatuses': [{ type: Input },],
    'selectedObjectChange': [{ type: Output },],
    'selectedObject': [{ type: Input },],
    'mode': [{ type: Input },],
    'settings': [{ type: Input },],
    'orderList': [{ type: Input },],
    'editSettings': [{ type: Input },],
    'complexSettings': [{ type: Input },],
    'additable': [{ type: Input },],
};
var PaginationComponent = /** @class */ (function () {
    function PaginationComponent() {
        this.page = new EventEmitter();
    }
    Object.defineProperty(PaginationComponent.prototype, "pageCurrent", {
        /**
         * @return {?}
         */
        get: function () {
            return this._pageCurrent;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._pageCurrent = value;
            this.setPaginate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "pageTotal", {
        /**
         * @return {?}
         */
        get: function () {
            return this._pageTotal;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._pageTotal = value;
            this.setPaginate();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * pagination
     * @param {?} pageTotal
     * @param {?=} pageCurrent
     * @param {?=} pageShowCurrent
     * @param {?=} pageShowAll
     * @return {?}
     */
    PaginationComponent.pagination = function (pageTotal, pageCurrent, pageShowCurrent, pageShowAll) {
        if (pageCurrent === void 0) { pageCurrent = 1; }
        if (pageShowCurrent === void 0) { pageShowCurrent = 4; }
        if (pageShowAll === void 0) { pageShowAll = 8; }
        var /** @type {?} */ page = [];
        if (pageTotal > pageShowAll) {
            if (pageCurrent <= pageShowCurrent * 2 - 2) {
                if (pageTotal <= 9) {
                    for (var /** @type {?} */ i = 1; i <= 9; i++) {
                        page.push(i);
                    }
                }
                else {
                    for (var /** @type {?} */ i = 1; i <= 8; i++) {
                        page.push(i);
                    }
                    page.push('...');
                    page.push(pageTotal - 1);
                    page.push(pageTotal);
                }
            }
            else {
                if (pageTotal >= 10) {
                    page.push(1);
                    page.push(2);
                    page.push('...');
                    if (pageTotal - pageShowCurrent > pageCurrent + 2) {
                        for (var /** @type {?} */ i = pageCurrent - pageShowCurrent + 1; i < pageCurrent + pageShowCurrent; i++) {
                            page.push(i);
                        }
                        page.push('...');
                        page.push(pageTotal - 1);
                        page.push(pageTotal);
                    }
                    else {
                        for (var /** @type {?} */ i = pageTotal - pageShowCurrent * 2 + 1; i <= pageTotal; i++) {
                            page.push(i);
                        }
                    }
                }
                else {
                    for (var /** @type {?} */ i = 1; i <= 9; i++) {
                        page.push(i);
                    }
                }
            }
        }
        else {
            for (var /** @type {?} */ i = 1; i <= pageTotal; i++) {
                page.push(i);
            }
        }
        return page;
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.setPaginate = function () {
        this.paginate = PaginationComponent.pagination(this.pageTotal, this.pageCurrent);
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.ngAfterContentChecked = function () {
        this.setPaginate();
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.moveToLeft = function () {
        if (this.pageCurrent <= 1) {
            return;
        }
        this.page.emit(this.pageCurrent - 1);
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.moveToRight = function () {
        if (this.pageCurrent >= this.pageTotal) {
            return;
        }
        this.page.emit(this.pageCurrent + 1);
    };
    /**
     * @param {?} i
     * @return {?}
     */
    PaginationComponent.prototype.changePage = function (i) {
        if (i !== '...' && i !== this.pageCurrent) {
            this.page.emit(i);
        }
    };
    return PaginationComponent;
}());
PaginationComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-pagination',
                template: "\n    <nav [hidden]=\"pageTotal == 1\">\n        <ul class=\"pagination\">\n            <li class=\"page-item\" [ngClass]=\"{'disabled': pageCurrent<=1}\">\n                <a class=\"page-link\" href=\"javascript:\" aria-label=\"Previous\" (click)=\"moveToLeft()\">\n                    <span aria-hidden=\"true\">&lsaquo;</span>\n                </a>\n            </li>\n            <li class=\"page-item\" *ngFor=\"let i of paginate\"\n                [ngClass]=\"{'active': i==pageCurrent, 'disabled': i=='...' || i==pageCurrent}\">\n                <a class=\"page-link\" href=\"javascript:\" (click)=\"changePage(i)\">{{i}}</a>\n            </li>\n            <li class=\"page-item\" [ngClass]=\"{'disabled': pageCurrent>=pageTotal}\">\n                <a class=\"page-link\" href=\"javascript:\" aria-label=\"Next\" (click)=\"moveToRight()\">\n                    <span aria-hidden=\"true\">&rsaquo;</span>\n                </a>\n            </li>\n        </ul>\n    </nav>\n  ",
                styles: ["\n    nav {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      margin-top: 16px; }\n\n    .pagination > li.active > a {\n      color: white;\n      background: #33414e;\n      border-color: #33414e; }\n  "]
            },] },
];
/**
 * @nocollapse
 */
PaginationComponent.ctorParameters = function () { return []; };
PaginationComponent.propDecorators = {
    'page': [{ type: Output },],
    'pageCurrent': [{ type: Input },],
    'pageTotal': [{ type: Input },],
};
var PaginationModule = /** @class */ (function () {
    function PaginationModule() {
    }
    return PaginationModule;
}());
PaginationModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    PaginationComponent
                ],
                entryComponents: [],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    Daterangepicker,
                ],
                providers: [
                    AuthenticationService,
                    BackendService
                ],
                exports: [PaginationComponent]
            },] },
];
/**
 * @nocollapse
 */
PaginationModule.ctorParameters = function () { return []; };
var DaterangepickerModule = /** @class */ (function () {
    function DaterangepickerModule() {
    }
    return DaterangepickerModule;
}());
DaterangepickerModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    Daterangepicker
                ],
                declarations: [
                    DaterangepickerComponent
                ],
                providers: [],
                exports: [
                    DaterangepickerComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
DaterangepickerModule.ctorParameters = function () { return []; };
var FilterPipe = /** @class */ (function () {
    function FilterPipe() {
    }
    /**
     * @param {?} array
     * @param {?} query
     * @return {?}
     */
    FilterPipe.prototype.transform = function (array, query) {
        if (query) {
            return array.filter(function (row) { return (row.resenje_id.indexOf(query) > -1 ||
                row.datum_knjizenja.indexOf(query) > -1 ||
                row.datum_kreiranja.indexOf(query) > -1 ||
                row.korisnik_id.indexOf(query) > -1 ||
                row.oznaka.indexOf(query) > -1); });
        }
        return array;
    };
    return FilterPipe;
}());
FilterPipe.decorators = [
    { type: Pipe, args: [{
                name: 'filter'
            },] },
];
/**
 * @nocollapse
 */
FilterPipe.ctorParameters = function () { return []; };
var FieldViewTexPurePipe = /** @class */ (function () {
    function FieldViewTexPurePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewTexPurePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        return retVal;
    };
    return FieldViewTexPurePipe;
}());
FieldViewTexPurePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewTextPure', pure: true },] },
];
/**
 * @nocollapse
 */
FieldViewTexPurePipe.ctorParameters = function () { return []; };
var FieldViewCheckboxPurePipe = /** @class */ (function () {
    function FieldViewCheckboxPurePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewCheckboxPurePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        return retVal ? 'Da' : 'Ne';
    };
    return FieldViewCheckboxPurePipe;
}());
FieldViewCheckboxPurePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewCheckboxPure', pure: true },] },
];
/**
 * @nocollapse
 */
FieldViewCheckboxPurePipe.ctorParameters = function () { return []; };
var FieldViewDatePurePipe = /** @class */ (function () {
    function FieldViewDatePurePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewDatePurePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        if (typeof retVal === 'undefined' || retVal === null) {
            return '';
        }
        return UtilService.formatDate(retVal);
    };
    return FieldViewDatePurePipe;
}());
FieldViewDatePurePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewDatePure', pure: true },] },
];
/**
 * @nocollapse
 */
FieldViewDatePurePipe.ctorParameters = function () { return []; };
var FieldViewCompleterPurePipe = /** @class */ (function () {
    function FieldViewCompleterPurePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewCompleterPurePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ data = UtilService.getFieldObject(documentData, fieldMap.propertyPath.all);
        if (data == null || fieldMap == null) {
            return '';
        }
        // XXX In case the field in question has no relation - show "--INVALID--" (to the tester/QA).
        var /** @type {?} */ value = fieldMap.relationValue.all.length === 0 ? '--INVALID--' : UtilService.getFieldObject(data, fieldMap.relationValue.all);
        var /** @type {?} */ key = fieldMap.relationKey.all.length === 0 ? '' : UtilService.getFieldObject(data, fieldMap.relationKey.all);
        if (key && key !== '' && value) {
            return key + '\xa0' + value;
        }
        else if (key && key !== '') {
            return key;
        }
        else if (value) {
            return value;
        }
        return '';
    };
    return FieldViewCompleterPurePipe;
}());
FieldViewCompleterPurePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewCompleterPure', pure: true },] },
];
/**
 * @nocollapse
 */
FieldViewCompleterPurePipe.ctorParameters = function () { return []; };
var FieldEditCheckboxPipe = /** @class */ (function () {
    function FieldEditCheckboxPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldEditCheckboxPipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        return retVal;
    };
    return FieldEditCheckboxPipe;
}());
FieldEditCheckboxPipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldEditCheckbox', pure: false },] },
];
/**
 * @nocollapse
 */
FieldEditCheckboxPipe.ctorParameters = function () { return []; };
var FieldEditDatePipe = /** @class */ (function () {
    function FieldEditDatePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldEditDatePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = null;
        if (fieldMap) {
            retVal = UtilService.getFieldValue(documentData, fieldMap);
        }
        if (retVal == null) {
            return null;
        }
        return retVal;
        // return UtilService.formatDate(retVal);
    };
    return FieldEditDatePipe;
}());
FieldEditDatePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldEditDate', pure: false },] },
];
/**
 * @nocollapse
 */
FieldEditDatePipe.ctorParameters = function () { return []; };
var FieldEditCompleterPipe = /** @class */ (function () {
    function FieldEditCompleterPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldEditCompleterPipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldObject(documentData, fieldMap.propertyPath.all);
        return retVal;
    };
    return FieldEditCompleterPipe;
}());
FieldEditCompleterPipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldEditCompleter', pure: false },] },
];
/**
 * @nocollapse
 */
FieldEditCompleterPipe.ctorParameters = function () { return []; };
var FieldViewComboFixedPurePipe = /** @class */ (function () {
    /**
     * @param {?} listService
     */
    function FieldViewComboFixedPurePipe(listService) {
        this.listService = listService;
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewComboFixedPurePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ value = UtilService.getFieldValue(documentData, fieldMap);
        var /** @type {?} */ enumResult = this.listService.getEnum(fieldMap.entityType).filter(function (item) { return item.value === value; });
        if (enumResult.length === 0) {
            return null;
        }
        return enumResult[0].label;
    };
    return FieldViewComboFixedPurePipe;
}());
FieldViewComboFixedPurePipe.decorators = [
    { type: Injectable },
    { type: Pipe, args: [{ name: 'fieldViewComboFixedPure', pure: true },] },
];
/**
 * @nocollapse
 */
FieldViewComboFixedPurePipe.ctorParameters = function () { return [
    { type: ListService, },
]; };
var FieldViewTimePurePipe = /** @class */ (function () {
    function FieldViewTimePurePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewTimePurePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        if (typeof retVal === 'undefined' || retVal === null || retVal === '') {
            return '';
        }
        return UtilService.formatTime(retVal);
    };
    return FieldViewTimePurePipe;
}());
FieldViewTimePurePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewTimePure', pure: true },] },
];
/**
 * @nocollapse
 */
FieldViewTimePurePipe.ctorParameters = function () { return []; };
var FieldViewComboFixedPipe = /** @class */ (function () {
    /**
     * @param {?} listService
     */
    function FieldViewComboFixedPipe(listService) {
        this.listService = listService;
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewComboFixedPipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ value = UtilService.getFieldValue(documentData, fieldMap);
        var /** @type {?} */ enumResult = this.listService.getEnum(fieldMap.entityType).filter(function (item) { return item.value === value; });
        if (enumResult.length === 0) {
            return null;
        }
        return enumResult[0].label;
    };
    return FieldViewComboFixedPipe;
}());
FieldViewComboFixedPipe.decorators = [
    { type: Injectable },
    { type: Pipe, args: [{ name: 'fieldViewComboFixed', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewComboFixedPipe.ctorParameters = function () { return [
    { type: ListService, },
]; };
var FieldViewCheckboxPipe = /** @class */ (function () {
    function FieldViewCheckboxPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewCheckboxPipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        return retVal ? 'Da' : 'Ne';
    };
    return FieldViewCheckboxPipe;
}());
FieldViewCheckboxPipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewCheckbox', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewCheckboxPipe.ctorParameters = function () { return []; };
var FieldViewTextPipe = /** @class */ (function () {
    function FieldViewTextPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewTextPipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        return retVal;
    };
    return FieldViewTextPipe;
}());
FieldViewTextPipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewText', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewTextPipe.ctorParameters = function () { return []; };
var FieldViewDatePipe = /** @class */ (function () {
    function FieldViewDatePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @param {?} format
     * @return {?}
     */
    FieldViewDatePipe.prototype.transform = function (documentData, fieldMap, format) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        if (typeof retVal === 'undefined' || retVal === null) {
            return '';
        }
        if (format) {
            return UtilService.formatDate(retVal, format);
        }
        else {
            return UtilService.formatDate(retVal);
        }
    };
    return FieldViewDatePipe;
}());
FieldViewDatePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewDate', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewDatePipe.ctorParameters = function () { return []; };
var FieldViewTimePipe = /** @class */ (function () {
    function FieldViewTimePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewTimePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        if (typeof retVal === 'undefined' || retVal === null || retVal === '') {
            return '';
        }
        return UtilService.formatTime(retVal);
    };
    return FieldViewTimePipe;
}());
FieldViewTimePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewTime', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewTimePipe.ctorParameters = function () { return []; };
var FieldViewCompleterPipe = /** @class */ (function () {
    function FieldViewCompleterPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewCompleterPipe.prototype.transform = function (documentData, fieldMap) {
        // const data = UtilService.getFieldObject(documentData, fieldMap.propertyPath.all);
        //
        // if (data == null || fieldMap == null) {
        //     return '';
        // }
        //
        // // XXX In case the field in question has no relation - show "--INVALID--" (to the tester/QA).
        // const value = fieldMap.relationValue.all.length === 0 ? '--INVALID--' : UtilService.getFieldObject(data, fieldMap.relationValue.all);
        // const key = fieldMap.relationKey.all.length === 0 ? '' : UtilService.getFieldObject(data, fieldMap.relationKey.all);
        //
        // if (key && key !== '' && value) {
        //     return key + '\xa0' + value;
        // }
        // if (key && key !== '') {
        //     return key;
        // }
        // if (value) {
        //     return value;
        // }
        // return '';
        return UtilService.getCompleterValue(documentData, fieldMap);
    };
    return FieldViewCompleterPipe;
}());
FieldViewCompleterPipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewCompleter', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewCompleterPipe.ctorParameters = function () { return []; };
var FieldEditCompleterPurePipe = /** @class */ (function () {
    function FieldEditCompleterPurePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldEditCompleterPurePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldObject(documentData, fieldMap.propertyPath.all);
        // console.log(fieldMap.fieldName, retVal);
        return retVal;
    };
    return FieldEditCompleterPurePipe;
}());
FieldEditCompleterPurePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldEditCompleterPure', pure: true },] },
];
/**
 * @nocollapse
 */
FieldEditCompleterPurePipe.ctorParameters = function () { return []; };
var FieldViewComboPurePipe = /** @class */ (function () {
    function FieldViewComboPurePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewComboPurePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ data = UtilService.getFieldObject(documentData, fieldMap.propertyPath.all);
        if (data == null || fieldMap == null) {
            return '';
        }
        var /** @type {?} */ value = UtilService.getFieldObject(data, fieldMap.relationValue.all);
        if (value) {
            return value;
        }
        return '';
    };
    return FieldViewComboPurePipe;
}());
FieldViewComboPurePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewComboPure', pure: true },] },
];
/**
 * @nocollapse
 */
FieldViewComboPurePipe.ctorParameters = function () { return []; };
var FieldViewComboPipe = /** @class */ (function () {
    function FieldViewComboPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewComboPipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ data = UtilService.getFieldObject(documentData, fieldMap.propertyPath.all);
        if (data == null || fieldMap == null) {
            return '';
        }
        var /** @type {?} */ value = UtilService.getFieldObject(data, fieldMap.relationValue.all);
        if (value) {
            return value;
        }
        return '';
    };
    return FieldViewComboPipe;
}());
FieldViewComboPipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewCombo', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewComboPipe.ctorParameters = function () { return []; };
var NumberPurePipe = /** @class */ (function () {
    function NumberPurePipe() {
    }
    /**
     * @param {?} fieldMap
     * @return {?}
     */
    NumberPurePipe.prototype.transform = function (fieldMap) {
        if (fieldMap['type'] === FieldTypeEnum.Input &&
            fieldMap.hasOwnProperty('dbType') &&
            typeof fieldMap['dbType'] !== 'undefined' &&
            (fieldMap['dbType'].indexOf('INTEGER') !== -1 ||
                fieldMap['dbType'].indexOf('BIGINT') !== -1 ||
                fieldMap['dbType'].indexOf('SMALLINT') !== -1 ||
                fieldMap['dbType'].indexOf('DECIMAL') !== -1)) {
            return true;
        }
        return false;
    };
    return NumberPurePipe;
}());
NumberPurePipe.decorators = [
    { type: Pipe, args: [{ name: 'NumberPure', pure: true },] },
];
/**
 * @nocollapse
 */
NumberPurePipe.ctorParameters = function () { return []; };
var NumberFormatPurePipe = /** @class */ (function () {
    function NumberFormatPurePipe() {
    }
    /**
     * @param {?} value
     * @param {?} fieldMap
     * @return {?}
     */
    NumberFormatPurePipe.prototype.transform = function (value, fieldMap) {
        if (fieldMap && fieldMap['type'] === FieldTypeEnum.Input &&
            fieldMap.hasOwnProperty('dbType') &&
            typeof fieldMap['dbType'] !== 'undefined' &&
            (fieldMap['dbType'].indexOf('INTEGER') !== -1 ||
                fieldMap['dbType'].indexOf('BIGINT') !== -1 ||
                fieldMap['dbType'].indexOf('SMALLINT') !== -1 ||
                fieldMap['dbType'].indexOf('DECIMAL') !== -1)) {
            value = value.toLocaleString(undefined, { maximumFractionDigits: 2 });
        }
        return value;
    };
    return NumberFormatPurePipe;
}());
NumberFormatPurePipe.decorators = [
    { type: Pipe, args: [{ name: 'NumberFormatPure', pure: true },] },
];
/**
 * @nocollapse
 */
NumberFormatPurePipe.ctorParameters = function () { return []; };
var FieldViewDecimalPipe = /** @class */ (function () {
    function FieldViewDecimalPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewDecimalPipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        if (typeof retVal === 'undefined' || retVal === null || retVal === '') {
            return '';
        }
        return UtilService.formatDecimal(retVal, fieldMap.decimalCount);
    };
    return FieldViewDecimalPipe;
}());
FieldViewDecimalPipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewDecimal', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewDecimalPipe.ctorParameters = function () { return []; };
var FieldViewDecimalPurePipe = /** @class */ (function () {
    function FieldViewDecimalPurePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewDecimalPurePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        if (typeof retVal === 'undefined' || retVal === null || retVal === '') {
            return '';
        }
        return UtilService.formatDecimal(retVal, fieldMap.decimalCount);
    };
    return FieldViewDecimalPurePipe;
}());
FieldViewDecimalPurePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewDecimalPure', pure: true },] },
];
/**
 * @nocollapse
 */
FieldViewDecimalPurePipe.ctorParameters = function () { return []; };
var FieldViewBigNumberPipe = /** @class */ (function () {
    function FieldViewBigNumberPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldViewBigNumberPipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        if (typeof retVal === 'undefined' || retVal === null) {
            return '';
        }
        return UtilService.formatBigNumber(retVal);
    };
    return FieldViewBigNumberPipe;
}());
FieldViewBigNumberPipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewBigNumber', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewBigNumberPipe.ctorParameters = function () { return []; };
var MessageUnreadPipe = /** @class */ (function () {
    function MessageUnreadPipe() {
    }
    /**
     * @param {?} message
     * @param {?} currentUsername
     * @return {?}
     */
    MessageUnreadPipe.prototype.transform = function (message, currentUsername) {
        var /** @type {?} */ senderUsername = message.senderUsername;
        if (message.messageReplays.length > 0) {
            senderUsername = message.messageReplays[message.messageReplays.length - 1].senderUsername;
        }
        if (message.messageReplays.length === 0) {
            if (senderUsername === currentUsername) {
                return false;
            }
            return message.status !== MessageStatusEnum.Opened;
        }
        else {
            var /** @type {?} */ opened = true;
            for (var /** @type {?} */ j = 0; j < message.messageReplays.length; j++) {
                if (message.messageReplays[j].status !== MessageStatusEnum.Opened &&
                    senderUsername !== currentUsername) {
                    opened = false;
                }
            }
            return !opened;
        }
    };
    return MessageUnreadPipe;
}());
MessageUnreadPipe.decorators = [
    { type: Pipe, args: [{ name: 'MessageUnread', pure: true },] },
];
/**
 * @nocollapse
 */
MessageUnreadPipe.ctorParameters = function () { return []; };
var IdentPipe = /** @class */ (function () {
    function IdentPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} tableMode
     * @param {?} ident
     * @return {?}
     */
    IdentPipe.prototype.transform = function (documentData, tableMode, ident) {
        return tableMode === TableModeEnum.Details ? documentData['rbr'] : documentData['id'];
    };
    return IdentPipe;
}());
IdentPipe.decorators = [
    { type: Pipe, args: [{ name: 'ident', pure: true },] },
];
/**
 * @nocollapse
 */
IdentPipe.ctorParameters = function () { return []; };
var FieldEditSelectPipe = /** @class */ (function () {
    function FieldEditSelectPipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldEditSelectPipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = [];
        retVal = documentData[fieldMap.fieldKey];
        return retVal;
    };
    return FieldEditSelectPipe;
}());
FieldEditSelectPipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldEditSelect', pure: false },] },
];
/**
 * @nocollapse
 */
FieldEditSelectPipe.ctorParameters = function () { return []; };
var FieldViewDateTimePipe = /** @class */ (function () {
    function FieldViewDateTimePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @param {?} format
     * @return {?}
     */
    FieldViewDateTimePipe.prototype.transform = function (documentData, fieldMap, format) {
        var /** @type {?} */ retVal = UtilService.getFieldValue(documentData, fieldMap);
        if (typeof retVal === 'undefined' || retVal === null) {
            return '';
        }
        return UtilService.formatDateTime(retVal);
    };
    return FieldViewDateTimePipe;
}());
FieldViewDateTimePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldViewDateTime', pure: false },] },
];
/**
 * @nocollapse
 */
FieldViewDateTimePipe.ctorParameters = function () { return []; };
var FieldEditDateTimePipe = /** @class */ (function () {
    function FieldEditDateTimePipe() {
    }
    /**
     * @param {?} documentData
     * @param {?} fieldMap
     * @return {?}
     */
    FieldEditDateTimePipe.prototype.transform = function (documentData, fieldMap) {
        var /** @type {?} */ retVal = null;
        if (fieldMap) {
            retVal = UtilService.getFieldValue(documentData, fieldMap);
        }
        if (retVal == null) {
            return null;
        }
        //return retVal;
        return UtilService.formatDateTime(retVal);
    };
    return FieldEditDateTimePipe;
}());
FieldEditDateTimePipe.decorators = [
    { type: Pipe, args: [{ name: 'fieldEditDateTime', pure: false },] },
];
/**
 * @nocollapse
 */
FieldEditDateTimePipe.ctorParameters = function () { return []; };
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
SharedModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    FilterPipe,
                    FieldViewTexPurePipe,
                    FieldViewCheckboxPurePipe,
                    FieldViewDatePurePipe,
                    FieldViewTimePurePipe,
                    FieldViewCompleterPurePipe,
                    FieldViewTextPipe,
                    FieldViewCheckboxPipe,
                    FieldViewDatePipe,
                    FieldViewDateTimePipe,
                    FieldViewTimePipe,
                    FieldViewCompleterPipe,
                    FieldEditCheckboxPipe,
                    FieldEditDatePipe,
                    FieldEditDateTimePipe,
                    FieldEditCompleterPipe,
                    FieldViewComboFixedPurePipe,
                    FieldViewComboFixedPipe,
                    FieldViewComboPurePipe,
                    FieldViewComboPipe,
                    FieldEditCompleterPurePipe,
                    FieldEditSelectPipe,
                    NumberPurePipe,
                    NumberFormatPurePipe,
                    FieldViewDecimalPipe,
                    FieldViewDecimalPurePipe,
                    FieldViewBigNumberPipe,
                    MessageUnreadPipe,
                    IdentPipe,
                ],
                imports: [],
                providers: [],
                exports: [
                    FieldViewTextPipe,
                    FieldViewCheckboxPipe,
                    FieldViewDatePipe,
                    FieldViewDateTimePipe,
                    FieldViewTimePipe,
                    FieldViewCompleterPipe,
                    FieldViewTexPurePipe,
                    FieldViewCheckboxPurePipe,
                    FieldViewDatePurePipe,
                    FieldViewTimePurePipe,
                    FieldViewCompleterPurePipe,
                    FieldEditCheckboxPipe,
                    FieldEditDatePipe,
                    FieldEditDateTimePipe,
                    FieldEditCompleterPipe,
                    FieldViewComboFixedPurePipe,
                    FieldViewComboFixedPipe,
                    FieldViewComboPurePipe,
                    FieldViewComboPipe,
                    FieldEditCompleterPurePipe,
                    FieldEditSelectPipe,
                    NumberPurePipe,
                    NumberFormatPurePipe,
                    FieldViewDecimalPipe,
                    FieldViewDecimalPurePipe,
                    FieldViewBigNumberPipe,
                    MessageUnreadPipe,
                    IdentPipe
                ]
            },] },
];
/**
 * @nocollapse
 */
SharedModule.ctorParameters = function () { return []; };
var ViewTableModule = /** @class */ (function () {
    function ViewTableModule() {
    }
    return ViewTableModule;
}());
ViewTableModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ViewTableComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    PaginationModule,
                    DataTablesModule,
                    DaterangepickerModule,
                    SharedModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService,
                    UtilService,
                    FieldService
                ],
                exports: [ViewTableComponent]
            },] },
];
/**
 * @nocollapse
 */
ViewTableModule.ctorParameters = function () { return []; };
var SettingsService = /** @class */ (function () {
    function SettingsService() {
        this.filterType = null;
        this.filterSwitched = new EventEmitter();
    }
    /**
     * @param {?} filterType
     * @return {?}
     */
    SettingsService.prototype.serviceSwitchFilter = function (filterType) {
        this.filterType = filterType;
        var /** @type {?} */ params = {
            filterType: filterType
        };
        this.filterSwitched.emit(params);
    };
    return SettingsService;
}());
SettingsService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
SettingsService.ctorParameters = function () { return []; };
SettingsService.propDecorators = {
    'filterSwitched': [{ type: Output },],
};
var FilterItemStyle = {};
FilterItemStyle.Default = /** @type {?} */ ('default');
FilterItemStyle.Success = /** @type {?} */ ('success');
FilterItemStyle[FilterItemStyle.Default] = "Default";
FilterItemStyle[FilterItemStyle.Success] = "Success";
var FilterComponent = /** @class */ (function () {
    /**
     * @param {?} eRef
     * @param {?} settingsService
     * @param {?} backendService
     * @param {?} listService
     */
    function FilterComponent(eRef, settingsService, backendService, listService) {
        this.eRef = eRef;
        this.settingsService = settingsService;
        this.backendService = backendService;
        this.listService = listService;
        this.FieldTypeEnum = FieldTypeEnum;
        this.filterQuery = '';
        this.daterange = {};
        this.isComplex = true;
        this.fieldsToFilter = [];
        this.itemsVisible = [];
        this.filterAction = new EventEmitter();
        this.valueChanged = new EventEmitter();
        this.resetFilters = new EventEmitter();
        this.styles = new Map([
            [FilterItemStyle.Default, { buttonClass: 'btn btn-default', iconClass: 'fa fa-bolt' }],
            [FilterItemStyle.Success, { buttonClass: 'btn btn-success', iconClass: 'fa fa-bolt' }]
        ]);
        this.disabledClass = 'disabled';
        this._subscriptions = [];
        this.alwaysComplex = false;
        this.addingEnabled = true;
        this.filterEnabled = true;
        this.refreshEnabled = true;
        this.filterAfterRefresh = true;
        this.isLookup = false;
        this.optionsDate = UtilService.datePickerOptionsDefault;
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(FilterComponent.prototype, "options", {
        /**
         * @return {?}
         */
        get: function () {
            return this._options;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._options = value;
            if (value && value.hasOwnProperty('items')) {
                this.itemsVisible = value.items;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterComponent.prototype, "settings", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var /** @type {?} */ that = this;
            if (value != null) {
                if (typeof this._settings === 'undefined') {
                    this.initSettings = value;
                }
                this._settings = value;
                this.fieldsToFilter = [];
                if (!this.alwaysComplex && this.settingsService.filterType !== null) {
                    this.isComplex = this.settingsService.filterType;
                }
                setTimeout(function () {
                    $('.selectpicker').selectpicker({
                        size: 5
                    });
                    that.setDefaultFields();
                }, 0);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FilterComponent.prototype.ngAfterViewInit = function () {
        this.prepareSelectPicker();
        this.setDefaultOperation();
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @param {?} o
     * @param {?} name
     * @return {?}
     */
    FilterComponent.prototype.hasProp = function (o, name) {
        return o.hasOwnProperty(name);
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.refreshFilterOnClose) {
            this._subscriptions.push(this.refreshFilterOnClose.subscribe(function () {
                _this.refresh();
            }));
        }
        var /** @type {?} */ that = this;
        if (this.alwaysComplex) {
            that.isComplex = true;
        }
        else {
            if (this.settingsService.filterType !== null) {
                that.isComplex = this.settingsService.filterType;
            }
            if (this.filterChangedSubscription) {
                this.filterChangedSubscription.unsubscribe();
            }
            this.filterChangedSubscription = this.settingsService.filterSwitched.subscribe(function (data) {
                that.isComplex = data.filterType;
            });
        }
        this.inputOperations = ['='];
        this.completerOperations = ['='];
        this.timeOperations = ['='];
        this.dateOperations = ['='];
        this.checkOperations = ['='];
        this.fromOperations = ['Od'];
        this.toOperations = ['Do'];
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.ngOnDestroy = function () {
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
        if (this.filterChangedSubscription) {
            this.filterChangedSubscription.unsubscribe();
        }
    };
    /**
     * @param {?} value
     * @param {?=} field
     * @return {?}
     */
    FilterComponent.prototype.selectedDate = function (value, field) {
        // this is the date the user selected
        LoggerService.log('selectedDate', value);
        // any object can be passed to the selected event and it will be passed back here
        field.start = value.start;
        field.end = value.end;
        // or manupulat your own internal property
        this.daterange.start = value.start;
        this.daterange.end = value.end;
        this.daterange.label = value.label;
        $(this.getItemRef().querySelector('.datepicker-filter-' + this.componentGuid)).val(this.daterange.start.format(UtilService.dateFormatDefault).toString());
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.filter = function () {
        var /** @type {?} */ date = '';
        var /** @type {?} */ datepicker = $(this.getItemRef().querySelector('.datepicker-filter-' + this.componentGuid));
        var /** @type {?} */ parts = datepicker.val().split('.');
        date = new Date(parts[2], parts[1] - 1, parts[0]).getTime().toString();
        var /** @type {?} */ filterDate = (datepicker.val() === '' || (typeof datepicker.val() === 'undefined')) ? '' : date;
        var /** @type {?} */ params = {
            action: FilterActionEnum.Filter,
            filter: {
                filterQuery: '',
                filterDate: '',
                filterObjects: [],
                filterCombined: null
            }
        };
        if (this.isComplex) {
            for (var /** @type {?} */ j = 0; j < this.fieldsToFilter.length; j++) {
                for (var /** @type {?} */ i = 0; i < this.fieldsToFilter[j].filterMapItems.length; i++) {
                    if (this.fieldsToFilter[j].filterMapItems[i].type === FieldTypeEnum.Completer) {
                        if (this.fieldsToFilter[j].filterMapItems[i].hasOwnProperty('value') &&
                            this.fieldsToFilter[j].filterMapItems[i]['value'] !== null &&
                            Object.keys(this.fieldsToFilter[j].filterMapItems[i]['value']).length !== 0) {
                            if ((this.fieldsToFilter[j].filterMapItems[i]['value'].hasOwnProperty('id') &&
                                this.fieldsToFilter[j].filterMapItems[i]['value']['id'] !== null) ||
                                !this.fieldsToFilter[j].filterMapItems[i]['value'].hasOwnProperty('id')) {
                                var /** @type {?} */ itemPathFollowed = UtilService.getFieldObject(this.fieldsToFilter[j].filterMapItems[i]['value'], this.fieldsToFilter[j].filterMapItems[i].fieldMapItem.relationKey.withoutLast);
                                var /** @type {?} */ newObject = Object.assign({}, this.fieldsToFilter[j].filterMapItems[i]);
                                newObject['name'] = 'id';
                                newObject['value'] = itemPathFollowed['id'];
                                if (itemPathFollowed['ime'] && itemPathFollowed['prezime']) {
                                    newObject['naziv'] = itemPathFollowed['ime'] + ' ' + itemPathFollowed['prezime'];
                                }
                                else if (itemPathFollowed['oznaka']) {
                                    newObject['naziv'] = itemPathFollowed['oznaka'];
                                }
                                else {
                                    newObject['naziv'] = itemPathFollowed['naziv'];
                                }
                                params['filter']['filterObjects'].push(Object.assign({}, newObject));
                            }
                        }
                    }
                    else if (this.fieldsToFilter[j].filterMapItems[i].type === FieldTypeEnum.Combo) {
                        if (this.fieldsToFilter[j].filterMapItems[i].hasOwnProperty('value') &&
                            this.fieldsToFilter[j].filterMapItems[i]['value'] !== null &&
                            Object.keys(this.fieldsToFilter[j].filterMapItems[i]['value']).length !== 0) {
                            var /** @type {?} */ newObject = Object.assign({}, this.fieldsToFilter[j].filterMapItems[i]);
                            newObject['name'] = 'id';
                            newObject['value'] = newObject['value']['id'];
                            params['filter']['filterObjects'].push(Object.assign({}, newObject));
                        }
                    }
                    else if (this.fieldsToFilter[j].filterMapItems[i].type === FieldTypeEnum.ComboFixed) {
                        if (this.fieldsToFilter[j].filterMapItems[i].hasOwnProperty('value') &&
                            this.fieldsToFilter[j].filterMapItems[i]['value'] !== null) {
                            var /** @type {?} */ newObject = Object.assign({}, this.fieldsToFilter[j].filterMapItems[i]);
                            newObject['value'] = newObject['value'];
                            params['filter']['filterObjects'].push(Object.assign({}, newObject));
                        }
                    }
                    else if (this.fieldsToFilter[j].filterMapItems[i].type === FieldTypeEnum.Date) {
                        if (this.fieldsToFilter[j].filterMapItems[i].hasOwnProperty('value')) {
                            if ((typeof this.fieldsToFilter[j].filterMapItems[i]['value'] === 'object' ||
                                typeof this.fieldsToFilter[j].filterMapItems[i]['value'] === 'string') &&
                                this.fieldsToFilter[j].filterMapItems[i]['value'] !== '') {
                                this.fieldsToFilter[j].filterMapItems[i]['value'] = Date.parse(this.fieldsToFilter[j].filterMapItems[i]['value']);
                            }
                            params['filter']['filterObjects'].push(Object.assign({}, this.fieldsToFilter[j].filterMapItems[i]));
                        }
                    }
                    else if (this.fieldsToFilter[j].filterMapItems[i].type === FieldTypeEnum.Time) {
                        if (this.fieldsToFilter[j].filterMapItems[i].hasOwnProperty('value')) {
                            if ((typeof this.fieldsToFilter[j].filterMapItems[i]['value'] === 'object' ||
                                typeof this.fieldsToFilter[j].filterMapItems[i]['value'] === 'string') &&
                                this.fieldsToFilter[j].filterMapItems[i]['value'] !== '') {
                                this.fieldsToFilter[j].filterMapItems[i]['value'] = Date.parse(this.fieldsToFilter[j].filterMapItems[i]['value']);
                            }
                            params['filter']['filterObjects'].push(Object.assign({}, this.fieldsToFilter[j].filterMapItems[i]));
                        }
                    }
                    else if (this.fieldsToFilter[j].filterMapItems[i].type === FieldTypeEnum.Check) {
                        if (this.fieldsToFilter[j].filterMapItems[i].hasOwnProperty('value')) {
                            if (this.fieldsToFilter[j].filterMapItems[i]['value'] === '') {
                                this.fieldsToFilter[j].filterMapItems[i]['value'] = 0;
                            }
                            else {
                                if (this.fieldsToFilter[j].filterMapItems[i]['value']) {
                                    this.fieldsToFilter[j].filterMapItems[i]['value'] = 1;
                                }
                                else {
                                    this.fieldsToFilter[j].filterMapItems[i]['value'] = 0;
                                }
                            }
                        }
                        else {
                            this.fieldsToFilter[j].filterMapItems[i]['value'] = 0;
                        }
                        params['filter']['filterObjects'].push(Object.assign({}, this.fieldsToFilter[j].filterMapItems[i]));
                    }
                    else {
                        if (this.fieldsToFilter[j].filterMapItems[i].hasOwnProperty('value') &&
                            this.fieldsToFilter[j].filterMapItems[i]['value'] !== '') {
                            params['filter']['filterObjects'].push(Object.assign({}, this.fieldsToFilter[j].filterMapItems[i]));
                        }
                    }
                    if (this.fieldsToFilter[j].filterMapItems[i]['operation'] === 'Prazno' ||
                        this.fieldsToFilter[j].filterMapItems[i]['operation'] === 'Nije prazno') {
                        var /** @type {?} */ newObject = Object.assign({}, this.fieldsToFilter[j].filterMapItems[i]);
                        if (this.fieldsToFilter[j].filterMapItems[i].type === FieldTypeEnum.Completer) {
                            newObject['name'] = 'id';
                        }
                        newObject['value'] = '';
                        params['filter']['filterObjects'].push(newObject);
                    }
                }
            }
        }
        else {
            params['filter']['filterQuery'] = this.filterQuery;
            params['filter']['filterDate'] = filterDate;
        }
        params['filter']['filterCombined'] = this.listService.getFilterCombined(this.backendService.getSettings(this.documentId), null, params['filter']['filterQuery'], params['filter']['filterDate'], params['filter']['filterObjects']);
        this.filterAction.emit(params);
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.prepareSelectPicker = function () {
        var /** @type {?} */ that = this;
        $('.filter-operation .selectpicker:last-of-type').selectpicker();
        $('.filter-operation .selectpicker:last-of-type').on('change', function (event) {
            var /** @type {?} */ i = $(this)[0].dataset.i;
            var /** @type {?} */ j = $(this)[0].dataset.j;
            var /** @type {?} */ operation = $(this).val();
            if (operation === 'Prazno' || operation === 'Nije prazno') {
                that.fieldsToFilter[i].filterMapItems[j].visible = false;
                if (that.fieldsToFilter[i].filterMapItems[j].type === FieldTypeEnum.Completer) {
                    that.fieldsToFilter[i].filterMapItems[j]['value'] = null;
                }
                else {
                    that.fieldsToFilter[i].filterMapItems[j]['value'] = '';
                }
            }
            else {
                that.fieldsToFilter[i].filterMapItems[j].visible = true;
            }
            if (operation === '%') {
                operation = 'contains';
            }
            else if (operation === 'Od') {
                operation = '>=';
            }
            else if (operation === 'Do') {
                operation = '<=';
            }
            that.fieldsToFilter[i].filterMapItems[j]['operation'] = operation;
        });
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.isFilterValid = function () {
        var /** @type {?} */ isValid = true;
        this.timePicker.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        this.datePicker.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        this.input.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        this.combo.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        this.autocomplete.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        if (!isValid) {
            return false;
        }
        return true;
    };
    /**
     * @param {?} filterMap
     * @param {?} newValue
     * @param {?} oldValue
     * @param {?} i
     * @param {?} j
     * @return {?}
     */
    FilterComponent.prototype.fieldUpdateValue = function (filterMap, newValue, oldValue, i, j) {
        if (filterMap.fieldMapItem.type === FieldTypeEnum.Date) {
            this.fieldsToFilter[i].filterMapItems[j].value = newValue.end;
            this.valueChanged.emit({ fieldMap: filterMap.fieldMapItem, newValue: newValue.end, oldValue: oldValue });
        }
        else if (filterMap.fieldMapItem.type === FieldTypeEnum.Time) {
            this.fieldsToFilter[i].filterMapItems[j].value = newValue;
            this.valueChanged.emit({ fieldMap: filterMap.fieldMapItem, newValue: newValue, oldValue: oldValue });
        }
        else if (filterMap.fieldMapItem.type === FieldTypeEnum.Check) {
            this.fieldsToFilter[i].filterMapItems[j].value = newValue.target.checked;
            this.valueChanged.emit({ fieldMap: filterMap.fieldMapItem, newValue: newValue, oldValue: oldValue });
        }
        else {
            this.fieldsToFilter[i].filterMapItems[j].value = newValue;
            this.valueChanged.emit({ fieldMap: filterMap.fieldMapItem, newValue: newValue, oldValue: oldValue });
        }
    };
    /**
     * @param {?} i
     * @return {?}
     */
    FilterComponent.prototype.removeFieldFromFilter = function (i) {
        delete this.fieldsToFilter[i]['value'];
        this.fieldsToFilter.splice(i, 1);
        setTimeout(function () {
            UtilService.recalculateCss();
        });
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.setDefaultFields = function () {
        this.fieldsToFilter = [];
        for (var /** @type {?} */ i = 0; i < this.initSettings['fieldList'].length; i++) {
            if (this.initSettings['fieldList'][i]['default']) {
                var /** @type {?} */ field = Object.assign({}, this.initSettings['fieldList'][i]);
                this.addField(field);
            }
        }
    };
    /**
     * @param {?} filter
     * @return {?}
     */
    FilterComponent.prototype.addField = function (filter) {
        var _this = this;
        if (this.alwaysComplex) {
            var /** @type {?} */ hasField = this.fieldsToFilter.some(function (item) { return item['id'] === filter.id; });
            if (hasField) {
                return;
            }
        }
        var /** @type {?} */ fieldToAdd = Object.assign({}, filter);
        for (var _i = 0, _a = fieldToAdd.filterMapItems; _i < _a.length; _i++) {
            var field = _a[_i];
            if (!field.hasOwnProperty('operation')) {
                field.operation = '=';
            }
            field.visible = true;
        }
        this.fieldsToFilter.push(filter);
        setTimeout(function () {
            _this.prepareSelectPicker();
            _this.setDefaultOperation();
            UtilService.recalculateCss();
        }, 0);
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.resetDefaultOperation = function () {
        for (var /** @type {?} */ i = 0; i < this.fieldsToFilter.length; i++) {
            for (var /** @type {?} */ j = 0; j < this.fieldsToFilter[i].filterMapItems.length; j++) {
                this.fieldsToFilter[i].filterMapItems[j]['operation'] = this.fieldsToFilter[i].filterMapItems[j]['defaultOperation'];
                if (this.fieldsToFilter[i].filterMapItems[j]['operation'] === 'Prazno' ||
                    this.fieldsToFilter[i].filterMapItems[j]['operation'] === 'Nije prazno') {
                    this.fieldsToFilter[i].filterMapItems[j].visible = false;
                    if (this.fieldsToFilter[i].filterMapItems[j].type === FieldTypeEnum.Completer) {
                        this.fieldsToFilter[i].filterMapItems[j]['value'] = null;
                    }
                    else {
                        this.fieldsToFilter[i].filterMapItems[j]['value'] = '';
                    }
                }
                else {
                    this.fieldsToFilter[i].filterMapItems[j].visible = true;
                }
            }
        }
        // this.fieldsToFilter = JSON.parse(JSON.stringify(this.fieldsToFilter));
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.setDefaultOperation = function () {
        for (var /** @type {?} */ i = 0; i < this.fieldsToFilter.length; i++) {
            for (var /** @type {?} */ j = 0; j < this.fieldsToFilter[i].filterMapItems.length; j++) {
                this.fieldsToFilter[i].filterMapItems[j]['defaultOperation'] = this.fieldsToFilter[i].filterMapItems[j]['operation'];
            }
        }
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.add = function () {
        var /** @type {?} */ selectedName = $(this.getItemRef().querySelector('div.field-selectpicker .field-selectpicker')).val();
        var /** @type {?} */ selectedField = this._settings['fieldList'].filter(function (field) { return field.id === selectedName; })[0];
        this.addField(selectedField);
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.refresh = function () {
        var _this = this;
        this.resetFilters.emit();
        if (this.isComplex) {
            $('.filter-row.complex').find('.input-group input').val('');
            $('.filter-row.complex').find('.input-group ul').val('');
            var /** @type {?} */ nonDefaultFilters = this.fieldsToFilter.filter(function (fm) { return !fm.mandatory; });
            for (var _i = 0, nonDefaultFilters_1 = nonDefaultFilters; _i < nonDefaultFilters_1.length; _i++) {
                var filter = nonDefaultFilters_1[_i];
                for (var _a = 0, _b = filter.filterMapItems; _a < _b.length; _a++) {
                    var field = _b[_a];
                    if (field.hasOwnProperty('value')) {
                        delete field.value;
                    }
                }
            }
        }
        else {
            $(this.getItemRef().querySelector('.datepicker-filter-' + this.componentGuid)).val('');
        }
        this.resetDefaultOperation();
        setTimeout(function () {
            _this.prepareSelectPicker();
        }, 0);
        if (this.filterAfterRefresh) {
            this.filter();
        }
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.exportToExcel = function () {
        var /** @type {?} */ params = {
            action: FilterActionEnum.Export
        };
        this.filterAction.emit(params);
    };
    /**
     * @return {?}
     */
    FilterComponent.prototype.print = function () {
        var /** @type {?} */ params = {
            action: FilterActionEnum.Print
        };
        this.filterAction.emit(params);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    FilterComponent.prototype.getButtonClass = function (item) {
        var /** @type {?} */ retVal = this.styles.get(item.style).buttonClass;
        if (!item.enabled) {
            retVal = retVal + ' ' + this.disabledClass;
        }
        return retVal;
    };
    /**
     * @param {?} n
     * @return {?}
     */
    FilterComponent.prototype.isOdd = function (n) {
        return Math.abs(n % 2) === 1;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    FilterComponent.prototype.getIconClass = function (item) {
        return this.styles.get(item.style).iconClass;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    FilterComponent.prototype.onItemAction = function (item) {
        // Ignore action if the items is disabled
        if (!item.enabled) {
            return;
        }
        this.filterAction.emit(item.action);
    };
    return FilterComponent;
}());
FilterComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-filter',
                template: "\n      <div [hidden]=\"isComplex\"\n           class=\"filter-row simple\">\n          <div class=\"dataTables_filter show row\">\n              <div>\n                  <div>\n                      <button type=\"submit\"\n                              class=\"btn btn-default\"\n                              (click)=\"filter()\">\n                          <i class=\"fa fa-filter\"></i> Filter</button>\n                      <button type=\"submit\"\n                              title=\"Osve\u017Ei\"\n                              class=\"btn btn-danger\"\n                              (click)=\"refresh()\">\n                          <i class=\"fa fa-refresh\"></i></button>\n                      <button *ngIf=\"options?.showExport\"\n                              type=\"submit\"\n                              title=\"Izvezi u Excel\"\n                              class=\"btn btn-default\"\n                              (click)=\"exportToExcel()\">\n                          <i class=\"fa fa-file-excel-o\"></i></button>\n                      <button *ngIf=\"options?.showPrint\"\n                              type=\"submit\"\n                              title=\"\u0160tampaj\"\n                              class=\"btn btn-default\"\n                              (click)=\"print()\">\n                          <i class=\"fa fa-print\"></i></button>\n                  </div>\n              </div>\n              <div>\n                  <input type=\"text\"\n                         class=\"{{'datepicker-filter-' + componentGuid}}\"\n                         (selected)=\"selectedDate($event, daterange)\"\n                         daterangepicker\n                         placeholder=\"Datum\"\n                         [options]=\"optionsDate\" />\n              </div>\n              <div>\n                  <input type=\"search\"\n                         class=\"\"\n                         placeholder=\"\"\n                         placeholder=\"Tekst\"\n                         aria-controls=\"DataTables_Table_0\"\n                         [(ngModel)]=\"filterQuery\">\n              </div>\n          </div>\n      </div>\n      <div [hidden]=\"!isComplex\"\n           class=\"filter-row complex\">\n          <div class=\"dataTables_filter show row col-md-12\">\n              <div\n                  class=\"filter-left\"\n                  [ngClass]=\"{\n                      'col-md-10': !isLookup,\n                      'col-md-9': isLookup,\n                      'z-index-9': isLookup\n                  }\">\n                  <div *ngFor=\"let filterField of fieldsToFilter; let i = index\"\n                      class=\"field-to-filter\">\n                      <!-- <span *ngIf=\"!filterField.filterMapItems[0].mandatory\"\n                          class=\"fa fa-times-circle\"\n                          (click)=\"removeFieldFromFilter(i)\"></span> -->\n                      <!-- <span *ngIf=\"filterField.filterMapItems[0].mandatory\"\n                          class=\"fa fa-info-circle\"\n                          title=\"Obavezno\"></span> -->\n                      <span class=\"filter-label\"\n                          title=\"{{filterField.filterMapItems[0].fieldMapItem.label}}\">{{filterField.filterMapItems[0].fieldMapItem.label}}</span>\n                      <div *ngFor=\"let filterItem of filterField.filterMapItems; let j = index\"\n                          class=\"field-to-filter-sub\">\n\n                          <!-- Operacije -->\n\n                          <!-- <div class=\"filter-operation\"\n                               *ngIf=\"!hasProp(filterItem, 'showOperation') || filterItem.showOperation\">\n                              <select *ngIf=\"filterItem.fieldMapItem.type !== FieldTypeEnum.Date &&\n                                              filterItem.fieldMapItem.type !== FieldTypeEnum.Completer &&\n                                              filterItem.fieldMapItem.type !== FieldTypeEnum.Time &&\n                                                  filterItem.fieldMapItem.type !== FieldTypeEnum.Check\"\n                                      class=\"form-control selectpicker\"\n                                      [attr.data-i]=\"i\"\n                                      [attr.data-j]=\"j\"\n                                      data-style=\"btn-default\">\n                                  <option *ngFor=\"let operation of inputOperations\">{{operation}}</option>\n                              </select>\n                              <select *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Check\"\n                                      class=\"form-control selectpicker\"\n                                      [attr.data-i]=\"i\"\n                                      [attr.data-j]=\"j\"\n                                      data-style=\"btn-default\">\n                                  <option *ngFor=\"let operation of checkOperations\">{{operation}}</option>\n                              </select>\n                              <select *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Completer\"\n                                      class=\"form-control selectpicker\"\n                                      [attr.data-i]=\"i\"\n                                      [attr.data-j]=\"j\"\n                                      data-style=\"btn-default\">\n                                  <option *ngFor=\"let operation of completerOperations\">{{operation}}</option>\n                              </select>\n                              <select *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Time\"\n                                      class=\"form-control selectpicker\"\n                                      [attr.data-i]=\"i\"\n                                      [attr.data-j]=\"j\"\n                                      data-style=\"btn-default\">\n                                  <option *ngFor=\"let operation of timeOperations\">{{operation}}</option>\n                              </select>\n                              <select *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Date &&\n                                              filterField.filterMapItems.length === 1\"\n                                      class=\"form-control selectpicker\"\n                                      [attr.data-i]=\"i\"\n                                      [attr.data-j]=\"j\"\n                                      data-style=\"btn-default\">\n                                  <option *ngFor=\"let operation of dateOperations\">{{operation}}</option>\n                              </select>\n                              <select *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Date &&\n                                              filterField.filterMapItems.length > 1 &&\n                                              j === 0\"\n                                      class=\"form-control selectpicker\"\n                                      [attr.data-i]=\"i\"\n                                      [attr.data-j]=\"j\"\n                                      [attr.disabled]=\"true\"\n                                      data-style=\"btn-default\">\n                                  <option *ngFor=\"let operation of fromOperations\">{{operation}}</option>\n                              </select>\n                              <select *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Date &&\n                                              filterField.filterMapItems.length > 1 &&\n                                              j === 1\"\n                                      class=\"form-control selectpicker\"\n                                      [attr.data-i]=\"i\"\n                                      [attr.data-j]=\"j\"\n                                      [attr.disabled]=\"true\"\n                                      data-style=\"btn-default\">\n                                  <option *ngFor=\"let operation of toOperations\">{{operation}}</option>\n                              </select>\n                          </div> -->\n\n                          <div *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Input\">\n                              <util-input *ngIf=\"filterItem.visible\"\n                                          [value]=\"filterItem.value\"\n                                          [columnItem]=\"filterItem.fieldMapItem\"\n                                          (valueChanged)=\"fieldUpdateValue(filterItem, $event.value, $event.oldValue, i, j)\"\n                                          [isFilter]=\"true\">\n                              </util-input>\n                          </div>\n                          <div *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Combo\"\n                              class=\"input-group combo\">\n                              <util-combo *ngIf=\"filterItem.visible\"\n                                          [selectedItem]=\"filterItem.value\"\n                                          (selectedItemChange)=\"fieldUpdateValue(filterItem, $event.value, $event.oldValue, i, j)\"\n                                          [fieldSettings]=\"filterItem.fieldMapItem\"\n                                          [useFixedValues]=\"false\"\n                                          [isFilter]=\"true\">\n                              </util-combo>\n                          </div>\n                          <div *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.ComboFixed\"\n                              class=\"input-group combo\">\n                              <util-combo *ngIf=\"filterItem.visible\"\n                                          [selectedItem]=\"filterItem.value\"\n                                          (selectedItemChange)=\"fieldUpdateValue(filterItem, $event.value, $event.oldValue, i, j)\"\n                                          [fieldSettings]=\"filterItem.fieldMapItem\"\n                                          [useFixedValues]=\"true\"\n                                          [isFilter]=\"true\">\n                              </util-combo>\n                          </div>\n                          <div *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Date\"\n                              class=\"input-group\">\n                              <util-daterangepicker *ngIf=\"filterItem.visible\"\n                                                  [value]=\"filterItem.value\"\n                                                  [columnItem]=\"filterItem.fieldMapItem\"\n                                                  (dateSelected)=\"fieldUpdateValue(filterItem, $event.value, $event.oldValue, i, j)\">\n                              </util-daterangepicker>\n                          </div>\n                          <div *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Time\"\n                               class=\"input-group\">\n                              <util-timepicker [entity]=\"filterItem.value\"\n                                               [columnItem]=\"filterItem.fieldMapItem\"\n                                               (timeChanged)=\"fieldUpdateValue(filterItem, $event.value, $event.oldValue, i, j)\">\n                              </util-timepicker>\n                          </div>\n                          <!-- <div *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Completer\"\n                               class=\"input-group\">\n                              <util-autocomplete *ngIf=\"filterItem.visible\"\n                                                 [selectedItem]=\"filterItem.value\"\n                                                 (selectedItemChange)=\"fieldUpdateValue(filterItem, $event.value, $event.oldValue, i, j)\"\n                                                 [fieldSettings]=\"filterItem.fieldMapItem\">\n                              </util-autocomplete>\n                          </div> -->\n                          <div *ngIf=\"filterItem.fieldMapItem.type === FieldTypeEnum.Check\"\n                               class=\"input-group\">\n                              <label *ngIf=\"filterItem.visible\"\n                                     class=\"switch switch-small\">\n                                  <input type=\"checkbox\"\n                                         class=\"icheckbox\"\n                                         [ngModel]=\"filterItem.value\"\n                                         (change)=\"fieldUpdateValue(filterItem, $event, $event.oldValue, i, j)\" />\n                                  <span></span>\n                              </label>\n                          </div>\n                      </div>\n                  </div>\n              </div>\n              <div\n                  class=\"filter-right\"\n                  [ngClass]=\"{\n                      'col-md-2': !isLookup,\n                      'col-md-3': isLookup,\n                      'z-index-10': isLookup\n                  }\">\n                  <div *ngFor=\"let item of itemsVisible\">\n                      <button [className]=\"getButtonClass(item)\"\n                              (click)=\"onItemAction(item)\"\n                              title=\"{{item.title}}\">\n                          <i [className]=\"getIconClass(item)\"></i> {{ item.label }}\n                      </button>\n                  </div>\n                  <div>\n                      <button *ngIf=\"filterEnabled\"\n                              type=\"submit\"\n                              class=\"btn btn-success\"\n                              (click)=\"filter()\">\n                          <i class=\"fa fa-filter\"></i> Filter</button>\n                      <button *ngIf=\"refreshEnabled\"\n                              type=\"submit\"\n                              class=\"btn btn-danger\"\n                              title=\"Osve\u017Ei\"\n                              (click)=\"refresh()\">\n                          <i class=\"fa fa-refresh\"></i></button>\n                      <button *ngIf=\"options?.showExport\"\n                              type=\"submit\"\n                              title=\"Izvezi u Excel\"\n                              class=\"btn btn-default\"\n                              (click)=\"exportToExcel()\">\n                          <i class=\"fa fa-file-excel-o\"></i></button>\n                      <button *ngIf=\"options?.showPrint\"\n                              type=\"submit\"\n                              title=\"\u0160tampaj\"\n                              class=\"btn btn-default\"\n                              (click)=\"print()\">\n                          <i class=\"fa fa-print\"></i></button>\n                  </div>\n                  <!-- <div *ngIf=\"addingEnabled && _settings\"\n                       class=\"field-selectpicker\">\n                      <select class=\"form-control selectpicker field-selectpicker\"\n                              data-style=\"btn-default\"\n                              width=\"css-width\">\n                          <option title=\"{{field.label}}\"\n                                  *ngFor=\"let field of _settings?.fieldList\"\n                                  value=\"{{field.id}}\">{{field.label}}</option>\n                      </select>\n                  </div>\n                  <div *ngIf=\"addingEnabled\">\n                      <button type=\"submit\"\n                              class=\"btn btn-primary\"\n                              (click)=\"add()\">\n                          <i class=\"fa fa-plus\"></i> Dodaj</button>\n                  </div> -->\n              </div>\n              <div style=\"clear: both;\"></div>\n          </div>\n      </div>\n    "
            },] },
];
/**
 * @nocollapse
 */
FilterComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: SettingsService, },
    { type: BackendService, },
    { type: ListService, },
]; };
FilterComponent.propDecorators = {
    'picker': [{ type: ViewChildren, args: [DaterangePickerComponent,] },],
    'filterAction': [{ type: Output, args: ['filterAction',] },],
    'valueChanged': [{ type: Output },],
    'resetFilters': [{ type: Output },],
    'timePicker': [{ type: ViewChildren, args: [TimepickerComponent,] },],
    'datePicker': [{ type: ViewChildren, args: [DaterangepickerComponent,] },],
    'autocomplete': [{ type: ViewChildren, args: [AutocompleteComponent,] },],
    'combo': [{ type: ViewChildren, args: [ComboComponent,] },],
    'input': [{ type: ViewChildren, args: [InputComponent,] },],
    'options': [{ type: Input },],
    'documentId': [{ type: Input },],
    'alwaysComplex': [{ type: Input },],
    'addingEnabled': [{ type: Input },],
    'filterEnabled': [{ type: Input },],
    'refreshEnabled': [{ type: Input },],
    'filterAfterRefresh': [{ type: Input },],
    'refreshFilterOnClose': [{ type: Input },],
    'isLookup': [{ type: Input },],
    'settings': [{ type: Input },],
};
var ComboModule = /** @class */ (function () {
    function ComboModule() {
    }
    return ComboModule;
}());
ComboModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    ComboComponent
                ],
                providers: [
                    ListService
                ],
                exports: [
                    ComboComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
ComboModule.ctorParameters = function () { return []; };
var InputModule = /** @class */ (function () {
    function InputModule() {
    }
    return InputModule;
}());
InputModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    SharedModule
                ],
                declarations: [
                    InputComponent
                ],
                providers: [],
                exports: [
                    InputComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
InputModule.ctorParameters = function () { return []; };
var TimepickerModule = /** @class */ (function () {
    function TimepickerModule() {
    }
    return TimepickerModule;
}());
TimepickerModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                ],
                declarations: [
                    TimepickerComponent
                ],
                providers: [],
                exports: [
                    TimepickerComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
TimepickerModule.ctorParameters = function () { return []; };
var FilterModule = /** @class */ (function () {
    function FilterModule() {
    }
    return FilterModule;
}());
FilterModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    FilterComponent
                ],
                entryComponents: [],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    Daterangepicker,
                    ComboModule,
                    DaterangepickerModule,
                    TimepickerModule,
                    //    AutocompleteModule,
                    InputModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService
                ],
                exports: [FilterComponent]
            },] },
];
/**
 * @nocollapse
 */
FilterModule.ctorParameters = function () { return []; };
var AutocompleteModule = /** @class */ (function () {
    function AutocompleteModule() {
    }
    return AutocompleteModule;
}());
AutocompleteModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ViewTableModule,
                    FilterModule
                ],
                declarations: [
                    AutocompleteComponent
                ],
                providers: [
                    ListService
                ],
                exports: [
                    AutocompleteComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
AutocompleteModule.ctorParameters = function () { return []; };
var TagsComponent = /** @class */ (function () {
    /**
     * @param {?} eRef
     */
    function TagsComponent(eRef) {
        this.eRef = eRef;
        this.help1 = '';
        this.valueChanged = new EventEmitter();
        this.valueChangedInput = new EventEmitter();
        this.componentGuid = null;
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(TagsComponent.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value == null) {
                value = '';
            }
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TagsComponent.prototype, "columnItem", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._columnItem = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    TagsComponent.prototype.openModal = function (event) {
        event.stopPropagation();
        $('#modal-parent').show();
        $('#modal').append($("#tags_" + this.componentGuid + " > #tagsModal_" + this.componentGuid));
    };
    /**
     * @return {?}
     */
    TagsComponent.prototype.closeModal = function () {
        $("#tags_" + this.componentGuid).append($("#modal > #tagsModal_" + this.componentGuid));
        $('#modal-parent').hide();
    };
    /**
     * @return {?}
     */
    TagsComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @param {?} help1
     * @return {?}
     */
    TagsComponent.prototype.showErrors = function (help1) {
        $(this.getItemRef().querySelector(this.getSelector())).addClass('error');
        this.help1 = help1;
        $(this.getItemRef().querySelector('.formError')).show().delay(5000).fadeOut();
    };
    /**
     * @return {?}
     */
    TagsComponent.prototype.hideErrors = function () {
        $(this.getItemRef().querySelector(this.getSelector())).removeClass('error');
        this.help1 = '';
        $(this.getItemRef().querySelector('.formError')).hide();
    };
    /**
     * @return {?}
     */
    TagsComponent.prototype.validate = function () {
        var /** @type {?} */ help1;
        var /** @type {?} */ val = $(this.getItemRef().querySelector(this.getSelector())).val();
        if (this._columnItem.mandatory &&
            (typeof val === 'undefined' || val === '')) {
            help1 = '* Vrednost je obavezna';
        }
        if (help1) {
            this.showErrors(help1);
            return false;
        }
        else {
            this.hideErrors();
            return true;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TagsComponent.prototype.textChanged = function (event) {
        var /** @type {?} */ params = {
            'columnItem': this._columnItem,
            'value': event.target.value
        };
        this.valueChangedInput.emit(params);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TagsComponent.prototype.blur = function (event) {
        this.validate();
        var /** @type {?} */ newVal = $(this.getItemRef().querySelector(this.getSelector())).val();
        var /** @type {?} */ params = {
            'columnItem': this._columnItem,
            'value': newVal
        };
        this.valueChanged.emit(params);
    };
    /**
     * @return {?}
     */
    TagsComponent.prototype.getSelector = function () {
        return 'input';
    };
    /**
     * @return {?}
     */
    TagsComponent.prototype.ngOnInit = function () {
        if ($('.tagsinput').length > 0) {
            $('.tagsinput').each(function () {
                var /** @type {?} */ dt = 'add a tag';
                if ($(this).data('placeholder') !== '') {
                    dt = $(this).data('placeholder');
                }
                $(this).tagsInput({ width: '100%', height: 'auto', defaultText: dt });
            });
        }
    };
    return TagsComponent;
}());
TagsComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-tags',
                template: "\n      <div id=\"tags_{{ componentGuid }}\" class=\"util-input tags\">\n          <div class=\"input-box\">\n              <input type=\"text\" class=\"tagsinput\" value=\"\"/>\n              <a href=\"javascript:void(0)\" tabindex=\"-1\" class=\"tags-icon\" (click)=\"openModal($event)\">\n                  <span class=\"fa fa-tags\"></span>\n              </a>\n              <div class=\"formError\" (click)=\"hideErrors()\">\n                  <div class=\"formErrorArrow formErrorArrowBottom\">\n                      <div class=\"line1\"><!-- TODO: Remove these lines--></div>\n                      <div class=\"line2\"><!-- --></div>\n                      <div class=\"line3\"><!-- --></div>\n                      <div class=\"line4\"><!-- --></div>\n                      <div class=\"line5\"><!-- --></div>\n                      <div class=\"line6\"><!-- --></div>\n                      <div class=\"line7\"><!-- --></div>\n                      <div class=\"line8\"><!-- --></div>\n                      <div class=\"line9\"><!-- --></div>\n                      <div class=\"line10\"><!-- --></div>\n                  </div>\n                  <div class=\"formErrorContent\">\n                      {{help1}}\n                  </div>\n              </div>\n          </div>\n\n          <div id=\"tagsModal_{{ componentGuid }}\" class=\"tags-modal\">\n              <div class=\"panel panel-default\">\n                  <div class=\"panel-heading\">\n                      <h3 class=\"panel-title\">{{fieldSettings?.label}}</h3>\n                      <ul class=\"panel-controls\">\n                          <li>\n                              <a href=\"javascript:void(0)\" (click)=\"closeModal()\">\n                                  <span class=\"fa fa-times\"></span>\n                              </a>\n                          </li>\n                      </ul>\n                  </div>\n                  <div class=\"panel-body\">\n                      <input type=\"text\" class=\"tagsinput\" value=\"First,Second,Third\"/>\n                  </div>\n              </div>\n          </div>\n      </div>\n    ",
                styles: ["\n      .util-input.tags {\n        width: auto;\n        position: relative; }\n        .util-input.tags .input-box .hidden {\n          display: none; }\n        .util-input.tags .input-box input {\n          width: 100%; }\n        .util-input.tags .input-box .tags-icon {\n          position: absolute;\n          right: 10px;\n          z-index: 2;\n          line-height: 30px;\n          top: 0;\n          bottom: 0; }\n        .util-input.tags .popup {\n          z-index: 100;\n          position: absolute;\n          display: none;\n          clear: both;\n          background-color: white; }\n          .util-input.tags .popup ul {\n            clear: both;\n            padding-left: 0;\n            -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);\n                    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08); }\n            .util-input.tags .popup ul li {\n              text-decoration: none;\n              list-style: none;\n              height: 30px;\n              line-height: 30px;\n              cursor: pointer;\n              padding-left: 10px;\n              text-overflow: ellipsis;\n              overflow: hidden;\n              white-space: nowrap; }\n              .util-input.tags .popup ul li.selected {\n                background-color: #ddd; }\n              .util-input.tags .popup ul li:hover {\n                background-color: #ddd; }\n              .util-input.tags .popup ul li .id {\n                display: inline-block; }\n              .util-input.tags .popup ul li .text {\n                padding-right: 50px; }\n          .util-input.tags .popup.show {\n            display: block; }\n        .util-input.tags .tags-modal {\n          display: none; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
TagsComponent.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
TagsComponent.propDecorators = {
    'fieldSettings': [{ type: Input },],
    'value': [{ type: Input },],
    'columnItem': [{ type: Input },],
    'valueChanged': [{ type: Output, args: ['valueChanged',] },],
    'valueChangedInput': [{ type: Output, args: ['valueChangedInput',] },],
};
var TagsModule = /** @class */ (function () {
    function TagsModule() {
    }
    return TagsModule;
}());
TagsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                ],
                declarations: [
                    TagsComponent
                ],
                providers: [],
                exports: [
                    TagsComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
TagsModule.ctorParameters = function () { return []; };
var StatusLozengeComponent = /** @class */ (function () {
    function StatusLozengeComponent() {
        this._showSaved = false;
        this.hideStatus = false;
    }
    Object.defineProperty(StatusLozengeComponent.prototype, "target", {
        /**
         * @return {?}
         */
        get: function () {
            return this._target;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._target = value;
            this.rebuild();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StatusLozengeComponent.prototype, "showSaved", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showSaved;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._showSaved = value;
            this.rebuild();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    StatusLozengeComponent.prototype.ngOnInit = function () {
        this.rebuild();
    };
    /**
     * @return {?}
     */
    StatusLozengeComponent.prototype.rebuild = function () {
        if (this.target == null) {
            return null;
        }
        var /** @type {?} */ status = this.getStatus();
        this.hideStatus = status === DocumentStatus.Unknown
            || (status === DocumentStatus.Draft && !this.showSaved);
        this.statusLabel = this.getStatusLabel(status);
        this.statusClass = this.getStatusClass(status);
    };
    /**
     * @return {?}
     */
    StatusLozengeComponent.prototype.getStatus = function () {
        var /** @type {?} */ target = this.target;
        var /** @type {?} */ noData = target == null || !target.hasOwnProperty('status');
        if (noData) {
            return DocumentStatus.Unknown;
        }
        if (target.storno) {
            return DocumentStatus.Deleted;
        }
        if (target.status) {
            return DocumentStatus.Published;
        }
        return DocumentStatus.Draft;
    };
    /**
     * @param {?} status
     * @return {?}
     */
    StatusLozengeComponent.prototype.getStatusLabel = function (status) {
        switch (status) {
            case DocumentStatus.Published: return 'Prihvaćen';
            case DocumentStatus.Deleted: return 'Storniran';
            case DocumentStatus.Draft: return 'Sačuvan';
            default: return null;
        }
    };
    /**
     * @param {?} status
     * @return {?}
     */
    StatusLozengeComponent.prototype.getStatusClass = function (status) {
        switch (status) {
            case DocumentStatus.Published: return 'status-lozenge-green';
            case DocumentStatus.Deleted: return 'status-lozenge-red';
            case DocumentStatus.Draft: return 'status-lozenge-yellow';
            default: return 'status-lozenge-blue-gray';
        }
    };
    return StatusLozengeComponent;
}());
StatusLozengeComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-status-lozenge',
                template: "\n      <div [hidden]=\"hideStatus\">\n          <div class=\"status-lozenge\" [ngClass]=\"statusClass\">{{statusLabel}}</div>\n      </div>\n    ",
                styles: ["\n      .status-lozenge {\n        border: 1px solid #dfe1e6;\n        border-radius: 3px;\n        color: #253858;\n        display: inline-block;\n        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;\n        font-size: 11px;\n        font-weight: 700;\n        line-height: 99%;\n        margin: 0;\n        padding: 2px 5px;\n        text-align: center;\n        text-decoration: none;\n        text-transform: uppercase;\n        vertical-align: text-bottom;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        /* TODO max-width: 12em;*/\n        word-wrap: normal;\n        word-break: normal; }\n\n      .status-lozenge-red {\n        background-color: #d04437;\n        border-color: #d04437;\n        color: #fff; }\n\n      .status-lozenge-yellow {\n        background-color: #ffd351;\n        border-color: #ffd351;\n        color: #594300; }\n\n      .status-lozenge-green {\n        background-color: #14892c;\n        border-color: #14892c;\n        color: #fff; }\n\n      .status-lozenge-blue-gray {\n        background-color: #4a6785;\n        border-color: #4a6785;\n        color: #fff; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
StatusLozengeComponent.ctorParameters = function () { return []; };
StatusLozengeComponent.propDecorators = {
    'target': [{ type: Input, args: ['target',] },],
    'showSaved': [{ type: Input, args: ['showSaved',] },],
};
var DocumentStatus = {};
DocumentStatus.Unknown = 0;
DocumentStatus.Draft = 1;
DocumentStatus.Published = 2;
DocumentStatus.Deleted = 3;
DocumentStatus[DocumentStatus.Unknown] = "Unknown";
DocumentStatus[DocumentStatus.Draft] = "Draft";
DocumentStatus[DocumentStatus.Published] = "Published";
DocumentStatus[DocumentStatus.Deleted] = "Deleted";
var StatusLozengeModule = /** @class */ (function () {
    function StatusLozengeModule() {
    }
    return StatusLozengeModule;
}());
StatusLozengeModule.decorators = [
    { type: NgModule, args: [{
                declarations: [StatusLozengeComponent],
                entryComponents: [],
                imports: [CommonModule],
                providers: [],
                exports: [StatusLozengeComponent]
            },] },
];
/**
 * @nocollapse
 */
StatusLozengeModule.ctorParameters = function () { return []; };
var TableModule = /** @class */ (function () {
    function TableModule() {
    }
    return TableModule;
}());
TableModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    TableComponent
                ],
                entryComponents: [
                    AutocompleteComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    Daterangepicker,
                    PaginationModule,
                    DataTablesModule,
                    AutocompleteModule,
                    ComboModule,
                    TimepickerModule,
                    InputModule,
                    TagsModule,
                    DaterangepickerModule,
                    SharedModule,
                    StatusLozengeModule,
                    TooltipModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService,
                    UtilService,
                    FieldService
                ],
                exports: [TableComponent]
            },] },
];
/**
 * @nocollapse
 */
TableModule.ctorParameters = function () { return []; };
var ModalSettingsModule = /** @class */ (function () {
    function ModalSettingsModule() {
    }
    return ModalSettingsModule;
}());
ModalSettingsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    DndModule,
                    TableModule
                ],
                declarations: [
                    ModalSettingsComponent
                ],
                providers: [
                    ModalSettingsService,
                    DragDropService,
                    DragDropConfig,
                    DragDropSortableService
                ],
                exports: [
                    ModalSettingsComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
ModalSettingsModule.ctorParameters = function () { return []; };
var ProfileComponent = /** @class */ (function (_super) {
    __extends(ProfileComponent, _super);
    /**
     * @param {?} backendService
     * @param {?} authenticationService
     * @param {?} notificationService
     * @param {?} modalService
     */
    function ProfileComponent(backendService, authenticationService, notificationService, modalService) {
        var _this = _super.call(this, backendService) || this;
        _this.backendService = backendService;
        _this.authenticationService = authenticationService;
        _this.notificationService = notificationService;
        _this.modalService = modalService;
        _this.podaci = [
            {
                'datumPromene': 1558801076316,
                'korisnik': 'admin',
                'ime': 'Marina',
                'prezime': 'Milenkovic',
                'sektor': 'IT',
                'telefon': '011 555 555',
                'email': 'm_milenkovic@rts.rs',
                'uloga': 'Administrator',
                'rbr': 1,
                'id': '601',
            },
        ];
        _this.FormModeEnum = FormModeEnum;
        _this.TableModeEnum = TableModeEnum;
        _this.documentListSource = new Subject$1();
        _this.documentList$ = _this.documentListSource.asObservable();
        console.log('ProfileComponent Instantiated');
        _this.modeChange(FormModeEnum.View);
        return _this;
    }
    Object.defineProperty(ProfileComponent.prototype, "order", {
        /**
         * @return {?}
         */
        get: function () {
            return this._order;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._order = value;
            this.changeName();
            this.infobarDocument = value;
            this.setOrderListDetails();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    ProfileComponent.prototype.modeChange = function (event) {
        this.mode = event;
        this.changeName();
        if (this.mode === FormModeEnum.Table) {
            this.infobarVisible = false;
            this.setToolbarOptions({
                toolbarVisible: false
            });
        }
        else {
            this.infobarVisible = true;
        }
        switch (this.mode) {
            case FormModeEnum.Edit:
                this.setToolbarOptions({
                    items: [
                        ToolbarItem.ItemSave(),
                        ToolbarItem.ItemCancel()
                    ]
                });
                break;
            case FormModeEnum.View:
                this._orderBeforeEditing = JSON.parse(JSON.stringify(this.podaci[0]));
                // Moved when order loads
                if (typeof this.order === 'undefined') {
                    this.setToolbarOptions({
                        items: [
                            ToolbarItem.ItemDelete(),
                            ToolbarItem.ItemEdit()
                        ]
                    });
                }
                else {
                    var /** @type {?} */ leftEnabled = true, /** @type {?} */ rightEnabled = true;
                    for (var /** @type {?} */ i = 0; i < this.orderList.length; i++) {
                        if (this.orderList[i].id === this.order.id) {
                            if (this.lastUsedFilter.pageCurrent === 1 && i === 0) {
                                leftEnabled = false;
                            }
                            if ((this.lastUsedFilter.pageCurrent - 1) * this.lastUsedFilter.rowsOnPage + i + 1 === this.orderListCount) {
                                rightEnabled = false;
                            }
                        }
                    }
                    this.setToolbarOptions({
                        items: [
                            ToolbarItem.ItemAdd(),
                            ToolbarItem.ItemDelete(),
                            ToolbarItem.ItemEdit()
                        ]
                    }, {
                        leftEnabled: leftEnabled,
                        rightEnabled: rightEnabled
                    });
                }
                break;
            case FormModeEnum.Add:
                this.setToolbarOptions({
                    items: [
                        ToolbarItem.ItemSave()
                    ]
                });
                break;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ProfileComponent.prototype.onToolbarAction = function (event) {
        switch (event) {
            case ToolbarAction.Close:
                this.modeChange(FormModeEnum.Table);
                break;
            // case ToolbarAction.Left:
            //   let orderIdLeft;
            //   for (let i = 0; i < this.orderList.length; i++) {
            //     if (this.orderList[i].id === this.order.id) {
            //       if (i === 0) {
            //         if (this.lastUsedFilter.pageCurrent !== 1) {
            //           this.tables.forEach((child) => {
            //             if (child.tableMode === TableModeEnum.Table) {
            //               child.page(this.lastUsedFilter.pageCurrent - 1);
            //             }
            //           });
            //           this.documentListSubscription = this.documentList$.subscribe(
            //             (data: any) => {
            //               this.documentListSubscription.unsubscribe();
            //               orderIdLeft = data.result[data.pageSize - 1].id;
            //               const paramsLeft: TableActionParams = {
            //                 action: TableActionEnum.View,
            //                 documentId: orderIdLeft
            //               };
            //               this.listTableAction(paramsLeft);
            //               setTimeout(function () {
            //                 that.tables.forEach((child) => {
            //                   if (child.tableMode === TableModeEnum.Table) {
            //                     child.onInlineSelect(data.result[data.pageSize - 1]);
            //                   }
            //                 });
            //               }, 1000);
            //             },
            //             error => {
            //               this.documentListSubscription.unsubscribe();
            //             }
            //           );
            //           break;
            //         }
            //       } else {
            //         this.tables.forEach((child) => {
            //           if (child.tableMode === TableModeEnum.Table) {
            //             child.onInlineViewAndSelect(this.orderList[i - 1]);
            //           }
            //         });
            //         break;
            //       }
            //     }
            //   }
            //   break;
            // case ToolbarAction.Right:
            //   let orderIdRight;
            //   for (let i = 0; i < this.orderList.length; i++) {
            //     if (this.orderList[i].id === this.order.id) {
            //       if (i === this.orderList.length - 1) {
            //         const totalPages = Math.ceil(this.orderListCount / this.lastUsedFilter.rowsOnPage);
            //         if (totalPages > this.lastUsedFilter.pageCurrent) {
            //           this.tables.forEach((child) => {
            //             if (child.tableMode === TableModeEnum.Table) {
            //               child.page(this.lastUsedFilter.pageCurrent + 1);
            //             }
            //           });
            //           this.documentListSubscription = this.documentList$.subscribe(
            //             (data: any) => {
            //               this.documentListSubscription.unsubscribe();
            //               orderIdRight = data.result[0].id;
            //               const paramsRight: TableActionParams = {
            //                 action: TableActionEnum.View,
            //                 documentId: orderIdRight
            //               };
            //               this.listTableAction(paramsRight);
            //               setTimeout(function () {
            //                 that.tables.forEach((child) => {
            //                   if (child.tableMode === TableModeEnum.Table) {
            //                     child.onInlineSelect(data.result[0]);
            //                   }
            //                 });
            //               }, 1000);
            //             },
            //             error => {
            //               this.documentListSubscription.unsubscribe();
            //             }
            //           );
            //           break;
            //         }
            //       } else {
            //         this.tables.forEach((child) => {
            //           if (child.tableMode === TableModeEnum.Table) {
            //             child.onInlineViewAndSelect(this.orderList[i + 1]);
            //           }
            //         });
            //         break;
            //       }
            //     }
            //   }
            //   break;
            case ToolbarAction.Delete:
                this.onDelete(null);
                break;
            case ToolbarAction.Save:
                if (this.mode === FormModeEnum.Add) {
                    this.addOrder();
                }
                else {
                    this.updateOrder();
                }
                break;
            case ToolbarAction.Cancel:
                this.order = JSON.parse(JSON.stringify(this._orderBeforeEditing));
                this.modeChange(FormModeEnum.View);
                break;
            case ToolbarAction.Edit:
                this.modeChange(FormModeEnum.Edit);
                break;
            case ToolbarAction.Add:
                this.order = {};
                this.modeChange(FormModeEnum.Add);
                break;
            default:
                console.log('Unhandled onToolbarAction' + event);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ProfileComponent.prototype.itemsTableDetailsAction = function (event) {
        switch (event.action) {
            case TableActionEnum.EditCancel:
                this.orderListDetails[event.index] = event.document;
                break;
            default:
                break;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ProfileComponent.prototype.listTableAction = function (event) {
        var _this = this;
        switch (event.action) {
            case TableActionEnum.Select:
                this.order = event.document;
                break;
            case TableActionEnum.Filter:
                var /** @type {?} */ filterObjects = this.lastUsedFilter.filterObjects;
                var /** @type {?} */ filterQuery = this.lastUsedFilter.filterQuery;
                var /** @type {?} */ filterDate = this.lastUsedFilter.filterDate;
                var /** @type {?} */ filterCombined = this.lastUsedFilter.filterCombined;
                this.lastUsedFilter = event.filter;
                this.lastUsedFilter.filterObjects = filterObjects;
                this.lastUsedFilter.filterQuery = filterQuery;
                this.lastUsedFilter.filterDate = filterDate;
                this.lastUsedFilter.filterCombined = filterCombined;
                this.refreshTable();
                break;
            case TableActionEnum.Edit:
                this._orderBeforeEditing = Object.assign({}, event.document);
                break;
            case TableActionEnum.EditCancel:
                this.orderList[event.index] = this._orderBeforeEditing;
                break;
            /* #region old view*/
            // case TableActionEnum.View:
            //   this.order = {};
            //   this.backendService.fetchOrder(this.identity.documentId, event.documentId, this.authenticationService.getUser().username).subscribe(
            //     data => {
            //       this.order = data;
            //       this.setToolbarOptions({
            //         items: [
            //           ToolbarItem.ItemEdit(true, !this.order.status)
            //         ]
            //       });
            //       this.modeChange(FormModeEnum.View);
            //     },
            //     error => {
            //       console.log(error);
            //     }
            //   );
            //   break;
            /* #endregion */
            case TableActionEnum.View:
                this.order = this.podaci[0];
                this.setToolbarOptions({
                    items: [
                        ToolbarItem.ItemEdit(true, !this.order.status)
                    ]
                });
                this.modeChange(FormModeEnum.View);
                break;
            case TableActionEnum.Update:
                this.backendService.editOrder(this.identity.documentId, event.document, 'test').subscribe(function (data) {
                    _this.refreshTable();
                }, function (error) {
                });
                break;
            case TableActionEnum.Add:
                this.order = {};
                this.modeChange(FormModeEnum.Add);
                break;
            case TableActionEnum.Delete:
                this.onDelete(null);
                break;
        }
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.setOrderListDetails = function () {
        var /** @type {?} */ fieldDetailsTable = this.settingsTableDetails.group;
        if (this.order != null && !this.order.hasOwnProperty(fieldDetailsTable)) {
            this.order[fieldDetailsTable] = [];
        }
        this.orderListDetails = this.order[fieldDetailsTable];
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.firstTableLoad = function () {
        this.lastUsedFilter = {
            pageCurrent: 1,
            filterQuery: '',
            filterDate: '',
            filterObjects: [],
            filterCombined: null,
            rowsOnPage: 10,
            sortOrder: {},
            direction: 'asc',
            relations: this.settingsTable.relations
        };
        this.refreshTable();
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.setAllFields = function () {
        for (var /** @type {?} */ i = 0; i < this.settingsFilter.fieldList.length; i++) {
            var /** @type {?} */ fieldData = this.settingsFilter.fieldList[i];
            var /** @type {?} */ filterWithItem = JSON.parse(JSON.stringify(fieldData));
            filterWithItem.fieldMapItem = UtilService.getFieldMapItem(this.settingsFilter.relations, fieldData);
            this.settingsFilter.fieldList[i].filterMapItems = [];
            this.settingsFilter.fieldList[i].filterMapItems.push(filterWithItem);
        }
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.changeName = function () {
        if (typeof this.order === 'undefined') {
            return;
        }
        if (this.order.hasOwnProperty('naziv')) {
            this.name = this.order.naziv;
        }
        else {
            if (this.mode === FormModeEnum.Add) {
                this.name = 'Novi Korisnik';
            }
            else if (this._order.hasOwnProperty('id')) {
                this.name = 'Profil';
            }
        }
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.settingsLoadSingle = function () {
        var /** @type {?} */ data = [{
                'title': 'Profil',
                'group': 'Profil',
                'deletable': true,
                'documentType': 'sifarnik',
                'fetchObject': 'basic',
                'lazyListSource': 'mainAndSecond',
                'formCode': 'MF5',
                'idProperty': 'id',
                'completerMainField': 'sifra',
                'completerSecondField': 'naziv',
                'completerMainAndSecond': true,
                'name': 'Main',
                'type': 'main',
                'editable': true,
                'additable': true,
                'inlineAdding': false,
                'inlineEditing': false,
                'filterFields': [
                    {
                        'id': '111111111',
                        'name': 'id',
                        'fieldKey': 'id',
                        'label': 'ID',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 10,
                        'dbType': 'VARCHAR(26)',
                        'default': false
                    },
                    {
                        'id': '222222222',
                        'name': 'rbr',
                        'fieldKey': 'rbr',
                        'label': 'Rbr',
                        'type': 'input',
                        'javaFieldType': 'java.lang.Integer',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 5,
                        'dbType': 'INTEGER',
                        'default': false
                    },
                    {
                        'id': '333333333',
                        'name': 'ime',
                        'fieldKey': 'ime',
                        'label': 'Ime',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 50,
                        'dbType': 'VARCHAR(300)',
                        'default': false
                    },
                    {
                        'id': '444444444',
                        'name': 'prezime',
                        'fieldKey': 'prezime',
                        'label': 'Prezime',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 50,
                        'dbType': 'VARCHAR(300)',
                        'default': false
                    },
                    {
                        'id': '5555555555',
                        'name': 'uloga',
                        'fieldKey': 'uloga',
                        'label': 'Uloga',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 120,
                        'dbType': 'VARCHAR(300)',
                        'default': false
                    },
                    {
                        'id': '66666666666',
                        'name': 'email',
                        'fieldKey': 'email',
                        'label': 'e-mail',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 120,
                        'dbType': 'VARCHAR(300)',
                    },
                    {
                        'id': '777777777777',
                        'name': 'sektor',
                        'fieldKey': 'sektor',
                        'label': 'Sektor',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 120,
                        'dbType': 'VARCHAR(300)',
                        'default': false
                    },
                    {
                        'id': '8888888888',
                        'name': 'telefon',
                        'fieldKey': 'telefon',
                        'label': 'Telefon',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 120,
                        'dbType': 'VARCHAR(300)',
                        'default': false
                    }
                ],
                'allFields': [
                    {
                        'id': '111111111',
                        'name': 'id',
                        'fieldKey': 'id',
                        'label': 'ID',
                        'type': 'input',
                        'javaFieldType': 'java.lang.Long',
                        'editable': false,
                        'additable': false,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 10,
                        'dbType': 'BIGINT'
                    },
                    {
                        'id': '222222222',
                        'name': 'rbr',
                        'fieldKey': 'rbr',
                        'label': 'Rbr',
                        'type': 'input',
                        'javaFieldType': 'java.lang.Integer',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 5,
                        'dbType': 'INTEGER'
                    },
                    {
                        'id': '333333333',
                        'name': 'ime',
                        'fieldKey': 'ime',
                        'label': 'Ime',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': true,
                        'path': 'Users',
                        'width': 50,
                        'dbType': 'VARCHAR(300)'
                    },
                    {
                        'id': '444444444',
                        'name': 'prezime',
                        'fieldKey': 'prezime',
                        'label': 'Prezime',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 50,
                        'dbType': 'VARCHAR(300)',
                    },
                    {
                        'id': '5555555555',
                        'name': 'uloga',
                        'fieldKey': 'uloga',
                        'label': 'Uloga',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 120,
                        'dbType': 'VARCHAR(300)',
                    },
                    {
                        'id': '66666666666',
                        'name': 'email',
                        'fieldKey': 'email',
                        'label': 'e-mail',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 120,
                        'dbType': 'VARCHAR(300)',
                    },
                    {
                        'id': '777777777777',
                        'name': 'sektor',
                        'fieldKey': 'sektor',
                        'label': 'Sektor',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 120,
                        'dbType': 'VARCHAR(300)',
                    },
                    {
                        'id': '8888888888',
                        'name': 'telefon',
                        'fieldKey': 'telefon',
                        'label': 'Telefon',
                        'type': 'input',
                        'javaFieldType': 'java.lang.String',
                        'editable': true,
                        'additable': true,
                        'mandatory': false,
                        'path': 'Users',
                        'width': 120,
                        'dbType': 'VARCHAR(300)',
                    }
                ],
                'formSettings': {
                    'header': [
                        {
                            'title': 'Podaci',
                            'panels': [
                                {
                                    'title': 'Panel 1',
                                    'panelVisible': false,
                                    'expanded': true,
                                    'controls': [
                                        [
                                            //  '222222222',
                                            '111111111',
                                            '444444444',
                                            '333333333',
                                            '5555555555',
                                            '66666666666',
                                            '777777777777',
                                            '8888888888'
                                        ],
                                        []
                                    ]
                                }
                            ]
                        }
                    ],
                    'table': [
                        '222222222',
                        '111111111',
                        '444444444',
                        '333333333',
                        '5555555555',
                    ],
                    'lookupTable': [
                        '111111111',
                        '444444444',
                        '333333333',
                        '222222222',
                        '5555555555',
                        '66666666666'
                    ]
                },
                'relations': [],
                'details': [
                    {
                        'title': 'Korisnici',
                        'group': 'Users',
                        'deletable': true,
                        'documentType': 'sifarnik',
                        'fetchObject': 'basic',
                        'lazyListSource': 'mainAndSecond',
                        'completerMainField': 'id',
                        'completerSecondField': 'rbr',
                        'completerMainAndSecond': true,
                        'name': 'Main',
                        'type': 'main',
                        'editable': true,
                        'additable': true,
                        'inlineAdding': true,
                        'inlineEditing': true,
                        'filterFields': [
                            {
                                'id': '1668898846',
                                'name': 'id',
                                'entityType': 'id',
                                'label': 'ID',
                                'type': 'completer',
                                'javaFieldType': 'id',
                                'editable': true,
                                'additable': true,
                                'mandatory': false,
                                'path': 'Users',
                                'width': 92,
                                'dbType': 'BIGINT',
                                'default': false
                            }
                        ],
                        'allFields': [
                            {
                                'id': '111111111',
                                'name': 'id',
                                'fieldKey': 'id',
                                'label': 'ID',
                                'type': 'input',
                                'javaFieldType': 'java.lang.Long',
                                'editable': false,
                                'additable': false,
                                'mandatory': false,
                                'path': 'Users',
                                'width': 20,
                                'dbType': 'BIGINT'
                            },
                            {
                                'id': '333333333',
                                'name': 'ime',
                                'fieldKey': 'ime',
                                'label': 'Ime',
                                'type': 'input',
                                'javaFieldType': 'java.lang.String',
                                'editable': true,
                                'additable': true,
                                'mandatory': true,
                                'path': 'Users',
                                'width': 50,
                                'dbType': 'VARCHAR(300)'
                            },
                            {
                                'id': '444444444',
                                'name': 'prezime',
                                'fieldKey': 'prezime',
                                'label': 'Prezime',
                                'type': 'input',
                                'javaFieldType': 'java.lang.String',
                                'editable': true,
                                'additable': true,
                                'mandatory': false,
                                'path': 'Users',
                                'width': 50,
                                'dbType': 'VARCHAR(300)',
                            },
                            {
                                'id': '5555555555',
                                'name': 'uloga',
                                'fieldKey': 'uloga',
                                'label': 'Uloga',
                                'type': 'input',
                                'javaFieldType': 'java.lang.String',
                                'editable': true,
                                'additable': true,
                                'mandatory': false,
                                'path': 'Users',
                                'width': 120,
                                'dbType': 'VARCHAR(300)',
                            },
                            {
                                'id': '66666666666',
                                'name': 'email',
                                'fieldKey': 'email',
                                'label': 'e-mail',
                                'type': 'input',
                                'javaFieldType': 'java.lang.String',
                                'editable': true,
                                'additable': true,
                                'mandatory': false,
                                'path': 'Users',
                                'width': 120,
                                'dbType': 'VARCHAR(300)',
                            },
                            {
                                'id': '777777777777',
                                'name': 'sektor',
                                'fieldKey': 'sektor',
                                'label': 'Sektor',
                                'type': 'input',
                                'javaFieldType': 'java.lang.String',
                                'editable': true,
                                'additable': true,
                                'mandatory': false,
                                'path': 'Users',
                                'width': 120,
                                'dbType': 'VARCHAR(300)',
                            },
                            {
                                'id': '8888888888',
                                'name': 'telefon',
                                'fieldKey': 'telefon',
                                'label': 'Telefon',
                                'type': 'input',
                                'javaFieldType': 'java.lang.String',
                                'editable': true,
                                'additable': true,
                                'mandatory': false,
                                'path': 'Users',
                                'width': 120,
                                'dbType': 'VARCHAR(300)',
                            }
                        ],
                        'formSettings': {
                            'header': [
                                {
                                    'title': 'Podaci',
                                    'panels': [
                                        {
                                            'title': 'Panel 1',
                                            'panelVisible': false,
                                            'expanded': true,
                                            'controls': [
                                                [
                                                    '1668898846'
                                                ],
                                                []
                                            ]
                                        }
                                    ]
                                }
                            ],
                            'table': [
                                '1668898846'
                            ],
                            'lookupTable': [
                                '1668898846'
                            ]
                        },
                        'relations': [],
                        '_id': '1932507674'
                    }
                ],
                '_id': '2075692643'
            }];
        var /** @type {?} */ settingsData = data[0];
        this.fieldStructure = new FieldStructure(settingsData, 'header');
        this.settingsTable = new TableSettings(settingsData, 'table');
        this.settingsFilter = new FilterSettings(settingsData);
        if (data.length > 0 && data[0].hasOwnProperty('details')) {
            this.settingsTableDetails = new TableSettings(settingsData['details'][0], 'table');
            this.fieldDetailsResurs = this.settingsTableDetails.getFieldByName('Resurs');
            // this.fieldDetailsResurs.lookupFilter = new ServiceFilterTerm(ServiceFilterOperandEnum.AND, [
            //   new ServiceFilterSymbol('Resurs.VrstaResursa', 'tipResursa', '=', TipResursaEnum.ObjektiOprema)
            // ]);
        }
        this.setAllFields();
        this.firstTableLoad();
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.refreshTable = function () {
        var /** @type {?} */ data = {
            'documentId': 'PROFIL',
            'result': this.podaci,
            'pageSize': 10,
            'pageNumber': 1,
            'count': this.podaci.length,
            'menuCalled': false,
            'error': 0
        };
        for (var /** @type {?} */ i = 0; i < this.podaci.length; i++) {
            this.podaci[i].rbr = i + 1;
        }
        this.orderListCount = data.count;
        this.orderList = data.result;
        this.documentListSource.next(data);
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.isValid = function () {
        // let detailsValid = true;
        // this.details.forEach((child) => {
        //   if (!child.isDetailsValid()) {
        //     detailsValid = false;
        //   }
        // });
        // let tableValid = true;
        // this.tables.forEach((child) => {
        //   if (child.tableMode === TableModeEnum.Details && !child.isTableValid()) {
        //     tableValid = false;
        //   }
        // });
        // if (tableValid && !detailsValid) {
        //   this.notificationService.openNoty('Nisu sva polja validna!');
        // }
        // if (!tableValid || !detailsValid) {
        //   return false;
        // }
        // return true;
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.updateOrder = function () {
        var _this = this;
        /* #region old update*/
        // if (!this.isValid()) {
        //   return;
        // }
        // this.backendService.editOrder(this.identity.documentId, this.order, this.authenticationService.getUser().username).subscribe(
        //   data => {
        //     console.log(data);
        //     this.notificationService.openNoty('Uspešno editovanje');
        //     this.order = data;
        //     this.refreshTable();
        //     this.modeChange(FormModeEnum.View);
        //   },
        //   error => {
        //     console.log(error);
        //   }
        // );
        /* #endregion */
        try {
            var /** @type {?} */ toUpdate = this.podaci.find(function (u) { return u.id === _this.order.id; });
            console.log("OLD " + toUpdate);
            for (var /** @type {?} */ key in toUpdate) {
                if (this.order.hasOwnProperty(key)) {
                    toUpdate[key] === this.order[key];
                }
            }
            this.notificationService.openNoty('Uspešno ažuriranje.');
            this.refreshTable();
            console.log("NEW " + toUpdate);
        }
        catch ( /** @type {?} */error) {
            this.notificationService.notifyError('Grška prilikom ažuriranja.');
        }
        this.modeChange(FormModeEnum.View);
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.addOrder = function () {
        // if (!this.isValid()) {
        //   return;
        // }
        /* #region old add */
        // this.backendService.addOrder(this.identity.documentId, this.order, this.authenticationService.getUser().username).subscribe(
        //   data => {
        //     console.log(data);
        //     this.notificationService.openNoty('Uspešno dodavanje');
        //     this.refreshTable();
        //     this.order = data;
        //     this.modeChange(FormModeEnum.View);
        //   },
        //   error => {
        //     console.log(error);
        //   }
        // );
        /* #endregion */
        try {
            var /** @type {?} */ toAdd = this.order;
            toAdd.id = +this.orderList[this.orderList.length - 1].id + 1;
            this.podaci.push(this.order);
            this.notificationService.openNoty('Uspešno dodavanje');
            this.refreshTable();
            console.log(toAdd);
        }
        catch ( /** @type {?} */error) {
            console.log(error);
            this.notificationService.notifyError('Desila se greška prilikom dodavanja.');
        }
        this.modeChange(FormModeEnum.View);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ProfileComponent.prototype.onDelete = function (event) {
        var /** @type {?} */ that = this;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.modalService.openModal(MessagesEnum.DeleteSifarnik, function (response) {
            if (response) {
                that.onDeleteConfirm();
            }
        });
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.onDeleteConfirm = function () {
        var _this = this;
        var /** @type {?} */ index = this.podaci.findIndex(function (u) { return u.id === _this.order.id; });
        this.podaci.splice(index, 1);
        this.notificationService.openNoty('Uspešno brisanje');
        if (FormModeEnum.View) {
            this.modeChange(FormModeEnum.Table);
        }
        this.refreshTable();
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.settingsLoadSingle();
        this.order = this.podaci[0];
        this.modeChange(FormModeEnum.View);
        this.settingsChangedSubscription = this.backendService.settingsChanged.subscribe(function (settingsData) {
            if (_this.settingsTable.documentId === settingsData['group']) {
                _this.settingsTable = new TableSettings(settingsData, 'table');
            }
        });
    };
    /**
     * @return {?}
     */
    ProfileComponent.prototype.ngOnDestroy = function () {
        if (this.settingsChangedSubscription) {
            this.settingsChangedSubscription.unsubscribe();
        }
    };
    return ProfileComponent;
}(PageBase));
ProfileComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-profile',
                template: "\n    <div *ngIf=\"mode !== FormModeEnum.Table\"\n         class=\"panel panel-default edit add view\">\n      <div class=\"panel-body edit\">\n        <util-details [mode]=\"mode\"\n                      [fieldStructure]=\"fieldStructure\"\n                      [documentData]=\"order\">\n        </util-details>\n        <util-table [ident]=\"'rbr'\"\n                    [tableMode]=\"TableModeEnum.Details\"\n                    [mode]=\"mode\"\n                    [settings]=\"settingsTableDetails\"\n                    [orderList]=\"orderListDetails\"\n                    (tableAction)=\"itemsTableDetailsAction($event)\"\n                    [paging]=\"false\">\n        </util-table>\n      </div>\n    </div>\n  ",
                styles: ["\n\n  "]
            },] },
];
/**
 * @nocollapse
 */
ProfileComponent.ctorParameters = function () { return [
    { type: BackendService, },
    { type: AuthenticationService, },
    { type: NotificationService, },
    { type: ModalService, },
]; };
var HeaderComponent = /** @class */ (function () {
    /**
     * @param {?} authenticationService
     * @param {?} _applicationService
     * @param {?} messageService
     * @param {?} modalService
     */
    function HeaderComponent(authenticationService, _applicationService, messageService, modalService) {
        this.authenticationService = authenticationService;
        this._applicationService = _applicationService;
        this.messageService = messageService;
        this.modalService = modalService;
        this.dummyEmails = [];
        this.newMessages = 0;
        // tabData = new OpenTabData('Poruke', 'PORUKE', DocumentTypeEnum.Sifarnik, 'PORUKE', 'Poruke', MessagesComponent);
        this.tabData = new OpenTabData('Profil', 'PROFIL', DocumentTypeEnum.Sifarnik, 'Profil', 'PROFIL', ProfileComponent);
    }
    /**
     * @return {?}
     */
    HeaderComponent.prototype.registerHandlers = function () {
        this.unsubscribeListeners();
        // this.messageLeftSubscription = this.messageService.messageLeftEvent.subscribe(
        //     (data: any) => {
        //         if (data) {
        //             this.countMessages(data);
        //         }
        //     },
        //     error => {
        //     }
        // );
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.logout = function () {
        var _this = this;
        this.modalService.openModal('Da li želite da napustite aplikaciju?', function (response) {
            if (response) {
                _this.authenticationService.emitLogout().subscribe(function () {
                    _this.authenticationService.logout().subscribe(function () {
                        sessionStorage.removeItem('currentUser');
                        sessionStorage.removeItem('token');
                        window.location.href = window.location.origin + '/login';
                    });
                });
            }
        });
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.mojProfil = function () {
        this._applicationService.openTab(this.tabData);
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.ngOnInit = function () {
        // let height = 0;
        // const applications = this.authenticationService.getUser().applications;
        // if (applications.hasOwnProperty('beyondOffice') && applications['beyondOffice']) {
        //     height += 70;
        // }
        // if (applications.hasOwnProperty('beyondBasic') && applications['beyondBasic']) {
        //     height += 70;
        // }
        // if (applications.hasOwnProperty('beyondPartners') && applications['beyondPartners']) {
        //     height += 70;
        // }
        // if (applications.hasOwnProperty('beyondManufacturing') && applications['beyondManufacturing']) {
        //     height += 70;
        // }
        // if (applications.hasOwnProperty('Smarts') && applications['Smarts']) {
        //     height += 70;
        // }
        // this.height = height + 'px';
        this._applicationService.registerViewComponent('Profil', 'PROFIL', DocumentTypeEnum.Sifarnik, 'Profil', 'PROFIL', ProfileComponent);
        this.registerHandlers();
        // this.getMessage();
        // TODO iskljuceno dok se ne srede server i klijent
        // this.messagesInterval = setInterval(() => {
        //     this.getMessage();
        // }, 30000);
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeListeners();
        // clearInterval(this.messagesInterval);
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.unsubscribeListeners = function () {
        if (this.messageLeftSubscription) {
            this.messageLeftSubscription.unsubscribe();
        }
    };
    return HeaderComponent;
}());
HeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-header',
                template: "\n      <!-- START X-NAVIGATION VERTICAL -->\n      <ul class=\"x-navigation x-navigation-horizontal x-navigation-panel\">\n          <li class=\"xn-icon-button\">\n              <a href=\"#\" class=\"x-navigation-minimize\"><span class=\"fa fa-dedent\"></span></a>\n          </li>\n          <li (click)=\"logout()\" class=\"xn-icon-button pull-right last\">\n              <a href=\"javascript:void(0)\" (click)=\"logout()\"><span (click)=\"logout()\" class=\"fa fa-power-off\"></span></a>\n          </li>\n          <!-- <li class=\"xn-icon-button pull-right\">\n              <a href=\"javascript:void(0)\"><span class=\"fa fa-gear\"></span></a>\n              <div class=\"panel panel-primary animated zoomIn xn-drop-left xn-panel-dragging\">\n                  <div class=\"panel-heading\">\n                      <h3 class=\"panel-title\"><span class=\"fa fa-laptop\"></span> Aplikacije</h3>\n                  </div>\n                  <div class=\"panel-body list-group list-group-contacts scroll\" [style.height]=\"height\">\n                      <a href=\"javascript:void(0)\" (click)=\"switchToIdentity()\" class=\"list-group-item\">\n                          <img src=\"assets/img/beyond_identity_black.png\">\n                      </a>\n                      <a *ngIf=\"hasApp('beyondOffice')\" href=\"javascript:void(0)\"\n                         (click)=\"switchToOffice()\" class=\"list-group-item\">\n                          <img src=\"assets/img/beyond-office-black.png\">\n                      </a>\n                      <a *ngIf=\"app['group'] !== 'partners' && hasApp('beyondPartners')\" href=\"javascript:void(0)\"\n                         (click)=\"switchToPartners()\" class=\"list-group-item\">\n                          <img src=\"assets/img/beyond_partners_black.png\">\n                      </a>\n                      <a *ngIf=\"app['group'] !== 'basic' && hasApp('beyondBasic')\" href=\"javascript:void(0)\"\n                         (click)=\"switchToBasic()\" class=\"list-group-item\">\n                          <img src=\"assets/img/beyond_basic_black.png\">\n                      </a>\n                      <a *ngIf=\"app['group'] !== 'manufacturing' && hasApp('beyondManufacturing')\" href=\"javascript:void(0)\"\n                         (click)=\"switchToManufacturing()\" class=\"list-group-item\">\n                          <img src=\"assets/img/beyond_manufacturing_black.png\">\n                      </a>\n                  </div>\n              </div>\n          </li> -->\n          <!-- <li class=\"xn-icon-button pull-right messages-popup-wrapper\">\n              <div *ngIf=\"newMessages\" class=\"informer informer-danger\">{{newMessages}}</div>\n              <div class=\"panel panel-primary animated zoomIn xn-drop-left xn-panel-dragging\">\n                  <div class=\"panel-heading\">\n                      <h3 class=\"panel-title\"><span class=\"fa fa-comments\"></span> Poruke</h3>                                \n                      <div class=\"pull-right\">\n                          <span *ngIf=\"newMessages\" class=\"label label-danger\">{{newMessages}} nove</span>\n                      </div>\n                  </div>\n                  <div class=\"panel-body list-group list-group-contacts scroll\" style=\"height: 200px;\">\n                      <a href=\"javascript:void(0)\" class=\"list-group-item\" *ngFor=\"let message of dummyEmails\" (click)=\"showSelectedMessage(message)\">\n                          <div class=\"list-group-status status-online\"></div>\n                          <img src=\"assets/images/users/no-image.jpg\" class=\"pull-left\" alt=\"John Doe\"/>\n                          <div class=\"message-contact-message\">\n                              <div class=\"contacts-title\">{{message.senderUsername}}</div>\n                              <div class=\"message-message\">{{message.message}}</div>\n                          </div>\n                      </a>\n                  </div>     \n                  <div class=\"panel-footer text-center\">\n                      <a href=\"javascript:void(0)\" (click)=\"showAllMessages()\">Prika\u017Ei sve poruke</a>\n                  </div>                            \n              </div>                        \n          </li> -->\n      </ul>\n      <!-- END X-NAVIGATION VERTICAL -->\n    "
            },] },
];
/**
 * @nocollapse
 */
HeaderComponent.ctorParameters = function () { return [
    { type: AuthenticationService, },
    { type: ApplicationService, },
    { type: MessageService, },
    { type: ModalService, },
]; };
HeaderComponent.propDecorators = {
    'app': [{ type: Input },],
};
var SearchService = /** @class */ (function () {
    function SearchService() {
        this.searchTriggeredEvent = new EventEmitter();
    }
    /**
     * @param {?} terms
     * @return {?}
     */
    SearchService.prototype.search = function (terms) {
        return terms.debounceTime(400)
            .distinctUntilChanged();
    };
    /**
     * @param {?} term
     * @return {?}
     */
    SearchService.prototype.triggerSearch = function (term) {
        this.searchTriggeredEvent.emit(term);
    };
    return SearchService;
}());
SearchService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
SearchService.ctorParameters = function () { return []; };
SearchService.propDecorators = {
    'searchTriggeredEvent': [{ type: Output },],
};
var HeaderModule = /** @class */ (function () {
    function HeaderModule() {
    }
    return HeaderModule;
}());
HeaderModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    HeaderComponent
                ],
                entryComponents: [],
                imports: [
                    CommonModule,
                    HttpClientModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService,
                    SearchService,
                    MessageService
                ],
                exports: [HeaderComponent]
            },] },
];
/**
 * @nocollapse
 */
HeaderModule.ctorParameters = function () { return []; };
var SidebarComponent = /** @class */ (function () {
    /**
     * @param {?} router
     * @param {?} authenticationService
     * @param {?} applicationService
     * @param {?} searchService
     */
    function SidebarComponent(router$$1, authenticationService, applicationService, searchService) {
        var _this = this;
        this.router = router$$1;
        this.authenticationService = authenticationService;
        this.applicationService = applicationService;
        this.searchService = searchService;
        this.filteredText = '';
        this.searchTerm$ = new Subject$1();
        this.containsDeep = function (text) { return function (value) {
            if (value.hasOwnProperty('subitems')) {
                return value.subitems.some(_this.containsDeep(text));
            }
            else {
                return value.text.toLowerCase().indexOf(text.toLowerCase()) > -1;
            }
        }; };
        this.searchService.search(this.searchTerm$)
            .subscribe(function (results) {
            _this.searchService.triggerSearch(results);
        });
    }
    /**
     * @return {?}
     */
    SidebarComponent.prototype.registerHandlers = function () {
        var _this = this;
        this.unsubscribeListeners();
        this.menuDataChangeSubscription = this.applicationService.menuDataChangeEvent.subscribe(function (data) {
            _this.menu = data;
            _this.filterMenu('', _this.menu);
            _this.setMenu();
        }, function (error) {
        });
        this.searchTermChangeSubscription = this.searchService.searchTriggeredEvent.subscribe(function (text) {
            _this.filterMenu(text, _this.menu);
            setTimeout(function () {
                if (text === '') {
                    $('.xn-openable').removeClass('active');
                }
                else {
                    $('.xn-openable').addClass('active');
                }
            }, 0);
        }, function (error) {
        });
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.resetSearch = function () {
        this.filteredText = '';
        this.searchTerm$.next(this.filteredText);
    };
    /**
     * @param {?} text
     * @param {?} filteredMenu
     * @return {?}
     */
    SidebarComponent.prototype.filterMenu = function (text, filteredMenu) {
        if (filteredMenu.hasOwnProperty('subitems')) {
            for (var /** @type {?} */ i = 0; i < filteredMenu.subitems.length; i++) {
                if (filteredMenu.subitems[i].hasOwnProperty('subitems')) {
                    if (filteredMenu.subitems[i].subitems.filter(this.containsDeep(text)).length === 0) {
                        filteredMenu.subitems[i]['show'] = false;
                    }
                    else {
                        filteredMenu.subitems[i]['show'] = true;
                        this.filterMenu(text, filteredMenu.subitems[i]);
                    }
                }
                else {
                    if (filteredMenu.subitems[i].text.toLowerCase().indexOf(text.toLowerCase()) === -1) {
                        filteredMenu.subitems[i]['show'] = false;
                    }
                    else {
                        filteredMenu.subitems[i]['show'] = true;
                    }
                }
            }
        }
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.setMenu = function () {
        var /** @type {?} */ script = document.createElement('script');
        script = document.createElement('script');
        script.setAttribute('src', 'assets/js/plugins.js');
        document.body.appendChild(script);
        script = document.createElement('script');
        script.setAttribute('src', 'assets/js/actions.js');
        document.body.appendChild(script);
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.getHomePage = function () {
        return 'Dobrodošli na ' + this.app['name'];
    };
    /**
     * @param {?} event
     * @param {?} subitem
     * @return {?}
     */
    SidebarComponent.prototype.navigateToHome = function (event, subitem) {
        if (subitem.hasOwnProperty('subitems')) {
            return;
        }
        $('.page-sidebar li').each(function (index) {
            if ($(this).has(event.target).length === 0) {
                $(this).removeClass('active');
            }
        });
        $(event.target).parent().addClass('active');
        this.applicationService.sidebarItemOpen(subitem);
        if (this.app['group'] === 'basic') {
            this.router.navigate(['pages/basics'], {
                queryParams: {
                    token: this.token,
                    group: subitem.name.toLocaleString()
                }
            });
        }
        else {
            this.router.navigate(['pages/partners'], {
                queryParams: {
                    token: this.token,
                    group: subitem.name.toLocaleString()
                }
            });
        }
    };
    /**
     * @param {?} event
     * @param {?} i
     * @return {?}
     */
    SidebarComponent.prototype.navigateOutsideHome = function (event, i) {
        this.router.navigate(['pages/progress'], { queryParams: { token: this.token } }).then(function () {
            setTimeout(function (self) {
                $('.page-sidebar li').each(function (index) {
                    if ($(this).has($('.' + i).parent()[0]).length !== 0) {
                        $(this).addClass('active');
                    }
                    else {
                        $(this).removeClass('active');
                    }
                });
                $('.' + i).parent().addClass('active');
            }, 10, this);
        });
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.ngOnInit = function () {
        this.setNameOnSidebar();
        this.registerHandlers();
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.setNameOnSidebar = function () {
        this.fullname = this.authenticationService.getFullName();
        this.role = this.authenticationService.getUloge();
        this.token = this.authenticationService.getToken();
        this.imagePath = 'assets/images/users/avatar.png'; // TODO: Nemam puno vremena da razmisljam o slici, verovatno je treba ukloniti. :D
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeListeners();
    };
    /**
     * @return {?}
     */
    SidebarComponent.prototype.unsubscribeListeners = function () {
        if (this.menuDataChangeSubscription) {
            this.menuDataChangeSubscription.unsubscribe();
        }
        if (this.searchTermChangeSubscription) {
            this.searchTermChangeSubscription.unsubscribe();
        }
    };
    return SidebarComponent;
}());
SidebarComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-sidebar',
                template: "\n      <div class=\"page-sidebar scroll\">\n      <ul class=\"x-navigation\">\n              <li class=\"xn-logo\">\n                  <a href=\"javascript:void(0)\">Beyond Basic</a>\n                  <a href=\"javascript:void(0)\" class=\"x-navigation-control\"></a>\n              </li>\n              <li class=\"xn-profile\">\n                  <a href=\"javascript:void(0)\" class=\"profile-mini\">\n                      <img src=\"{{imagePath}}\"/>\n                  </a>\n                  <div class=\"profile\">\n                      <div class=\"profile-data\">\n                          <div class=\"profile-data-name\">{{fullname}}</div>\n                          <div class=\"profile-data-title\">{{role}}</div>\n                      </div>\n                      <div class=\"profile-controls\">\n                          <a href=\"javascript:void(0)\" class=\"profile-control-left\"><span class=\"fa fa-info\"></span></a>\n                          <a href=\"javascript:void(0)\" class=\"profile-control-right\"><span class=\"fa fa-envelope\"></span></a>\n                      </div>\n                  </div>\n              </li>\n              <!-- <li class=\"xn-search\">\n                  <form role=\"form\">\n                      <input type=\"text\"\n                             (keyup)='searchTerm$.next($event.target.value)'\n                             name=\"search\"\n                             autocomplete=\"off\"\n                             [(ngModel)]=\"filteredText\"\n                             [ngModelOptions]=\"{standalone:true}\"\n                             placeholder=\"Search...\"/>\n                      <span class=\"fa fa-times-circle\"\n                            *ngIf=\"filteredText !== ''\"\n                            (click)=\"resetSearch()\"></span>\n                  </form>\n              </li> -->\n              <li *ngFor=\"let subitem of menu?.subitems\"\n                  [ngClass]=\"{'xn-openable': subitem.show}\">\n                  <a href=\"javascript:void(0)\" *ngIf=\"subitem.show\">\n                      <span class=\"fa fa-files-o\"></span>\n                      <span class=\"xn-text\">{{subitem['text']}}</span>\n                  </a>\n                  <ul *ngIf=\"subitem.show\">\n                      <li *ngFor=\"let subitem1 of subitem.subitems\"\n                          [ngClass]=\"{'xn-openable': subitem1.hasOwnProperty('subitems') && subitem1.show}\">\n                          <a href=\"javascript:void(0)\" *ngIf=\"subitem1.show\"\n                             (click)=\"navigateToHome($event, subitem1)\">\n                              <span class=\"fa fa-file\"></span>\n                              {{subitem1['text']}}\n                          </a>\n                          <ul *ngIf=\"subitem1.show\">\n                              <li *ngFor=\"let subitem2 of subitem1.subitems\"\n                                  [ngClass]=\"{'xn-openable': subitem2.hasOwnProperty('subitems') && subitem2.show}\">\n                                  <a href=\"javascript:void(0)\" *ngIf=\"subitem2.show\"\n                                     [className]=\"subitem2.code\"\n                                     (click)=\"navigateToHome($event, subitem2)\">\n                                      <span class=\"fa fa-sitemap\"></span>\n                                      {{subitem2['text']}}\n                                  </a>\n                                  <ul *ngIf=\"subitem2.show\">\n                                      <li *ngFor=\"let subitem3 of subitem2.subitems\"\n                                          [ngClass]=\"{'xn-openable': subitem3.hasOwnProperty('subitems') && subitem3.show}\">\n                                          <a href=\"javascript:void(0)\" *ngIf=\"subitem3.show\"\n                                             [className]=\"subitem3.code\"\n                                             (click)=\"navigateToHome($event, subitem3)\">\n                                              <span class=\"fa fa-sitemap\"></span>\n                                              {{subitem3['text']}}\n                                          </a>\n                                          <ul *ngIf=\"subitem3.show\">\n                                              <li *ngFor=\"let subitem4 of subitem3.subitems\"\n                                                  [ngClass]=\"{'xn-openable': subitem4.hasOwnProperty('subitems') && subitem4.show}\">\n                                                  <a href=\"javascript:void(0)\" *ngIf=\"subitem4.show\"\n                                                     [className]=\"subitem4.code\"\n                                                     (click)=\"navigateToHome($event, subitem4)\">\n                                                      <span class=\"fa fa-sitemap\"></span>\n                                                      {{subitem4['text']}}\n                                                  </a>\n                                                  <ul *ngIf=\"subitem4.show\">\n                                                      <li *ngFor=\"let subitem5 of subitem4.subitems\"\n                                                          [ngClass]=\"{'xn-openable': subitem5.hasOwnProperty('subitems') && subitem5.show}\">\n                                                          <a href=\"javascript:void(0)\" *ngIf=\"subitem5.show\"\n                                                             [className]=\"subitem5.code\"\n                                                             (click)=\"navigateToHome($event, subitem5)\">\n                                                              <span class=\"fa fa-sitemap\"></span>\n                                                              {{subitem5['text']}}\n                                                          </a>\n                                                          <ul *ngIf=\"subitem5.show\">\n                                                              <li *ngFor=\"let subitem6 of subitem5.subitems\">\n                                                                  <a href=\"javascript:void(0)\" *ngIf=\"subitem6.show\"\n                                                                     [className]=\"subitem6.code\"\n                                                                     (click)=\"navigateToHome($event, subitem6)\">\n                                                                      <span class=\"fa fa-sitemap\"></span>\n                                                                      {{subitem6['text']}}\n                                                                  </a>\n                                                              </li>\n                                                          </ul>\n                                                      </li>\n                                                  </ul>\n                                              </li>\n                                          </ul>\n                                      </li>\n                                  </ul>\n                              </li>\n                          </ul>\n                      </li>\n                  </ul>\n              </li>\n          </ul>\n\n          <div class=\"expanded-version\">\n              <div *ngIf=\"verzija\" class=\"verzija\">\n                  Verzija {{ verzija }}\n              </div>\n\n              <div *ngIf=\"datum\" class=\"datum\">\n                  {{ datum }}\n              </div>\n          </div>\n\n          <div *ngIf=\"!datum\" class=\"collapsed-version verzija\" style=\"display: none;\">\n              <button type=\"button\" class=\"btn btn-default\">\n                  <span class=\"fa fa-info\"></span>\n              </button>\n          </div>\n\n          <div *ngIf=\"datum\" class=\"collapsed-version verzija\" title=\"Verzija: {{ verzija }} Datum: {{ datum }}\" style=\"display: none;\">\n              <button type=\"button\" class=\"btn btn-default\">\n                  <span class=\"fa fa-info\"></span>\n              </button>\n          </div>\n      </div>\n    "
            },] },
];
/**
 * @nocollapse
 */
SidebarComponent.ctorParameters = function () { return [
    { type: Router, },
    { type: AuthenticationService, },
    { type: ApplicationService, },
    { type: SearchService, },
]; };
SidebarComponent.propDecorators = {
    'app': [{ type: Input },],
    'verzija': [{ type: Input },],
    'datum': [{ type: Input },],
};
var SidebarModule = /** @class */ (function () {
    function SidebarModule() {
    }
    return SidebarModule;
}());
SidebarModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    SidebarComponent
                ],
                entryComponents: [],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService
                ],
                exports: [SidebarComponent]
            },] },
];
/**
 * @nocollapse
 */
SidebarModule.ctorParameters = function () { return []; };
var ToolbarItemStyle = {};
ToolbarItemStyle.Default = /** @type {?} */ ('default');
ToolbarItemStyle.Add = /** @type {?} */ ('add');
ToolbarItemStyle.Save = /** @type {?} */ ('save');
ToolbarItemStyle.Cancel = /** @type {?} */ ('cancel');
ToolbarItemStyle.Edit = /** @type {?} */ ('edit');
ToolbarItemStyle.Delete = /** @type {?} */ ('delete');
ToolbarItemStyle.Copy = /** @type {?} */ ('copy');
ToolbarItemStyle.Accept = /** @type {?} */ ('accept');
ToolbarItemStyle.Settings = /** @type {?} */ ('settings');
ToolbarItemStyle.Custom = /** @type {?} */ ('custom');
ToolbarItemStyle.Back = /** @type {?} */ ('back');
ToolbarItemStyle.Filter = /** @type {?} */ ('filter');
ToolbarItemStyle.Unlock = /** @type {?} */ ('unlock');
ToolbarItemStyle.Download = /** @type {?} */ ('download');
ToolbarItemStyle.Check = /** @type {?} */ ('check');
ToolbarItemStyle.Eye = /** @type {?} */ ('eye');
ToolbarItemStyle[ToolbarItemStyle.Default] = "Default";
ToolbarItemStyle[ToolbarItemStyle.Add] = "Add";
ToolbarItemStyle[ToolbarItemStyle.Save] = "Save";
ToolbarItemStyle[ToolbarItemStyle.Cancel] = "Cancel";
ToolbarItemStyle[ToolbarItemStyle.Edit] = "Edit";
ToolbarItemStyle[ToolbarItemStyle.Delete] = "Delete";
ToolbarItemStyle[ToolbarItemStyle.Copy] = "Copy";
ToolbarItemStyle[ToolbarItemStyle.Accept] = "Accept";
ToolbarItemStyle[ToolbarItemStyle.Settings] = "Settings";
ToolbarItemStyle[ToolbarItemStyle.Custom] = "Custom";
ToolbarItemStyle[ToolbarItemStyle.Back] = "Back";
ToolbarItemStyle[ToolbarItemStyle.Filter] = "Filter";
ToolbarItemStyle[ToolbarItemStyle.Unlock] = "Unlock";
ToolbarItemStyle[ToolbarItemStyle.Download] = "Download";
ToolbarItemStyle[ToolbarItemStyle.Check] = "Check";
ToolbarItemStyle[ToolbarItemStyle.Eye] = "Eye";
var ToolbarItem = /** @class */ (function () {
    /**
     * @param {?} label
     * @param {?} action
     * @param {?} style
     * @param {?} visible
     * @param {?} enabled
     * @param {?=} title
     */
    function ToolbarItem(label, action, style, visible, enabled, title) {
        if (title === void 0) { title = null; }
        this.label = label;
        this.action = action;
        this.style = style;
        this.visible = visible;
        this.enabled = enabled;
        this.title = title;
    }
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} title
     * @param {?=} label
     * @return {?}
     */
    ToolbarItem.ItemAdd = function (visible, enabled, title, label) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (title === void 0) { title = null; }
        return new ToolbarItem(label, ToolbarAction.Add, ToolbarItemStyle.Add, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} title
     * @return {?}
     */
    ToolbarItem.ItemSave = function (visible, enabled, title) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (title === void 0) { title = null; }
        return new ToolbarItem('Sačuvaj', ToolbarAction.Save, ToolbarItemStyle.Save, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} title
     * @return {?}
     */
    ToolbarItem.ItemCancel = function (visible, enabled, title) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (title === void 0) { title = null; }
        return new ToolbarItem('Otkaži', ToolbarAction.Cancel, ToolbarItemStyle.Cancel, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} title
     * @param {?=} label
     * @return {?}
     */
    ToolbarItem.ItemEdit = function (visible, enabled, title, label) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (title === void 0) { title = null; }
        return new ToolbarItem(label, ToolbarAction.Edit, ToolbarItemStyle.Edit, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} label
     * @param {?=} title
     * @return {?}
     */
    ToolbarItem.ItemDelete = function (visible, enabled, label, title) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (label === void 0) { label = 'Obriši'; }
        if (title === void 0) { title = null; }
        return new ToolbarItem(label, ToolbarAction.Delete, ToolbarItemStyle.Delete, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} title
     * @return {?}
     */
    ToolbarItem.ItemCopy = function (visible, enabled, title) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (title === void 0) { title = null; }
        return new ToolbarItem('Kopiraj', ToolbarAction.Copy, ToolbarItemStyle.Copy, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} title
     * @return {?}
     */
    ToolbarItem.ItemAccept = function (visible, enabled, title) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (title === void 0) { title = null; }
        return new ToolbarItem('Prihvati', ToolbarAction.Accept, ToolbarItemStyle.Accept, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} title
     * @return {?}
     */
    ToolbarItem.ItemSettings = function (visible, enabled, title) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (title === void 0) { title = null; }
        return new ToolbarItem(null, ToolbarAction.Settings, ToolbarItemStyle.Settings, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} title
     * @return {?}
     */
    ToolbarItem.ItemBack = function (visible, enabled, title) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (title === void 0) { title = null; }
        return new ToolbarItem(null, ToolbarAction.Back, ToolbarItemStyle.Back, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @param {?=} title
     * @return {?}
     */
    ToolbarItem.ItemFilter = function (visible, enabled, title) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        if (title === void 0) { title = null; }
        return new ToolbarItem(null, ToolbarAction.Filter, ToolbarItemStyle.Filter, visible, enabled, title);
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @return {?}
     */
    ToolbarItem.ItemAneksiraj = function (visible, enabled) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        return new ToolbarItem('Aneksiraj', ToolbarAction.Aneksiraj, ToolbarItemStyle.Add, visible, enabled, 'Aneksiraj');
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @return {?}
     */
    ToolbarItem.ItemDodajPodugovor = function (visible, enabled) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        return new ToolbarItem('Podugovor', ToolbarAction.Podugovor, ToolbarItemStyle.Add, visible, enabled, 'Podugovor');
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @return {?}
     */
    ToolbarItem.PreuzmiIzSapa = function (visible, enabled) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        return new ToolbarItem('Preuzmi iz SAP-a', ToolbarAction.PreuzmiIzSapa, ToolbarItemStyle.Download, visible, enabled, 'Preuzmi iz SAP-a');
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @return {?}
     */
    ToolbarItem.ProveriVideoServer = function (visible, enabled) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        return new ToolbarItem('Proveri Video Server', ToolbarAction.ProveriVideoServer, ToolbarItemStyle.Check, visible, enabled, 'Proveri Video Server');
    };
    /**
     * @param {?=} visible
     * @param {?=} enabled
     * @return {?}
     */
    ToolbarItem.PogledajSpot = function (visible, enabled) {
        if (visible === void 0) { visible = true; }
        if (enabled === void 0) { enabled = true; }
        return new ToolbarItem('Pogledaj spot', ToolbarAction.PogledajSpot, ToolbarItemStyle.Eye, visible, enabled, 'Pogledaj spot');
    };
    return ToolbarItem;
}());
var FieldStructureTab = /** @class */ (function () {
    function FieldStructureTab() {
    }
    return FieldStructureTab;
}());
var FieldStructurePanel = /** @class */ (function () {
    function FieldStructurePanel() {
    }
    return FieldStructurePanel;
}());
var FieldStructure = /** @class */ (function () {
    /**
     * @param {?} settings
     * @param {?} formSettingsSection
     */
    function FieldStructure(settings, formSettingsSection) {
        this.fieldList = this.getAllFields(settings);
        this._tabsAll = this.getStructureTabs(settings, formSettingsSection);
        this._tabs = this._tabsAll;
    }
    Object.defineProperty(FieldStructure.prototype, "tabs", {
        /**
         * @return {?}
         */
        get: function () {
            return this._tabs;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} title
     * @return {?}
     */
    FieldStructure.prototype.hideTab = function (title) {
        this._tabs = this._tabs.filter(function (tab) { return tab.title !== title; });
    };
    /**
     * @param {?} title
     * @return {?}
     */
    FieldStructure.prototype.showTab = function (title) {
        if (!this._tabs.some(function (tab) { return tab.title === title; })) {
            var /** @type {?} */ index = this._tabsAll.findIndex(function (tab) { return tab.title === title; });
            var /** @type {?} */ tabShow = this._tabsAll.find(function (tab) { return tab.title === title; });
            this._tabs.splice(index, 0, tabShow);
        }
    };
    /**
     * @param {?} settings
     * @param {?} formSettingsSection
     * @return {?}
     */
    FieldStructure.prototype.getStructureTabs = function (settings, formSettingsSection) {
        var /** @type {?} */ relations = settings.relations;
        var /** @type {?} */ detailsData = settings.formSettings[formSettingsSection] || [];
        var /** @type {?} */ retVal = [];
        for (var /** @type {?} */ i = 0; i < detailsData.length; i++) {
            var /** @type {?} */ tabData = detailsData[i];
            var /** @type {?} */ tab = new FieldStructureTab();
            tab.title = tabData.title;
            tab.panels = this.getStructurePanels(tabData.panels, relations);
            // Set the first tab as active
            if (i === 0) {
                tab.active = true;
            }
            retVal.push(tab);
        }
        return retVal;
    };
    /**
     * @param {?} settings
     * @param {?} relations
     * @return {?}
     */
    FieldStructure.prototype.getStructurePanels = function (settings, relations) {
        var /** @type {?} */ retVal = [];
        for (var /** @type {?} */ i = 0; i < settings.length; i++) {
            var /** @type {?} */ panelData = settings[i];
            var /** @type {?} */ panel = new FieldStructurePanel();
            panel.title = panelData.title;
            panel.visible = panelData.panelVisible;
            panel.expanded = panelData.expanded;
            var /** @type {?} */ panelColumn1 = panelData.hasOwnProperty('controls') ? panelData.controls[0] : [];
            var /** @type {?} */ panelColumn2 = panelData.hasOwnProperty('controls') ? panelData.controls[1] : [];
            panel.fieldsColumns = new Array();
            panel.fieldsColumns.push(this.getStructureFields(panelColumn1, relations));
            panel.fieldsColumns.push(this.getStructureFields(panelColumn2, relations));
            retVal.push(panel);
        }
        return retVal;
    };
    /**
     * @param {?} settings
     * @param {?} relations
     * @return {?}
     */
    FieldStructure.prototype.getStructureFields = function (settings, relations) {
        var /** @type {?} */ retVal = [];
        for (var /** @type {?} */ i = 0; i < settings.length; i++) {
            if (typeof settings[i] === 'string') {
                var /** @type {?} */ fieldData = this.getFieldById(settings[i]);
                if (fieldData != null) {
                    retVal.push([fieldData]);
                }
            }
            else {
                var /** @type {?} */ fieldMapItemArray = [];
                for (var /** @type {?} */ j = 0; j < settings[i].length; j++) {
                    var /** @type {?} */ fieldData = this.getFieldById(settings[i][j]);
                    if (fieldData != null) {
                        fieldMapItemArray.push(fieldData);
                    }
                }
                retVal.push(fieldMapItemArray);
            }
        }
        return retVal;
    };
    /**
     * @param {?} settings
     * @return {?}
     */
    FieldStructure.prototype.getAllFields = function (settings) {
        var /** @type {?} */ retVal = [];
        for (var /** @type {?} */ i = 0; i < settings.allFields.length; i++) {
            var /** @type {?} */ fieldData = settings.allFields[i];
            var /** @type {?} */ relation = UtilService.findRelation(settings.relations, fieldData.entityType);
            retVal.push(UtilService.getFieldDataSingle(fieldData, relation));
        }
        return retVal;
    };
    /**
     * @param {?} fieldName
     * @return {?}
     */
    FieldStructure.prototype.getFieldByName = function (fieldName) {
        var /** @type {?} */ results = this.fieldList.filter(function (it) { return it.fieldName === fieldName; });
        if (results.length === 0) {
            return null;
        }
        else {
            return results[0];
        }
    };
    /**
     * @param {?} fieldId
     * @return {?}
     */
    FieldStructure.prototype.getFieldById = function (fieldId) {
        var /** @type {?} */ results = this.fieldList.filter(function (it) { return it.id === fieldId; });
        if (results.length === 0) {
            return null;
        }
        else {
            return results[0];
        }
    };
    return FieldStructure;
}());
var ValidatorEnum = {};
ValidatorEnum.NotEmptyValidator = /** @type {?} */ ('NotEmptyValidator');
ValidatorEnum[ValidatorEnum.NotEmptyValidator] = "NotEmptyValidator";
var SelectComponent = /** @class */ (function () {
    /**
     * @param {?} listService
     * @param {?} eRef
     */
    function SelectComponent(listService, eRef) {
        this.listService = listService;
        this._items = [];
        this._fieldSettings = null;
        this.disabled = false;
        this.useFixedValues = false;
        this.valueChanged = new EventEmitter();
        this.dropdownList = [];
        this.selectedItems = [];
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(SelectComponent.prototype, "items", {
        /**
         * @return {?}
         */
        get: function () {
            return this._items;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._items = value;
            if (this.dropdownList && this.dropdownList.length) {
                this.selectedItems = this.setSelectedItems();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "fieldSettings", {
        /**
         * @return {?}
         */
        get: function () {
            return this._fieldSettings;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._fieldSettings = value;
            this.dropdownList = this.setDropDownList();
            this.selectedItems = this.setSelectedItems();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SelectComponent.prototype.setSelectedItems = function () {
        var /** @type {?} */ selectedItems = [];
        if (this.items && this.items.length) {
            for (var /** @type {?} */ i = 0; i < this.items.length; i++) {
                for (var /** @type {?} */ j = 0; j < this.dropdownList.length; j++) {
                    if (this.dropdownList[j].item_id === this.items[i]) {
                        selectedItems.push(this.dropdownList[j]);
                    }
                }
            }
        }
        return selectedItems;
    };
    /**
     * @return {?}
     */
    SelectComponent.prototype.setDropDownList = function () {
        var /** @type {?} */ dropdownList = this.listService
            .getEnum(this._fieldSettings.entityType)
            .map(function (value, index) {
            return {
                item_text: value.label,
                item_id: value.value,
            };
        });
        return dropdownList;
    };
    /**
     * @return {?}
     */
    SelectComponent.prototype.validate = function () {
        return true;
    };
    /**
     * @return {?}
     */
    SelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Označi sve',
            unSelectAllText: 'Obriši sve',
            itemsShowLimit: 4,
            allowSearchFilter: false,
            searchPlaceholderText: 'Izaberi'
        };
        this.listService.enumItemsSet.subscribe(function (et) {
            if (_this.fieldSettings.entityType === et) {
                _this.setDropDownList();
                _this.setSelectedItems();
            }
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectComponent.prototype.onItemSelect = function (event) {
        this.valueChanged.emit(this.selectedItems.map(function (i) { return i.item_id; }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectComponent.prototype.onSelectAll = function (event) {
        this.valueChanged.emit(( /** @type {?} */(event)).map(function (i) { return i.item_id; }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectComponent.prototype.onItemDeSelect = function (event) {
        this.valueChanged.emit(this.selectedItems.map(function (i) { return i.item_id; }));
    };
    return SelectComponent;
}());
SelectComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-select',
                template: "\n      <div id=\"select_{{ componentGuid }}\" style=\"width: 100%;\">\n          <ng-multiselect-dropdown\n              [placeholder]=\"'Izaberi'\"\n              [data]=\"dropdownList\"\n              [(ngModel)]=\"selectedItems\"\n              [settings]=\"dropdownSettings\"\n              (onSelect)=\"onItemSelect($event)\"\n              (onSelectAll)=\"onSelectAll($event)\"\n              (onDeSelect)=\"onItemDeSelect($event)\"\n          >\n          </ng-multiselect-dropdown>\n      </div>\n    ",
                styles: ["\n\n    "]
            },] },
];
/**
 * @nocollapse
 */
SelectComponent.ctorParameters = function () { return [
    { type: ListService, },
    { type: ElementRef, },
]; };
SelectComponent.propDecorators = {
    'disabled': [{ type: Input },],
    'useFixedValues': [{ type: Input },],
    'items': [{ type: Input },],
    'fieldSettings': [{ type: Input },],
    'valueChanged': [{ type: Output },],
};
var DetailsComponent = /** @class */ (function () {
    /**
     * @param {?} backendService
     * @param {?} authenticationService
     * @param {?} listService
     * @param {?} fieldService
     * @param {?} route
     */
    function DetailsComponent(backendService, authenticationService, listService, fieldService, route) {
        this.backendService = backendService;
        this.authenticationService = authenticationService;
        this.listService = listService;
        this.fieldService = fieldService;
        this.route = route;
        this.FieldTypeEnum = FieldTypeEnum;
        this.validated = new EventEmitter();
        this.FormModeEnum = FormModeEnum;
        this.getColumnDisabled = UtilService.getColumnDisabled;
        this._subscriptions = [];
        this.panelTabs = {
            title: '',
            visible: true,
            expanded: true,
            fieldsColumns: null
        };
        this.tooltipOptions = {
            'placement': 'top',
            'show-delay': '500',
            'theme': 'light'
        };
        this.viewInitialized = new EventEmitter();
        this.tabChanging = new EventEmitter();
        /**
         * Fired before the value is changed
         */
        this.valueChanging = new EventEmitter();
        /**
         * Fired after the value is changed
         */
        this.valueChanged = new EventEmitter();
    }
    Object.defineProperty(DetailsComponent.prototype, "fieldStructure", {
        /**
         * @return {?}
         */
        get: function () {
            return this._fieldStructure;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._fieldStructure = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsComponent.prototype, "showAddEdit", {
        /**
         * @return {?}
         */
        get: function () {
            return this.mode === FormModeEnum.Edit
                || this.mode === FormModeEnum.Add
                || this.mode === FormModeEnum.Copy
                || this.mode === FormModeEnum.Aneks
                || this.mode === FormModeEnum.Podugovor;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?=} oldValue
     * @return {?}
     */
    DetailsComponent.prototype.fieldUpdateDate = function (fieldMap, newValue, oldValue) {
        if (oldValue === void 0) { oldValue = null; }
        this.fieldUpdateValue(fieldMap, newValue != null ? newValue.end : newValue, oldValue);
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?=} oldValue
     * @return {?}
     */
    DetailsComponent.prototype.fieldUpdateTime = function (fieldMap, newValue, oldValue) {
        if (oldValue === void 0) { oldValue = null; }
        this.fieldUpdateValue(fieldMap, newValue, oldValue);
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?=} oldValue
     * @return {?}
     */
    DetailsComponent.prototype.fieldUpdateValue = function (fieldMap, newValue, oldValue) {
        if (oldValue === void 0) { oldValue = null; }
        this.valueChanging.emit({ fieldMap: fieldMap, newValue: newValue, oldValue: oldValue });
        UtilService.fieldUpdateValue(this.documentData, fieldMap, newValue);
        this.valueChanged.emit({ fieldMap: fieldMap, newValue: newValue, oldValue: oldValue });
    };
    /**
     * @param {?} panel
     * @return {?}
     */
    DetailsComponent.prototype.togglePanel = function (panel) {
        // const panelControl = $(event.target).closest('.panel');
        panel.expanded = !panel.expanded;
        // if (panelControl.hasClass('panel-toggled')) {
        //     panelControl.find('.panel-collapse:first .fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
        // } else {
        //     panelControl.find('.panel-collapse:first .fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-up');
        // }
        return false;
    };
    /**
     * @param {?} fieldName
     * @return {?}
     */
    DetailsComponent.prototype.isFieldDisabled = function (fieldName) {
        if (fieldName === 'id') {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @param {?} group
     * @return {?}
     */
    DetailsComponent.prototype.getAutocompleteItem = function (group) {
        if (!this.documentData) {
            return {};
        }
        var /** @type {?} */ value = this.documentData[group.substr(0, 1).toLowerCase() + group.substr(1)];
        return value;
    };
    /**
     * @return {?}
     */
    DetailsComponent.prototype.isDetailsValid = function () {
        var /** @type {?} */ isValid = true;
        this.timePicker.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        this.datePicker.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        this.input.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        this.combo.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        this.autocomplete.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        this.select.forEach(function (child) {
            if (!child.validate()) {
                isValid = false;
            }
        });
        return isValid;
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @param {?} fieldMap
     * @return {?}
     */
    DetailsComponent.prototype.getComboFixedText = function (order, columnName, fieldMap) {
        var /** @type {?} */ value = UtilService.getFieldValue(order, fieldMap);
        var /** @type {?} */ enumResult = this.listService.getEnum(fieldMap.entityType).filter(function (item) { return item.value === value; });
        if (enumResult.length === 0) {
            return null;
        }
        return enumResult[0].label;
    };
    /**
     * @param {?} order
     * @param {?} column
     * @return {?}
     */
    DetailsComponent.prototype.getInputValue = function (order, column) {
        return this.fieldService.getInputValue(order, column);
    };
    /**
     * @return {?}
     */
    DetailsComponent.prototype.getDetailsData = function () {
        var _this = this;
        var /** @type {?} */ object = {};
        this.fieldStructure.tabs.forEach(function (tab) {
            tab.panels.forEach(function (panel) {
                panel.fieldsColumns.forEach(function (columns) {
                    columns.forEach(function (column) {
                        column.forEach(function (columnItem) {
                            var /** @type {?} */ val = '';
                            if (columnItem['type'] === FieldTypeEnum.Input) {
                                val = UtilService.getFieldValue(_this.documentData, columnItem);
                            }
                            else if (columnItem['type'] === FieldTypeEnum.Completer) {
                                val = UtilService.getCompleterValue(_this.documentData, columnItem);
                            }
                            else if (columnItem['type'] === FieldTypeEnum.Date) {
                                val = UtilService.formatDate(_this.getInputValue(_this.documentData, columnItem.fieldName));
                            }
                            else if (columnItem['type'] === FieldTypeEnum.DateTime) {
                                val = UtilService.formatDateTime(_this.getInputValue(_this.documentData, columnItem.fieldName));
                            }
                            else if (columnItem['type'] === FieldTypeEnum.Time) {
                                val = UtilService.formatTime(_this.getInputValue(_this.documentData, columnItem.fieldName));
                            }
                            else if (columnItem['type'] === FieldTypeEnum.Check) {
                                val = _this.getInputValue(_this.documentData, columnItem.fieldName);
                            }
                            else if (columnItem['type'] === FieldTypeEnum.Combo ||
                                columnItem['type'] === FieldTypeEnum.ComboFixed) {
                                val = _this.getComboFixedText(_this.documentData, columnItem.fieldName, columnItem);
                            }
                            if (typeof val !== 'undefined' && val !== null) {
                                object[columnItem.label] = val;
                            }
                        });
                    });
                });
            });
        });
        return object;
    };
    /**
     * @return {?}
     */
    DetailsComponent.prototype.subscribeToValidateOrder = function () {
        var _this = this;
        if (this.validateOrder) {
            this._subscriptions.push(this.validateOrder.subscribe(function () {
                _this.validated.next(_this.isDetailsValid());
            }));
        }
    };
    /**
     * @return {?}
     */
    DetailsComponent.prototype.ngOnInit = function () {
        this.subscribeToValidateOrder();
    };
    /**
     * @return {?}
     */
    DetailsComponent.prototype.ngOnDestroy = function () {
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    DetailsComponent.prototype.setActiveTab = function (tab) {
        this.fieldStructure.tabs.forEach(function (item) {
            if (item === tab) {
                item.active = true;
            }
            else {
                item.active = false;
            }
        });
        this.tabChanging.emit({ newValue: this.fieldStructure });
    };
    /**
     * @param {?} validatorName
     * @return {?}
     */
    DetailsComponent.prototype.getValidator = function (validatorName) {
        return ValidatorEnum.NotEmptyValidator;
    };
    /**
     * @return {?}
     */
    DetailsComponent.prototype.ngAfterViewInit = function () {
        this.viewInitialized.emit(true);
    };
    return DetailsComponent;
}());
DetailsComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-details',
                template: "\n      <div>\n          <form class=\"form-horizontal edit add view\">\n              <div class=\"panel panel-default\" [ngClass]=\"{'tabs': fieldStructure.tabs.length > 1}\">\n                  <ng-container *ngIf=\"fieldStructure.tabs.length > 1\">\n                      <div class=\"panel-heading\">\n                          <ul class=\"nav nav-tabs\" role=\"tablist\">\n                              <li [ngClass]=\"{active: tabIndex === 0}\"\n                                  *ngFor=\"let tab of fieldStructure.tabs; let tabIndex = index\">\n                                  <a href=\"{{'#tab-' + tabIndex}}\"\n                                     role=\"tab\"\n                                     data-toggle=\"tab\"\n                                     aria-expanded=\"true\"\n                                     (click)=\"setActiveTab(tab)\">{{ tab.title }}</a>\n                              </li>\n                          </ul>\n                          <ul class=\"panel-controls\">\n                              <li>\n                                  <a href=\"javascript:void(0)\" (click)=\"togglePanel(panelTabs)\" class=\"panel-collapse\">\n                                      <span class=\"fa\" [ngClass]=\"{'fa-angle-down': panelTabs.expanded, 'fa-angle-up': !panelTabs.expanded}\"></span>\n                                  </a>\n                              </li>\n                          </ul>\n                      </div>\n                  </ng-container>\n\n                  <div [ngClass]=\"{'panel-body': fieldStructure.tabs.length > 1, 'tab-content': fieldStructure.tabs.length > 1}\" [hidden]=\"!panelTabs.expanded\">\n                      <div [ngClass]=\"{'tab-pane': fieldStructure.tabs.length > 1, 'active': tab.active}\"\n                           id=\"{{'tab-' + tabIndex}}\"\n                           *ngFor=\"let tab of fieldStructure.tabs; let tabIndex = index\">\n\n                          <ng-container *ngIf=\"tab.active\">\n                              <div *ngFor=\"let panel of tab.panels; let panelIndex = index\" class=\"panel\" [ngClass]=\"{'panel-toggled': !panel.expanded && panel.visible}\">\n                                  <div *ngIf=\"panel.visible\" class=\"panel-heading\">\n                                      <h4 class=\"panel-title\">\n                                          <span>{{ panel.title }}</span>\n                                      </h4>\n                                      <ul class=\"panel-controls\">\n                                          <li>\n                                              <a href=\"javascript:void(0)\" (click)=\"togglePanel(panel)\" class=\"panel-collapse\">\n                                                  <span class=\"fa\" [ngClass]=\"{'fa-angle-down': panel.expanded, 'fa-angle-up': !panel.expanded}\"></span>\n                                              </a>\n                                          </li>\n                                      </ul>\n                                  </div>\n                                  <div class=\"panel-body\"\n                                       [ngClass]=\"{'p-b-40': panel.visible, 'panel-body-open': (panel.expanded || !panel.visible) }\"\n                                       id=\"{{'panel-' + tabIndex + '-' + panelIndex}}\">\n                                      <!-- VIEW -->\n                                      <ng-container *ngIf=\"mode === FormModeEnum.View\">\n                                          <div *ngFor=\"let columns of panel.fieldsColumns\" class=\"col-md-6\">\n                                              <div class=\"panel-body\" *ngFor=\"let column of columns\">\n                                                  <div *ngFor=\"let columnItem of column\"\n                                                       class=\"details-col-md\"\n                                                       [ngClass]=\"{'col-md-6': column.length > 1, 'col-md-12': column.length === 1}\">\n                                                      <div class=\"form-group\"\n                                                           *ngIf=\"columnItem.visible\">\n                                                          <label [ngClass]=\"{'col-md-5': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                                 class=\"control-label\">{{columnItem?.label}}&nbsp;</label>\n\n                                                          <span *ngIf=\"columnItem.type === 'input' &&\n                                                                !columnItem.multiline &&\n                                                                (!!!columnItem['dbType'] || (!!columnItem['dbType'] &&\n                                                                  columnItem['dbType'].indexOf('DECIMAL') === -1))\"\n                                                                [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                                class=\"control-span\">\n                                                                  {{ documentData | fieldViewText: columnItem }}\n                                                              </span>\n                                                          <span *ngIf=\"columnItem.type === 'input' &&\n                                                                !columnItem.multiline &&\n                                                                (!!columnItem['dbType'] &&\n                                                                  columnItem['dbType'].indexOf('DECIMAL') !== -1)\"\n                                                                [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                                class=\"control-span\">\n                                                                  {{ documentData | fieldViewDecimal: columnItem }}\n                                                              </span>\n                                                          <textarea *ngIf=\"columnItem.type === 'input' && columnItem.multiline\"\n                                                            rows=\"3\"\n                                                            disabled\n                                                            class=\"textarea-view\"\n                                                            [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                            >{{ documentData | fieldViewText: columnItem }}</textarea>\n                                                          <label *ngIf=\"columnItem.type === 'check'\" class=\"switch switch-small\">\n                                                              <input type=\"checkbox\" class=\"icheckbox\"\n                                                                     [ngModel]=\"documentData | fieldEditCheckbox: columnItem\"\n                                                                     [ngModelOptions]=\"{standalone:true}\"\n                                                                     (ngModelChange)=\"fieldUpdateValue(columnItem, $event)\"\n                                                                     [attr.disabled]=\"true\" />\n                                                              <span></span>\n                                                          </label>\n                                                          <span *ngIf=\"columnItem.type === 'combo'\"\n                                                                [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                                class=\"control-span\">\n                                                                  {{ documentData | fieldViewCombo: columnItem }}\n                                                              </span>\n                                                          <span *ngIf=\"columnItem.type === 'comboFixed'\"\n                                                                [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                                class=\"control-span\">\n                                                                  {{documentData | fieldViewComboFixed: columnItem}}\n                                                              </span>\n                                                          <span *ngIf=\"columnItem.type === 'date'\"\n                                                                [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                                class=\"control-span\">\n                                                                  {{ documentData | fieldViewDate: columnItem }}\n                                                              </span>\n                                                          <span *ngIf=\"columnItem.type === 'datetime'\"\n                                                              [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                              class=\"control-span\">\n                                                              {{ documentData | fieldViewDateTime: columnItem }}\n                                                          </span>\n                                                          <span *ngIf=\"columnItem.type === 'time'\"\n                                                                [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                                class=\"control-span\">\n                                                                  {{ documentData | fieldViewTime: columnItem }}\n                                                              </span>\n                                                          <span *ngIf=\"columnItem.type === 'completer'\"\n                                                                [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                                class=\"control-span\">\n                                                                  {{ documentData | fieldViewCompleter: columnItem }}\n                                                              </span>\n                                                          <span   \n                                                              *ngIf=\"columnItem.type === 'select'\"\n                                                              [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                              class=\"control-span\">\n                                                                  {{ documentData | fieldViewCompleter: columnItem }}\n                                                          </span>\n                                                      </div>\n                                                  </div>\n                                              </div>\n                                          </div>\n                                      </ng-container>\n\n                                      <!-- EDIT / ADD -->\n                                      <div *ngIf=\"showAddEdit\">\n                                          <div *ngFor=\"let columns of panel.fieldsColumns\" class=\"col-md-6\">\n                                              <div class=\"panel-body\" *ngFor=\"let column of columns\">\n                                                  <div *ngFor=\"let columnItem of column\"\n                                                       class=\"details-col-md\"\n                                                       [ngClass]=\"{'col-md-6': column.length > 1, 'col-md-12': column.length === 1}\">\n                                                      <div class=\" form-group\"\n                                                           *ngIf=\"columnItem.visible\">\n                                                          <label [ngClass]=\"{'col-md-5': column.length === 1, 'col-md-6': column.length > 1, 'required': columnItem.mandatory}\"\n                                                                 class=\"control-label\">\n                                                              <span *ngIf=\"columnItem?.title\"\n                                                                    class=\"fa fa-info-circle\"></span>\n                                                              {{columnItem?.label}}&nbsp;</label>\n\n                                                          <div\n                                                              [ngClass]=\"{'col-md-7': column.length === 1, 'col-md-6': column.length > 1}\"\n                                                              class=\"input-div\"\n                                                              [ngClass]=\"{'col-md-6': column.length === 1 && columnItem.width === 'medium', 'col-md-5': column.length === 1 && columnItem.width === 'small'}\"\n                                                              [tooltip]=\"columnItem?.tooltipText\"\n                                                              [options]=\"tooltipOptions\"\n                                                              [display]=\"!!columnItem?.tooltipText && columnItem['type'] !== FieldTypeEnum.Check\"\n                                                          >\n                                                              <div\n                                                                  *ngIf=\"columnItem['type'] === FieldTypeEnum.Input &&\n                                                                      (!!!columnItem['dbType'] ||\n                                                                      (!!columnItem['dbType'] && columnItem['dbType'].indexOf('DECIMAL') === -1))\"\n                                                                  class=\"input-group\"\n                                                              >\n                                                                  <util-input [value]=\"documentData | fieldViewText: columnItem\"\n                                                                              [columnItem]=\"columnItem\"\n                                                                              (valueChanged)=\"fieldUpdateValue(columnItem, $event.value, $event.oldValue)\">\n                                                                  </util-input>\n                                                              </div>\n                                                              <div *ngIf=\"columnItem['type'] === FieldTypeEnum.Input &&\n                                                                          !!columnItem['dbType'] &&\n                                                                          columnItem['dbType'].indexOf('DECIMAL') !== -1\"\n                                                                   class=\"input-group\">\n                                                                  <util-input [value]=\"documentData | fieldViewDecimal: columnItem\"\n                                                                              [columnItem]=\"columnItem\"\n                                                                              (valueChanged)=\"fieldUpdateValue(columnItem, $event.value, $event.oldValue)\">\n                                                                  </util-input>\n                                                              </div>\n                                                              <div *ngIf=\"columnItem.type === 'check'\" class=\"input-group\">\n                                                                  <label\n                                                                      class=\"switch switch-small\"\n                                                                      [tooltip]=\"columnItem?.tooltipText\"\n                                                                      [options]=\"tooltipOptions\"\n                                                                      [display]=\"!!columnItem?.tooltipText\"\n                                                                  >\n                                                                      <input type=\"checkbox\" class=\"icheckbox\"\n                                                                             [ngModel]=\"documentData | fieldEditCheckbox: columnItem\"\n                                                                             [ngModelOptions]=\"{standalone:true}\"\n                                                                             (ngModelChange)=\"fieldUpdateValue(columnItem, $event)\"\n                                                                             [attr.disabled]=\"getColumnDisabled(columnItem, mode)\" />\n                                                                      <span></span>\n                                                                  </label>\n                                                              </div>\n                                                              <div *ngIf=\"columnItem.type == 'combo'\">\n                                                                  <util-combo\n                                                                          [selectedItem]=\"documentData | fieldEditCompleter: columnItem\"\n                                                                          (selectedItemChange)=\"fieldUpdateValue(columnItem, $event.value, $event.oldValue)\"\n                                                                          [fieldSettings]=\"columnItem\"\n                                                                          [useFixedValues]=\"false\"\n                                                                          [disabled]=\"getColumnDisabled(columnItem, mode)\">\n                                                                  </util-combo>\n                                                              </div>\n                                                              <div *ngIf=\"columnItem.type == 'comboFixed'\">\n                                                                  <util-combo\n                                                                          [selectedItem]=\"documentData | fieldViewText: columnItem\"\n                                                                          (selectedItemChange)=\"fieldUpdateValue(columnItem, $event.value, $event.oldValue)\"\n                                                                          [fieldSettings]=\"columnItem\"\n                                                                          [useFixedValues]=\"true\"\n                                                                          [disabled]=\"getColumnDisabled(columnItem, mode)\">\n                                                                  </util-combo>\n                                                              </div>\n                                                              <util-daterangepicker *ngIf=\"columnItem.type === 'date'\"\n                                                                                    [value]=\"documentData | fieldEditDate: columnItem\"\n                                                                                    [columnItem]=\"columnItem\"\n                                                                                    (dateSelected)=\"fieldUpdateDate(columnItem, $event.value, $event.oldValue)\">\n                                                              </util-daterangepicker>\n                                                              <util-input *ngIf=\"columnItem.type === 'datetime'\"\n                                                                          [value]=\"documentData | fieldEditDateTime: columnItem\"\n                                                                          [columnItem]=\"columnItem\">\n                                                              </util-input>\n                                                              <div *ngIf=\"columnItem.type == 'completer'\" class=\"input-group\" style=\"width: 100%;\">\n                                                                  <util-autocomplete\n                                                                          [selectedItem]=\"documentData | fieldEditCompleter: columnItem\"\n                                                                          (selectedItemChange)=\"fieldUpdateValue(columnItem, $event.value, $event.oldValue)\"\n                                                                          [fieldSettings]=\"columnItem\"\n                                                                          [disabled]=\"getColumnDisabled(columnItem, mode)\">\n                                                                  </util-autocomplete>\n                                                              </div>\n                                                              <util-timepicker *ngIf=\"columnItem.type === 'time'\"\n                                                                               [entity]=\"documentData\"\n                                                                               [columnItem]=\"columnItem\"\n                                                                               (timeChanged)=\"fieldUpdateTime(columnItem, $event.value, $event.oldValue)\">\n                                                              </util-timepicker>\n                                                              <div *ngIf=\"columnItem.type == 'select'\">\n                                                                  <util-select \n                                                                              [items]=\"documentData | fieldEditSelect: columnItem\"\n                                                                              (valueChanged)=\"fieldUpdateValue(columnItem, $event)\"\n                                                                              [fieldSettings]=\"columnItem\"\n                                                                              [disabled]=\"getColumnDisabled(columnItem, mode)\">    \n                                                                  </util-select>                                                    \n                                                              </div>\n                                                          </div>\n                                                      </div>\n                                                  </div>\n                                              </div>\n                                          </div>\n                                      </div>\n                                  </div>\n                              </div>\n                          </ng-container>\n                      </div>\n                  </div>\n              </div>\n          </form>\n      </div>\n    ",
                styles: ["\n      form label.required:after {\n        color: red;\n        content: \"*\"; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
DetailsComponent.ctorParameters = function () { return [
    { type: BackendService, },
    { type: AuthenticationService, },
    { type: ListService, },
    { type: FieldService, },
    { type: ActivatedRoute, },
]; };
DetailsComponent.propDecorators = {
    'mode': [{ type: Input },],
    'validateOrder': [{ type: Input },],
    'validated': [{ type: Output },],
    'timePicker': [{ type: ViewChildren, args: [TimepickerComponent,] },],
    'datePicker': [{ type: ViewChildren, args: [DaterangepickerComponent,] },],
    'autocomplete': [{ type: ViewChildren, args: [AutocompleteComponent,] },],
    'combo': [{ type: ViewChildren, args: [ComboComponent,] },],
    'input': [{ type: ViewChildren, args: [InputComponent,] },],
    'select': [{ type: ViewChildren, args: [SelectComponent,] },],
    'fieldStructure': [{ type: Input },],
    'documentData': [{ type: Input },],
    'viewInitialized': [{ type: Output },],
    'tabChanging': [{ type: Output },],
    'valueChanging': [{ type: Output },],
    'valueChanged': [{ type: Output },],
};
var MessagesEnum = {};
MessagesEnum.DeleteStavka = /** @type {?} */ ('Da li ste sigurni da želite da obrišete ovu stavku?');
MessagesEnum.DeleteDocument = /** @type {?} */ ('Da li ste sigurni da želite da stornirate ovaj dokument?');
MessagesEnum.DeleteSifarnik = /** @type {?} */ ('Da li ste sigurni da želite da obrišete?');
MessagesEnum.AreYouSure = /** @type {?} */ ('Da li ste sigurni da ste sve dobro prekontrolisali?');
MessagesEnum[MessagesEnum.DeleteStavka] = "DeleteStavka";
MessagesEnum[MessagesEnum.DeleteDocument] = "DeleteDocument";
MessagesEnum[MessagesEnum.DeleteSifarnik] = "DeleteSifarnik";
MessagesEnum[MessagesEnum.AreYouSure] = "AreYouSure";
var EditTableComponent = /** @class */ (function () {
    /**
     * @param {?} backendService
     * @param {?} authenticationService
     * @param {?} route
     * @param {?} daterangepickerOptions
     * @param {?} ref
     * @param {?} fieldService
     * @param {?} listService
     * @param {?} applicationService
     * @param {?} notificationService
     * @param {?} eRef
     */
    function EditTableComponent(backendService, authenticationService, route, daterangepickerOptions, ref, fieldService, listService, applicationService, notificationService, eRef) {
        this.backendService = backendService;
        this.authenticationService = authenticationService;
        this.route = route;
        this.daterangepickerOptions = daterangepickerOptions;
        this.ref = ref;
        this.fieldService = fieldService;
        this.listService = listService;
        this.applicationService = applicationService;
        this.notificationService = notificationService;
        this.eRef = eRef;
        this.FilterActionEnum = FilterActionEnum$1;
        this.FormModeEnum = FormModeEnum;
        this.TableModeEnum = TableModeEnum;
        this.TableActionEnum = TableActionEnum;
        this.DocumentTypeEnum = DocumentTypeEnum;
        this.FieldTypeEnum = FieldTypeEnum;
        this.getColumnDisabled = UtilService.getColumnDisabled;
        this.approveTableActions = false;
        this.optionsDate = UtilService.datePickerOptionsDefault;
        this.paging = true;
        this.copyEnabled = false;
        this.sortingEnabled = true;
        this.sticking = true;
        this.resizable = true;
        this.reordable = true;
        this.ident = 'id';
        this.tableMode = TableModeEnum.Table;
        this.tag = null; // Used by parent components to tag instances. Not to be used internally
        this.customAddHandling = false;
        this._showDocumentStatusColumn = true;
        this.tableAction = new EventEmitter();
        this.valueChanged = new EventEmitter();
        this._decrement = 2;
        this.columns = [];
        this.columnsWithActions = [];
        this.shownEditingRows = [];
        this.initialized = false;
        this._columnsSet = false;
        this.disableDrawCallback = false;
        this.isAdmin = false;
        this.daterange = {};
        this.fieldsByName = []; // TODO: Remove
        this.rowsOnPage = 10;
        this.totalPages = 1;
        this.pageCurrent = 1;
        this._outside = false;
        this._settings = null;
        this.direction = 0;
        this.from = 0;
        this.to = 1000000;
        this.selectedObjectChange = new EventEmitter();
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(EditTableComponent.prototype, "showDocumentStatusColumn", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showDocumentStatusColumn;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._decrement = 2;
            }
            else {
                this._decrement = 1;
            }
            this._showDocumentStatusColumn = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditTableComponent.prototype, "outside", {
        /**
         * @param {?} outside$
         * @return {?}
         */
        set: function (outside$) {
            var _this = this;
            this.outside$ = outside$;
            this.outsideSubscription = outside$.subscribe(function (data) {
                _this._outside = data;
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditTableComponent.prototype, "selectedObject", {
        /**
         * @return {?}
         */
        get: function () {
            return this._selectObject;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selectObject = value;
            // This we have because it can happen that selection have to be returned after validation
            $('.orderList' + this.componentGuid + this.tableMode + ' tbody tr').removeClass('selected');
            this.selectObject();
            this.selectedObjectChange.emit(this._selectObject);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditTableComponent.prototype, "orderListCount", {
        /**
         * @param {?} orderListCount$
         * @return {?}
         */
        set: function (orderListCount$) {
            var _this = this;
            this.orderListCount$ = orderListCount$;
            this.orderListCountSubscription = orderListCount$.subscribe(function (data) {
                _this._orderListCount = data;
                _this.setPagination();
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditTableComponent.prototype, "mode", {
        /**
         * @param {?} mode$
         * @return {?}
         */
        set: function (mode$) {
            var _this = this;
            this.mode$ = mode$;
            this.modeSubscription = mode$.subscribe(function (data) {
                _this._mode = data;
                _this.ref.detectChanges();
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditTableComponent.prototype, "settings", {
        /**
         * @param {?} tableSettings$
         * @return {?}
         */
        set: function (tableSettings$) {
            var _this = this;
            this.tableSettings$ = tableSettings$;
            this.tableSettingsSubscription = tableSettings$.subscribe(function (data) {
                if (data != null) {
                    _this._settings = data;
                    _this.onOrderListAndRelationsLoaded();
                    _this.overrideBySecurity();
                    _this.ref.detectChanges();
                }
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditTableComponent.prototype, "orderList", {
        /**
         * @return {?}
         */
        get: function () {
            return this._orderList;
        },
        /**
         * @param {?} documentList$
         * @return {?}
         */
        set: function (documentList$) {
            var _this = this;
            this.documentListSubscription = documentList$.subscribe(function (data) {
                switch (_this.tableMode) {
                    case TableModeEnum.Table:
                        if (typeof data !== 'undefined') {
                            if (typeof _this._orderListTotal === 'undefined') {
                                if (!_this.paging) {
                                    _this.rowsOnPage = 10000000000;
                                }
                                else {
                                    _this.rowsOnPage = 10;
                                }
                                _this.pageCurrent = 1;
                            }
                            _this._orderListTotal = data;
                            _this.setPagination();
                            _this.onOrderListAndRelationsLoaded();
                            _this.ref.detectChanges();
                        }
                        break;
                    case TableModeEnum.Details:
                        if (typeof data !== 'undefined') {
                            if (typeof _this._orderListTotal === 'undefined') {
                                if (!_this.paging) {
                                    _this.rowsOnPage = 10000000000;
                                }
                                else {
                                    _this.rowsOnPage = 10;
                                }
                                _this.pageCurrent = 1;
                            }
                            _this._orderListTotal = data;
                            _this.setPagination();
                            _this.from = (_this.pageCurrent - 1) * _this.rowsOnPage;
                            _this.to = _this.rowsOnPage * _this.pageCurrent;
                            if (typeof _this.sortOrder !== 'undefined' && Object.keys(_this.sortOrder).length > 0) {
                                _this.fieldName = _this.sortOrder.fieldName;
                            }
                            _this.onOrderListAndRelationsLoaded();
                            if (!_this._outside) {
                                _this.shownEditingRows = [];
                            }
                            _this.ref.detectChanges();
                        }
                        break;
                }
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditTableComponent.prototype, "complexSettings", {
        /**
         * @param {?} complexTableSettings$
         * @return {?}
         */
        set: function (complexTableSettings$) {
            var _this = this;
            this.complexTableSettings$ = complexTableSettings$;
            this.complexTableSettingsSubscription = complexTableSettings$.subscribe(function (data) {
                _this._complexSettings = data;
            }, function (error) {
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditTableComponent.prototype, "additable", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.listAdditableOverride != null) {
                return this.listAdditableOverride;
            }
            else {
                return this._settings.listAdditable;
            }
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.listAdditableOverride = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    EditTableComponent.prototype.overrideBySecurity = function () {
        if (this.tableMode === TableModeEnum.Table) {
            var /** @type {?} */ security = this.backendService.getSecurity();
            if (security && this.tableMode === TableModeEnum.Table) {
                var /** @type {?} */ hasAdd = true;
                var /** @type {?} */ hasUpdate = true;
                var /** @type {?} */ hasDeleteStorno = true;
                var /** @type {?} */ securityDeleteStorno = SecurityEnum.Delete;
                security = this.backendService.getSecurity();
                if (this._settings.documentType === DocumentTypeEnum.Dokument) {
                    securityDeleteStorno = SecurityEnum.Storno;
                }
                for (var /** @type {?} */ i = 0; i < security.length; i++) {
                    if (security[i].formCode === this.identity.documentSecurityCode) {
                        hasAdd = false;
                        hasUpdate = false;
                        hasDeleteStorno = false;
                        for (var /** @type {?} */ j = 0; j < security[i].allowedModes.length; j++) {
                            if (security[i].allowedModes[j] === SecurityEnum.Add) {
                                hasAdd = true;
                            }
                            if (security[i].allowedModes[j] === SecurityEnum.Update) {
                                hasUpdate = true;
                            }
                            if (security[i].allowedModes[j] === securityDeleteStorno) {
                                hasDeleteStorno = true;
                            }
                        }
                    }
                }
                if (!hasAdd) {
                    this._settings.inlineAdding = false;
                    this._settings.listAdditable = false;
                }
                if (!hasUpdate) {
                    this._settings.inlineEditing = false;
                    this._settings.listEditable = false;
                }
                if (!hasDeleteStorno) {
                    this._settings.listDeletable = false;
                }
            }
        }
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.setPagination = function () {
        if ((typeof this.serverPagination !== 'undefined' && !this.serverPagination) || this.tableMode === TableModeEnum.Details) {
            this.totalPages = Math.ceil(this._orderListTotal.length / this.rowsOnPage);
            if (this.totalPages < this.pageCurrent) {
                this.pageCurrent = 1;
            }
            var /** @type {?} */ from = (this.pageCurrent - 1) * this.rowsOnPage;
            this._orderList = this._orderListTotal.slice(from, this.rowsOnPage * this.pageCurrent);
        }
        else {
            this.totalPages = Math.ceil(this._orderListCount / this.rowsOnPage);
            if (this.totalPages < this.pageCurrent) {
                this.pageCurrent = 1;
            }
            this._orderList = this._orderListTotal;
        }
        this.ref.detectChanges();
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.selectObject = function () {
        if (this.ident && this._selectObject) {
            var /** @type {?} */ tableRow = $(this.getItemRef().querySelector('tbody span[data-data-' + this.ident + '=\'' + this._selectObject[this.ident] + '\']')).closest('tr');
            if (!tableRow.hasClass('selected')) {
                $(this.getItemRef().querySelector('tr')).removeClass('selected');
                tableRow.addClass('selected');
            }
        }
    };
    Object.defineProperty(EditTableComponent.prototype, "identFromTableMode", {
        /**
         * @return {?}
         */
        get: function () {
            return this.tableMode === TableModeEnum.Details ? 'rbr' : 'id';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    EditTableComponent.prototype.onAction = function (event) {
        this.tableAction.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EditTableComponent.prototype.inlineUpdateOrAddOrder = function (event) {
        if ($(event.target).closest('tr').hasClass('editing')) {
            this.onInlineUpdateOrder(event.target, true);
        }
        else {
            this.onInlineAddOrder(event.target, true);
        }
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?} order
     * @param {?} index
     * @return {?}
     */
    EditTableComponent.prototype.fieldUpdateCheck = function (fieldMap, newValue, order, index) {
        this.fieldUpdateValue(fieldMap, newValue, null, order, index);
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?=} oldValue
     * @param {?=} order
     * @param {?=} index
     * @return {?}
     */
    EditTableComponent.prototype.fieldUpdateDate = function (fieldMap, newValue, oldValue, order, index) {
        if (oldValue === void 0) { oldValue = null; }
        this.fieldUpdateValue(fieldMap, newValue != null ? newValue.end : newValue, oldValue, order, index);
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?=} oldValue
     * @param {?=} order
     * @param {?=} index
     * @return {?}
     */
    EditTableComponent.prototype.fieldUpdateTime = function (fieldMap, newValue, oldValue, order, index) {
        if (oldValue === void 0) { oldValue = null; }
        this.fieldUpdateValue(fieldMap, newValue, oldValue, order, index);
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?=} oldValue
     * @param {?=} order
     * @param {?=} index
     * @return {?}
     */
    EditTableComponent.prototype.fieldUpdateValue = function (fieldMap, newValue, oldValue, order, index) {
        if (oldValue === void 0) { oldValue = null; }
        this.onInlineSelect(order);
        // if (this.tableMode === TableModeEnum.Table) {
        UtilService.fieldUpdateValue(order, fieldMap, newValue);
        // }
        this.valueChanged.emit({ fieldMap: fieldMap, newValue: newValue, oldValue: oldValue, order: order });
    };
    /**
     * @param {?} row
     * @param {?} operation
     * @return {?}
     */
    EditTableComponent.prototype.changeRowStatus = function (row, operation) {
        var /** @type {?} */ that = this;
        if (this.tableMode === TableModeEnum.Table) {
            $(this.getItemRef().querySelector('tbody')).find('tr').each(function () {
                $(this).removeClass('editing');
                $(this).removeClass('adding');
            });
        }
        if (operation === '') {
            row.removeClass('editing');
            row.removeClass('adding');
            delete that.shownEditingRows[row[0].dataset.rowIdentity];
            row.find('.icheckbox').each(function () {
                $(this).prop('disabled', true);
            });
        }
        else {
            row.addClass(operation);
            that.shownEditingRows[row[0].dataset.rowIdentity] = Object.assign({}, this._selectObject);
            row.find('.icheckbox').each(function () {
                if (that.fieldsByName[$(this)[0].dataset.dataName]['editable']) {
                    $(this).prop('disabled', false);
                }
            });
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    EditTableComponent.prototype.keydownListener = function (e) {
        var /** @type {?} */ that = this;
        var /** @type {?} */ index = $(e.target).closest('td').index();
        var /** @type {?} */ rowIndex = $(e.target).closest('tr').index();
        // const table = $('.orderList' + that.componentGuid + this.tableMode).DataTable();
        // const info = table.page.info();
        var /** @type {?} */ thisRow = $(e.target).closest('tr');
        var /** @type {?} */ prevRow = thisRow.prev('tr');
        var /** @type {?} */ nextRow = thisRow.next('tr');
        setTimeout(function () {
            switch (e.keyCode) {
                case 38: // Up arrow
                    if ($(e.target).closest('td').find('.popup.show').length === 0 &&
                        $(e.target).closest('td').find('.combo-component.open').length === 0) {
                        if (prevRow.length !== 0) {
                            // Move to previous row
                            that.inlineUpdateOrAddOrder(e);
                            if (!prevRow.hasClass('adding')) {
                                that.changeRowStatus(prevRow, 'editing');
                            }
                            setTimeout(function (self) {
                                prevRow.find('td:eq(' + index + ') input').focus();
                                prevRow.find('td:eq(' + index + ') input').select();
                            }, 0, that);
                        }
                        else {
                            // Previous page
                            if (that.pageCurrent !== 0) {
                                that.inlineUpdateOrAddOrder(e);
                                that.pageCurrent--;
                                that.setPagination();
                                that.addKeyListeners();
                                setTimeout(function (self) {
                                    if ($('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last td:first button:first')[0].classList.contains('edit') &&
                                        !$('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last td:first button:first')[0].hasAttribute('disabled')) {
                                        if (!$('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last').hasClass('adding')) {
                                            self.changeRowStatus($('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last'), 'editing');
                                        }
                                        setTimeout(function (self2) {
                                            $('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last').find('td:eq(' + index + ')').each(function () {
                                                $(this).find('input').focus();
                                                $(this).find('input').select();
                                            });
                                        }, 0, self);
                                    }
                                }, 0, that);
                            }
                        }
                    }
                    break;
                case 40: // Down arrow
                    if ($(e.target).closest('td').find('.popup.show').length === 0 &&
                        $(e.target).closest('td').find('.combo-component.open').length === 0) {
                        if (nextRow.length !== 0) {
                            // Move to next row
                            that.inlineUpdateOrAddOrder(e);
                            if (!nextRow.hasClass('adding')) {
                                that.changeRowStatus(nextRow, 'editing');
                            }
                            setTimeout(function (self) {
                                nextRow.find('> td:eq(' + index + ') input').focus();
                                nextRow.find('> td:eq(' + index + ') input').select();
                            }, 0, that);
                        }
                        else {
                            if (rowIndex + 1 === that.rowsOnPage && that.pageCurrent + 1 !== that.totalPages && that.totalPages !== 0) {
                                that.inlineUpdateOrAddOrder(e);
                                // Move to next page and first row
                                that.disableDrawCallback = true;
                                that.pageCurrent++;
                                that.setPagination();
                                setTimeout(function (self) {
                                    self.addKeyListeners();
                                    if ($('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first td:first button:first')[0].classList.contains('edit') &&
                                        !$('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first td:first button:first')[0].hasAttribute('disabled')) {
                                        if (!$('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first').hasClass('adding')) {
                                            $('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first').addClass('editing');
                                        }
                                        setTimeout(function (self2) {
                                            $('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first').find('td:eq(' + index + ')').each(function () {
                                                $(this).find('input').focus();
                                                $(this).find('input').select();
                                            });
                                        }, 0, self);
                                    }
                                }, 0, that);
                            }
                            else {
                                // Add new record on the same page
                                if (that._settings.inlineAdding) {
                                    that.inlineUpdateOrAddOrder(e);
                                    that.onInlineAddOpen(index);
                                }
                            }
                        }
                    }
                    break;
                case 9: // Tab
                    if (e.shiftKey) {
                        e.preventDefault();
                        e.stopPropagation();
                        var /** @type {?} */ found_3 = false;
                        thisRow.find('td').each(function () {
                            if ((index > $(this)[0].cellIndex) && ($(this).find('input').length > 0 && !$(this).find('input')[0].hasAttribute('disabled'))) {
                                $(this).find('input').focus();
                                $(this).find('input').select();
                                found_3 = true;
                            }
                        });
                        // previous line or move to previous page
                        if (!found_3) {
                            if (prevRow.length === 0) {
                                // jump to previous page
                                if (that.pageCurrent !== 0) {
                                    that.inlineUpdateOrAddOrder(e);
                                    that.pageCurrent--;
                                    that.setPagination();
                                    that.addKeyListeners();
                                    setTimeout(function (self) {
                                        if ($('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last td:first button:first')[0].classList.contains('edit') &&
                                            !$('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last td:first button:first')[0].hasAttribute('disabled')) {
                                            if (!$('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last').hasClass('adding')) {
                                                self.changeRowStatus($('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last'), 'editing');
                                            }
                                            setTimeout(function (self2) {
                                                $('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:last').find('td').each(function () {
                                                    if ($(this).find('input').length > 0 && !$(this).find('input')[0].hasAttribute('disabled')) {
                                                        $(this).find('input').focus();
                                                        $(this).find('input').select();
                                                    }
                                                });
                                            }, 0, self);
                                        }
                                    }, 0, that);
                                }
                            }
                            else {
                                // Move to previous line
                                if (prevRow.find('button')[0].classList.contains('edit') &&
                                    !prevRow.find('button')[0].hasAttribute('disabled')) {
                                    that.inlineUpdateOrAddOrder(e);
                                    if (!prevRow.hasClass('adding')) {
                                        that.changeRowStatus(prevRow, 'editing');
                                    }
                                    setTimeout(function (self) {
                                        prevRow.find('td').each(function () {
                                            if ($(this).find('input').length > 0 && !$(this).find('input')[0].hasAttribute('disabled')) {
                                                $(this).find('input').focus();
                                                $(this).find('input').select();
                                            }
                                        });
                                    }, 0, that);
                                }
                            }
                        }
                    }
                    else {
                        e.preventDefault();
                        e.stopPropagation();
                        var /** @type {?} */ found_4 = false;
                        thisRow.find('td').each(function () {
                            if ((index < $(this)[0].cellIndex) &&
                                ($(this).find('input').length > 0 && !$(this).find('input')[0].hasAttribute('disabled'))) {
                                $(this).find('input').focus();
                                $(this).find('input').select();
                                found_4 = true;
                                return false;
                            }
                        });
                        // Next line, add or move to next page
                        if (!found_4) {
                            if (rowIndex + 1 === that.rowsOnPage && that.pageCurrent + 1 !== that.totalPages && that.totalPages !== 0) {
                                that.inlineUpdateOrAddOrder(e);
                                // Move to next page and first row
                                that.pageCurrent++;
                                that.setPagination();
                                setTimeout(function (self) {
                                    if ($('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first td:first button:first')[0].classList.contains('edit') &&
                                        !$('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first td:first button:first')[0].hasAttribute('disabled')) {
                                        if (!$('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first').hasClass('adding')) {
                                            self.changeRowStatus($('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first'), 'editing');
                                        }
                                        setTimeout(function (self2) {
                                            $('.orderList' + that.componentGuid + that.tableMode + ' tbody tr:first').find('td').each(function () {
                                                if ($(this).find('input').length > 0 && !$(this).find('input')[0].hasAttribute('disabled')) {
                                                    $(this).find('input').focus();
                                                    $(this).find('input').select();
                                                    return false;
                                                }
                                            });
                                        }, 0, self);
                                    }
                                }, 0, that);
                            }
                            else {
                                if (nextRow.length === 0) {
                                    // Add new record on the same page
                                    if (that._settings.inlineAdding) {
                                        that.inlineUpdateOrAddOrder(e);
                                        that.onInlineAddOpen(null);
                                    }
                                }
                                else {
                                    // Move to next line
                                    if (nextRow.find('button')[0].classList.contains('edit') &&
                                        !nextRow.find('button')[0].hasAttribute('disabled')) {
                                        that.inlineUpdateOrAddOrder(e);
                                        if (!nextRow.hasClass('adding')) {
                                            that.changeRowStatus(nextRow, 'editing');
                                        }
                                        setTimeout(function (self) {
                                            nextRow.find('td').each(function () {
                                                if ($(this).find('input').length > 0 && !$(this).find('input')[0].hasAttribute('disabled')) {
                                                    $(this).find('input').focus();
                                                    $(this).find('input').select();
                                                    return false;
                                                }
                                            });
                                        }, 0, that);
                                    }
                                }
                            }
                        }
                    }
                    break;
                default:
            }
        }, 0);
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.addKeyListeners = function () {
        var /** @type {?} */ that = this;
        $('.orderList' + this.componentGuid + this.tableMode).find('td').off('keydown');
        $('.orderList' + this.componentGuid + this.tableMode).find('td').on('keydown', function (e) {
            $('.orderList' + that.componentGuid + that.tableMode).find('td').off('keydown');
            that.keydownListener(e);
            setTimeout(function (self) {
                $('.orderList' + self.componentGuid + that.tableMode).find('td').off('keydown');
                $('.orderList' + self.componentGuid + that.tableMode).find('td').on('keydown', function (event) {
                    self.keydownListener(event);
                });
            }, 0, that);
        });
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.onInlineAddOpenFromHeader = function () {
        if (this.customAddHandling) {
            var /** @type {?} */ params = {
                action: TableActionEnum.AddCustom,
                document: document
            };
            this.onAction(params);
        }
        else {
            // const table = $('.orderList' + this.componentGuid + this.tableMode).DataTable();
            // const info = table.page.info();
            if (this.pageCurrent !== this.totalPages) {
                // Move to last page
                this.setPagination();
                if (this.totalPages === 0) {
                    this.totalPages = 1;
                }
                this.pageCurrent = this.totalPages;
                this.setPagination();
            }
            setTimeout(function (self) {
                self.addKeyListeners();
                self.onInlineAddOpen(null);
            }, 0, this);
        }
    };
    /**
     * @param {?} index
     * @return {?}
     */
    EditTableComponent.prototype.onInlineAddOpenApproved = function (index) {
        if (this.maxRows && this.maxRows <= this._orderList.length) {
            return;
        }
        this.disableDrawCallback = true;
        $('.orderList' + this.componentGuid + this.tableMode).find('td').off('keydown');
        var /** @type {?} */ that = this;
        var /** @type {?} */ rbr = this._orderListTotal.length + 1;
        this._orderListTotal.push({
            rbr: rbr
        });
        that.setPagination();
        if (this.totalPages === 0) {
            this.totalPages = 1;
        }
        that.pageCurrent = that.totalPages;
        that.setPagination();
        setTimeout(function () {
            that.onInlineSelect(that._orderList[that._orderList.length - 1]);
            that.changeRowStatus($('.orderList' + that.componentGuid + that.tableMode + " button[data-data-rbr='" + rbr + "']").closest('tr'), 'adding');
            var /** @type {?} */ time = 0;
            if ($('.orderList' + that.componentGuid + that.tableMode + " button[data-data-rbr='" + rbr + "']").closest('tr').prev('tr').length === 0) {
                that.disableDrawCallback = true;
                time = 500;
            }
            if (index !== null) {
                setTimeout(function () {
                    $('.orderList' + that.componentGuid + that.tableMode + " button[data-data-rbr='" + rbr + "']").closest('tr').find('> td:eq(' + index + ')').each(function () {
                        $(this).find('input').focus();
                    });
                }, time);
            }
            else {
                setTimeout(function () {
                    $('.orderList' + that.componentGuid + that.tableMode + " button[data-data-rbr='" + rbr + "']").closest('tr').find('> td').each(function () {
                        if ($(this).find('input').length > 0 && !$(this).find('input')[0].hasAttribute('disabled')) {
                            $(this).find('input').focus();
                            return false;
                        }
                    });
                }, time);
            }
            that.addKeyListeners();
            that.addListenersToNewlyAddedRow();
            var /** @type {?} */ params = {
                action: TableActionEnum.Add,
                document: that._orderList[that._orderList.length - 1]
            };
            that.tableAction.emit(params);
        }, 0);
    };
    /**
     * @param {?} index
     * @return {?}
     */
    EditTableComponent.prototype.onInlineAddOpen = function (index) {
        if (!this.approveTableActions) {
            this.onInlineAddOpenApproved(index);
        }
        else {
            var /** @type {?} */ params = {
                action: TableActionEnum.Add,
                index: index
            };
            this.tableAction.emit(params);
        }
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.addListenersToNewlyAddedRow = function () {
        var /** @type {?} */ that = this;
        $('.orderList' + that.componentGuid + that.tableMode).find('tr.adding td.actions').off('click');
        $('.orderList' + that.componentGuid + that.tableMode).find('tr.adding td.actions').on('click', function (e) {
            if ($(e.target).closest('button')[0].classList.contains('add-check')) {
                that.onInlineAddOrder(e.target, true);
            }
            else if ($(e.target).closest('button')[0].classList.contains('add-cancel')) {
                if (that.tableMode === TableModeEnum.Details) {
                    that.removeRow(e);
                }
            }
        });
    };
    /**
     * @param {?} order
     * @return {?}
     */
    EditTableComponent.prototype.removeRowApproved = function (order) {
        var _this = this;
        this._orderListTotal.splice(this._orderList.indexOf(order), 1);
        this.setPagination();
        for (var /** @type {?} */ i = 0; i < this._orderListTotal.length; i++) {
            this._orderListTotal[i]['rbr'] = i + 1;
        }
        if (this._complexSettings) {
            this._complexSettings.splice(this._orderList.indexOf(order), 1);
        }
        if (order.rbr) {
            delete this.shownEditingRows[order['rbr']];
            Object.keys(this.shownEditingRows).forEach(function (key) {
                if (order.rbr < key) {
                    delete _this.shownEditingRows[+key];
                    _this.shownEditingRows[+key - 1] = { 'rbr': +key - 1 };
                }
            });
        }
        this.ref.detectChanges();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EditTableComponent.prototype.removeRow = function (event) {
        var /** @type {?} */ order = this._orderList.filter(function (listItem) { return listItem['rbr'].toString() ===
            $(event.target).closest('button')[0].dataset.dataRbr; })[0];
        if (!this.approveTableActions) {
            this.removeRowApproved(order);
        }
        var /** @type {?} */ params = {
            action: TableActionEnum.Delete,
            document: order
        };
        this.tableAction.emit(params);
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.getTableWidth = function () {
        return 100 / this._settings.columns.length + '%';
    };
    /**
     * @param {?} obj
     * @param {?} fields
     * @param {?} val
     * @return {?}
     */
    EditTableComponent.prototype.setNestedPropertyValue = function (obj, fields, val) {
        fields = fields.split('.');
        var /** @type {?} */ cur = obj;
        var /** @type {?} */ last = fields.pop();
        fields.forEach(function (field) {
            cur[field] = {};
            cur = cur[field];
        });
        cur[last] = val;
        return obj;
    };
    /**
     * @param {?} eventTarget
     * @param {?} notify
     * @return {?}
     */
    EditTableComponent.prototype.onInlineUpdateOrder = function (eventTarget, notify) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ row = $(eventTarget).closest('tr');
        if (!row.hasClass('adding') && !row.hasClass('editing')) {
            return;
        }
        var /** @type {?} */ isValid = self.doValidationOfRow(eventTarget);
        if (notify && !isValid) {
            this.notificationService.openNoty('Nisu sva polja validna!');
        }
        if (row.find('.error').length > 0) {
            return;
        }
        var /** @type {?} */ rowIdentity = row[0].dataset.rowIdentity.toString();
        var /** @type {?} */ orderToUpdate = {};
        orderToUpdate[this.identFromTableMode] = rowIdentity;
        var /** @type {?} */ index;
        if (this.tableMode === TableModeEnum.Details) {
            for (var /** @type {?} */ i = 0; i < self._orderList.length; i++) {
                if (self._orderList[i].rbr.toString() === orderToUpdate['rbr']) {
                    index = i;
                }
            }
        }
        var /** @type {?} */ rowOrder = self.tableMode === TableModeEnum.Details ? self._orderList[index] : orderToUpdate;
        row.find('> td').each(function () {
            var /** @type {?} */ key = $(this)[0].dataset.dataName;
            var /** @type {?} */ type = $(this)[0].dataset.dataType;
            var /** @type {?} */ fieldName = $(this)[0].dataset.dataFieldname;
            if (fieldName == null) {
                return;
            }
            var /** @type {?} */ textArea = $(this).find('textarea').length;
            var /** @type {?} */ input = $(this).find('input');
            if (textArea > 0) {
                input = $(this).find('textarea');
            }
            var /** @type {?} */ val = input != null ? input.val() : null;
            var /** @type {?} */ value = input != null ? input.val() : null;
            if (type === 'date' || (type === 'complex' && self._complexSettings[index][key]['type'] === 'date')) {
                var /** @type {?} */ parts = val.split('.');
                var /** @type {?} */ date = '';
                if (parts[0] !== '') {
                    date = new Date(parts[2], parts[1] - 1, parts[0]).toISOString();
                }
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = date;
                }
                else {
                    orderToUpdate[key] = date;
                }
            }
            else if (type === 'time' || (type === 'complex' && self._complexSettings[index][key]['type'] === 'time')) {
                var /** @type {?} */ parts = val.split(':');
                var /** @type {?} */ date = '';
                if (parts[0] !== '') {
                    var /** @type {?} */ today = new Date();
                    date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parts[0], parts[1], 0).toISOString();
                }
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = date;
                }
                else {
                    orderToUpdate[key] = date;
                }
            }
            else if (type === 'input' || (type === 'complex' && self._complexSettings[index][key]['type'] === 'input')) {
                for (var /** @type {?} */ i = 0; i < self.columns.length; i++) {
                    var /** @type {?} */ shouldBeNumber = false;
                    var /** @type {?} */ dbType = '';
                    var /** @type {?} */ isDbTypeDefined = false;
                    if (type === 'complex') {
                        if (self._complexSettings[index][key].hasOwnProperty('dbType')) {
                            isDbTypeDefined = true;
                            dbType = self._complexSettings[index][key]['dbType'];
                        }
                    }
                    else {
                        if (self.fieldsByName[self.columns[i].name].hasOwnProperty('dbType')) {
                            isDbTypeDefined = true;
                            dbType = self.fieldsByName[self.columns[i].name]['dbType'];
                        }
                    }
                    if (self.columns[i].name === key && isDbTypeDefined) {
                        if (dbType.indexOf('DECIMAL') !== -1) {
                            var /** @type {?} */ fieldMap = self.fieldsByName[key];
                            value = UtilService.deformatDecimal(val, fieldMap.decimalCount);
                            shouldBeNumber = true;
                            if (isNaN(value)) {
                                if (self.tableMode === TableModeEnum.Details) {
                                    delete self._orderList[index][key];
                                }
                            }
                        }
                        else if (dbType.indexOf('INTEGER') !== -1 ||
                            dbType.indexOf('BIGINT') !== -1 ||
                            dbType.indexOf('SMALLINT') !== -1) {
                            value = parseInt(val, 0);
                            shouldBeNumber = true;
                            if (isNaN(value)) {
                                if (self.tableMode === TableModeEnum.Details) {
                                    delete self._orderList[index][key];
                                }
                            }
                        }
                        if (!(shouldBeNumber && isNaN(value))) {
                            if (self.tableMode === TableModeEnum.Details) {
                                self._orderList[index][key] = value;
                            }
                            else {
                                orderToUpdate[key] = value;
                            }
                        }
                    }
                }
            }
            else if (type === 'check' || (type === 'complex' && self._complexSettings[index][key]['type'] === 'check')) {
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = input.is(':checked');
                }
                else {
                    orderToUpdate[key] = input.is(':checked');
                }
            }
            else if (type === 'completer' || (type === 'complex' && self._complexSettings[index][key]['type'] === 'completer')) {
                self.autocomplete.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName && child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
            else if (type === 'combo' || (type === 'complex' && self._complexSettings[index][key]['type'] === 'combo')) {
                self.combo.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName && child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
            else if (type === 'comboFixed' || (type === 'complex' && self._complexSettings[index][key]['type'] === 'comboFixed')) {
                self.combo.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName && child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
        });
        this.changeRowStatus(row, '');
        if (this.tableMode === TableModeEnum.Table) {
            var /** @type {?} */ params = {
                action: TableActionEnum.Update,
                document: orderToUpdate
            };
            this.tableAction.emit(params);
        }
    };
    /**
     * @param {?} eventTarget
     * @param {?} notify
     * @return {?}
     */
    EditTableComponent.prototype.onInlineAddOrder = function (eventTarget, notify) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ row = $(eventTarget).closest('tr');
        var /** @type {?} */ isValid = self.doValidationOfRow(eventTarget);
        if (notify && !isValid) {
            this.notificationService.openNoty('Nisu sva polja validna!');
        }
        if (row.find('.error').length > 0) {
            return;
        }
        var /** @type {?} */ rowIdentity = row[0].dataset.rowIdentity.toString();
        var /** @type {?} */ orderToAdd = {};
        orderToAdd[this.identFromTableMode] = rowIdentity;
        // if (this.tableMode === TableModeEnum.Details) {
        //     orderToAdd['rbr'] = row.find('button')[0].dataset.dataRbr;
        // }
        var /** @type {?} */ index;
        if (this.tableMode === TableModeEnum.Details) {
            for (var /** @type {?} */ i = 0; i < self._orderList.length; i++) {
                if (self._orderList[i].rbr.toString() === orderToAdd['rbr']) {
                    index = i;
                }
            }
        }
        var /** @type {?} */ rowOrder = self.tableMode === TableModeEnum.Details ? self._orderList[index] : orderToAdd;
        row.find('> td').each(function () {
            var /** @type {?} */ key = $(this)[0].dataset.dataName;
            var /** @type {?} */ type = $(this)[0].dataset.dataType;
            var /** @type {?} */ fieldName = $(this)[0].dataset.dataFieldname;
            if (fieldName == null) {
                return;
            }
            var /** @type {?} */ textArea = $(this).find('textarea').length;
            var /** @type {?} */ input = $(this).find('input');
            if (textArea > 0) {
                input = $(this).find('textarea');
            }
            var /** @type {?} */ val = input != null ? input.val() : null;
            var /** @type {?} */ value = input != null ? input.val() : null;
            if (type === 'date') {
                var /** @type {?} */ parts = val.split('.');
                var /** @type {?} */ date = '';
                if (parts[0] !== '') {
                    date = new Date(parts[2], parts[1] - 1, parts[0]).toISOString();
                }
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = date;
                }
                else {
                    orderToAdd[key] = date;
                }
            }
            else if (type === 'time') {
                var /** @type {?} */ parts = val.split(':');
                var /** @type {?} */ date = '';
                if (parts[0] !== '') {
                    var /** @type {?} */ today = new Date();
                    date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parts[0], parts[1], 0).toISOString();
                }
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = date;
                }
                else {
                    orderToAdd[key] = date;
                }
            }
            else if (type === 'input') {
                for (var /** @type {?} */ i = 0; i < self.columns.length; i++) {
                    var /** @type {?} */ shouldBeNumber = false;
                    var /** @type {?} */ dbType = '';
                    var /** @type {?} */ isDbTypeDefined = false;
                    if (type === 'complex') {
                        if (self._complexSettings[index][key].hasOwnProperty('dbType')) {
                            isDbTypeDefined = true;
                            dbType = self._complexSettings[index][key]['dbType'];
                        }
                    }
                    else {
                        if (self.fieldsByName[self.columns[i].name].hasOwnProperty('dbType')) {
                            isDbTypeDefined = true;
                            dbType = self.fieldsByName[self.columns[i].name]['dbType'];
                        }
                    }
                    if (self.columns[i].name === key && isDbTypeDefined) {
                        if (dbType.indexOf('DECIMAL') !== -1) {
                            var /** @type {?} */ fieldMap = self.fieldsByName[key];
                            value = UtilService.deformatDecimal(val, fieldMap.decimalCount);
                            shouldBeNumber = true;
                            if (isNaN(value)) {
                                if (self.tableMode === TableModeEnum.Details) {
                                    delete self._orderList[index][key];
                                }
                            }
                        }
                        else if (dbType.indexOf('INTEGER') !== -1 ||
                            dbType.indexOf('BIGINT') !== -1 ||
                            dbType.indexOf('SMALLINT') !== -1) {
                            value = parseInt(val, 0);
                            shouldBeNumber = true;
                            if (isNaN(value)) {
                                if (self.tableMode === TableModeEnum.Details) {
                                    delete self._orderList[index][key];
                                }
                            }
                        }
                        if (!(shouldBeNumber && isNaN(value))) {
                            if (self.tableMode === TableModeEnum.Table) {
                                self._orderList[index][key] = value;
                            }
                            else {
                                orderToAdd[key] = value;
                            }
                        }
                    }
                }
            }
            else if (type === 'check') {
                if (self.tableMode === TableModeEnum.Details) {
                    self._orderList[index][key] = input.is(':checked');
                }
                else {
                    orderToAdd[key] = input.is(':checked');
                }
            }
            else if (type === 'completer' || type === 'combo') {
                self.autocomplete.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName && child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
            else if (type === 'comboFixed') {
                self.combo.forEach(function (child) {
                    if (child.fieldSettings.fieldName === fieldName && child.tag.toString() === rowIdentity) {
                        UtilService.fieldUpdateValue(rowOrder, child.fieldSettings, child.selectedItem);
                    }
                });
            }
        });
        this.changeRowStatus(row, '');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EditTableComponent.prototype.onKeyDown = function (event) {
        if (($('.popup').is(':visible') && event.keyCode === 13) ||
            ($('.combo-component').is(':visible') && event.keyCode === 13)) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    /**
     * @param {?} orderId
     * @param {?} mode
     * @return {?}
     */
    EditTableComponent.prototype.propagateAction = function (orderId, mode) {
        setTimeout(function (self) {
            var /** @type {?} */ action;
            switch (mode) {
                case TableActionEnum.View:
                    this._mode = FormModeEnum.View;
                    action = TableActionEnum.View;
                    break;
                case TableActionEnum.Delete:
                    action = TableActionEnum.Delete;
                    break;
                case TableActionEnum.Add:
                    this._mode = FormModeEnum.Add;
                    action = TableActionEnum.Add;
                    break;
                case TableActionEnum.Copy:
                    this._mode = FormModeEnum.Copy;
                    action = TableActionEnum.Copy;
                    break;
            }
            var /** @type {?} */ params = {
                action: action,
                documentId: orderId
            };
            self.tableAction.emit(params);
        }, 0, this);
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.ordersTableCommon = function () {
        var /** @type {?} */ that = this;
        if (this.tableMode === TableModeEnum.Details) {
            this.addKeyListeners();
            this.addListenersToNewlyAddedRow();
        }
        if (this.tableMode === TableModeEnum.Table) {
            $('.orderList' + this.componentGuid + this.tableMode).find("tr td:not('.actions')").off('click');
            this.setViewListener();
        }
        if (this.tableMode === TableModeEnum.Details) {
            $('.orderList' + this.componentGuid + this.tableMode).on('page.dt length.dt', function () {
                that.doValidationAndSaveOfCurrentPage();
                setTimeout(function (self) {
                    self.addKeyListeners();
                }, 0, that);
            });
        }
        if (this.resizable) {
            this.resizableGrid();
        }
        if (this.reordable) {
            this.dropGrid();
        }
        if (this._columnsSet) {
            return;
        }
        this._columnsSet = true;
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.setViewListener = function () {
        var _this = this;
        // TODO This method needs an explanation!
        $('.orderList' + this.componentGuid + this.tableMode).find("tr td:not('.actions')").on('click', function (e) {
            $('.orderList' + _this.componentGuid + _this.tableMode).find("tr td:not('.actions')").off('click');
            var /** @type {?} */ $row = $(e.target).closest('tr');
            if (!$row.hasClass('adding') && !$row.hasClass('editing')) {
                var /** @type {?} */ $childrenWithData = $row.find('td span[data-data-id]');
                _this.propagateAction($childrenWithData[0].dataset.dataId, TableActionEnum.View);
            }
            _this.setViewListener();
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EditTableComponent.prototype.page = function (event) {
        this.filter(FilterActionEnum$1.Page, this.sortOrder, event);
    };
    /**
     * @param {?} column
     * @return {?}
     */
    EditTableComponent.prototype.sortAction = function (column) {
        if (!this.sortingEnabled || !column.sortable) {
            return;
        }
        if (this.sortColumnName !== column.name) {
            this.sortColumnName = column.name;
            this.sortAscending = true;
        }
        else {
            this.sortAscending = !this.sortAscending;
        }
        this.filter(FilterActionEnum$1.Sort, this.fieldsByName[column.name], null);
    };
    /**
     * @param {?} action
     * @param {?} order
     * @param {?} page
     * @return {?}
     */
    EditTableComponent.prototype.filter = function (action, order, page) {
        var _this = this;
        if (action === FilterActionEnum$1.Sort && !this.isTableValid()) {
            return;
        }
        if (action === FilterActionEnum$1.Page) {
            this.pageCurrent = page;
        }
        if (typeof order !== 'undefined' && Object.keys(order).length === 0 && page === null) {
            this.pageCurrent = 1;
        }
        else {
            this.sortOrder = order;
        }
        var /** @type {?} */ direction = this.sortColumnName != null
            ? (this.sortAscending ? 'asc' : 'desc') : 'asc';
        if (this.tableMode === TableModeEnum.Table) {
            // Server-side filtering, sorting, pagination, etc.
            var /** @type {?} */ params = {
                action: TableActionEnum.Filter,
                filter: {
                    pageCurrent: this.pageCurrent,
                    filterQuery: '',
                    filterDate: null,
                    filterObjects: [],
                    filterCombined: null,
                    rowsOnPage: this.rowsOnPage,
                    sortOrder: this.sortOrder,
                    direction: direction,
                    relations: this._settings.relations
                }
            };
            this.tableAction.emit(params);
            return;
        }
        if (this.tableMode === TableModeEnum.Details) {
            // Client-side filtering, sorting, pagination, etc.
            if (typeof this.sortOrder !== 'undefined' && Object.keys(this.sortOrder).length > 0) {
                this._orderListTotal = this._orderListTotal.sort(function (a, b) {
                    var /** @type {?} */ x = _this.getTableCellText(order['fieldName'], a);
                    var /** @type {?} */ y = _this.getTableCellText(order['fieldName'], b);
                    if (direction === 'desc') {
                        if (typeof x === 'undefined' && typeof y === 'undefined') {
                            return 0;
                        }
                        else if (typeof x === 'undefined') {
                            return 1;
                        }
                        else if (typeof y === 'undefined') {
                            return -1;
                        }
                        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
                    }
                    if (typeof x === 'undefined' && typeof y === 'undefined') {
                        return 0;
                    }
                    else if (typeof x === 'undefined') {
                        return -1;
                    }
                    else if (typeof y === 'undefined') {
                        return 1;
                    }
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            }
            this.totalPages = Math.ceil(this._orderListTotal.length / this.rowsOnPage);
            if (this.totalPages < this.pageCurrent) {
                this.pageCurrent = 1;
            }
            var /** @type {?} */ from = (this.pageCurrent - 1) * this.rowsOnPage;
            this._orderList = this._orderListTotal.slice(from, this.rowsOnPage * this.pageCurrent);
            this.from = (this.pageCurrent - 1) * this.rowsOnPage;
            this.to = this.rowsOnPage * this.pageCurrent;
            if (direction === 'asc') {
                this.direction = 0;
            }
            else {
                this.direction = 1;
            }
            if (typeof this.sortOrder !== 'undefined' && Object.keys(this.sortOrder).length > 0) {
                this.fieldName = this.sortOrder.fieldName;
            }
            this.ref.detectChanges();
            this.addKeyListeners();
            this.addListenersToNewlyAddedRow();
            this.sortOrder = undefined;
            return;
        }
    };
    /**
     * @param {?} fieldName
     * @return {?}
     */
    EditTableComponent.prototype.isFieldDisabled = function (fieldName) {
        if (fieldName === 'id') {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @param {?} columnName
     * @param {?} eventTarget
     * @return {?}
     */
    EditTableComponent.prototype.doValidationOfInput = function (columnName, eventTarget) {
        // TODO Add validation from validator field
        var /** @type {?} */ isValid = true;
        if (this._settings.getFieldByName(columnName).mandatory) {
            if ($(eventTarget).val() === '') {
                $(eventTarget).addClass('error');
                isValid = false;
            }
            else {
                $(eventTarget).removeClass('error');
            }
        }
        return isValid;
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.isTableValid = function () {
        this.doValidationAndSaveOfCurrentPage();
        var /** @type {?} */ isValid = true;
        if (typeof this._orderList !== 'undefined' && this._orderList !== null) {
            for (var /** @type {?} */ i = 0; i < this._orderList.length; i++) {
                if (this._orderList[i].hasOwnProperty('isValid') && !this._orderList[i].isValid) {
                    isValid = false;
                    break;
                }
            }
            if (isValid) {
                for (var /** @type {?} */ i = 0; i < this._orderList.length; i++) {
                    if (this._orderList[i].hasOwnProperty('isValid')) {
                        delete this._orderList[i].isValid;
                    }
                }
            }
        }
        return isValid;
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.doValidationAndSaveOfCurrentPage = function () {
        var /** @type {?} */ that = this;
        $('.orderList' + this.componentGuid + TableModeEnum.Details).find('tbody tr').each(function () {
            if ($(this).is(':visible')) {
                if (this.className.indexOf('adding') !== -1) {
                    that.onInlineAddOrder($(this), false);
                }
                else if (this.className.indexOf('editing') !== -1) {
                    that.onInlineUpdateOrder($(this), false);
                }
            }
        });
        if ($('.orderList' + this.componentGuid + TableModeEnum.Details).find('.error').length > 0) {
            return false;
        }
        return true;
    };
    /**
     * @param {?} tableRow
     * @return {?}
     */
    EditTableComponent.prototype.isRowValid = function (tableRow) {
        var /** @type {?} */ isValid = true;
        this.timePicker.forEach(function (child) {
            if (tableRow && tableRow.length > 0 && tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        this.datePicker.forEach(function (child) {
            if (tableRow && tableRow.length > 0 && tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        this.input.forEach(function (child) {
            if (tableRow && tableRow.length > 0 && tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        this.combo.forEach(function (child) {
            if (tableRow && tableRow.length > 0 && tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        this.autocomplete.forEach(function (child) {
            if (tableRow && tableRow.length > 0 && tableRow[0].contains(child.getItemRef())) {
                if (!child.validate()) {
                    isValid = false;
                }
            }
        });
        if (!isValid) {
            return false;
        }
        return true;
    };
    /**
     * @param {?} eventTarget
     * @return {?}
     */
    EditTableComponent.prototype.doValidationOfRow = function (eventTarget) {
        var /** @type {?} */ tableRow = $(eventTarget).closest('tr');
        var /** @type {?} */ isValid = this.isRowValid(tableRow);
        if (this.tableMode === this.TableModeEnum.Details) {
            var /** @type {?} */ rbr = tableRow.find('button')[0].dataset.dataRbr;
            for (var /** @type {?} */ i = 0; i < this._orderList.length; i++) {
                if (this._orderList[i]['rbr'].toString() === rbr) {
                    this._orderList[i]['isValid'] = isValid;
                    break;
                }
            }
        }
        return isValid;
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.setFieldByName = function () {
        if (this._settings != null) {
            for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
                for (var /** @type {?} */ i = 0; i < this._settings.columns.length; i++) {
                    if (this.columns[j].name.toLowerCase() === this._settings.columns[i].fieldName.toLowerCase()) {
                        var /** @type {?} */ fieldByName = this._settings.columns[i];
                        this.fieldsByName[this.columns[j].name] = fieldByName;
                        this.fieldsByName[this.columns[j].name]['sortable'] = this._settings.columns[i].sortable;
                        this.fieldsByName[this.columns[j].name]['resizing'] = false;
                    }
                }
            }
        }
    };
    /**
     * @param {?} order
     * @param {?} column
     * @return {?}
     */
    EditTableComponent.prototype.getInputValue = function (order, column) {
        return this.fieldService.getInputValue(order, column);
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @param {?=} complexFieldMap
     * @return {?}
     */
    EditTableComponent.prototype.getComboFixedText = function (order, columnName, complexFieldMap) {
        if (complexFieldMap === void 0) { complexFieldMap = null; }
        var /** @type {?} */ fieldMap = this._settings.getFieldByName(columnName);
        var /** @type {?} */ value = UtilService.getFieldValue(order, fieldMap);
        var /** @type {?} */ enumResult;
        if (complexFieldMap && complexFieldMap.lookupList != null) {
            enumResult = complexFieldMap.lookupList.filter(function (listItem) { return listItem.value === value; });
        }
        else {
            enumResult = this.listService.getEnum(fieldMap.entityType).filter(function (item) { return item.value === value; });
        }
        if (enumResult.length === 0) {
            return null;
        }
        return enumResult[0].label;
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @return {?}
     */
    EditTableComponent.prototype.getCompleterItem = function (order, columnName) {
        return UtilService.getFieldObject(order, this._settings.getFieldByName(columnName).propertyPath.all);
    };
    /**
     * @param {?} order
     * @param {?} columnName
     * @return {?}
     */
    EditTableComponent.prototype.getComboFixedItem = function (order, columnName) {
        return UtilService.getFieldValue(order, this._settings.getFieldByName(columnName));
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.onOrderListAndRelationsLoaded = function () {
        if (!this.initialized || this.tableMode == null || this.orderList == null) {
            return;
        }
        var /** @type {?} */ setColumns = false;
        if (this.columns.length === 0) {
            setColumns = true;
        }
        var /** @type {?} */ columnsTemp = [];
        for (var /** @type {?} */ i = 0; i < this._settings.columns.length; i++) {
            if (Object.keys(this._settings.columns[i]).length !== 0) {
                columnsTemp.push({
                    'name': this._settings.columns[i].fieldName,
                    'label': this._settings.columns[i].label,
                    'dbType': this._settings.columns[i].dbType,
                    'id': this._settings.columns[i].id,
                    'size': this._settings.columns[i].width,
                    'sortable': this._settings.columns[i].sortable,
                });
            }
        }
        this.columns = columnsTemp;
        this.columnsWithActions = this.columns.slice();
        this.columnsWithActions.splice(0, 0, {
            'name': '',
            'label': '',
            'dbType': '',
            'id': '',
            'size': '',
            'sortable': false
        });
        this.setFieldByName();
        if (setColumns && this.tableMode === TableModeEnum.Table) {
            if (this.resizable) {
                this.setColumnsSizes();
            }
            if (this.reordable) {
                this.setColumnsOrders();
            }
        }
        setTimeout(function (self) {
            self.ordersTableCommon();
        }, 0, this);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EditTableComponent.prototype.onInlineDeleteOpen = function (event) {
        if (this.tableMode === TableModeEnum.Table) {
            this.propagateAction($(event.target).closest('button')[0].dataset.dataId, TableActionEnum.Delete);
        }
        else {
            this.removeRow(event);
        }
    };
    /**
     * @param {?} event
     * @param {?} document
     * @return {?}
     */
    EditTableComponent.prototype.onInlineEditOpen = function (event, document) {
        if (!$(event.target).closest('tr').hasClass('adding')) {
            this.changeRowStatus($(event.target).closest('tr'), 'editing');
        }
        var /** @type {?} */ params = {
            action: TableActionEnum.Edit,
            document: document
        };
        this.onAction(params);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    EditTableComponent.prototype.onInlineEditCancel = function (event) {
        var _this = this;
        var /** @type {?} */ element = event;
        if (event.target) {
            element = $(event.target).closest('button.edit-cancel');
        }
        else {
            element = event.find('button.edit-cancel');
        }
        var /** @type {?} */ index = this._orderList.findIndex(function (listItem) { return listItem['rbr'].toString() ===
            element[0].dataset.dataRbr; });
        var /** @type {?} */ row = element.closest('tr');
        this.orderList[index] = this.shownEditingRows[row[0].dataset.rowIdentity];
        this.changeRowStatus(row, '');
        var /** @type {?} */ params = {
            action: TableActionEnum.EditCancel,
            document: this.orderList[index],
            index: index
        };
        this.onAction(params);
        setTimeout(function () {
            _this.setViewListener();
        });
    };
    /**
     * @param {?} selectedDocument
     * @return {?}
     */
    EditTableComponent.prototype.onInlineViewAndSelect = function (selectedDocument) {
        var /** @type {?} */ tableRow = $(this.getItemRef().querySelector('tbody span[data-data-' + this.ident + '=\'' + selectedDocument[this.ident] + '\']')).closest('tr');
        if (this.tableMode === TableModeEnum.Table) {
            if (!tableRow.hasClass('adding') &&
                !tableRow.hasClass('editing')) {
                this.propagateAction(selectedDocument[this.ident], TableActionEnum.View);
            }
        }
        this.onInlineSelect(selectedDocument);
    };
    /**
     * @param {?} selectedDocument
     * @return {?}
     */
    EditTableComponent.prototype.onInlineSelect = function (selectedDocument) {
        var /** @type {?} */ params = {
            action: TableActionEnum.Select,
            document: selectedDocument
        };
        if (selectedDocument === null) {
            $('.orderList' + this.componentGuid + this.tableMode + ' tbody tr').removeClass('selected');
            this.onAction(params);
        }
        else {
            var /** @type {?} */ tableRow = $(this.getItemRef().querySelector('tbody span[data-data-' + this.ident + '=\'' + selectedDocument[this.ident] + '\']')).closest('tr');
            if (!tableRow.hasClass('selected')) {
                this.selectedObject = selectedDocument;
                $('.orderList' + this.componentGuid + this.tableMode + ' tbody tr').removeClass('selected');
                tableRow.addClass('selected');
                this.onAction(params);
            }
        }
        params = {
            action: TableActionEnum.Click,
            document: selectedDocument
        };
        this.onAction(params);
    };
    /**
     * @param {?} columnName
     * @param {?} order
     * @return {?}
     */
    EditTableComponent.prototype.getTableCellText = function (columnName, order) {
        var /** @type {?} */ val = '';
        if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Input) {
            val = UtilService.getFieldValue(order, this.fieldsByName[columnName]);
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Completer) {
            val = UtilService.getCompleterValue(order, this.fieldsByName[columnName]);
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Date) {
            val = UtilService.formatDate(this.getInputValue(order, columnName));
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Time) {
            val = UtilService.formatTime(this.getInputValue(order, columnName));
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Check) {
            val = this.getInputValue(order, columnName);
        }
        else if (this.fieldsByName[columnName]['type'] === FieldTypeEnum.Combo ||
            this.fieldsByName[columnName]['type'] === FieldTypeEnum.ComboFixed) {
            val = this.getComboFixedText(order, columnName);
        }
        return val;
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.getTableData = function () {
        var /** @type {?} */ table = [];
        if (this._orderList) {
            for (var /** @type {?} */ i = 0; i < this._orderList.length; i++) {
                var /** @type {?} */ row = {};
                for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
                    var /** @type {?} */ val = this.getTableCellText(this.columns[j].name, this._orderList[i]);
                    if (typeof val !== 'undefined' && val !== null) {
                        row[this.columns[j].label] = val;
                    }
                }
                table.push(row);
            }
        }
        return table;
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.setColumnsSizes = function () {
        var /** @type {?} */ columnsSizes = new Map();
        for (var /** @type {?} */ i = 0; i < this.columns.length; i++) {
            columnsSizes.set(this.columns[i].id, parseInt(this.columns[i].size, 0));
        }
        this.backendService.setColumnsSizes(columnsSizes);
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.setColumnsOrders = function () {
        this.backendService.setColumnsOrders(this.columns.map(function (column) { return column.id; }));
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.ngOnInit = function () {
        var /** @type {?} */ that = this;
        this.initialized = true;
        this.onOrderListAndRelationsLoaded();
        if (this.resizable) {
            this.setColumnsSizes();
        }
        if (this.reordable) {
            this.setColumnsOrders();
        }
        this.isAdmin = this.authenticationService.getUser().type === 'admin';
        $('.table-responsive').on('scroll', function (e) {
            $('.popup').removeClass('show');
            $('.combo-component').removeClass('open');
        });
        if (this.tableMode === TableModeEnum.Table) {
            this.tabSwitchSubscription = this.applicationService.tabSwitchEvent.subscribe(function (data) {
                if (that.identity.documentId === data.identity.documentId) {
                    setTimeout(function () {
                        UtilService.resetCss();
                        UtilService.recalculateCss();
                    });
                }
            });
            this.tabOpenSubscription = this.applicationService.tabOpenEvent.subscribe(function (data) {
                setTimeout(function () {
                    UtilService.resetCss();
                    UtilService.recalculateCss();
                });
            });
        }
    };
    /**
     * @param {?} element
     * @return {?}
     */
    EditTableComponent.prototype.scrollbarVisible = function (element) {
        return element.scrollWidth > element.clientWidth;
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.scrollHeaderEvent$ = Observable$1.fromEvent($(this.getItemRef().querySelector('.tbody-wrapper')), 'scroll').subscribe(function (event) {
            $(_this.getItemRef().querySelector('.thead-wrapper')).scrollLeft($(_this.getItemRef().querySelector('.tbody-wrapper')).get(0).scrollLeft);
        });
        this.scrollBodyEvent$ = Observable$1.fromEvent($(this.getItemRef().querySelector('.thead-wrapper')), 'scroll').subscribe(function (event) {
            $(_this.getItemRef().querySelector('.tbody-wrapper')).scrollLeft($(_this.getItemRef().querySelector('.thead-wrapper')).get(0).scrollLeft);
        });
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.ngOnDestroy = function () {
        if ($('.editing .edit-cancel').length > 0) {
            var /** @type {?} */ element = $(this.getItemRef().querySelector('.editing'));
            this.onInlineEditCancel(element);
        }
        $('.adding .add-cancel').trigger('click');
        if (this.tableSettingsSubscription) {
            this.tableSettingsSubscription.unsubscribe();
        }
        if (this.orderListCountSubscription) {
            this.orderListCountSubscription.unsubscribe();
        }
        if (this.modeSubscription) {
            this.modeSubscription.unsubscribe();
        }
        if (this.outsideSubscription) {
            this.outsideSubscription.unsubscribe();
        }
        if (this.documentListSubscription) {
            this.documentListSubscription.unsubscribe();
        }
        if (this.scrollHeaderEvent$) {
            this.scrollHeaderEvent$.unsubscribe();
        }
        if (this.scrollBodyEvent$) {
            this.scrollBodyEvent$.unsubscribe();
        }
        if (this.resizeEvent$) {
            this.resizeEvent$.unsubscribe();
        }
        if (this.tabSwitchSubscription) {
            this.tabSwitchSubscription.unsubscribe();
        }
        if (this.tabOpenSubscription) {
            this.tabOpenSubscription.unsubscribe();
        }
        this.ref.detach();
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.resizableGrid = function () {
        var /** @type {?} */ that = this;
        var /** @type {?} */ tbody = $(this.getItemRef().querySelector('.tbody-wrapper')).find('table');
        var /** @type {?} */ table = $(this.getItemRef().querySelector('.thead-wrapper')).find('table');
        if (this.tableMode !== TableModeEnum.Table) {
            table = $(this.getItemRef().querySelector('.tbody-wrapper')).find('table');
        }
        var /** @type {?} */ thHeight = table.find('th:first').height();
        var /** @type {?} */ columnName = '';
        for (var /** @type {?} */ j = 0; j < this.columns.length; j++) {
            if (table.find('th.column_' + that.columns[j].name).is('.ui-resizable')) {
                table.find('th.column_' + that.columns[j].name).resizable('destroy');
            }
            var /** @type {?} */ options = {
                handles: 'e',
                minHeight: thHeight,
                maxHeight: thHeight,
                animate: true,
                resize: function (event, ui) {
                    // Subtract padding
                    var /** @type {?} */ width = (parseInt(ui.size.width, 0) - 40) + '';
                    that.fieldsByName[columnName]['width'] = width;
                    that.ref.detectChanges();
                },
                stop: function (event, ui) {
                    // Subtract padding
                    var /** @type {?} */ width = (parseInt(ui.size.width, 0) - 40) + '';
                    // Prevent flickering
                    for (var /** @type {?} */ i = 0; i < that.columns.length; i++) {
                        that.fieldsByName[that.columns[i].name]['width'] = table.find('th.column_' + that.columns[i].name).width();
                    }
                    that.ref.detectChanges();
                    that.fieldsByName[columnName]['width'] = width;
                    that.fieldsByName[columnName]['resizing'] = false;
                    that.fieldsByName[columnName]['size'] = ui.size.width;
                    that.ref.detectChanges();
                    if (that.tableMode === TableModeEnum.Table) {
                        // Save columns sizes
                        var /** @type {?} */ columnsSizes = new Map();
                        for (var /** @type {?} */ key in that.fieldsByName) {
                            if (that.fieldsByName.hasOwnProperty(key)) {
                                var /** @type {?} */ field = (that.fieldsByName[key]);
                                if (that.fieldsByName[field.fieldName]['size']) {
                                    columnsSizes.set(field.id, parseInt(that.fieldsByName[field.fieldName]['size'], 0));
                                }
                                else {
                                    columnsSizes.set(field.id, parseInt(field.width, 0));
                                }
                            }
                        }
                        that.backendService.setColumnsSizes(columnsSizes);
                    }
                    // Prevent flickering
                    for (var /** @type {?} */ i = 0; i < that.columns.length; i++) {
                        that.fieldsByName[that.columns[i].name]['width'] = 'auto';
                        that.fieldsByName[that.columns[i].name]['size'] = that.columns[i].size;
                    }
                },
                start: function (event, ui) {
                    columnName = $(event.target)[0].classList[0].substring(7, $(event.target)[0].classList[0].length);
                    that.fieldsByName[columnName]['resizing'] = true;
                    that.ref.detectChanges();
                }
            };
            if (this.tableMode === TableModeEnum.Table) {
                options['alsoResize'] = tbody.find('th.column_' + that.columns[j].name);
            }
            table.find('th.column_' + that.columns[j].name).resizable(options);
        }
    };
    /**
     * @return {?}
     */
    EditTableComponent.prototype.dropGrid = function () {
        var /** @type {?} */ self = this;
        var /** @type {?} */ table = $(this.getItemRef().querySelector('.thead-wrapper')).find('table');
        if (this.tableMode !== TableModeEnum.Table) {
            table = $(this.getItemRef().querySelector('.tbody-wrapper')).find('table');
        }
        var /** @type {?} */ el = table[0];
        var /** @type {?} */ dragger = tableDragger(el, {
            mode: 'column',
            dragHandler: '.handle',
            animation: 300
        });
        dragger.on('drop', function (from, to) {
            var /** @type {?} */ decrement = self._decrement;
            if (self.tableMode !== TableModeEnum.Table) {
                decrement--;
            }
            var /** @type {?} */ f = self.columns[from - decrement];
            self.columns[from - decrement] = self.columns[to - decrement];
            self.columns[to - decrement] = f;
            self.ref.detectChanges();
            if (self.tableMode === TableModeEnum.Table) {
                // Save orders
                var /** @type {?} */ columnsOrders = self.columns.map(function (column) { return column.id; });
                self.backendService.setColumnsOrders(columnsOrders);
            }
        });
    };
    return EditTableComponent;
}());
EditTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-edit-table',
                template: "\n      <div [ngClass]=\"{'main-table': tableMode === TableModeEnum.Table, 'details-table': tableMode === TableModeEnum.Details}\">\n          <div class=\"panel panel-default\">\n              <div class=\"panel-body\">\n                  <div class=\"table-responsive\" [ngClass]=\"{'main': tableMode === TableModeEnum.Table, 'paging': paging, 'sticking': sticking}\">\n                      <table *ngIf=\"paging\"\n                             class=\"dataTable orderList display table-striped\"\n                             [ngClass]=\"{'pagination-main-table': tableMode === TableModeEnum.Table, 'table': tableMode === TableModeEnum.Table, 'details': tableMode !== TableModeEnum.Table}\"\n                             cellspacing=\"0\" width=\"100%\">\n                          <tfoot>\n                          <tr>\n                              <td>\n                                  <div class=\"dataTables_length\"\n                                       id=\"{{'DataTables_Table_0_length' + componentGuid + tableMode}}\">\n                                      <label>Prika\u017Ei\n                                          <select name=\"DataTables_Table_0_length\" aria-controls=\"DataTables_Table_0\" class=\"\"\n                                                  [(ngModel)]=\"rowsOnPage\" (change)=\"filter(FilterActionEnum.RowsPerPage, {}, null, null)\">\n                                              <option [ngValue]=\"10\">10</option>\n                                              <option [ngValue]=\"25\">25</option>\n                                              <option [ngValue]=\"50\">50</option>\n                                              <option [ngValue]=\"100\">100</option>\n                                              <option [ngValue]=\"1000\">1000</option>\n                                          </select> stavki</label>\n                                  </div>\n                              </td>\n                              <td>\n                                  <util-pagination *ngIf=\"_orderList\"\n                                                   [pageCurrent]=\"pageCurrent\"\n                                                   [pageTotal]=\"totalPages\"\n                                                   (page)=\"page($event)\"></util-pagination>\n                              </td>\n                          </tr>\n                          </tfoot>\n                      </table>\n                      <div class=\"thead-wrapper\" [ngClass]=\"{'thead-wrapper-main-table': tableMode === TableModeEnum.Table}\">\n                          <div class=\"sindu-wrapper\">\n                              <table class=\"{{'orderList' + componentGuid + tableMode}}\"\n                                     class=\"thead-main-table dataTable orderList display table table-striped row-border hover\"\n                                     [ngClass]=\"{'columns-main-table': tableMode === TableModeEnum.Table, 'hide-actions': tableMode !== TableModeEnum.Table && _mode === FormModeEnum.View}\"\n                                     cellspacing=\"0\"\n                                     width=\"100%\">\n                                  <thead>\n                                      <tr>\n                                          <th *ngIf=\"columns.length !== 0\"\n                                              class=\"actions dt-head-center\"\n                                              [ngClass]=\"{'wide': copyEnabled}\">\n                                              <button *ngIf=\"_settings.inlineAdding && additable &&\n                                                              (!maxRows || maxRows > _orderList.length)\"\n                                                      title=\"Dodaj\"\n                                                      (click)=\"onInlineAddOpenFromHeader(); $event.stopPropagation(); $event.preventDefault()\"\n                                                      class=\"actions btn btn-default btn-rounded btn-condensed btn-sm\">\n                                                  <span class=\"fa fa-plus\"></span>\n                                              </button>\n                                              <button *ngIf=\"!_settings.inlineAdding && additable &&\n                                                              (!maxRows || maxRows > _orderList.length)\"\n                                                      (click)=\"propagateAction(null, TableActionEnum.Add); $event.stopPropagation(); $event.preventDefault()\"\n                                                      title=\"Dodaj\"\n                                                      class=\"actions btn btn-default btn-rounded btn-condensed btn-sm\">\n                                                  <span class=\"fa fa-plus\"></span>\n                                              </button>\n                                          </th>\n                                          <th *ngIf=\"tableMode === TableModeEnum.Table && showDocumentStatusColumn\" style=\"width: 80px; min-width: 80px; max-width: 80px;\"><span>Status</span></th>\n                                          <th *ngFor=\"let column of columns\"\n                                              class=\"{{'column_' + column.name}}\"\n                                              title=\"{{column.label}}\"\n                                              [style.min-width.px]=\"fieldsByName[column.name]['width']\"\n                                              [style.max-width.px]=\"fieldsByName[column.name]['width']\"\n                                              [style.width.px]=\"fieldsByName[column.name]['width']\"\n                                              [ngClass]=\"{'auto': !fieldsByName[column.name]['resizing'], 'right-align': fieldsByName[column.name] | NumberPure, 'hidden': !fieldsByName[column.name]['visible']}\">\n                                              <div class=\"header-flex\" [ngClass]=\"{'sorting': column.sortable === true, 'sorting_asc': column.name === sortColumnName && sortAscending, 'sorting_desc': column.name === sortColumnName && !sortAscending}\">\n                                                  <i *ngIf=\"tableMode === TableModeEnum.Table\" class=\"handle fa fa-arrows\"></i>\n                                                  <span class=\"span-text\" [ngClass]=\"{'sorting': column.sortable === true}\"\n                                                        (click)=\"sortAction(column)\"\n                                                        [attr.data-data-name]=\"column.name\">{{column.label}}</span>\n                                              </div>\n                                          </th>\n                                      </tr>\n                                  </thead>\n                              </table>\n                          </div>\n                      </div>\n\n                      <!-- ### THIS (most likely) IS NOT THE REAL TABLE HEADER, LOOK UP!!! -->\n                      <div class=\"tbody-wrapper\" [ngClass]=\"{'tbody-wrapper-main-table': tableMode === TableModeEnum.Table}\">\n                          <div class=\"sindu-wrapper\">\n                              <table class=\"{{'orderList' + componentGuid + tableMode}}\"\n                             class=\"dataTable orderList display table table-striped row-border hover\"\n                             [ngClass]=\"{'hide-actions': tableMode !== TableModeEnum.Table && _mode === FormModeEnum.View}\"\n                             cellspacing=\"0\"\n                             width=\"100%\">\n                              <thead>\n                              <tr>\n                                  <th *ngIf=\"columns.length !== 0\"\n                                      class=\"actions dt-head-center\"\n                                      [ngClass]=\"{'wide': copyEnabled}\">\n                                      <button *ngIf=\"_settings.inlineAdding && additable &&\n                                                      (!maxRows || maxRows > _orderList.length)\"\n                                              title=\"Dodaj\"\n                                              (click)=\"onInlineAddOpenFromHeader(); $event.stopPropagation(); $event.preventDefault()\"\n                                              class=\"actions btn btn-default btn-rounded btn-condensed btn-sm\">\n                                          <span class=\"fa fa-plus\"></span>\n                                      </button>\n                                      <button *ngIf=\"!_settings.inlineAdding && additable &&\n                                                      (!maxRows || maxRows > _orderList.length)\"\n                                              (click)=\"propagateAction(null, TableActionEnum.Add); $event.stopPropagation(); $event.preventDefault()\"\n                                              title=\"Dodaj\"\n                                              class=\"actions btn btn-default btn-rounded btn-condensed btn-sm\">\n                                          <span class=\"fa fa-plus\"></span>\n                                      </button>\n                                  </th>\n                                  <th *ngIf=\"tableMode === TableModeEnum.Table && showDocumentStatusColumn\" style=\"width: 80px; min-width: 80px; max-width: 80px;\"><span>Status</span></th>\n                                  <th *ngFor=\"let column of columns\"\n                                      class=\"{{'column_' + column.name}}\"\n                                      title=\"{{column.label}}\"\n                                      [style.min-width.px]=\"fieldsByName[column.name]['width']\"\n                                      [style.max-width.px]=\"fieldsByName[column.name]['width']\"\n                                      [style.width.px]=\"fieldsByName[column.name]['width']\"\n                                      [ngClass]=\"{'auto': !fieldsByName[column.name]['resizing'], 'right-align': fieldsByName[column.name] | NumberPure, 'hidden': !fieldsByName[column.name]['visible']}\">\n                                      <div class=\"header-flex\" [ngClass]=\"{'sorting': column.sortable === true, 'sorting_asc': column.name === sortColumnName && sortAscending, 'sorting_desc': column.name === sortColumnName && !sortAscending}\">\n                                          <i *ngIf=\"tableMode !== TableModeEnum.Table\" class=\"handle fa fa-arrows\"></i>\n                                          <span class=\"span-text\" [ngClass]=\"{'sorting': column.sortable === true}\"\n                                                (click)=\"sortAction(column)\"\n                                                [attr.data-data-name]=\"column.name\">{{column.label}}{{!fieldsByName[column.name]['resizing']}}</span>\n                                      </div>\n                                  </th>\n                              </tr>\n                              </thead>\n                              <tbody>\n                              <tr *ngFor=\"let order of _orderList; let i = index\"\n                              (click)=\"onInlineSelect(order)\"\n                              [attr.data-row-identity]=\"order | ident : tableMode : ident\">\n                              <td class=\"actions\"\n                                  [ngClass]=\"{'wide': copyEnabled}\">\n                                  <button *ngIf=\"_settings.listEditable && _settings.documentType !== DocumentTypeEnum.Dokument && _settings.inlineEditing\"\n                                          title=\"Izmeni\"\n                                          (click)=\"onInlineSelect(order); onInlineEditOpen($event, order); $event.stopPropagation(); $event.preventDefault()\"\n                                          [attr.data-data-id]=\"order?.id\"\n                                          [attr.data-data-rbr]=\"order?.rbr\"\n                                          [attr.disabled]=\"tableMode === TableModeEnum.Details || (tableMode === TableModeEnum.Table &&\n                                                  (!order.hasOwnProperty(fieldSayingIsEditable) ||\n                                                  (order.hasOwnProperty(fieldSayingIsEditable) &&\n                                                  !order[fieldSayingIsEditable]))) ? null : ''\"\n                                          class=\"btn btn-default btn-rounded btn-condensed btn-sm edit\">\n                                      <span class=\"fa fa-pencil\"></span>\n                                  </button>\n                                  <button *ngIf=\"_settings.listEditable && _settings.documentType !== DocumentTypeEnum.Dokument && _settings.inlineEditing\"\n                                          title=\"Potvrdi\"\n                                          [attr.data-data-id]=\"order?.id\"\n                                          [attr.data-data-rbr]=\"order?.rbr\"\n                                          (click)=\"onInlineUpdateOrder($event.target); $event.stopPropagation(); $event.preventDefault()\"\n                                          class=\"btn btn-default btn-rounded btn-condensed btn-sm edit-check\">\n                                      <span class=\"fa fa-check\"></span>\n                                  </button>\n                                  <button *ngIf=\"_settings.listDeletable\"\n                                          title=\"{{(_settings.documentType === DocumentTypeEnum.Dokument) ? 'Storniraj' : 'Obri\u0161i'}}\"\n                                          [attr.data-data-id]=\"order?.id\"\n                                          [attr.data-data-rbr]=\"order?.rbr\"\n                                          (click)=\"onInlineSelect(order); onInlineDeleteOpen($event); $event.stopPropagation(); $event.preventDefault()\"\n                                          class=\"btn btn-danger btn-rounded btn-condensed btn-sm delete\">\n                                      <span class=\"fa fa-times\"></span>\n                                  </button>\n                                  <button *ngIf=\"_settings.listEditable && _settings.documentType !== DocumentTypeEnum.Dokument && _settings.inlineEditing\"\n                                          title=\"Otka\u017Ei\"\n                                          [attr.data-data-id]=\"order?.id\"\n                                          [attr.data-data-rbr]=\"order?.rbr\"\n                                          (click)=\"onInlineEditCancel($event); $event.stopPropagation(); $event.preventDefault()\"\n                                          class=\"btn btn-default btn-rounded btn-condensed btn-sm edit-cancel\">\n                                      <span class=\"fa fa-times\"></span>\n                                  </button>\n                                  <button title=\"Potvrdi\"\n                                          [attr.data-data-id]=\"\"\n                                          [attr.data-data-rbr]=\"order?.rbr\"\n                                          class=\"btn btn-default btn-rounded btn-condensed btn-sm add-check\">\n                                      <span class=\"fa fa-check\"></span>\n                                  </button>\n                                  <button title=\"Otka\u017Ei\"\n                                          [attr.data-data-id]=\"\"\n                                          [attr.data-data-rbr]=\"order?.rbr\"\n                                          class=\"btn btn-default btn-rounded btn-condensed btn-sm add-cancel\">\n                                      <span class=\"fa fa-times\"></span>\n                                  </button>\n                                  <button title=\"Kopiraj\"\n                                          *ngIf=\"_settings.listEditable && tableMode === TableModeEnum.Details && copyEnabled && _settings.documentType !== DocumentTypeEnum.Dokument\"\n                                          (click)=\"onInlineSelect(order); propagateAction(order.rbr, TableActionEnum.Copy); $event.stopPropagation(); $event.stopPropagation(); $event.preventDefault()\"\n                                          class=\"actions btn btn-default btn-rounded btn-condensed btn-sm\">\n                                      <span class=\"fa fa-copy\"></span>\n                                  </button>\n                              </td>\n                              <td *ngIf=\"tableMode === TableModeEnum.Table && showDocumentStatusColumn\" style=\"width: 80px; min-width: 80px; max-width: 80px;\">\n                                  <util-status-lozenge [target]=\"order\"></util-status-lozenge>\n                              </td>\n                              <td *ngFor=\"let column of columns\"\n                                  [style.min-width.px]=\"fieldsByName[column.name]['width']\"\n                                  [style.max-width.px]=\"fieldsByName[column.name]['width']\"\n                                  [ngClass]=\"{'right-align': fieldsByName[column.name] | NumberPure, 'hidden': !fieldsByName[column.name]['visible']}\"\n                                  [attr.data-data-fieldname]=\"fieldsByName[column.name]['fieldName']\"\n                                  [attr.data-column-type]=\"fieldsByName[column.name]['type']\"\n                                  [attr.data-data-name]=\"fieldsByName[column.name]['fieldKey']\"\n                                  [attr.data-data-type]=\"fieldsByName[column.name]['type']\">\n                                  <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Input &&\n                                              (!!!fieldsByName[column.name]['dbType'] ||\n                                              (!!fieldsByName[column.name]['dbType'] && fieldsByName[column.name]['dbType'].indexOf('DECIMAL') === -1))\"\n                                       title=\"{{order | fieldViewText: fieldsByName[column.name]}}\">\n                                      <span title=\"{{order | fieldViewText: fieldsByName[column.name]}}\"\n                                            class='span-text'\n                                            [attr.data-data-id]=\"order?.id\"\n                                            [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                            [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewText: fieldsByName[column.name]}}</span>\n                                      <util-input *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                  class=\"isRowInAction\"\n                                                  [value]=\"order | fieldViewText: fieldsByName[column.name]\"\n                                                  [columnItem]=\"fieldsByName[column.name]\"\n                                                  (valueChanged)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i); doValidationOfInput(column.name, $event.target)\">\n                                      </util-input>\n                                  </div>\n                                  <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Input &&\n                                              !!fieldsByName[column.name]['dbType'] &&\n                                              fieldsByName[column.name]['dbType'].indexOf('DECIMAL') !== -1\"\n                                       title=\"{{order | fieldViewDecimal: fieldsByName[column.name]}}\">\n                                          <span title=\"{{order | fieldViewDecimal: fieldsByName[column.name]}}\"\n                                                class='span-text'\n                                                [attr.data-data-id]=\"order?.id\"\n                                                [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                                [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewDecimal: fieldsByName[column.name]}}</span>\n                                      <util-input *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                  class=\"isRowInAction\"\n                                                  [value]=\"order | fieldViewDecimal: fieldsByName[column.name]\"\n                                                  [columnItem]=\"fieldsByName[column.name]\"\n                                                  (valueChanged)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i); doValidationOfInput(column.name, $event.target)\">\n                                      </util-input>\n                                  </div>\n                                  <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Completer\">\n                                      <span class='span-text'\n                                            title=\"{{order | fieldViewCompleter: fieldsByName[column.name]}}\"\n                                            [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                            [attr.data-data-id]=\"order?.id\"\n                                            [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCompleter: fieldsByName[column.name]}}</span>\n                                      <util-autocomplete\n                                              *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                              class=\"isRowInAction\"\n                                              [fieldsResticted]=\"fieldsResticted\"\n                                              [selectedItem]=\"order | fieldEditCompleter: fieldsByName[column.name]\"\n                                              (selectedItemChange)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\"\n                                              [fieldSettings]=\"fieldsByName[column.name]\"\n                                              [disabled]=\"getColumnDisabled(fieldsByName[column.name], _mode)\"\n                                              [tag]=\"order[identFromTableMode]\">\n                                      </util-autocomplete>\n                                  </div>\n                                  <div *ngIf=\"(fieldsByName[column.name]['type'] === FieldTypeEnum.Combo)\">\n                                      <span class='span-text'\n                                            title=\"{{order | fieldViewCombo: fieldsByName[column.name]}}\"\n                                            [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                            [attr.data-data-id]=\"order?.id\"\n                                            [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCombo: fieldsByName[column.name]}}</span>\n                                      <util-combo\n                                              *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                              class=\"isRowInAction\"\n                                              [selectedItem]=\"getComboFixedItem(order, column.name)\"\n                                              [fieldSettings]=\"fieldsByName[column.name]\"\n                                              (selectedItemChange)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\"\n                                              [useFixedValues]=\"false\"\n                                              [disabled]=\"getColumnDisabled(fieldsByName[column.name], _mode)\"\n                                              [tag]=\"order[identFromTableMode]\">\n                                      </util-combo>\n                                  </div>\n                                  <div *ngIf=\"(fieldsByName[column.name]['type'] === FieldTypeEnum.ComboFixed)\">\n                                      <span class='span-text'\n                                            title=\"{{getComboFixedText(order, column.name)}}\"\n                                            [ngStyle]=\"{'color': fieldsByName[column.name]?.color}\"\n                                            [attr.data-data-id]=\"order?.id\"\n                                            [attr.data-data-rbr]=\"order?.rbr\">{{getComboFixedText(order, column.name)}}</span>\n                                      <util-combo\n                                              *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                              class=\"isRowInAction\"\n                                              [selectedItem]=\"getComboFixedItem(order, column.name)\"\n                                              [fieldSettings]=\"fieldsByName[column.name]\"\n                                              (selectedItemChange)=\"fieldUpdateValue(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\"\n                                              [useFixedValues]=\"true\"\n                                              [disabled]=\"getColumnDisabled(fieldsByName[column.name], _mode)\"\n                                              [tag]=\"order[identFromTableMode]\">\n                                      </util-combo>\n                                  </div>\n                                  <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Check\">\n                                      <span class='span-text'\n                                            [attr.data-data-id]=\"order?.id\"\n                                            [attr.data-data-rbr]=\"order?.rbr\"></span>\n                                      <label class=\"switch switch-small\">\n                                          <input type=\"checkbox\"\n                                                 class=\"icheckbox\"\n                                                 [ngModel]=\"getInputValue(order, column.name)\"\n                                                 (ngModelChange)=\"fieldUpdateCheck(fieldsByName[column.name], $event, order, i)\"\n                                                 [attr.data-data-name]=\"column.name\"\n                                                 [attr.data-data-type]=\"'check'\"\n                                                 [attr.disabled]=\"true\"/>\n                                          <span class=\"checkbox-span\"></span>\n                                      </label>\n                                  </div>\n                                  <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Date\">\n                                      <span class='span-text'\n                                            title=\"{{order | fieldViewDate: fieldsByName[column.name]}}\"\n                                            [attr.data-data-rbr]=\"order?.rbr\"\n                                            [attr.data-data-id]=\"order?.id\">{{order | fieldViewDate: fieldsByName[column.name]}}</span>\n                                      <util-daterangepicker class=\"isRowInAction\"\n                                                            *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                            [value]=\"order | fieldEditDate: fieldsByName[column.name]\"\n                                                            [columnItem]=\"fieldsByName[column.name]\"\n                                                            (dateSelected)=\"fieldUpdateDate(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\">\n                                      </util-daterangepicker>\n                                  </div>\n                                  <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Time\">\n                                      <span class='span-text'\n                                            title=\"{{order | fieldViewTime: fieldsByName[column.name]}}\"\n                                            [attr.data-data-rbr]=\"order?.rbr\"\n                                            [attr.data-data-id]=\"order?.id\">{{order | fieldViewTime: fieldsByName[column.name]}}</span>\n                                      <util-timepicker class=\"isRowInAction\"\n                                                       *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                       [entity]=\"order\"\n                                                       [columnItem]=\"fieldsByName[column.name]\"\n                                                       (timeChanged)=\"fieldUpdateTime(fieldsByName[column.name], $event.value, $event.oldValue, order, i)\">\n                                      </util-timepicker>\n                                  </div>\n\n                                  <div *ngIf=\"fieldsByName[column.name]['type'] === FieldTypeEnum.Complex &&\n                                   _complexSettings && _complexSettings.length > 0 && _complexSettings.length === _orderList.length\">\n                                      <div *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Input &&\n                                                  (!!!_complexSettings[i][column.name]['dbType'] ||\n                                                  (!!_complexSettings[i][column.name]['dbType'] && _complexSettings[i][column.name]['dbType'].indexOf('DECIMAL') === -1))\"\n                                           title=\"{{order | fieldViewText: _complexSettings[i][column.name]}}\">\n                                          <span title=\"{{order | fieldViewText: _complexSettings[i][column.name]}}\"\n                                                class='span-text'\n                                                [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                [attr.data-data-id]=\"order?.id\"\n                                                [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewText: _complexSettings[i][column.name]}}</span>\n                                          <util-input *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                      class=\"isRowInAction\"\n                                                      [value]=\"order | fieldViewText: _complexSettings[i][column.name]\"\n                                                      [columnItem]=\"_complexSettings[i]\"\n                                                      (valueChanged)=\"fieldUpdateValue(_complexSettings[i], $event.value, $event.oldValue, order, i); doValidationOfInput(column.name, $event.target)\">\n                                          </util-input>\n                                      </div>\n                                      <div *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Input &&\n                                              !!_complexSettings[i][column.name]['dbType'] &&\n                                              _complexSettings[i][column.name]['dbType'].indexOf('DECIMAL') !== -1\"\n                                           title=\"{{order | fieldViewDecimal: _complexSettings[i][column.name]}}\">\n                                              <span title=\"{{order | fieldViewDecimal: _complexSettings[i][column.name]}}\"\n                                                    class='span-text'\n                                                    [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                    [attr.data-data-id]=\"order?.id\"\n                                                    [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewDecimal: _complexSettings[i][column.name]}}</span>\n                                          <util-input *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                      class=\"isRowInAction\"\n                                                      [value]=\"order | fieldViewDecimal: _complexSettings[i][column.name]\"\n                                                      [columnItem]=\"_complexSettings[i][column.name]\"\n                                                      (valueChanged)=\"fieldUpdateValue(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i); doValidationOfInput(column.name, $event.target)\">\n                                          </util-input>\n                                      </div>\n                                      <div *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Completer\">\n                                          <span class='span-text'\n                                                title=\"{{order | fieldViewCompleter: _complexSettings[i][column.name]}}\"\n                                                [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                [attr.data-data-id]=\"order?.id\"\n                                                [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCompleter: _complexSettings[i][column.name]}}</span>\n                                          <util-autocomplete\n                                                  *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                  class=\"isRowInAction\"\n                                                  [fieldsResticted]=\"fieldsResticted\"\n                                                  [selectedItem]=\"order | fieldEditCompleter: _complexSettings[i][column.name]\"\n                                                  (selectedItemChange)=\"fieldUpdateValue(_complexSettings[i], $event.value, $event.oldValue, order, i)\"\n                                                  [fieldSettings]=\"_complexSettings[i]\"\n                                                  [disabled]=\"getColumnDisabled(_complexSettings[i], _mode)\"\n                                                  [tag]=\"order[identFromTableMode]\">\n                                          </util-autocomplete>\n                                      </div>\n                                      <div *ngIf=\"(_complexSettings[i][column.name]['type'] === FieldTypeEnum.Combo)\">\n                                          <span class='span-text'\n                                                title=\"{{order | fieldViewCombo: _complexSettings[i][column.name]}}\"\n                                                [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                [attr.data-data-id]=\"order?.id\"\n                                                [attr.data-data-rbr]=\"order?.rbr\">{{order | fieldViewCombo: _complexSettings[i][column.name]}}</span>\n                                          <util-combo\n                                                  *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                  class=\"isRowInAction\"\n                                                  [selectedItem]=\"getComboFixedItem(order, column.name)\"\n                                                  [fieldSettings]=\"_complexSettings[i]\"\n                                                  (selectedItemChange)=\"fieldUpdateValue(_complexSettings[i], $event.value, $event.oldValue, order, i)\"\n                                                  [useFixedValues]=\"false\"\n                                                  [disabled]=\"getColumnDisabled(_complexSettings[i], _mode)\"\n                                                  [tag]=\"order[identFromTableMode]\">\n                                          </util-combo>\n                                      </div>\n                                      <div *ngIf=\"(_complexSettings[i][column.name]['type'] === FieldTypeEnum.ComboFixed)\">\n                                          <span class='span-text'\n                                                title=\"{{getComboFixedText(order, column.name, _complexSettings[i][column.name])}}\"\n                                                [ngStyle]=\"{'color': _complexSettings[i][column.name].color ? _complexSettings[i][column.name].color : '#656C78'}\"\n                                                [attr.data-data-id]=\"order?.id\"\n                                                [attr.data-data-rbr]=\"order?.rbr\">{{getComboFixedText(order, column.name, _complexSettings[i][column.name])}}</span>\n                                          <util-combo\n                                                  *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                  class=\"isRowInAction\"\n                                                  [selectedItem]=\"getComboFixedItem(order, column.name)\"\n                                                  [fieldSettings]=\"_complexSettings[i]\"\n                                                  (selectedItemChange)=\"fieldUpdateValue(_complexSettings[i], $event.value, $event.oldValue, order, i)\"\n                                                  [useFixedValues]=\"true\"\n                                                  [disabled]=\"getColumnDisabled(_complexSettings[i], _mode)\"\n                                                  [tag]=\"order[identFromTableMode]\">\n                                          </util-combo>\n                                      </div>\n                                      <div *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Check\">\n                                          <span class='span-text'\n                                                [attr.data-data-id]=\"order?.id\"\n                                                [attr.data-data-rbr]=\"order?.rbr\"></span>\n                                          <label class=\"switch switch-small\">\n                                              <input type=\"checkbox\"\n                                                     class=\"icheckbox\"\n                                                     [ngModel]=\"getInputValue(order, column.name)\"\n                                                     (ngModelChange)=\"fieldUpdateCheck(_complexSettings[i], $event, order, i)\"\n                                                     [attr.data-data-name]=\"column.name\"\n                                                     [attr.data-data-type]=\"'check'\"\n                                                     [attr.disabled]=\"true\"/>\n                                              <span class=\"checkbox-span\"></span>\n                                          </label>\n                                      </div>\n                                      <div *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Date\">\n                                              <span class='span-text'\n                                                    title=\"{{order | fieldViewDate: _complexSettings[i][column.name]}}\"\n                                                    [attr.data-data-rbr]=\"order?.rbr\"\n                                                    [attr.data-data-id]=\"order?.id\">{{order | fieldViewDate: _complexSettings[i][column.name]}}</span>\n                                          <util-daterangepicker class=\"isRowInAction\"\n                                                                *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                                [value]=\"order | fieldEditDate: _complexSettings[i]\"\n                                                                [columnItem]=\"_complexSettings[i]\"\n                                                                (dateSelected)=\"fieldUpdateDate(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i)\">\n                                          </util-daterangepicker>\n                                      </div>\n                                      <div *ngIf=\"_complexSettings[i][column.name]['type'] === FieldTypeEnum.Time\">\n                                          <span class='span-text'\n                                                title=\"{{order | fieldViewTime: _complexSettings[i][column.name]}}\"\n                                                [attr.data-data-rbr]=\"order?.rbr\"\n                                                [attr.data-data-id]=\"order?.id\">{{order | fieldViewTime: _complexSettings[i][column.name]}}</span>\n                                          <util-timepicker class=\"isRowInAction\"\n                                                           *ngIf=\"shownEditingRows.hasOwnProperty(order[identFromTableMode])\"\n                                                           [entity]=\"order\"\n                                                           [columnItem]=\"_complexSettings[i]\"\n                                                           (timeChanged)=\"fieldUpdateTime(_complexSettings[i][column.name], $event.value, $event.oldValue, order, i)\">\n                                          </util-timepicker>\n                                      </div>\n                                  </div>\n                              </td>\n                          </tr>\n                      </tbody>\n                          </table>\n                          </div>\n                      </div>\n\n                  </div>\n              </div>\n          </div>\n      </div>\n    ",
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
/**
 * @nocollapse
 */
EditTableComponent.ctorParameters = function () { return [
    { type: BackendService, },
    { type: AuthenticationService, },
    { type: ActivatedRoute, },
    { type: DaterangepickerConfig, },
    { type: ChangeDetectorRef, },
    { type: FieldService, },
    { type: ListService, },
    { type: ApplicationService, },
    { type: NotificationService, },
    { type: ElementRef, },
]; };
EditTableComponent.propDecorators = {
    'timePicker': [{ type: ViewChildren, args: [TimepickerComponent,] },],
    'datePicker': [{ type: ViewChildren, args: [DaterangepickerComponent,] },],
    'autocomplete': [{ type: ViewChildren, args: [AutocompleteComponent,] },],
    'combo': [{ type: ViewChildren, args: [ComboComponent,] },],
    'input': [{ type: ViewChildren, args: [InputComponent,] },],
    'approveTableActions': [{ type: Input },],
    'identity': [{ type: Input },],
    'paging': [{ type: Input },],
    'copyEnabled': [{ type: Input },],
    'sortingEnabled': [{ type: Input },],
    'maxRows': [{ type: Input },],
    'sticking': [{ type: Input },],
    'resizable': [{ type: Input },],
    'reordable': [{ type: Input },],
    'serverPagination': [{ type: Input },],
    'ident': [{ type: Input },],
    'tableMode': [{ type: Input },],
    'tag': [{ type: Input },],
    'fieldsResticted': [{ type: Input },],
    'customAddHandling': [{ type: Input },],
    'showDocumentStatusColumn': [{ type: Input, args: ['showDocumentStatusColumn',] },],
    'tableAction': [{ type: Output, args: ['tableAction',] },],
    'valueChanged': [{ type: Output },],
    'outside': [{ type: Input },],
    'selectedObjectChange': [{ type: Output },],
    'selectedObject': [{ type: Input },],
    'orderListCount': [{ type: Input },],
    'mode': [{ type: Input },],
    'settings': [{ type: Input },],
    'orderList': [{ type: Input },],
    'complexSettings': [{ type: Input },],
    'additable': [{ type: Input },],
};
var OrdersComponent = /** @class */ (function (_super) {
    __extends(OrdersComponent, _super);
    /**
     * @param {?} backendService
     * @param {?} authenticationService
     * @param {?} notificationService
     * @param {?} modalService
     */
    function OrdersComponent(backendService, authenticationService, notificationService, modalService) {
        var _this = _super.call(this, backendService) || this;
        _this.backendService = backendService;
        _this.authenticationService = authenticationService;
        _this.notificationService = notificationService;
        _this.modalService = modalService;
        _this.FormModeEnum = FormModeEnum;
        _this.TableModeEnum = TableModeEnum;
        _this.documentListSource = new Subject$1();
        _this.documentList$ = _this.documentListSource.asObservable();
        _this.settingsTableSource = new Subject$1();
        _this.settingsTable$ = _this.settingsTableSource.asObservable();
        _this.orderListCountSource = new Subject$1();
        _this.orderListCount$ = _this.orderListCountSource.asObservable();
        _this.modeSource = new Subject$1();
        _this.mode$ = _this.modeSource.asObservable();
        _this.modeChange(FormModeEnum.Table);
        return _this;
    }
    Object.defineProperty(OrdersComponent.prototype, "order", {
        /**
         * @return {?}
         */
        get: function () {
            return this._order;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._order = value;
            this.changeName();
            this.infobarDocument = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    OrdersComponent.prototype.modeChange = function (event) {
        var _this = this;
        this.mode = event;
        this.changeName();
        if (this.mode === FormModeEnum.Table) {
            this.infobarVisible = false;
            this.setToolbarOptions({
                toolbarVisible: false
            });
        }
        else {
            this.infobarVisible = true;
        }
        switch (this.mode) {
            case FormModeEnum.Edit:
                this.setToolbarOptions({
                    items: [
                        ToolbarItem.ItemSave(),
                        ToolbarItem.ItemCancel()
                    ]
                });
                break;
            case FormModeEnum.View:
                this._orderBeforeEditing = JSON.parse(JSON.stringify(this._order));
                // Moved when order loads
                if (typeof this.order === 'undefined') {
                    this.setToolbarOptions({
                        items: []
                    });
                }
                else {
                    var /** @type {?} */ items = [
                        ToolbarItem.ItemDelete(),
                        ToolbarItem.ItemEdit(true, !this.order.status)
                    ];
                    if (this.settingsTable.listAdditable) {
                        items.unshift(ToolbarItem.ItemAdd());
                    }
                    var /** @type {?} */ options = {
                        items: items
                    };
                    var /** @type {?} */ leftEnabled = true, /** @type {?} */ rightEnabled = true;
                    for (var /** @type {?} */ i = 0; i < this.orderList.length; i++) {
                        if (this.orderList[i].id === this.order.id) {
                            if (this.lastUsedFilter.pageCurrent === 1 && i === 0) {
                                leftEnabled = false;
                            }
                            if ((this.lastUsedFilter.pageCurrent - 1) * this.lastUsedFilter.rowsOnPage + i + 1 === this.orderListCount) {
                                rightEnabled = false;
                            }
                        }
                    }
                    this.setToolbarOptions(options, {
                        leftEnabled: leftEnabled,
                        rightEnabled: rightEnabled
                    });
                }
                break;
            case FormModeEnum.Add:
                this.setToolbarOptions({
                    items: [
                        ToolbarItem.ItemSave()
                    ]
                });
                break;
        }
        setTimeout(function () {
            _this.modeSource.next(_this.mode);
        }, 0);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    OrdersComponent.prototype.onToolbarAction = function (event) {
        var _this = this;
        var /** @type {?} */ that = this;
        switch (event) {
            case ToolbarAction.Close:
                this.modeChange(FormModeEnum.Table);
                break;
            case ToolbarAction.Left:
                var /** @type {?} */ orderIdLeft_1;
                var _loop_2 = function (i) {
                    if (this_1.orderList[i].id === this_1.order.id) {
                        if (i === 0) {
                            if (this_1.lastUsedFilter.pageCurrent !== 1) {
                                this_1.tables.forEach(function (child) {
                                    child.page(_this.lastUsedFilter.pageCurrent - 1);
                                });
                                this_1.documentListSubscription = this_1.documentList$.subscribe(function (data) {
                                    _this.documentListSubscription.unsubscribe();
                                    orderIdLeft_1 = data[data.length - 1].id;
                                    var /** @type {?} */ paramsLeft = {
                                        action: TableActionEnum.View,
                                        documentId: orderIdLeft_1
                                    };
                                    _this.listTableAction(paramsLeft);
                                    setTimeout(function () {
                                        that.tables.forEach(function (child) {
                                            child.onInlineSelect(data[data.length - 1]);
                                        });
                                    }, 1000);
                                }, function (error) {
                                    _this.documentListSubscription.unsubscribe();
                                });
                                return "break";
                            }
                        }
                        else {
                            this_1.tables.forEach(function (child) {
                                child.onInlineViewAndSelect(_this.orderList[i - 1]);
                            });
                            return "break";
                        }
                    }
                };
                var this_1 = this;
                for (var /** @type {?} */ i = 0; i < this.orderList.length; i++) {
                    var state_1 = _loop_2(/** @type {?} */ i);
                    if (state_1 === "break")
                        break;
                }
                break;
            case ToolbarAction.Right:
                var /** @type {?} */ orderIdRight_1;
                var _loop_3 = function (i) {
                    if (this_2.orderList[i].id === this_2.order.id) {
                        if (i === this_2.orderList.length - 1) {
                            var /** @type {?} */ totalPages = Math.ceil(this_2.orderListCount / this_2.lastUsedFilter.rowsOnPage);
                            if (totalPages > this_2.lastUsedFilter.pageCurrent) {
                                this_2.tables.forEach(function (child) {
                                    child.page(_this.lastUsedFilter.pageCurrent + 1);
                                });
                                this_2.documentListSubscription = this_2.documentList$.subscribe(function (data) {
                                    _this.documentListSubscription.unsubscribe();
                                    orderIdRight_1 = data[0].id;
                                    var /** @type {?} */ paramsRight = {
                                        action: TableActionEnum.View,
                                        documentId: orderIdRight_1
                                    };
                                    _this.listTableAction(paramsRight);
                                    setTimeout(function () {
                                        that.tables.forEach(function (child) {
                                            child.onInlineSelect(data[0]);
                                        });
                                    }, 1000);
                                }, function (error) {
                                    _this.documentListSubscription.unsubscribe();
                                });
                                return "break";
                            }
                        }
                        else {
                            this_2.tables.forEach(function (child) {
                                child.onInlineViewAndSelect(_this.orderList[i + 1]);
                            });
                            return "break";
                        }
                    }
                };
                var this_2 = this;
                for (var /** @type {?} */ i = 0; i < this.orderList.length; i++) {
                    var state_2 = _loop_3(/** @type {?} */ i);
                    if (state_2 === "break")
                        break;
                }
                break;
            case ToolbarAction.Delete:
                this.onDelete(null);
                break;
            case ToolbarAction.Save:
                if (this.mode === FormModeEnum.Add) {
                    this.addOrder();
                }
                else {
                    this.updateOrder();
                }
                break;
            case ToolbarAction.Cancel:
                this.order = JSON.parse(JSON.stringify(this._orderBeforeEditing));
                this.modeChange(FormModeEnum.View);
                break;
            case ToolbarAction.Edit:
                this.modeChange(FormModeEnum.Edit);
                break;
            case ToolbarAction.Add:
                this.order = {};
                this.modeChange(FormModeEnum.Add);
                break;
            default:
                console.log('Unhandled onToolbarAction' + event);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    OrdersComponent.prototype.filterAction = function (event) {
        switch (event.action) {
            case FilterActionEnum.Filter:
                this.lastUsedFilter.filterQuery = event.filter.filterQuery;
                this.lastUsedFilter.filterDate = event.filter.filterDate;
                this.lastUsedFilter.filterObjects = event.filter.filterObjects;
                this.lastUsedFilter.filterCombined = event.filter.filterCombined;
                this.refreshTable();
                break;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    OrdersComponent.prototype.listTableAction = function (event) {
        var _this = this;
        switch (event.action) {
            case TableActionEnum.Select:
                this.order = event.document;
                break;
            case TableActionEnum.Filter:
                var /** @type {?} */ filterObjects = this.lastUsedFilter.filterObjects;
                var /** @type {?} */ filterQuery = this.lastUsedFilter.filterQuery;
                var /** @type {?} */ filterDate = this.lastUsedFilter.filterDate;
                var /** @type {?} */ filterCombined = this.lastUsedFilter.filterCombined;
                this.lastUsedFilter = event.filter;
                this.lastUsedFilter.filterObjects = filterObjects;
                this.lastUsedFilter.filterQuery = filterQuery;
                this.lastUsedFilter.filterDate = filterDate;
                this.lastUsedFilter.filterCombined = filterCombined;
                this.refreshTable();
                break;
            case TableActionEnum.Edit:
                this._orderBeforeEditing = Object.assign({}, event.document);
                break;
            case TableActionEnum.EditCancel:
                this.orderList[event.index] = this._orderBeforeEditing;
                break;
            case TableActionEnum.View:
                this.order = {};
                this.backendService.fetchOrder(this.identity.documentId, event.documentId, 'test').subscribe(function (data) {
                    _this.order = data;
                    _this.setToolbarOptions({
                        items: [
                            ToolbarItem.ItemEdit(true, !_this.order.status)
                        ]
                    });
                    _this.modeChange(FormModeEnum.View);
                }, function (error) {
                    console.log(error);
                });
                break;
            case TableActionEnum.Update:
                this.backendService.editOrder(this.identity.documentId, event.document, 'test').subscribe(function (data) {
                    _this.refreshTable();
                }, function (error) {
                });
                break;
            case TableActionEnum.Add:
                this.order = {};
                this.modeChange(FormModeEnum.Add);
                break;
            case TableActionEnum.Delete:
                this.onDelete(null);
                break;
        }
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.changeName = function () {
        if (typeof this.order === 'undefined') {
            return;
        }
        if (this.order.hasOwnProperty('naziv')) {
            this.name = this.order.naziv;
        }
        else {
            if (this.mode === FormModeEnum.Add) {
                this.name = 'Novi Šifarnik';
            }
            else if (this._order.hasOwnProperty('id')) {
                this.name = 'Šifarnik ' + this.order.id;
            }
        }
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.firstTableLoad = function () {
        this.lastUsedFilter = {
            pageCurrent: 1,
            filterQuery: '',
            filterDate: '',
            filterObjects: [],
            filterCombined: null,
            rowsOnPage: 10,
            sortOrder: {},
            direction: 'asc',
            relations: this.settingsTable.relations
        };
        this.refreshTable();
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.setAllFields = function () {
        for (var /** @type {?} */ i = 0; i < this.settingsFilter.fieldList.length; i++) {
            var /** @type {?} */ fieldData = this.settingsFilter.fieldList[i];
            var /** @type {?} */ filterWithItem = JSON.parse(JSON.stringify(fieldData));
            filterWithItem.fieldMapItem = UtilService.getFieldMapItem(this.settingsFilter.relations, fieldData);
            this.settingsFilter.fieldList[i].filterMapItems = [];
            this.settingsFilter.fieldList[i].filterMapItems.push(filterWithItem);
        }
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.settingsLoadSingle = function () {
        var _this = this;
        this.backendService.fetchSettingForOrders('test', this.identity.documentId).subscribe(// TODO: Remove
        function (data) {
            var /** @type {?} */ settingsData = data[0];
            _this.fieldStructure = new FieldStructure(settingsData, 'header');
            _this.settingsTable = new TableSettings(settingsData, 'table');
            _this.settingsTableSource.next(_this.settingsTable);
            _this.settingsFilter = new FilterSettings(settingsData);
            _this.setAllFields();
            _this.firstTableLoad();
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.refreshTable = function () {
        var _this = this;
        this.backendService.fetchOrderListWithFilter(this.identity.documentId, this.lastUsedFilter).subscribe(function (data) {
            _this.orderListCount = data.count;
            _this.orderList = data.result;
            _this.orderListCountSource.next(_this.orderListCount);
            _this.documentListSource.next(_this.orderList);
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.isNadredjeniValid = function () {
        if (this.order.hasOwnProperty('klasifikacijaLabAnalize') &&
            this.order['klasifikacijaLabAnalize'].id === this.order.id) {
            this.notificationService.openNoty('Klasifikacija Labaratorijske Analize ne može sama sebi biti nadređena!');
            return false;
        }
        return true;
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.isValid = function () {
        var _this = this;
        var /** @type {?} */ detailsValid = true;
        this.details.forEach(function (child) {
            if (!child.isDetailsValid()) {
                _this.notificationService.openNoty('Nisu sva polja validna!');
                detailsValid = false;
            }
        });
        var /** @type {?} */ tableValid = true;
        this.tables.forEach(function (child) {
            if (child.tableMode === TableModeEnum.Details && !child.isTableValid()) {
                _this.notificationService.openNoty('Nisu sva polja validna!');
                tableValid = false;
            }
        });
        if (!tableValid || !detailsValid) {
            return false;
        }
        return true;
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.updateOrder = function () {
        var _this = this;
        if (!this.isValid()) {
            return;
        }
        var /** @type {?} */ isNadredjeniValid = this.isNadredjeniValid();
        if (!isNadredjeniValid) {
            return;
        }
        this.backendService.editOrder(this.identity.documentId, this.order, 'test').subscribe(function (data) {
            console.log(data);
            _this.notificationService.openNoty('Uspešno editovanje');
            _this.order = data;
            _this.refreshTable();
            _this.modeChange(FormModeEnum.View);
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.addOrder = function () {
        var _this = this;
        if (!this.isValid()) {
            return;
        }
        var /** @type {?} */ isNadredjeniValid = this.isNadredjeniValid();
        if (!isNadredjeniValid) {
            return;
        }
        this.backendService.addOrder(this.identity.documentId, this.order, 'test').subscribe(function (data) {
            console.log(data);
            _this.notificationService.openNoty('Uspešno dodavanje');
            _this.refreshTable();
            _this.order = data;
            _this.modeChange(FormModeEnum.View);
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    OrdersComponent.prototype.onDelete = function (event) {
        var /** @type {?} */ that = this;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.modalService.openModal(MessagesEnum.DeleteSifarnik, function (response) {
            if (response) {
                that.onDeleteConfirm();
            }
        });
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.onDeleteConfirm = function () {
        var _this = this;
        this.backendService.deleteOrder(this.identity.documentId, this.order.id, 'test').subscribe(function (data) {
            console.log(data);
            _this.notificationService.openNoty('Uspešno brisanje');
            _this.refreshTable();
            _this.modeChange(FormModeEnum.Table);
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.settingsLoadSingle();
        this.settingsChangedSubscription = this.backendService.settingsChanged.subscribe(function (settingsData) {
            if (_this.settingsTable.documentId === settingsData['group']) {
                _this.settingsTable = new TableSettings(settingsData, 'table');
                _this.settingsTableSource.next(_this.settingsTable);
            }
        });
    };
    /**
     * @return {?}
     */
    OrdersComponent.prototype.ngOnDestroy = function () {
        if (this.settingsChangedSubscription) {
            this.settingsChangedSubscription.unsubscribe();
        }
    };
    return OrdersComponent;
}(PageBase));
OrdersComponent.decorators = [
    { type: Component, args: [{
                // TODO: Rename the component
                selector: 'util-orders',
                template: "\n      <!-- *ngIf=\"mode === FormModeEnum.Table\"  -->\n      <div class=\"table-mode\" [hidden]=\"mode !== FormModeEnum.Table\">\n          <!-- <util-filter (filterAction)=\"filterAction($event)\"\n                       [settings]=\"settingsFilter\"\n                      [documentId]=\"identity.documentId\">\n          </util-filter> -->\n          <util-edit-table\n                  [identity]=\"identity\"\n                  [ident]=\"'id'\"\n                  [tableMode]=\"TableModeEnum.Table\"\n                  [mode]=\"mode$\"\n                  [settings]=\"settingsTable$\"\n                  [orderList]=\"documentList$\"\n                  [orderListCount]=\"orderListCount$\"\n                  [selectedObject]=\"order\"\n                  [showDocumentStatusColumn]=\"false\"\n                  (tableAction)=\"listTableAction($event)\">\n          </util-edit-table>\n      </div>\n      <div *ngIf=\"mode !== FormModeEnum.Table\" class=\"panel panel-default edit add view\">\n          <div class=\"panel-body edit\">\n              <util-details\n                      [mode]=\"mode\"\n                      [fieldStructure]=\"fieldStructure\"\n                      [documentData]=\"order\">\n              </util-details>\n          </div>\n      </div>\n    "
            },] },
];
/**
 * @nocollapse
 */
OrdersComponent.ctorParameters = function () { return [
    { type: BackendService, },
    { type: AuthenticationService, },
    { type: NotificationService, },
    { type: ModalService, },
]; };
OrdersComponent.propDecorators = {
    'tables': [{ type: ViewChildren, args: [EditTableComponent,] },],
    'details': [{ type: ViewChildren, args: [DetailsComponent,] },],
};
var Utils = /** @class */ (function () {
    function Utils() {
        this.indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        this.dbMode = {
            readOnly: "readonly",
            readWrite: "readwrite"
        };
    }
    return Utils;
}());
Utils.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Utils.ctorParameters = function () { return []; };
var DbWrapper = /** @class */ (function () {
    function DbWrapper() {
        this.dbName = 'pos';
        this.dbVersion = 1;
        this.db = null;
    }
    /**
     * @param {?} storeName
     * @return {?}
     */
    DbWrapper.prototype.validateStoreName = function (storeName) {
        return this.db.objectStoreNames.contains(storeName);
    };
    ;
    /**
     * @param {?} storeName
     * @param {?} reject
     * @return {?}
     */
    DbWrapper.prototype.validateBeforeTransaction = function (storeName, reject) {
        if (!this.db) {
            reject('You need to use the createStore function to create a database before you query it!');
        }
        if (!this.validateStoreName(storeName)) {
            reject(('objectStore does not exists: ' + storeName));
        }
    };
    /**
     * @param {?} options
     * @return {?}
     */
    DbWrapper.prototype.createTransaction = function (options) {
        var /** @type {?} */ trans = this.db.transaction(options.storeName, options.dbMode);
        trans.onerror = options.error;
        trans.oncomplete = options.complete;
        trans.onabort = options.abort;
        return trans;
    };
    return DbWrapper;
}());
DbWrapper.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
DbWrapper.ctorParameters = function () { return []; };
var Angular2IndexeddbService = /** @class */ (function () {
    /**
     * @param {?} utils
     * @param {?} dbWrapper
     */
    function Angular2IndexeddbService(utils, dbWrapper) {
        this.utils = utils;
        this.dbWrapper = dbWrapper;
        this.utils = new Utils();
        this.dbWrapper = new DbWrapper();
    }
    /**
     * @param {?} version
     * @param {?} upgradeCallback
     * @return {?}
     */
    Angular2IndexeddbService.prototype.createStore = function (version, upgradeCallback) {
        var _this = this;
        var /** @type {?} */ self = this, /** @type {?} */ promise = new Promise(function (resolve, reject) {
            _this.dbWrapper.dbVersion = version;
            var /** @type {?} */ request = _this.utils.indexedDB.open(_this.dbWrapper.dbName, version);
            request.onsuccess = function (e) {
                self.dbWrapper.db = request.result;
                resolve();
            };
            request.onerror = function (e) {
                reject("IndexedDB error: " + ( /** @type {?} */(e.target)).errorCode);
            };
            request.onupgradeneeded = function (e) {
                upgradeCallback(e, self.dbWrapper.db);
            };
        });
        return promise;
    };
    /**
     * @param {?} storeName
     * @param {?} key
     * @return {?}
     */
    Angular2IndexeddbService.prototype.getByKey = function (storeName, key) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var /** @type {?} */ transaction = self.dbWrapper.createTransaction({
                storeName: storeName,
                dbMode: self.utils.dbMode.readOnly,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                }
            });
            var /** @type {?} */ objectStore = transaction.objectStore(storeName);
            var /** @type {?} */ request;
            request = objectStore.get(key);
            request.onsuccess = function (event) {
                resolve(( /** @type {?} */(event.target)).result);
            };
        });
        return promise;
    };
    /**
     * @param {?} storeName
     * @param {?=} keyRange
     * @return {?}
     */
    Angular2IndexeddbService.prototype.getAll = function (storeName, keyRange) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var /** @type {?} */ transaction = self.dbWrapper.createTransaction({
                storeName: storeName,
                dbMode: self.utils.dbMode.readOnly,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                }
            }), /** @type {?} */ objectStore = transaction.objectStore(storeName), /** @type {?} */ result = [], /** @type {?} */ request = objectStore.openCursor(keyRange);
            request.onerror = function (e) {
                reject(e);
            };
            request.onsuccess = function (evt) {
                var /** @type {?} */ cursor = ( /** @type {?} */(evt.target)).result;
                if (cursor) {
                    result.push(cursor.value);
                    cursor["continue"]();
                }
                else {
                    resolve(result);
                }
            };
        });
        return promise;
    };
    /**
     * @param {?} storeName
     * @param {?} value
     * @param {?=} key
     * @return {?}
     */
    Angular2IndexeddbService.prototype.add = function (storeName, value, key) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var /** @type {?} */ transaction = self.dbWrapper.createTransaction({
                storeName: storeName,
                dbMode: self.utils.dbMode.readWrite,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve({ key: key, value: value });
                }
            }), /** @type {?} */ objectStore = transaction.objectStore(storeName);
            objectStore.add(value, key);
        });
        return promise;
    };
    /**
     * @param {?} storeName
     * @param {?} value
     * @param {?=} key
     * @return {?}
     */
    Angular2IndexeddbService.prototype.update = function (storeName, value, key) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var /** @type {?} */ transaction = self.dbWrapper.createTransaction({
                storeName: storeName,
                dbMode: self.utils.dbMode.readWrite,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve(value);
                },
                abort: function (e) {
                    reject(e);
                }
            }), /** @type {?} */ objectStore = transaction.objectStore(storeName);
            objectStore.put(value, key);
        });
        return promise;
    };
    /**
     * @param {?} storeName
     * @param {?} key
     * @return {?}
     */
    Angular2IndexeddbService.prototype.delete = function (storeName, key) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var /** @type {?} */ transaction = self.dbWrapper.createTransaction({
                storeName: storeName,
                dbMode: self.utils.dbMode.readWrite,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve();
                },
                abort: function (e) {
                    reject(e);
                }
            }), /** @type {?} */ objectStore = transaction.objectStore(storeName);
            objectStore["delete"](key);
        });
        return promise;
    };
    /**
     * @param {?} storeName
     * @param {?} cursorCallback
     * @param {?=} keyRange
     * @return {?}
     */
    Angular2IndexeddbService.prototype.openCursor = function (storeName, cursorCallback, keyRange) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var /** @type {?} */ transaction = self.dbWrapper.createTransaction({
                storeName: storeName,
                dbMode: self.utils.dbMode.readOnly,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve();
                },
                abort: function (e) {
                    reject(e);
                }
            }), /** @type {?} */ objectStore = transaction.objectStore(storeName), /** @type {?} */ request = objectStore.openCursor(keyRange);
            request.onsuccess = function (evt) {
                cursorCallback(evt);
                resolve();
            };
        });
        return promise;
    };
    /**
     * @param {?} storeName
     * @return {?}
     */
    Angular2IndexeddbService.prototype.clear = function (storeName) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var /** @type {?} */ transaction = self.dbWrapper.createTransaction({
                storeName: storeName,
                dbMode: self.utils.dbMode.readWrite,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve();
                },
                abort: function (e) {
                    reject(e);
                }
            }), /** @type {?} */ objectStore = transaction.objectStore(storeName);
            objectStore.clear();
            resolve();
        });
        return promise;
    };
    /**
     * @param {?} storeName
     * @param {?} indexName
     * @param {?} key
     * @return {?}
     */
    Angular2IndexeddbService.prototype.getByIndex = function (storeName, indexName, key) {
        var /** @type {?} */ self = this;
        var /** @type {?} */ promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var /** @type {?} */ transaction = self.dbWrapper.createTransaction({
                storeName: storeName,
                dbMode: self.utils.dbMode.readOnly,
                error: function (e) {
                    reject(e);
                },
                abort: function (e) {
                    reject(e);
                },
                complete: function (e) {
                }
            }), /** @type {?} */ objectStore = transaction.objectStore(storeName), /** @type {?} */ index = objectStore.index(indexName), /** @type {?} */ request = index.get(key);
            request.onsuccess = function (event) {
                resolve(( /** @type {?} */(event.target)).result);
            };
        });
        return promise;
    };
    return Angular2IndexeddbService;
}());
Angular2IndexeddbService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Angular2IndexeddbService.ctorParameters = function () { return [
    { type: Utils, },
    { type: DbWrapper, },
]; };
var IndexeddbService = /** @class */ (function () {
    function IndexeddbService() {
        this.db = new Angular2IndexeddbService(null, null);
        this.objectStoresCreated = new EventEmitter();
        this.objectStoresCreatedBoolean = false;
        var db = this.db;
        db.createStore(1, function (evt) {
            var objectStoreMagacini = evt.currentTarget.result.createObjectStore('magacini');
            var objectStoreValute = evt.currentTarget.result.createObjectStore('valute');
        }).then(function (jsonData) {
            this.objectStoresCreated.emit(true);
            this.objectStoresCreatedBoolean = true;
        }.bind(this)).catch(function (e) {
            console.log(e);
        });
    }
    /**
     * @return {?}
     */
    IndexeddbService.prototype.getDB = function () {
        return this.db;
    };
    return IndexeddbService;
}());
IndexeddbService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
IndexeddbService.ctorParameters = function () { return []; };
var ToolbarComponent = /** @class */ (function () {
    /**
     * @param {?} backendService
     */
    function ToolbarComponent(backendService) {
        this.backendService = backendService;
        this._options = ToolbarOptions.getDefault();
        this.tooltipOptions = {
            'placement': 'top',
            'show-delay': '500',
            'theme': 'light'
        };
        this.showHiddenItems = false;
        this.toolbarAction = new EventEmitter();
        this.styles = new Map([
            [
                ToolbarItemStyle.Default,
                { buttonClass: 'btn btn-default', iconClass: 'fa fa-bolt' }
            ],
            [
                ToolbarItemStyle.Add,
                {
                    buttonClass: 'btn btn-primary',
                    iconClass: 'fa fa-plus-circle'
                }
            ],
            [
                ToolbarItemStyle.Save,
                { buttonClass: 'btn btn-primary', iconClass: 'fa fa-floppy-o' }
            ],
            [
                ToolbarItemStyle.Cancel,
                { buttonClass: 'btn btn-warning', iconClass: 'fa fa-ban' }
            ],
            [
                ToolbarItemStyle.Edit,
                { buttonClass: 'btn btn-warning', iconClass: 'fa fa-pencil' }
            ],
            [
                ToolbarItemStyle.Delete,
                { buttonClass: 'btn btn-danger', iconClass: 'fa fa-trash' }
            ],
            [
                ToolbarItemStyle.Copy,
                { buttonClass: 'btn btn-default', iconClass: 'fa fa-copy' }
            ],
            [
                ToolbarItemStyle.Accept,
                { buttonClass: 'btn btn-success', iconClass: 'fa fa-check' }
            ],
            [
                ToolbarItemStyle.Custom,
                { buttonClass: 'btn btn-default', iconClass: 'fa fa-file-text' }
            ],
            [
                ToolbarItemStyle.Settings,
                { buttonClass: 'btn btn-default btn-condensed', iconClass: 'fa fa-cogs' }
            ],
            [
                ToolbarItemStyle.Back,
                { buttonClass: 'btn btn-default btn-condensed', iconClass: 'fa fa-angle-up' }
            ],
            [
                ToolbarItemStyle.Filter,
                { buttonClass: 'btn btn-success', iconClass: 'fa fa-filter' }
            ],
            [
                ToolbarItemStyle.Unlock,
                { buttonClass: 'btn btn-default', iconClass: 'fa fa-unlock' }
            ],
            [
                ToolbarItemStyle.Download,
                { buttonClass: 'btn btn-default', iconClass: 'fa fa-download' }
            ],
            [
                ToolbarItemStyle.Check,
                { buttonClass: 'btn btn-default', iconClass: 'fa fa-check' }
            ],
            [
                ToolbarItemStyle.Eye,
                { buttonClass: 'btn btn-default', iconClass: 'fa fa-eye' }
            ],
        ]);
        this.disabledClass = 'disabled';
    }
    Object.defineProperty(ToolbarComponent.prototype, "document", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._document = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolbarComponent.prototype, "options", {
        /**
         * @return {?}
         */
        get: function () {
            return this._options;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._options = value;
            this.itemsVisible = value.items.filter(function (item) { return item.visible; });
            this.itemsHidden = value.items.filter(function (item) { return !item.visible; });
            this.closeTooltip = value.closeTooltip;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.clickAttachments = function () {
        this.showHiddenItems = false;
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.clickExport = function () {
        this.toolbarAction.emit(ToolbarAction.Export);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ToolbarComponent.prototype.clickPrethodnik = function (event) {
        // TODO DOES NOT WORK - mixing grandmas and frogs, i.e. strings and objects!
        this.toolbarAction.emit(event);
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.clickPrint = function () {
        // TODO open modal
        this.toolbarAction.emit(ToolbarAction.Print);
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.clickComments = function () {
        this.showHiddenItems = false;
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.clickLeft = function () {
        this.toolbarAction.emit('left');
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.clickRight = function () {
        this.toolbarAction.emit('right');
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.clickMore = function () {
        this.showHiddenItems = !this.showHiddenItems;
    };
    /**
     * @param {?} action
     * @return {?}
     */
    ToolbarComponent.prototype.onAction = function (action) {
        this.showHiddenItems = false;
        this.toolbarAction.emit(action);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ToolbarComponent.prototype.onItemAction = function (item) {
        // Ignore action if the items is disabled
        if (!item.enabled) {
            return;
        }
        this.showHiddenItems = false;
        this.toolbarAction.emit(item.action);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ToolbarComponent.prototype.getButtonClass = function (item) {
        var /** @type {?} */ retVal = this.styles.get(item.style).buttonClass;
        if (!item.enabled) {
            retVal = retVal + ' ' + this.disabledClass;
        }
        return retVal;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ToolbarComponent.prototype.getIconClass = function (item) {
        return this.styles.get(item.style).iconClass;
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.ngOnInit = function () {
        LoggerService.log('ToolbarComponent - ngOnInit');
        LoggerService.log(this.mode);
        LoggerService.log(this.newLayoutView);
        LoggerService.log(this.showingSettings);
        LoggerService.log(this.isAdmin);
        LoggerService.log(this.listEditable);
        LoggerService.log(this.selectedOrder);
    };
    return ToolbarComponent;
}());
ToolbarComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-toolbar',
                template: "\n      <div class=\"panel-body toolbar-component\">\n          <h3 class=\"panel-title\">\n              <strong>{{name}}</strong>\n          </h3>\n          <ul class=\"panel-controls\">\n              <li *ngFor=\"let item of itemsVisible\">\n                  <button\n                      *ngIf=\"item?.title !== null\"\n                      [className]=\"getButtonClass(item)\"\n                      (click)=\"onItemAction(item)\"\n                      [tooltip]=\"item.title\"\n                      [options]=\"tooltipOptions\"\n                  >\n                      <i [className]=\"getIconClass(item)\"></i>\n                      {{ item.label }}\n                  </button>\n                  <button *ngIf=\"item?.title === null\" [className]=\"getButtonClass(item)\" (click)=\"onItemAction(item)\">\n                      <i [className]=\"getIconClass(item)\"></i> {{ item.label }}\n                  </button>\n              </li>\n              <li *ngIf=\"options.showPrethodnici\">\n                  <util-prethodnici [document]='_document' [documentCode]='documentCode' [mode]='mode' (prethodniciClick)=\"clickPrethodnik($event)\"></util-prethodnici>\n              </li>\n              <li *ngIf=\"options.showExport\">\n                  <button class=\"btn btn-default btn-condensed\" title=\"Izvezi u Excel\" (click)=\"clickExport('export')\">\n                      <i class=\"fa fa-file-excel-o\"></i>\n                  </button>\n              </li>\n              <li *ngIf=\"options.showPrint\">\n                  <button class=\"btn btn-default btn-condensed\" title=\"\u0160tampaj\" (click)=\"clickPrint()\">\n                      <i class=\"fa fa-print\"></i>\n                  </button>\n\n                  <!-- <util-print *ngIf=\"documentCode != null\" [identity]=\"identity\" [document]='_document' [documentId]='documentId' [documentCode]='documentCode' [mode]='mode'></util-print> -->\n              </li>\n              <li *ngIf=\"options.showAttachments\">\n                  <button class=\"btn btn-default btn-condensed\" (click)=\"clickAttachments()\">\n                      <i class=\"fa fa-paperclip\"></i>\n                  </button>\n              </li>\n              <li *ngIf=\"options.showComments\">\n                  <button class=\"btn btn-default btn-condensed\" (click)=\"clickComments()\">\n                      <i class=\"fa fa-commenting\"></i>\n                  </button>\n              </li>\n              <li *ngIf=\"itemsHidden?.length > 0\">\n                  <button class=\"btn btn-default btn-condensed\" (click)=\"clickMore()\">\n                      <i class=\"fa fa-ellipsis-v\"></i>\n                  </button>\n              </li>\n              <!-- <li>\n                  <button [disabled]=\"!options.leftEnabled\" class=\"btn btn-default btn-condensed\" (click)=\"onAction('left')\">\n                      <i class=\"fa fa-chevron-left\"></i>\n                  </button>\n              </li>\n              <li>\n                  <button [disabled]=\"!options.rightEnabled\" class=\"btn btn-default btn-condensed\" (click)=\"onAction('right')\">\n                      <i class=\"fa fa-chevron-right\"></i>\n                  </button>\n              </li> -->\n              <li *ngIf=\"options.showClose\">\n                  <a\n                      href=\"javascript:void(0)\"\n                      class=\"panel-remove\"\n                      (click)=\"onAction('close')\"\n                      [tooltip]=\"closeTooltip\"\n                      [options]=\"tooltipOptions\"\n                      [display]=\"!!closeTooltip\"\n                  >\n                      <span class=\"fa fa-times\"></span>\n                  </a>\n              </li>\n          </ul>\n\n          <ul *ngIf=\"showHiddenItems\">\n              <li *ngFor=\"let item of itemsHidden\">\n                  <button [className]=\"getButtonClass(item.style)\" (click)=\"onItemAction(item)\">\n                      <i [className]=\"getIconClass(item.style)\"></i> {{ item.label }}\n                  </button>\n              </li>\n          </ul>\n      </div>\n    ",
                styles: ["\n      .toolbar-component .panel-title {\n        margin-left: 15px; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
ToolbarComponent.ctorParameters = function () { return [
    { type: BackendService, },
]; };
ToolbarComponent.propDecorators = {
    'newLayoutView': [{ type: Input },],
    'showingSettings': [{ type: Input },],
    'isAdmin': [{ type: Input },],
    'listEditable': [{ type: Input },],
    'selectedOrder': [{ type: Input },],
    'name': [{ type: Input },],
    'mode': [{ type: Input },],
    'documentCode': [{ type: Input },],
    'documentId': [{ type: Input },],
    'identity': [{ type: Input },],
    'document': [{ type: Input },],
    'options': [{ type: Input },],
    'toolbarAction': [{ type: Output, args: ['toolbarAction',] },],
};
var SimpleFilterComponent = /** @class */ (function () {
    /**
     * @param {?} eRef
     * @param {?} listService
     * @param {?} backendService
     */
    function SimpleFilterComponent(eRef, listService, backendService) {
        this.eRef = eRef;
        this.listService = listService;
        this.backendService = backendService;
        this.FieldTypeEnum = FieldTypeEnum;
        this.filterQuery = '';
        this.daterange = {};
        this.filterAction = new EventEmitter();
        this.optionsDate = UtilService.datePickerOptionsDefault;
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(SimpleFilterComponent.prototype, "settings", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value != null) {
                if (typeof this._settings === 'undefined') {
                    this.initSettings = value;
                }
                this._settings = value;
                this.clearFields();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SimpleFilterComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @return {?}
     */
    SimpleFilterComponent.prototype.ngOnInit = function () {
    };
    /**
     * @return {?}
     */
    SimpleFilterComponent.prototype.ngOnDestroy = function () {
    };
    /**
     * @return {?}
     */
    SimpleFilterComponent.prototype.clearFields = function () {
        $(this.getItemRef().querySelector('.datepicker-filter-' + this.componentGuid)).val('');
        this.filterQuery = '';
    };
    /**
     * @param {?} value
     * @param {?=} field
     * @return {?}
     */
    SimpleFilterComponent.prototype.selectedDate = function (value, field) {
        // this is the date the user selected
        LoggerService.log('selectedDate', value);
        // any object can be passed to the selected event and it will be passed back here
        field.start = value.start;
        field.end = value.end;
        // or manupulat your own internal property
        this.daterange.start = value.start;
        this.daterange.end = value.end;
        this.daterange.label = value.label;
        $(this.getItemRef().querySelector('.datepicker-filter-' + this.componentGuid)).val(this.daterange.start.format(UtilService.dateFormatDefault).toString());
    };
    /**
     * @return {?}
     */
    SimpleFilterComponent.prototype.filter = function () {
        var /** @type {?} */ date = '';
        var /** @type {?} */ datepicker = $(this.getItemRef().querySelector('.datepicker-filter-' + this.componentGuid));
        var /** @type {?} */ parts = datepicker.val().split('.');
        date = new Date(parts[2], parts[1] - 1, parts[0]).getTime().toString();
        var /** @type {?} */ filterDate = (datepicker.val() === '' || (typeof datepicker.val() === 'undefined')) ? '' : date;
        var /** @type {?} */ params = {
            action: FilterActionEnum.Filter,
            filter: {
                filterQuery: '',
                filterDate: '',
                filterObjects: [],
                filterCombined: null
            }
        };
        params['filter']['filterQuery'] = this.filterQuery;
        params['filter']['filterDate'] = filterDate;
        params['filter']['filterCombined'] = this.listService.getFilterCombined(this.backendService.getSettings(this.documentId), null, params['filter']['filterQuery'], params['filter']['filterDate'], params['filter']['filterObjects'], true);
        this.filterAction.emit(params);
    };
    /**
     * @return {?}
     */
    SimpleFilterComponent.prototype.refresh = function () {
        $(this.getItemRef().querySelector('.datepicker-filter-' + this.componentGuid)).val('');
        this.filterQuery = '';
        this.filter();
    };
    return SimpleFilterComponent;
}());
SimpleFilterComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-simple-filter',
                template: "\n      <div class=\"filter-row simple\">\n          <div class=\"dataTables_filter show row\">\n              <div>\n                  <div>\n                      <label>Datum:\n                          <input type=\"text\"\n                                 class=\"{{'datepicker-filter-' + componentGuid}}\"\n                                 (selected)=\"selectedDate($event, daterange)\"\n                                 daterangepicker\n                                 [options]=\"optionsDate\"/>\n                      </label>\n                  </div>\n                  <div>\n                      <label>Tekst:\n                          <input type=\"search\"\n                                 class=\"\"\n                                 placeholder=\"\"\n                                 aria-controls=\"DataTables_Table_0\"\n                                 [(ngModel)]=\"filterQuery\">\n                      </label>\n                  </div>\n                  <div>\n                      <button type=\"submit\" class=\"btn btn-success\" (click)=\"filter()\">\n                          <i class=\"fa fa-filter\"></i> Filter</button>\n                      <button type=\"submit\" class=\"btn btn-danger\" (click)=\"refresh()\">\n                          <i class=\"fa fa-refresh\"></i></button>\n                  </div>\n              </div>\n          </div>\n      </div>\n    ",
                styles: ["\n\n    "]
            },] },
];
/**
 * @nocollapse
 */
SimpleFilterComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: ListService, },
    { type: BackendService, },
]; };
SimpleFilterComponent.propDecorators = {
    'picker': [{ type: ViewChildren, args: [DaterangePickerComponent,] },],
    'filterAction': [{ type: Output, args: ['filterAction',] },],
    'documentId': [{ type: Input },],
    'settings': [{ type: Input },],
};
var SimpleFilterModule = /** @class */ (function () {
    function SimpleFilterModule() {
    }
    return SimpleFilterModule;
}());
SimpleFilterModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    SimpleFilterComponent
                ],
                entryComponents: [],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    Daterangepicker,
                    DaterangepickerModule,
                    TimepickerModule,
                    InputModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService
                ],
                exports: [SimpleFilterComponent]
            },] },
];
/**
 * @nocollapse
 */
SimpleFilterModule.ctorParameters = function () { return []; };
/**
 * Osnovni dokument koji extenduju svi dokumenti
 */
var Dokument = /** @class */ (function () {
    /**
     * @param {?} document
     */
    function Dokument(document) {
        this.id = document.id;
        this.oznaka = document.id;
        this.vrstaDokumenta = document.vrstaDokumenta;
        this.korisnik = document.korisnik;
        this.datumKreiranja = document.datumKreiranja;
    }
    return Dokument;
}());
/**
 * Osnovni dokument koji extenduju svi dokumenti
 */
var DokumentDokumenta = /** @class */ (function () {
    /**
     * @param {?} naredni
     * @param {?} prethodni
     */
    function DokumentDokumenta(naredni, prethodni) {
        this.naredni = naredni;
        this.prethodni = prethodni;
        // this.korisnik = authenticationService.getUser();
    }
    return DokumentDokumenta;
}());
/**
 * Type Guard (feature of TypeScript) ensuring that the "OnCopyPredecessors" event handler can be invoked.
 *
 * \@example
 * if (hasOnCopyPredecessors(someObject))
 *     someObject.bfOnCopyPredecessors(someData);
 * @param {?} arg
 * @return {?}
 */
function hasOnCopyPredecessors(arg) {
    return ( /** @type {?} */(arg)).bfOnCopyPredecessors !== undefined;
}
var PrethodniciComponent = /** @class */ (function () {
    /**
     * @param {?} eRef
     * @param {?} authenticationService
     * @param {?} backendService
     * @param {?} notificationService
     */
    function PrethodniciComponent(eRef, authenticationService, backendService, notificationService) {
        this.eRef = eRef;
        this.authenticationService = authenticationService;
        this.backendService = backendService;
        this.notificationService = notificationService;
        this.FormModeEnum = FormModeEnum;
        this.TableModeEnum = TableModeEnum;
        this.fieldVrstePrethodnika = {
            type: FieldTypeEnum.Completer,
            entityType: 'VrstaDokumenta',
            fieldName: 'selectedVrstaPrethodnika',
            fieldKey: 'documentType',
            relation: { _id: '-369224886', completerMainAndSecond: true },
            relationKey: new PathParts(['oznaka']),
            relationValue: new PathParts(['naziv']),
            propertyPath: new PathParts(['selectedVrstaPrethodnika']),
            mandatory: false,
            editable: true,
            additable: true,
            visible: true,
            id: '',
            dbType: '',
            path: '',
            label: '',
            width: '',
            validator: '',
            title: '',
            editableOverride: null,
            additableOverride: null,
            lookupFilter: null,
            lookupList: null,
            documentType: null,
            multiline: false,
            decimalCount: 2,
            color: null,
            errorMessage: '',
            lookupFormCode: null,
            lookupFormName: null,
            lookupInitFilter: null,
            tooltipText: null,
            sortable: true
        };
        this.vrstePrethodnika = [];
        this.selectedVrstaPrethodnika = null;
        this.fieldDocument = null;
        this.documentSelected = null;
        this.tooltipTextHTML = '';
        this.serverPagination = true;
        this.prethodniciClick = new EventEmitter();
        this.componentGuid = null;
        this.maxPrethodniciMap = new Map();
        this.prethodniciCount = 0;
        this.sledbeniciCount = 0;
        this.canCopyPredecessors = false;
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(PrethodniciComponent.prototype, "document", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._document = value;
            this.setVrstePrethodnika();
            this.setPrethodniciSledbenici();
            this.setTooltipTable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrethodniciComponent.prototype, "mode", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._mode = value;
            if (this.settingsTable) {
                this.settingsTable.listDeletable = this._mode !== FormModeEnum.View;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.setTooltipTable = function () {
        var _this = this;
        var /** @type {?} */ prethodnici = this._document.prethodni;
        var /** @type {?} */ sledbenici = this._document.naredni;
        this.tooltipTextHTML = '';
        var /** @type {?} */ sledbeniciExist = sledbenici && sledbenici.length > 0 && sledbenici !== 'undefined';
        var /** @type {?} */ prethodniciExist = prethodnici && prethodnici.length > 0 && prethodnici !== 'undefined';
        // prethodnici tabela
        this.tooltipTextHTML += '<table><tr><th>Prethodnici</th></tr>';
        if (prethodniciExist) {
            prethodnici.forEach(function (element) {
                var /** @type {?} */ prethodni = element['prethodni'];
                _this.tooltipTextHTML += '  <tr><td>' + prethodni.oznaka + '</td></tr>';
            });
            if (sledbenici && sledbenici.length > prethodnici.length) {
                var /** @type {?} */ count = sledbenici.length - prethodnici.length;
                for (var /** @type {?} */ j = 0; j < count; j++) {
                    this.tooltipTextHTML += '  <tr><td>&nbsp;</td></tr>';
                }
            }
        }
        else if (sledbeniciExist) {
            for (var /** @type {?} */ j = 0; j < sledbenici.length; j++) {
                this.tooltipTextHTML += '  <tr><td>&nbsp;</td></tr>';
            }
        }
        this.tooltipTextHTML += '</table>';
        // sledbenici tabela
        this.tooltipTextHTML += '<table><tr><th>Sledbenici</th></tr>';
        if (sledbeniciExist) {
            sledbenici.forEach(function (element) {
                var /** @type {?} */ naredni = element['naredni'];
                _this.tooltipTextHTML += '  <tr><td>' + naredni.oznaka + '</td></tr>';
            });
            if (prethodnici && prethodnici.length > sledbenici.length) {
                var /** @type {?} */ count = prethodnici.length - sledbenici.length;
                for (var /** @type {?} */ j = 0; j < count; j++) {
                    this.tooltipTextHTML += '  <tr><td>&nbsp;</td></tr>';
                }
            }
        }
        else if (prethodniciExist) {
            for (var /** @type {?} */ j = 0; j < prethodnici.length; j++) {
                this.tooltipTextHTML += '  <tr><td>&nbsp;</td></tr>';
            }
        }
        this.tooltipTextHTML += '</table>';
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.setVrstePrethodnika = function () {
        var _this = this;
        var /** @type {?} */ processVrstaDokumentaFn = function (vrsta) {
            var /** @type {?} */ oznaka = vrsta.vrstaDokumentaPoc.oznaka;
            var /** @type {?} */ max = vrsta.brojPojavaPrethodnika;
            _this.maxPrethodniciMap.set(oznaka, max);
            return new VrstaDokumentaPrethodnika(vrsta.vrstaDokumentaPoc.naziv, oznaka, max);
        };
        if (this._document) {
            var /** @type {?} */ params = {
                documentId: 'DokumentMenadzer',
                action: 'getVrstePrethodnikaFiltered',
                user: this.authenticationService.getUser().username,
                additionalParams: {
                    vrstaDokumenta: this.documentCode,
                    filterPrethodnici: this._document.filterPrethodnici
                }
            };
            this.backendService.executeCustomActionOrder(params).subscribe(function (data) {
                var /** @type {?} */ vrsteDokumenata = data.parts != null ? data.parts.vrsteDokumenta || [] : [];
                var /** @type {?} */ vrstePrethodnika = vrsteDokumenata.map(processVrstaDokumentaFn);
                _this.vrstePrethodnika = vrstePrethodnika;
                UtilService.fieldSetLookupList(_this.fieldVrstePrethodnika, vrstePrethodnika);
                var /** @type {?} */ selection = vrstePrethodnika.length > 0 ? vrstePrethodnika[0] : null;
                _this.selectedVrstaPrethodnikaChanged(_this.fieldVrstePrethodnika, selection);
            }, function (error) {
                console.log(error);
            });
        }
    };
    /**
     * @param {?} fieldSettings
     * @param {?} newValue
     * @return {?}
     */
    PrethodniciComponent.prototype.selectedVrstaPrethodnikaChanged = function (fieldSettings, newValue) {
        var _this = this;
        this.selectedVrstaPrethodnika = newValue;
        if (newValue != null) {
            this.backendService.fetchSettingsForDocumentType(newValue.oznaka).subscribe(function (data) {
                var /** @type {?} */ field = UtilService.getFieldDataSingle(data[0], data[0]);
                field.entityType = data[0].group;
                field.dbType = 'BIGINT';
                var /** @type {?} */ filter = null;
                if (_this._document.filterPrethodnici) {
                    filter = _this._document.filterPrethodnici.find(function (element) {
                        return element.vd === data[0].vrstaDokumenta;
                    });
                }
                if (filter) {
                    field.lookupFilter = filter.serviceFilterTerm;
                }
                else {
                    field.lookupFilter = new ServiceFilterTerm(ServiceFilterOperandEnum.AND, [
                        new ServiceFilterSymbol(data[0].group, 'vrstaDokumenta', '=', data[0].vrstaDokumenta, 'vrstaDokumentaFilter')
                    ]);
                }
                _this.fieldDocument = field;
            }, function (error) {
                console.log(error);
            });
        }
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.newPrethodnikAdd = function () {
        var _this = this;
        var /** @type {?} */ checkOk = true;
        if (this.orderList) {
            this.orderList.forEach(function (element) {
                var /** @type {?} */ id = element['id'];
                if (id === _this.documentSelected.id) {
                    checkOk = false;
                    _this.notificationService.openNoty('Odabrani dokument je već dodat kao prethodnik!');
                }
                if (_this.documentSelected.vrstaDokumenta === element['vrstaDokumenta']) {
                }
            });
        }
        // XXX "brojPrethodnika" zapravo NIJE BROJ već "0/1 as BOOL"!
        // WAS: const cantAdd = this.maxPrethodniciMap.size > 0 && countByDocType >= this.maxPrethodniciMap.get(this.documentSelected.vrstaDokumenta);
        if (this.maxPrethodniciMap.size > 0 && this.maxPrethodniciMap.get(this.documentSelected.vrstaDokumenta) === 0) {
            var /** @type {?} */ dodatiPrethodnici = this.orderList.find(function (item) { return item.vrstaDokumenta === _this.documentSelected.vrstaDokumenta; });
            if (dodatiPrethodnici) {
                checkOk = false;
                this.notificationService.openNoty('Maksimalan broj prethodnika za datu vrstu dokumenta ' + this.documentSelected.vrstaDokumenta + ' je 1');
            }
        }
        if (checkOk) {
            this.documentSelected.rbr = this.orderList.length + 1;
            this.orderList = this.orderList.concat([this.documentSelected]);
            this.determineCanCopyPredecessors();
        }
    };
    /**
     * @param {?} fieldMap
     * @param {?} newValue
     * @param {?} oldValue
     * @return {?}
     */
    PrethodniciComponent.prototype.documentUpdateValue = function (fieldMap, newValue, oldValue) {
        this.documentSelected = newValue;
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.closeModal = function () {
        this.documentSelected = null;
        $('.prethodnici-modal').hide();
        $("#prethodnici_" + this.componentGuid).append($("#modal-popup > #prethodniciModal_" + this.componentGuid));
        $('#modal-popup-parent').hide();
        // TODO: Clear table data
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PrethodniciComponent.prototype.openModal = function (event) {
        event.stopPropagation();
        this.setVrstePrethodnika();
        // XXX Must recalculate the condition because of the inject-_viewRef_-just-before-editing!!!
        this.determineCanCopyPredecessors();
        $('#modal-popup-parent').show();
        $('.prethodnici-modal').show();
        $('#modal-popup').append($("#prethodnici_" + this.componentGuid + " > #prethodniciModal_" + this.componentGuid));
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.ngOnInit = function () {
        this.settingsLoadSingle();
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.settingsLoadSingle = function () {
        var _this = this;
        this.backendService.fetchSettingForOrders(this.authenticationService.getUser().username, 'Dokument').subscribe(function (data) {
            _this.settingsData = data[0];
            _this.settingsTable = new TableSettings(_this.settingsData, 'table');
            _this.settingsTable.listDeletable = true;
            _this.settingsFilter = new FilterSettings(_this.settingsData);
            _this.settingsTable.listEditable = false;
            _this.settingsTable.listAdditable = false;
            _this.settingsDataSledbenici = data[0];
            _this.settingsTableSledbenici = new TableSettings(_this.settingsDataSledbenici, 'table');
            _this.settingsFilterSledbenici = new FilterSettings(_this.settingsDataSledbenici);
            _this.settingsTableSledbenici.listEditable = false;
            _this.settingsTableSledbenici.listAdditable = false;
            if (_this._mode) {
                _this.settingsTable.listDeletable = _this._mode !== FormModeEnum.View;
            }
            _this.setPrethodniciSledbenici();
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.determineCanCopyPredecessors = function () {
        this.canCopyPredecessors = this.orderList.length > 0 && this.hasOnCopyPredecessorsHandler();
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.setPrethodnici = function () {
        var /** @type {?} */ prethodnici = this._document.prethodni || [];
        this.orderList = prethodnici.map(function (item, index) {
            item.prethodni.rbr = index + 1;
            return item.prethodni;
        });
        this.prethodniciCount = this.orderList.length;
        // XXX Initially the condition will be false since the `_viewRef_` is not yet injected!!!
        this.determineCanCopyPredecessors();
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.setPrethodniciSledbenici = function () {
        var _this = this;
        this.setPrethodnici();
        // TODO Refactor the following block.
        var /** @type {?} */ sledbenici = this._document.naredni || [];
        this.orderListSledbenici = [];
        if (sledbenici && sledbenici.length > 0 && sledbenici !== 'undefined') {
            var /** @type {?} */ rbr_1 = 1;
            sledbenici.forEach(function (element) {
                var /** @type {?} */ naredni = element['naredni'];
                naredni.rbr = rbr_1++;
                _this.orderListSledbenici = _this.orderListSledbenici.concat([naredni]);
            });
        }
        this.sledbeniciCount = this.orderListSledbenici.length;
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.setCount = function () {
        this.sledbeniciCount = this.orderListSledbenici.length;
        this.prethodniciCount = this.orderList.length;
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.savePrethodnici = function () {
        var _this = this;
        var /** @type {?} */ naredni = new Dokument(this._document);
        if (this.orderList) {
            this._document['prethodni'] = [];
            this.orderList.forEach(function (element) {
                var /** @type {?} */ prethodnik = new DokumentDokumenta(naredni, element);
                _this._document['prethodni'] = _this._document['prethodni'].concat([prethodnik]);
            });
        }
        this.setCount();
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.savePrethodniciAction = function () {
        // TODO Refactor - remove the "save" logic, work directly on raw data.
        this.savePrethodnici();
        this.closeModal();
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.hasOnCopyPredecessorsHandler = function () {
        return UtilService.valueExists(this._document._viewRef_) && hasOnCopyPredecessors(this._document._viewRef_);
    };
    /**
     * @return {?}
     */
    PrethodniciComponent.prototype.kopirajPrethodnike = function () {
        var _this = this;
        if (this.hasOnCopyPredecessorsHandler()) {
            this.backendService.copyPredecessors(this.documentCode, this.orderList).subscribe(function (data) {
                _this._document._viewRef_.bfOnCopyPredecessors(data);
                _this.savePrethodnici(); // TODO Refactor - remove the "save" logic, work directly on raw data.
            });
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PrethodniciComponent.prototype.listTableAction = function (event) {
        switch (event.action) {
            case TableActionEnum.Click:
                var /** @type {?} */ params = {
                    action: ToolbarAction.Prethodnik,
                    documentCode: event.document.vrstaDokumenta,
                    id: event.document.id
                };
                this.prethodniciClick.emit(params);
                this.closeModal();
        }
    };
    return PrethodniciComponent;
}());
PrethodniciComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-prethodnici',
                template: "\n      <div id=\"prethodnici_{{ componentGuid }}\" class=\"prethodnici util-prethodnici\">\n          <div class=\"btn btn-default btn-condensed prethodnici-tooltip\">\n              <div class=\"tooltiptext\" [innerHTML]=\"tooltipTextHTML\"></div>\n              <a href=\"javascript:void(0)\"\n                 id=\"toolbarTooltip\"\n                 tabindex=\"-1\"\n                 (click)=\"openModal($event)\"\n                 class=\"fa fa-exchange\"> {{prethodniciCount}}/{{sledbeniciCount}}</a>\n          </div>\n\n          <div id=\"prethodniciModal_{{ componentGuid }}\" class=\"prethodnici-modal\">\n              <div class=\"panel panel-default\">\n                  <div class=\"panel-heading\">\n                      <div class=\"panel-heading\">\n                          <h3 class=\"panel-title\">Prethodnici</h3>\n                          <ul class=\"panel-controls\">\n                              <li>\n                                  <a href=\"javascript:void(0)\" (click)=\"closeModal()\">\n                                      <span class=\"fa fa-times\"></span>\n                                  </a>\n                              </li>\n                          </ul>\n                      </div>\n                      <div class=\"panel-body\">\n                          <div class=\"row\">\n                              <div class=\"col-md-2\">\n                                  <label>Mogu\u0107i&nbsp;prethodnici:</label>\n                              </div>\n                              <div class=\"col-md-5\">\n                                  <util-autocomplete\n                                      [selectedItem]=\"selectedVrstaPrethodnika\"\n                                      (selectedItemChange)=\"selectedVrstaPrethodnikaChanged(fieldVrstePrethodnika, $event.value)\"\n                                      [fieldSettings]=\"fieldVrstePrethodnika\"\n                                      [disabled]=\"_mode === FormModeEnum.View\">\n                                  </util-autocomplete>\n                              </div>\n                              <div class=\"col-md-5 flex-row\">\n                                  <util-autocomplete *ngIf=\"fieldDocument != null\" style=\"margin-left: 6px\"\n                                      [selectedItem]=\"documentSelected\"\n                                      (selectedItemChange)=\"documentUpdateValue(fieldDocument, $event.value, $event.oldValue)\"\n                                      [fieldSettings]=\"fieldDocument\"\n                                      [disabled]=\"_mode === FormModeEnum.View || selectedVrstaPrethodnika == null\">\n                                  </util-autocomplete>\n\n                                  <button type=\"button\" style=\"margin-left: 6px\"\n                                      class=\"btn btn-default add-action\"\n                                      [disabled]=\"_mode === FormModeEnum.View || !documentSelected\"\n                                      (click)=\"newPrethodnikAdd()\">\n                                      <i class=\"fa fa-plus\"></i>\n                                  </button>\n                              </div>\n                          </div>\n\n                          <div class=\"row\" style=\"margin-top: 1rem\"><div class=\"col-md-1\"><label>Prethodnici:</label></div></div>\n                          <div class=\"row\" *ngIf='settingsTable'>\n                              <util-table ident=\"id\"\n                                      [tableMode]=\"TableModeEnum.Details\"\n                                      [mode]=\"FormModeEnum.Table\"\n                                      [settings]=\"settingsTable\"\n                                      [paging]=\"false\"\n                                      [orderList]=\"orderList\"\n                                      [(selectedObject)]=\"selectedObject\"\n                                      (tableAction)=\"listTableAction($event)\">\n                              </util-table>\n                          </div>\n                          <div class=\"row\">\n                              <div class=\"col-md-12\">\n                                  <button type=\"button\" class=\"btn btn-default\"\n                                          [disabled]=\"_mode === FormModeEnum.View || !canCopyPredecessors\"\n                                          (click)=\"kopirajPrethodnike()\"\n                                          title=\"Kopiraj podatke iz navedenih prethodnika\">Kopiraj podatke\n                                  </button>\n                              </div>\n                          </div>\n\n                          <div class=\"row\" style=\"margin-top: 1rem\"><div class=\"col-md-1\"><label>Sledbenici:</label></div></div>\n                          <div class=\"row\" *ngIf='settingsTableSledbenici'>\n                              <util-table ident=\"id\"\n                                      [tableMode]=\"TableModeEnum.Details\"\n                                      [mode]=\"FormModeEnum.Table\"\n                                      [settings]=\"settingsTableSledbenici\"\n                                      [paging]=\"false\"\n                                      [orderList]=\"orderListSledbenici\"\n                                      [(selectedObject)]=\"selectedObjectSledbenici\"\n                                      (tableAction)=\"listTableAction($event)\">\n                              </util-table>\n                          </div>\n                          <div class=\"row\">\n                              <div class=\"centered-buttons\">\n                                  <button type=\"button\" class=\"btn btn-default add-action\"\n                                          [disabled]=\"_mode === FormModeEnum.View\"\n                                          (click)=\"savePrethodniciAction()\">Snimi\n                                  </button>\n                              </div>\n                          </div>\n                      </div>\n                  </div>\n              </div>\n          </div>\n      </div>\n    "
            },] },
];
/**
 * @nocollapse
 */
PrethodniciComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: AuthenticationService, },
    { type: BackendService, },
    { type: NotificationService, },
]; };
PrethodniciComponent.propDecorators = {
    'prethodniciClick': [{ type: Output, args: ['prethodniciClick',] },],
    'documentCode': [{ type: Input },],
    'document': [{ type: Input },],
    'mode': [{ type: Input },],
};
var VrstaDokumentaPrethodnika = /** @class */ (function () {
    /**
     * @param {?} naziv is the `VrstaDokumentaVeza.vrstaDokumentaPoc.naziv`
     * @param {?} oznaka is the `VrstaDokumentaVeza.vrstaDokumentaPoc.oznaka`
     * @param {?} maxPrethodnika is the `VrstaDokumentaVeza.brojPojavaPrethodnika`
     */
    function VrstaDokumentaPrethodnika(naziv, oznaka, maxPrethodnika) {
        this.naziv = naziv;
        this.oznaka = oznaka;
        this.maxPrethodnika = maxPrethodnika;
    }
    return VrstaDokumentaPrethodnika;
}());
var PrethodniciModule = /** @class */ (function () {
    function PrethodniciModule() {
    }
    return PrethodniciModule;
}());
PrethodniciModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ViewTableModule,
                    SimpleFilterModule,
                    ComboModule,
                    AutocompleteModule,
                    TableModule
                ],
                declarations: [
                    PrethodniciComponent
                ],
                providers: [
                    ListService
                ],
                exports: [
                    PrethodniciComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
PrethodniciModule.ctorParameters = function () { return []; };
var SecurityUtilEnum = {};
SecurityUtilEnum.Print = 404;
SecurityUtilEnum[SecurityUtilEnum.Print] = "Print";
var PrintComponent = /** @class */ (function () {
    /**
     * @param {?} authenticationService
     * @param {?} backendService
     */
    function PrintComponent(authenticationService, backendService) {
        this.authenticationService = authenticationService;
        this.backendService = backendService;
        this.FormModeEnum = FormModeEnum;
        this.TableModeEnum = TableModeEnum;
        this.prints = [];
        this.fields = [];
        this.names = [];
        this.componentGuid = null;
        this._btnKreirajVisible = false;
        this.VRSTA_DOC_BEYOND_XML = 5;
        this.componentGuid = UtilService.generateGuid();
    }
    Object.defineProperty(PrintComponent.prototype, "mode", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._mode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrintComponent.prototype, "document", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._document = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PrintComponent.prototype.ngOnInit = function () {
        this.checkPravoNaAdminPrint();
    };
    /**
     * @return {?}
     */
    PrintComponent.prototype.closeModal = function () {
        $('.print-modal').hide();
        $("#print_" + this.componentGuid).append($("#modal-popup > #printModal_" + this.componentGuid));
        $('#modal-popup-parent').hide();
    };
    /**
     * @return {?}
     */
    PrintComponent.prototype.openModal = function () {
        var _this = this;
        this.backendService.getPrintTemplate(this.identity.documentSecurityCode).subscribe(function (data) {
            _this.prints = data.parts.templates;
            $('#modal-popup-parent').show();
            $('.print-modal').show();
            $('#modal-popup').append($("#print_" + _this.componentGuid + " > #printModal_" + _this.componentGuid));
        });
    };
    /**
     * @return {?}
     */
    PrintComponent.prototype.closeModalDetails = function () {
        $('.print-details-modal').hide();
        $("#print_" + this.componentGuid).append($("#modal-popup > #printDetailsModal_" + this.componentGuid));
        $('#modal-popup-parent').hide();
    };
    /**
     * @return {?}
     */
    PrintComponent.prototype.openModalDetails = function () {
        var _this = this;
        var /** @type {?} */ documentId = this.identity.documentId2 == null ? this.identity.documentId : this.identity.documentId2;
        this.backendService.getTemplateFields(this.identity.documentSecurityCode, documentId).subscribe(function (data) {
            _this.fields = data.parts.stavke;
            _this.names = data.parts.names;
            _this.closeModal();
            $('#modal-popup-parent').show();
            $('.print-details-modal').show();
            $('#modal-popup').append($("#print_" + _this.componentGuid + " > #printDetailsModal_" + _this.componentGuid));
        });
    };
    /**
     * @param {?} print
     * @return {?}
     */
    PrintComponent.prototype.onSelect = function (print) {
        var /** @type {?} */ onSuccessFn = function (file) {
            var /** @type {?} */ out = new Blob([file], { type: 'application/pdf' });
            var /** @type {?} */ iframe = '<iframe style="position:absolute;top:0;left:0;width:100%;height:100%;" src="' + URL.createObjectURL(out)
                + '" height="this.height=window.innerHeight;" frameborder="0" allowfullscreen"></iframe>';
            var /** @type {?} */ x = window.open();
            x.document.open();
            x.document.write(iframe);
            x.document.close();
            x.onload = function () { return x.document.title = print.opis; };
        };
        var /** @type {?} */ documentId = this.identity.documentId2 == null ? this.identity.documentId : this.identity.documentId2;
        var /** @type {?} */ username = this.authenticationService.getUser().username;
        if (print.vrsta === this.VRSTA_DOC_BEYOND_XML) {
            this.backendService.printDocument(documentId, this.documentCode, this._document.id, username).subscribe(onSuccessFn);
        }
        else {
            this.backendService.printPDF(documentId, this.documentCode, this._document.id, username, print.id, print.opis).subscribe(onSuccessFn);
        }
    };
    /**
     * @return {?}
     */
    PrintComponent.prototype.checkPravoNaAdminPrint = function () {
        var _this = this;
        if (this.identity == null) {
            console.log('WARNING: PrintComponent is in invalid state (no document identity).');
            return;
        }
        var /** @type {?} */ security = this.backendService.getLabSecurity() || [];
        this.security = security; // TODO Shouldn't be stored as it is only used in this method.
        var /** @type {?} */ formSecurity = security.find(function (i) { return i.formCode === _this.identity.documentSecurityCode; });
        this._btnKreirajVisible = formSecurity != null && formSecurity.allowedModes.find(function (m) { return m === SecurityUtilEnum.Print; }) != null;
    };
    /**
     * @param {?} val
     * @return {?}
     */
    PrintComponent.prototype.copyText = function (val) {
        var /** @type {?} */ selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    };
    return PrintComponent;
}());
PrintComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-print',
                template: "\n      <div id=\"print_{{ componentGuid }}\" class=\"print util-print\">\n\n          <button class=\"btn btn-default btn-condensed\" title=\"\u0160tampaj\" (click)=\"openModal()\">\n              <i class=\"fa fa-print\"></i>\n          </button>\n\n          <div id=\"printModal_{{ componentGuid }}\" class=\"print-modal\">\n              <div class=\"panel panel-default\">\n                  <div class=\"panel-heading\">\n                      <h3 class=\"panel-title\">\u0160tampe</h3>\n                      <ul class=\"panel-controls\">\n                          <li><a href=\"javascript:void(0)\" (click)=\"closeModal()\"><span class=\"fa fa-times\"></span></a></li>\n                      </ul>\n                  </div>\n\n                  <div class=\"panel-body\">\n                      <button *ngIf=\"_btnKreirajVisible\" class=\"btn btn-default btn-condensed\" title=\"Kreiraj \u0161tampu\" (click)=\"openModalDetails()\">\n                          <i class=\"fa fa-plus-circle\"></i> Kreiraj \u0161tampu\n                      </button>\n\n                      <div class=\"row\" style=\"margin-top: 1rem\"><div class=\"col-md-2\"><label>Odabir \u0161tampe:</label></div></div>\n                      <div class=\"list-group\" *ngFor=\"let print of prints\" (click)=\"onSelect(print)\">\n                          <button type=\"button\" class=\"list-group-item\">{{print.opis}}</button>\n                      </div>\n                  </div>\n              </div>\n          </div>\n\n          <div id=\"printDetailsModal_{{ componentGuid }}\" class=\"print-details-modal\">\n                  <div class=\"panel panel-default\">\n                      <div class=\"panel-heading\">\n                          <h3 class=\"panel-title\">Struktura</h3>\n                          <ul class=\"panel-controls\">\n                              <li><a href=\"javascript:void(0)\" (click)=\"closeModalDetails()\"><span class=\"fa fa-times\"></span></a></li>\n                          </ul>\n                      </div>\n\n                      <div class=\"panel-body\">\n                          <div *ngFor=\"let field of fields; let i = index\">\n                              <h4 class=\"panel-title\"><span>{{names[i]}}</span></h4>\n                              <table class=\"print-table\">\n                                  <tr>\n                                      <th>Label</th>\n                                      <th>Type</th>\n                                      <th>Path</th>\n                                      <th></th>\n                                   </tr>\n                                      <tr *ngFor=\"let cell of field\">\n                                      <td>{{cell.label}}</td>\n                                      <td>{{cell.type}}</td>\n                                      <td>{{cell.path}}</td>\n                                      <td><button (click)=\"copyText(cell.path)\" class=\"actions btn btn-default btn-rounded btn-condensed btn-sm\">\n                                              <span class=\"fa fa-copy\"></span>\n                                          </button>\n                                      </td>\n                                  </tr>\n                              </table>\n                          </div>\n                      </div>\n                  </div>\n              </div>\n      </div>\n    ",
                styles: ["\n      .print-table {\n        border: 1px solid black;\n        width: 100%;\n        margin-top: 1em; }\n\n      .print-table tr:nth-child(odd) {\n        background-color: lightgrey; }\n\n      .print-table td {\n        width: 33%;\n        text-align: left; }\n\n      .print-modal, .print-details-modal {\n        display: none; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
PrintComponent.ctorParameters = function () { return [
    { type: AuthenticationService, },
    { type: BackendService, },
]; };
PrintComponent.propDecorators = {
    'documentCode': [{ type: Input },],
    'documentId': [{ type: Input },],
    'identity': [{ type: Input },],
    'mode': [{ type: Input },],
    'document': [{ type: Input },],
};
var PrintModule = /** @class */ (function () {
    function PrintModule() {
    }
    return PrintModule;
}());
PrintModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ViewTableModule,
                    SimpleFilterModule,
                    ComboModule,
                    AutocompleteModule,
                    TableModule
                ],
                declarations: [
                    PrintComponent
                ],
                providers: [
                    ListService
                ],
                exports: [
                    PrintComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
PrintModule.ctorParameters = function () { return []; };
var ToolbarModule = /** @class */ (function () {
    function ToolbarModule() {
    }
    return ToolbarModule;
}());
ToolbarModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ToolbarComponent
                ],
                entryComponents: [PrethodniciComponent, PrintComponent],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    PrethodniciModule,
                    PrintModule,
                    TooltipModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService
                ],
                exports: [ToolbarComponent]
            },] },
];
/**
 * @nocollapse
 */
ToolbarModule.ctorParameters = function () { return []; };
var SelectModule = /** @class */ (function () {
    function SelectModule() {
    }
    return SelectModule;
}());
SelectModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    NgMultiSelectDropDownModule
                ],
                declarations: [
                    SelectComponent
                ],
                providers: [
                    ListService
                ],
                exports: [
                    SelectComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
SelectModule.ctorParameters = function () { return []; };
var DetailsModule = /** @class */ (function () {
    function DetailsModule() {
    }
    return DetailsModule;
}());
DetailsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    DetailsComponent,
                ],
                entryComponents: [
                    AutocompleteComponent,
                    ComboComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    AutocompleteModule,
                    ComboModule,
                    DndModule,
                    DaterangepickerModule,
                    InputModule,
                    TimepickerModule,
                    ToolbarModule,
                    SharedModule,
                    TooltipModule,
                    SelectModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService
                ],
                exports: [DetailsComponent]
            },] },
];
/**
 * @nocollapse
 */
DetailsModule.ctorParameters = function () { return []; };
var EditTableModule = /** @class */ (function () {
    function EditTableModule() {
    }
    return EditTableModule;
}());
EditTableModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    EditTableComponent
                ],
                entryComponents: [
                    AutocompleteComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    Daterangepicker,
                    PaginationModule,
                    DataTablesModule,
                    AutocompleteModule,
                    ComboModule,
                    TimepickerModule,
                    InputModule,
                    TagsModule,
                    DaterangepickerModule,
                    SharedModule,
                    StatusLozengeModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService,
                    UtilService,
                    FieldService
                ],
                exports: [EditTableComponent]
            },] },
];
/**
 * @nocollapse
 */
EditTableModule.ctorParameters = function () { return []; };
var OrdersModule = /** @class */ (function () {
    function OrdersModule() {
    }
    return OrdersModule;
}());
OrdersModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    OrdersComponent
                ],
                entryComponents: [
                    AutocompleteComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    PaginationModule,
                    FilterModule,
                    EditTableModule,
                    DetailsModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService,
                    IndexeddbService
                ],
                exports: [OrdersComponent]
            },] },
];
/**
 * @nocollapse
 */
OrdersModule.ctorParameters = function () { return []; };
var TabsComponent = /** @class */ (function () {
    /**
     * @param {?} backendService
     * @param {?} route
     * @param {?} applicationService
     */
    function TabsComponent(backendService, route, applicationService) {
        this.backendService = backendService;
        this.route = route;
        this.applicationService = applicationService;
        this.tabsArray = [];
        this.activeTab = null;
        this.tabsMap = new Map();
        this.registerHandlers();
    }
    /**
     * @return {?}
     */
    TabsComponent.prototype.registerHandlers = function () {
        var _this = this;
        if (this.tabOpenSubscription) {
            this.tabOpenSubscription.unsubscribe();
        }
        this.tabOpenSubscription = this.applicationService.tabOpenEvent.subscribe(function (data) {
            LoggerService.log('Adding Tab', data);
            // Check if a tab of the same identity already exists
            var /** @type {?} */ existingTab = _this.getTabByLikeIdentity(data.identity);
            if (existingTab != null) {
                // Tab already exists, switch to it instead
                existingTab.params = data.params;
                _this.changeActiveTab(existingTab);
            }
            else {
                // Creating a new tab
                _this.tabsMap.set(data.identity, data.component);
                _this.tabsArray.push(data);
                _this.changeActiveTab(data);
                setTimeout(function (self) {
                    var /** @type {?} */ i = self.getCurrentKey();
                    var /** @type {?} */ num = i + 1;
                    $('#navigationTabs a:nth-child(' + num + ')')[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
                }, 0, _this);
            }
        }, function (error) {
        });
        if (this.tabCloseSubscription) {
            this.tabCloseSubscription.unsubscribe();
        }
        this.tabCloseSubscription = this.applicationService.tabCloseEvent.subscribe(function (data) {
            LoggerService.log('Closing Tab', data);
            // Check if a tab of the same identity already exists
            var /** @type {?} */ existingTab = _this.getTabByLikeIdentity(data);
            if (existingTab != null) {
                // Tab exists, close it
                _this.closeTab(existingTab);
            }
        }, function (error) {
        });
        if (this.settingsLoadedForOrdersSubscription) {
            this.settingsLoadedForOrdersSubscription.unsubscribe();
        }
        this.settingsLoadedForOrdersSubscription = this.backendService.settingsLoadedForOrders.subscribe(function (data) {
            _this.tabsArray.forEach(function (item, index) {
                if (data[0] && item.identity.documentLabel === data[0].title) {
                    item.identity.documentCode = data[0].vrstaDokumenta;
                    item.identity.documentSecurityCode = data[0].formCode;
                }
            });
        }, function (error) {
        });
    };
    /**
     * @param {?} identity
     * @return {?}
     */
    TabsComponent.prototype.getTabByLikeIdentity = function (identity) {
        var /** @type {?} */ retVal = null;
        this.tabsArray.forEach(function (item, index) {
            if (item.identity.isEqual(identity)) {
                retVal = item;
            }
        });
        return retVal;
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    TabsComponent.prototype.tabClicked = function (tab) {
        tab.params = null;
        this.changeActiveTab(tab);
    };
    /**
     * @param {?} newActiveTab
     * @return {?}
     */
    TabsComponent.prototype.changeActiveTab = function (newActiveTab) {
        this.activeTab = newActiveTab;
        this.applicationService.tabSwitchNotify(newActiveTab);
    };
    /**
     * @return {?}
     */
    TabsComponent.prototype.getCurrentKey = function () {
        for (var /** @type {?} */ key in this.tabsArray) {
            if (this.activeTab === this.tabsArray[key]) {
                return parseInt(key, 0);
            }
        }
        return 0;
    };
    /**
     * @param {?} direction
     * @return {?}
     */
    TabsComponent.prototype.arrowTabClicked = function (direction) {
        var /** @type {?} */ i = this.getCurrentKey();
        if (direction === 'next') {
            i++;
        }
        else {
            i--;
        }
        if (i in this.tabsArray) {
            var /** @type {?} */ num = i + 1;
            this.changeActiveTab(this.tabsArray[i]);
            if (direction === 'next') {
                $('#navigationTabs a:nth-child(' + num + ')')[0].scrollIntoView({ block: 'end', behavior: 'smooth' });
            }
            else {
                $('#navigationTabs a:nth-child(' + num + ')')[0].scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
        }
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    TabsComponent.prototype.getComponent = function (tab) {
        return this.tabsMap.get(tab);
    };
    /**
     * @param {?} tabToClose
     * @return {?}
     */
    TabsComponent.prototype.closeTab = function (tabToClose) {
        this.tabsArray = this.tabsArray.filter(function (item) { return item !== tabToClose; });
        this.tabsMap.delete(tabToClose.identity);
        this.applicationService.sacuvajMontazu.next(tabToClose.identity);
        this.applicationService.sacuvajVerifikaciju.next(tabToClose.identity);
        this.applicationService.sacuvajKopijuVerifikacije.next(tabToClose.identity);
        if (this.activeTab === tabToClose) {
            if (this.tabsArray.length > 0) {
                this.changeActiveTab(this.tabsArray[0]);
            }
            else {
                this.changeActiveTab(null);
            }
        }
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    TabsComponent.prototype.isOrder = function (tab) {
        if (tab.indexOf('Dobrodošli na') === -1) {
            return true;
        }
        return false;
    };
    /**
     * @return {?}
     */
    TabsComponent.prototype.ngOnInit = function () {
        // TODO: Re-enable opening a page by URL
        // const group = this.backendService.getGroup();
        // if (group === '') {
        //     if (this.route.snapshot.queryParams.hasOwnProperty('group')) {
        //         this.backendService.setGroup(this.route.snapshot.queryParams['group']);
        //     } else {
        //         this.backendService.setGroup('Dobrodošli na ' + this.app['name']);
        //     }
        // }
        // this.tabs.push(this.backendService.getGroup());
        // this.activeTab = this.backendService.getGroup();
    };
    /**
     * @return {?}
     */
    TabsComponent.prototype.ngOnDestroy = function () {
        if (this.tabOpenSubscription) {
            this.tabOpenSubscription.unsubscribe();
        }
        if (this.tabCloseSubscription) {
            this.tabCloseSubscription.unsubscribe();
        }
        if (this.settingsLoadedForOrdersSubscription) {
            this.settingsLoadedForOrdersSubscription.unsubscribe();
        }
    };
    return TabsComponent;
}());
TabsComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-tabs',
                template: "\n      <!-- PAGE CONTENT TABBED -->\n      <div class=\"page-tabs\">\n          <a (click)=\"arrowTabClicked('previous')\" class=\"left-arraw\"><i class=\"fa fa-angle-left\"></i></a>\n          <div class=\"navigation-tabs\" id=\"navigationTabs\">\n              <a [ngClass]=\"{active: activeTab === tab}\"\n                 (click)=\"tabClicked(tab)\"\n                 *ngFor=\"let tab of tabsArray; let i = index\">{{tab.identity.documentLabel}}\n                  <span *ngIf=\"tabsArray.length !== 1\" class=\"fa fa-times\" (click)=\"closeTab(tab)\"></span>\n              </a>\n          </div>\n          <a (click)=\"arrowTabClicked('next')\" class=\"right-arraw\"><i class=\"fa fa-angle-right\"></i></a>\n      </div>\n      <div *ngFor=\"let tab of tabsArray; let i = index\"\n           [ngClass]=\"{active: activeTab === tab, 'page-content-wrap': true, 'page-tabs-item': true}\">\n          <div class=\"row\">\n              <div class=\"col-md-12 scrolled-content\">\n                  <util-page [identity]=\"tab.identity\"\n                             [params]=\"tab.params\"\n                             [component]=\"getComponent(tab.identity)\"\n                             [isActiveTab]=\"tab === activeTab\"></util-page>\n              </div>\n          </div>\n      </div>\n    ",
                styles: ["\n      .page-tabs a.left-arraw, .page-tabs a.right-arraw {\n        min-width: 40px;\n        padding: 0;\n        position: absolute; }\n\n      .page-tabs a.right-arraw {\n        right: 0; }\n\n      .page-tabs .navigation-tabs {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: nowrap;\n            flex-wrap: nowrap;\n        position: absolute;\n        margin-left: 40px;\n        width: calc(100% - 80px);\n        overflow-x: scroll; }\n        .page-tabs .navigation-tabs a {\n          -webkit-box-flex: 0;\n              -ms-flex: 0 0 auto;\n                  flex: 0 0 auto; }\n\n      .navigation-tabs::-webkit-scrollbar {\n        display: none; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
TabsComponent.ctorParameters = function () { return [
    { type: BackendService, },
    { type: ActivatedRoute, },
    { type: ApplicationService, },
]; };
TabsComponent.propDecorators = {
    'app': [{ type: Input },],
};
var PageComponent = /** @class */ (function () {
    /**
     * @param {?} cdr
     */
    function PageComponent(cdr) {
        this.cdr = cdr;
        this.FormModeEnum = FormModeEnum;
        this.name = null;
        this.mode = FormModeEnum.Table;
        this.toolbarOptions = ToolbarOptions.getDefault();
        this.infobarVisible = false;
        this.infobarDocument = null;
        this.infobarPodugovor = null;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    PageComponent.prototype.onToolbarAction = function (event) {
        this.component.componentInstance.onToolbarAction(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PageComponent.prototype.onInfoAction = function (event) {
        this.component.componentInstance.onInfoAction(event);
    };
    /**
     * @return {?}
     */
    PageComponent.prototype.ngOnChanges = function () {
        if (this.component != null && this.component.componentInstance != null) {
            this.component.componentInstance.setIsActiveTab(this.isActiveTab);
        }
    };
    /**
     * @return {?}
     */
    PageComponent.prototype.ngAfterViewInit = function () {
    };
    /**
     * @return {?}
     */
    PageComponent.prototype.ngOnDestroy = function () {
    };
    /**
     * @return {?}
     */
    PageComponent.prototype.componentReady = function () {
        var _this = this;
        this.component.componentInstance.setIdentity(this.identity);
        this.component.componentInstance.setParams(this.params);
        this.component.componentInstance.setIsActiveTab(this.isActiveTab);
        this.documentCode = this.identity.documentCode;
        this.documentId = this.identity.documentId;
        this.component.componentInstance.nameSubject.subscribe(function (name) {
            _this.name = name;
        });
        this.component.componentInstance.modeSubject.subscribe(function (mode) {
            _this.mode = mode;
        });
        this.component.componentInstance.toolbarOptionsSubject.subscribe(function (toolbarOptions) {
            _this.toolbarOptions = toolbarOptions;
        });
        this.component.componentInstance.infobarVisibleSubject.subscribe(function (infobarVisible) {
            _this.infobarVisible = infobarVisible;
        });
        this.component.componentInstance.infobarDocumentSubject.subscribe(function (infobarDocument) {
            _this.infobarDocument = infobarDocument;
            _this.cdr.detectChanges(); // TODO: Is this needed?
        });
        this.component.componentInstance.infobarPodugovorSubject.subscribe(function (infobarPodugovor) {
            _this.infobarPodugovor = infobarPodugovor;
            _this.cdr.detectChanges(); // TODO: Is this needed?
        });
        // Notify Angular of model changes
        this.cdr.detectChanges();
    };
    return PageComponent;
}());
PageComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-page',
                template: "\n      <div class=\"panel panel-default main-panel\"\n           [ngClass]=\"{'main-panel-not-table-mode': mode !== FormModeEnum.Table, 'main-panel-table-mode': mode === FormModeEnum.Table}\">\n          <div *ngIf=\"mode !== FormModeEnum.Table\" class=\"transparent-background\"></div>\n          <util-toolbar *ngIf=\"mode !== FormModeEnum.Table\"\n                        [name]=\"name\"\n                        [mode]=\"mode\"\n                        [documentCode]=\"documentCode\"\n                        [documentId]=\"documentId\"\n                        [options]=\"toolbarOptions\"\n                        [document]=\"infobarDocument\"\n                        [identity]=\"identity\"\n                        (toolbarAction)=\"onToolbarAction($event)\"></util-toolbar>\n          <util-infobar *ngIf=\"infobarVisible\"\n                        [document]=\"infobarDocument\"\n                        [podugovor]=\"infobarPodugovor\"\n                        (infoAction)=\"onInfoAction($event)\"\n                        [mode]=\"mode\"></util-infobar>\n          <util-dcl-wrapper [identity]=\"identity\"\n                       [component]=\"component\"\n                       [isActiveTab]=\"isActiveTab\"\n                       (componentReady)=\"componentReady()\"></util-dcl-wrapper>\n      </div>\n    "
            },] },
];
/**
 * @nocollapse
 */
PageComponent.ctorParameters = function () { return [
    { type: ChangeDetectorRef, },
]; };
PageComponent.propDecorators = {
    'component': [{ type: Input },],
    'identity': [{ type: Input },],
    'params': [{ type: Input },],
    'isActiveTab': [{ type: Input },],
};
var DclWrapperComponent = /** @class */ (function () {
    /**
     * @param {?} componentFactoryResolver
     * @param {?} compiler
     * @param {?} cdRef
     */
    function DclWrapperComponent(componentFactoryResolver, compiler, cdRef) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.compiler = compiler;
        this.cdRef = cdRef;
        this.componentReady = new EventEmitter();
        this.cmpRef = null;
        this.isViewInitialized = false;
    }
    /**
     * @return {?}
     */
    DclWrapperComponent.prototype.updateComponent = function () {
        if (!this.isViewInitialized) {
            return;
        }
        if (this.cmpRef) {
            // this.cmpRef.destroy();
        }
        else {
            LoggerService.log('Creating page');
            LoggerService.log(this.component);
            var /** @type {?} */ factory = this.componentFactoryResolver.resolveComponentFactory(this.component.componentClass);
            this.cmpRef = this.target.createComponent(factory, this.identity);
            this.component.componentInstance = ( /** @type {?} */(this.cmpRef.instance));
            this.componentReady.emit();
            // To access the created instance use
            // this.compRef.instance.someProperty = 'someValue';
            // this.compRef.instance.someOutput.subscribe(val => doSomething());
        }
        this.cdRef.detectChanges();
    };
    /**
     * @return {?}
     */
    DclWrapperComponent.prototype.ngOnChanges = function () {
        this.updateComponent();
    };
    /**
     * @return {?}
     */
    DclWrapperComponent.prototype.ngAfterViewInit = function () {
        this.isViewInitialized = true;
        this.updateComponent();
    };
    /**
     * @return {?}
     */
    DclWrapperComponent.prototype.ngOnDestroy = function () {
        if (this.cmpRef) {
            LoggerService.log('Destroying page');
            this.cmpRef.destroy();
        }
    };
    return DclWrapperComponent;
}());
DclWrapperComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-dcl-wrapper',
                template: "\n      <div #target></div>\n    "
            },] },
];
/**
 * @nocollapse
 */
DclWrapperComponent.ctorParameters = function () { return [
    { type: ComponentFactoryResolver, },
    { type: Compiler, },
    { type: ChangeDetectorRef, },
]; };
DclWrapperComponent.propDecorators = {
    'target': [{ type: ViewChild, args: ['target', { read: ViewContainerRef },] },],
    'component': [{ type: Input },],
    'identity': [{ type: Input },],
    'isActiveTab': [{ type: Input },],
    'componentReady': [{ type: Output },],
};
var DclWrapperModule = /** @class */ (function () {
    function DclWrapperModule() {
    }
    return DclWrapperModule;
}());
DclWrapperModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    DclWrapperComponent
                ],
                entryComponents: [],
                imports: [
                    CommonModule,
                    HttpClientModule,
                ],
                providers: [
                    AuthenticationService,
                    BackendService
                ],
                exports: [DclWrapperComponent]
            },] },
];
/**
 * @nocollapse
 */
DclWrapperModule.ctorParameters = function () { return []; };
var InfobarComponent = /** @class */ (function () {
    /**
     * @param {?} eRef
     */
    function InfobarComponent(eRef) {
        this.eRef = eRef;
        this.optionsDate = UtilService.datePickerOptionsDefault;
        this.editable = false;
        this.infoAction = new EventEmitter();
    }
    Object.defineProperty(InfobarComponent.prototype, "document", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._document = value;
            this.initDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfobarComponent.prototype, "podugovor", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._podugovor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfobarComponent.prototype, "mode", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._mode = value;
            switch (value) {
                case FormModeEnum.Edit:
                case FormModeEnum.Add:
                case FormModeEnum.Copy:
                    this.editable = true;
                    break;
                case FormModeEnum.View:
                    this.editable = false;
                    break;
            }
            if (this._document.status || this._document.storno) {
                this.editable = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    InfobarComponent.prototype.onAction = function (event) { };
    /**
     * @return {?}
     */
    InfobarComponent.prototype.getItemRef = function () {
        return this.eRef.nativeElement;
    };
    /**
     * @param {?} startDate
     * @return {?}
     */
    InfobarComponent.prototype.selectDate = function (startDate) {
        if (this.picker != null) {
            this.picker.forEach(function (child) {
                child.datePicker.setStartDate(startDate);
            });
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    InfobarComponent.prototype.dateChanged = function (value) {
        this.selectDate(value.end);
        var /** @type {?} */ params = {
            value: value.end
        };
        this.infoAction.emit(params);
        var /** @type {?} */ date = value.end.format(UtilService.dateFormatDefault);
        $(this.getItemRef().querySelector('input')).val(date);
        // this.hideErrors();
    };
    /**
     * @return {?}
     */
    InfobarComponent.prototype.initDate = function () {
        if (this._document != null && this._document.hasOwnProperty('datum')) {
            $(this.getItemRef().querySelector('input')).val(UtilService.formatDate(this._document.datum));
        }
        else {
            var /** @type {?} */ date = new Date().toISOString();
            $(this.getItemRef().querySelector('input')).val(UtilService.formatDate(date));
            var /** @type {?} */ params = {
                value: date
            };
            this.infoAction.emit(params);
        }
    };
    /**
     * @return {?}
     */
    InfobarComponent.prototype.ngOnInit = function () {
        LoggerService.log('ngOnInit');
        LoggerService.log('document', this._document);
    };
    return InfobarComponent;
}());
InfobarComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-infobar',
                template: "\n      <div class=\"panel panel-info no-border header-info-wrapper\">\n          <ul class=\"panel-body header-info-panel\">\n              <li class=\"first-part\">\n\n                  <div class=\"util-datepicker input-group date\">\n                      <input type=\"text\"\n                             daterangepicker\n                             [options]=\"optionsDate\"\n                             class=\"form-control date-form-control\"\n                             (selected)=\"dateChanged($event)\"\n                             [attr.disabled]=\"editable ? null : ''\"/>\n                  </div>\n\n                  <!-- HACK margin-top below is to center the component vertically. -->\n                  <util-status-lozenge [target]=\"_document\" [showSaved]=\"true\" style=\"margin-top: 6px;\"></util-status-lozenge>\n\n                  <span *ngIf=\"_document?.statusDokumenta\"\n                        class=\"btn\" style=\"margin-left: 6px;\"\n                        [ngClass]=\"{'btn-danger': _document?.storno, 'btn-success': _document?.status && !_document?.storno, 'btn-warning': !_document?.status && !_document?.storno}\">{{ _document?.statusDokumenta?.naziv }}</span>\n                  <i class=\"label-huge\" *ngIf=\"_document?.statusDokumenta\" class=\"fa fa-clock-o fa-lg\"></i>\n              </li>\n\n              <li class=\"last-part\">\n                  <!-- <span class=\"label label-basic label-form label-huge\" *ngIf=\"_document?.korisnik\">{{ _document?.korisnik }}</span> -->\n                  <span class=\"label label-basic label-form label-huge\" *ngIf=\"_document?.ShowInfoBar\">Kreirano: {{_document?.KreiraoImePrezime}} {{ _document?.DatumKreiranja | date: 'dd.MM.yyyy. HH:mm:ss' }}</span>\n                  <span class=\"label label-basic label-form label-huge\" *ngIf=\"_document?.ShowInfoBar\">Promenjeno: {{_document?.IzmenioImePrezime}} {{ _document?.DatumIzmene | date: 'dd.MM.yyyy. HH:mm:ss' }}</span>\n                  <span class=\"label label-basic label-form label-huge\" *ngIf=\"_document?.ShowInfoBarUgovor && !_podugovor\">Kreirano: {{_document?.KorisnikImePrezime}} {{ _document?.StvarniDatumKreiranja | date: 'dd.MM.yyyy. HH:mm:ss' }}</span>\n                  <span class=\"label label-basic label-form label-huge\" *ngIf=\"_document?.ShowInfoBarUgovor && !_podugovor\">Promenjeno: {{_document?.IzmenioImePrezime}} {{ _document?.DatumIzmene | date: 'dd.MM.yyyy. HH:mm:ss' }}</span>\n                  <span class=\"label label-basic label-form label-huge\" *ngIf=\"_podugovor\">Kreirano: {{_podugovor?.KorisnikImePrezime}} {{ _podugovor?.StvarniDatumKreiranja | date: 'dd.MM.yyyy. HH:mm:ss' }}</span>\n                  <span class=\"label label-basic label-form label-huge\" *ngIf=\"_podugovor\">Promenjeno: {{_podugovor?.IzmenioImePrezime}} {{ _podugovor?.DatumIzmene | date: 'dd.MM.yyyy. HH:mm:ss' }}</span>\n\n                  <!-- <span class=\"label label-basic label-form label-huge\" *ngIf=\"_document?.datumPromene\">Promenjen: {{ _document?.datumPromene | date: 'dd.MM.yyyy' }}</span>\n                  <span class=\"label label-basic label-form label-huge\" *ngIf=\"_document?.datumKreiranja\">Kreiran: {{ _document?.datumKreiranja | date: 'dd.MM.yyyy' }}</span> -->\n                  <span class=\"label label-basic label-form label-huge\" *ngIf=\"_document?.prisutanNaVS\">{{_document?.prisutanNaVS ? 'Prisutan na video serveru' : 'Nije prisutan na video serveru'}}</span>           \n                  <span class=\"label label-basic label-form label-huge\" *ngIf=\"_document?.datumProvereVS\">{{_document?.datumProvereVS ? 'Prisutan na video serveru' : 'Nije prisutan na video serveru'}}</span>\n              </li>\n          </ul>\n      </div>\n    ",
                styles: ["\n      .header-info-wrapper {\n        margin-bottom: 0px; }\n        .header-info-wrapper input {\n          border: none; }\n        .header-info-wrapper .form-control:focus,\n        .header-info-wrapper .form-control[disabled] {\n          background-color: transparent;\n          color: #555; }\n        .header-info-wrapper .first-part {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n        .header-info-wrapper .util-datepicker {\n          width: 100px; }\n        .header-info-wrapper .fa.fa-clock-o {\n          line-height: 30px;\n          padding-left: 10px; }\n    "]
            },] },
];
/**
 * @nocollapse
 */
InfobarComponent.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
InfobarComponent.propDecorators = {
    'document': [{ type: Input },],
    'podugovor': [{ type: Input },],
    'mode': [{ type: Input },],
    'picker': [{ type: ViewChildren, args: [DaterangePickerComponent,] },],
    'infoAction': [{ type: Output, args: ['infoAction',] },],
};
var InfobarModule = /** @class */ (function () {
    function InfobarModule() {
    }
    return InfobarModule;
}());
InfobarModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    InfobarComponent
                ],
                entryComponents: [],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    Daterangepicker,
                    StatusLozengeModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService
                ],
                exports: [InfobarComponent]
            },] },
];
/**
 * @nocollapse
 */
InfobarModule.ctorParameters = function () { return []; };
var PageModule = /** @class */ (function () {
    function PageModule() {
    }
    return PageModule;
}());
PageModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    PageComponent
                ],
                entryComponents: [
                    MessagesComponent
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    DclWrapperModule,
                    ToolbarModule,
                    InfobarModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService,
                    NotificationService,
                    RtsBackendService
                ],
                exports: [PageComponent]
            },] },
];
/**
 * @nocollapse
 */
PageModule.ctorParameters = function () { return []; };
var TabsModule = /** @class */ (function () {
    function TabsModule() {
    }
    return TabsModule;
}());
TabsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    TabsComponent
                ],
                entryComponents: [
                    OrdersComponent
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    OrdersModule,
                    PageModule
                ],
                providers: [
                    AuthenticationService,
                    ApplicationService,
                    BackendService
                ],
                exports: [TabsComponent]
            },] },
];
/**
 * @nocollapse
 */
TabsModule.ctorParameters = function () { return []; };
var ExpandPanelComponent = /** @class */ (function () {
    function ExpandPanelComponent() {
        this.panelTitle = 'default name';
        this.showInterface = true;
        this.isFullscreen = false;
    }
    /**
     * @return {?}
     */
    ExpandPanelComponent.prototype.ngOnInit = function () {
    };
    return ExpandPanelComponent;
}());
ExpandPanelComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-expand-panel',
                template: "\n    <div *ngIf=\"showInterface\" [ngClass]=\"{'panel-fullscreen-wrap': isFullscreen}\">\n\n        <div class=\"panel panel-info\" [ngClass]=\"{ 'panel-fullscreened': isFullscreen}\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\"> {{panelTitle}} </h3>\n                <ul class=\"panel-controls\">\n\n                    <li>\n              <span class=\"panel-fullscreen\" (click)=\"isFullscreen = !isFullscreen\">\n                <span class=\"fa fa-expand\"></span>\n              </span>\n                    </li>\n\n                    <li>\n              <span class=\"panel-collapse\" (click)=\"isExpanded = !isExpanded\">\n                <span class=\"fa fa-angle-down\" [ngClass]=\"{'panel-toggled': isExpanded}\"></span>\n              </span>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"panel-body\" *ngIf=\"isExpanded\">\n                <ng-container *ngTemplateOutlet=\"panelContent\"></ng-container>\n            </div>\n        </div>\n    </div>\n\n    <div *ngIf=\"!showInterface\">\n        <ng-container *ngTemplateOutlet=\"panelContent\"></ng-container>\n    </div>\n\n    <ng-template #panelContent>\n        <ng-content></ng-content>\n    </ng-template>\n  ",
                styles: ["\n    .panel-hidden {\n      display: none; }\n\n    .panel-fullscreen-wrap {\n      z-index: 99999; }\n\n    .panel-fullscreen,\n    .panel-collapse {\n      display: block;\n      float: left;\n      width: 36px;\n      height: 36px;\n      text-align: center;\n      line-height: 34px;\n      color: #656D78;\n      border: 1px solid #BBB;\n      border-radius: 50%;\n      margin-left: 3px;\n      -webkit-transition: all 200ms ease;\n      transition: all 200ms ease; }\n      .panel-fullscreen:hover,\n      .panel-collapse:hover {\n        border-color: #999;\n        color: #434A54; }\n      .panel-fullscreen .panel-toggled,\n      .panel-collapse .panel-toggled {\n        -webkit-transform: rotate(180deg);\n                transform: rotate(180deg); }\n  "]
            },] },
];
/**
 * @nocollapse
 */
ExpandPanelComponent.ctorParameters = function () { return []; };
ExpandPanelComponent.propDecorators = {
    'panelTitle': [{ type: Input },],
    'showInterface': [{ type: Input },],
    'isExpanded': [{ type: Input },],
};
var ExpandPanelModule = /** @class */ (function () {
    function ExpandPanelModule() {
    }
    return ExpandPanelModule;
}());
ExpandPanelModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ExpandPanelComponent
                ],
                entryComponents: [],
                imports: [
                    CommonModule,
                ],
                providers: [],
                exports: [
                    ExpandPanelComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
ExpandPanelModule.ctorParameters = function () { return []; };
var SettingsComponent = /** @class */ (function () {
    /**
     * @param {?} authenticationService
     * @param {?} backendService
     * @param {?} applicationService
     * @param {?} modalSettingsService
     * @param {?} settingsService
     */
    function SettingsComponent(authenticationService, backendService, applicationService, modalSettingsService, settingsService) {
        this.authenticationService = authenticationService;
        this.backendService = backendService;
        this.applicationService = applicationService;
        this.modalSettingsService = modalSettingsService;
        this.settingsService = settingsService;
        this.themeSettingsClass = '';
        this._settingsSingle = null;
        this.complexFilter = false;
        this.settingsAction = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SettingsComponent.prototype.toggleSettings = function () {
        if (this.themeSettingsClass === '') {
            this.themeSettingsClass = 'active';
        }
        else {
            this.themeSettingsClass = '';
        }
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.getIdentity = function () {
        return this.applicationService.currentTabIdentity;
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.getDocumentId = function () {
        return this.applicationService.currentTabIdentity.documentId;
    };
    /**
     * @param {?} group
     * @return {?}
     */
    SettingsComponent.prototype.setSettings = function (group) {
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.ngAfterViewInit = function () {
        $('.theme-settings input').on('ifClicked', function (event) {
            if ($(this).attr('name') === 'complex_filter') {
                $(event.target).click();
            }
        });
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.unsubscribeListeners();
        this.settingsLoadedForOrdersSubscription = this.backendService.settingsLoadedForOrders.subscribe(function (data) {
            _this.applicationService.settingsSingleLoaded(data);
            _this.refreshSettings();
        });
        this.tabSwitchSubscription = this.applicationService.tabSwitchEvent.subscribe(function (data) {
            _this.refreshSettings();
        });
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.refreshSettings = function () {
        var /** @type {?} */ settingsSingle = this.backendService.getSettings(this.getDocumentId());
        if (settingsSingle && settingsSingle.length > 0) {
            this._settingsSingle = settingsSingle[0];
        }
    };
    /**
     * @param {?} complexFilter
     * @return {?}
     */
    SettingsComponent.prototype.switchFilter = function (complexFilter) {
        this.complexFilter = !this.complexFilter;
        this.settingsService.serviceSwitchFilter(this.complexFilter);
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.resetToDefault = function () {
        if (this._settingsSingle !== null) {
            this.backendService.deleteSettings(this.authenticationService.getUser().username, false, this._settingsSingle.group).subscribe(function (data) {
            }, function (error) {
                console.log(error);
            });
            var /** @type {?} */ params = {
                name: 'open'
            };
            this.settingsAction.emit(params);
        }
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.openSettings = function () {
        if (this._settingsSingle !== null) {
            this.modalSettingsService.openModal(this._settingsSingle, function (response) {
            });
            var /** @type {?} */ params = {
                name: 'open'
            };
            this.settingsAction.emit(params);
        }
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeListeners();
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.unsubscribeListeners = function () {
        if (this.settingsChangedSubscription) {
            this.settingsChangedSubscription.unsubscribe();
        }
        if (this.settingsLoadedForOrdersSubscription) {
            this.settingsLoadedForOrdersSubscription.unsubscribe();
        }
        if (this.tabSwitchSubscription) {
            this.tabSwitchSubscription.unsubscribe();
        }
    };
    return SettingsComponent;
}());
SettingsComponent.decorators = [
    { type: Component, args: [{
                selector: 'util-settings',
                template: "\n      <div [hidden]=\"_settingsSingle === null\" class=\"theme-settings\" ngClass=\"{{themeSettingsClass}}\">\n          <div class=\"ts-button\" (click)=\"toggleSettings()\">\n              <span class=\"fa fa-cog\"></span>\n          </div>\n          <div class=\"ts-body\">\n              <div class=\"ts-title\" >Izgled layout-a</div>\n              <div class=\"ts-row\">\n                  <label class=\"check\">\n                      <input type=\"checkbox\"\n                             class=\"icheckbox\"\n                             (click)=\"switchFilter($event)\"\n                             name=\"complex_filter\"\n                             [ngModel]=\"complexFilter\"/> Slo\u017Een filter</label>\n              </div>\n              <div class=\"ts-row\">\n                  <label class=\"check\" (click)=\"resetToDefault()\">\n                      &nbsp;Resetuj na osnovno\n                  </label>\n              </div>\n              <div class=\"ts-row\" *ngIf=\"_settingsSingle\">\n                  <label class=\"check\">\n                      &nbsp;{{_settingsSingle.name}}\n                  </label>\n              </div>\n              <div class=\"ts-row\">\n                  <label class=\"check\" (click)=\"openSettings()\">\n                      <span class=\"fa fa-cogs\"></span>\n                      &nbsp;Pode\u0161avanja\n                  </label>\n              </div>\n              <div id=\"ts-wallpapers\">\n                  <div class=\"ts-title\">Wallpapers</div>\n                  <div class=\"ts-themes\">\n                      <a href=\"#\" class=\"active\" data-wall=\"wall_1\"><img src=\"assets/img/backgrounds/wall_1.jpg\"/></a>\n                      <a href=\"#\" data-wall=\"wall_2\"><img src=\"assets/img/backgrounds/wall_2.jpg\"/></a>\n                      <a href=\"#\" data-wall=\"wall_3\"><img src=\"assets/img/backgrounds/wall_3.jpg\"/></a>\n                      <a href=\"#\" data-wall=\"wall_4\"><img src=\"assets/img/backgrounds/wall_4.jpg\"/></a>\n                      <a href=\"#\" data-wall=\"wall_5\"><img src=\"assets/img/backgrounds/wall_5.jpg\"/></a>\n\n                      <a href=\"#\" data-wall=\"wall_6\"><img src=\"assets/img/backgrounds/wall_6.jpg\"/></a>\n                      <a href=\"#\" data-wall=\"wall_7\"><img src=\"assets/img/backgrounds/wall_7.jpg\"/></a>\n                      <a href=\"#\" data-wall=\"wall_8\"><img src=\"assets/img/backgrounds/wall_8.jpg\"/></a>\n                      <a href=\"#\" data-wall=\"wall_9\"><img src=\"assets/img/backgrounds/wall_9.jpg\"/></a>\n                      <a href=\"#\" data-wall=\"wall_10\"><img src=\"assets/img/backgrounds/wall_10.jpg\"/></a>\n                  </div>\n              </div>\n          </div>\n      </div>\n    "
            },] },
];
/**
 * @nocollapse
 */
SettingsComponent.ctorParameters = function () { return [
    { type: AuthenticationService, },
    { type: BackendService, },
    { type: ApplicationService, },
    { type: ModalSettingsService, },
    { type: SettingsService, },
]; };
SettingsComponent.propDecorators = {
    'settingsAction': [{ type: Output, args: ['settingsAction',] },],
};
var SettingsModule = /** @class */ (function () {
    function SettingsModule() {
    }
    return SettingsModule;
}());
SettingsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    SettingsComponent
                ],
                entryComponents: [
                    ModalSettingsComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    HttpClientModule,
                    OrdersModule,
                    TableModule,
                    DndModule,
                    ModalSettingsModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService,
                    ModalSettingsService,
                    SettingsService,
                    DragDropService,
                    DragDropConfig,
                    DragDropSortableService
                ],
                exports: [SettingsComponent]
            },] },
];
/**
 * @nocollapse
 */
SettingsModule.ctorParameters = function () { return []; };
var MessagesModule = /** @class */ (function () {
    function MessagesModule() {
    }
    return MessagesModule;
}());
MessagesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    MessagesComponent
                ],
                entryComponents: [
                    AutocompleteComponent
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    PaginationModule,
                    TagInputModule,
                    BrowserAnimationsModule,
                    FormsModule,
                    ReactiveFormsModule,
                    SharedModule
                ],
                providers: [
                    AuthenticationService,
                    BackendService,
                    IndexeddbService,
                    MessageService
                ],
                exports: [MessagesComponent]
            },] },
];
/**
 * @nocollapse
 */
MessagesModule.ctorParameters = function () { return []; };
var ProfileModule = /** @class */ (function () {
    function ProfileModule() {
    }
    return ProfileModule;
}());
ProfileModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    BrowserModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    TabsModule,
                    FilterModule,
                    DetailsModule,
                    PaginationModule,
                    OrdersModule,
                    SettingsModule,
                    ToolbarModule,
                    TableModule
                ],
                declarations: [ProfileComponent],
                exports: [ProfileComponent],
                entryComponents: [ProfileComponent]
            },] },
];
/**
 * @nocollapse
 */
ProfileModule.ctorParameters = function () { return []; };
var FilterActionParams = /** @class */ (function () {
    function FilterActionParams() {
    }
    return FilterActionParams;
}());
var FilterActionFilterParams = /** @class */ (function () {
    function FilterActionFilterParams() {
    }
    return FilterActionFilterParams;
}());
var TableActionParams = /** @class */ (function () {
    function TableActionParams() {
    }
    return TableActionParams;
}());
var TableActionFilterParams = /** @class */ (function () {
    function TableActionFilterParams() {
    }
    return TableActionFilterParams;
}());
var FieldMapItem = /** @class */ (function () {
    function FieldMapItem() {
        this.sortable = true;
        this.title = '';
        this.errorMessage = '';
        this.visible = true;
        this.editableOverride = null; // Override for the editable property. To be used by the forms
        this.additableOverride = null; // Override for the additable property. To be used by the forms
        // Filters used by the forms to additinally filter lookup values when calling the services (on the autocomplete and combobox)
        this.lookupFilter = null;
        // Data list to be used for autocomplete or combo field instead of calling the service
        // Currently, lookupList and lookupFilter should not be used together, as the local filtering system is disabled
        this.lookupList = null;
        this.documentType = null;
        // Used only by the input control
        this.multiline = false;
        this.decimalCount = 2;
        this.color = null;
        this.lookupInitFilter = [];
        this.tooltipText = null;
    }
    return FieldMapItem;
}());
var FilterMapItem = /** @class */ (function () {
    function FilterMapItem() {
        this.title = '';
        this.default = false;
        // If type equal to date
        this.dateRange = false;
        this.value = '';
        this.operation = null;
        this.defaultOperation = null;
        // Is set to false when operation is 'is null' for example
        this.visible = true;
        this.showOperation = true;
        this.filterMapItems = null;
        this.fieldMapItem = null;
    }
    return FilterMapItem;
}());
var ValueChangeParams = /** @class */ (function () {
    function ValueChangeParams() {
    }
    return ValueChangeParams;
}());
var ValueTableChangeParams = /** @class */ (function () {
    function ValueTableChangeParams() {
    }
    return ValueTableChangeParams;
}());
var CustomActionOrderParams = /** @class */ (function () {
    function CustomActionOrderParams() {
    }
    return CustomActionOrderParams;
}());
var CustomActionDocumentParams = /** @class */ (function () {
    function CustomActionDocumentParams() {
    }
    return CustomActionDocumentParams;
}());
var FilterOptions = /** @class */ (function () {
    function FilterOptions() {
        this.showPrint = false;
        this.showExport = false;
    }
    /**
     * @param {?} options
     * @return {?}
     */
    FilterOptions.populate = function (options) {
        if (options.items == null) {
            options.items = new Array();
        }
        if (options.showPrint == null) {
            options.showPrint = true;
        }
        if (options.showExport == null) {
            options.showExport = true;
        }
    };
    /**
     * @return {?}
     */
    FilterOptions.getDefault = function () {
        var /** @type {?} */ retVal = new FilterOptions();
        FilterOptions.populate(retVal);
        return retVal;
    };
    return FilterOptions;
}());
var FilterItem = /** @class */ (function () {
    /**
     * @param {?} label
     * @param {?} action
     * @param {?} style
     * @param {?} visible
     * @param {?} enabled
     * @param {?=} title
     */
    function FilterItem(label, action, style, visible, enabled, title) {
        if (title === void 0) { title = null; }
        this.label = label;
        this.action = action;
        this.style = style;
        this.visible = visible;
        this.enabled = enabled;
        this.title = title;
    }
    return FilterItem;
}());
var DokumentParams = /** @class */ (function (_super) {
    __extends(DokumentParams, _super);
    /**
     * @param {?} id
     */
    function DokumentParams(id) {
        var _this = _super.call(this) || this;
        _this.id = null;
        _this.id = id;
        return _this;
    }
    return DokumentParams;
}(OpenTabParamBase));
var PrethodniciParams = /** @class */ (function () {
    function PrethodniciParams() {
    }
    return PrethodniciParams;
}());
var PrethodnikFilter = /** @class */ (function () {
    /**
     * @param {?} vd
     * @param {?} serviceFilterTerm
     */
    function PrethodnikFilter(vd, serviceFilterTerm) {
        this.vd = vd;
        this.serviceFilterTerm = serviceFilterTerm;
    }
    return PrethodnikFilter;
}());
// Pazi kako redjas komponente zbog nasledjivanja prvo idu opsti moduli koji su standalone pa onda stvari koje nasledjuju te module
/**
 * Generated bundle index. Do not edit.
 */
export { ModalModule, CustomModalModule, ModalSettingsModule, SharedModule, HeaderModule, SidebarModule, OrdersModule, TabsModule, ExpandPanelModule, FilterModule, TableModule, ViewTableModule, EditTableModule, DetailsModule, PaginationModule, SettingsModule, AutocompleteModule, ToolbarModule, ComboModule, InputModule, MessagesModule, DaterangepickerModule, ProfileModule, AuthenticationService, NotificationService, ApplicationService, PageBase, OpenTabData, OpenTabParamBase, DocumentIdentity, ToolbarItem, ToolbarItemStyle, ToolbarAction, BackendService, ModalSettingsService, ModalService, CustomModalService, UtilService, ListService, InputComponent, AutocompleteComponent, DaterangepickerComponent, SidebarComponent, OrdersComponent, DetailsComponent, SettingsComponent, TableComponent, ViewTableComponent, EditTableComponent, ModalComponent, CustomModalComponent, ModalSettingsComponent, MessagesComponent, FilterComponent, ProfileComponent, MessagesEnum, FormModeEnum, FilterActionParams, FilterActionFilterParams, TableModeEnum, TableActionEnum, TableActionParams, TableActionFilterParams, FieldMapItem, FilterMapItem, FieldTypeEnum, PathParts, FieldStructurePanel, FieldStructureTab, FieldStructure, TableSettings, FilterSettings, DocumentTypeEnum, ServiceFilterTerm, ServiceFilterSymbol, ServiceFilterOperandEnum, ValueChangeParams, ValueTableChangeParams, CustomActionOrderParams, CustomActionDocumentParams, FilterOptions, FilterItem, FilterItemStyle, FilterActionEnum, DokumentParams, PrethodniciParams, PrethodnikFilter, DclWrapperComponent as ɵcf, DclWrapperModule as ɵce, ExpandPanelComponent as ɵci, SimpleFilterComponent as ɵbx, SimpleFilterModule as ɵbw, ComboComponent as ɵd, SelectComponent as ɵbr, SelectModule as ɵbz, TagsComponent as ɵbl, TagsModule as ɵbk, TimepickerComponent as ɵa, TimepickerModule as ɵbj, HeaderComponent as ɵbo, InfobarComponent as ɵch, InfobarModule as ɵcg, PageComponent as ɵcd, PageModule as ɵcc, PaginationComponent as ɵe, PrethodniciComponent as ɵbt, PrethodniciModule as ɵbv, PrintComponent as ɵbu, PrintModule as ɵby, SettingsService as ɵbi, StatusLozengeComponent as ɵbn, StatusLozengeModule as ɵbm, TabsComponent as ɵcb, ToolbarComponent as ɵbs, ServiceFilterBase as ɵcj, FieldEditCheckboxPipe as ɵr, FieldEditDateTimePipe as ɵt, FieldEditDatePipe as ɵs, FieldEditCompleterPipe as ɵu, FieldEditSelectPipe as ɵba, FieldViewBigNumberPipe as ɵbf, FieldViewCheckboxPipe as ɵm, FieldViewComboFixedPipe as ɵw, FieldViewComboPipe as ɵy, FieldViewCompleterPipe as ɵq, FieldViewDateTimePipe as ɵo, FieldViewDatePipe as ɵn, FieldViewDecimalPipe as ɵbd, FieldViewTextPipe as ɵl, FieldViewTimePipe as ɵp, FieldEditCompleterPurePipe as ɵz, FieldViewCheckboxPurePipe as ɵh, FieldViewComboFixedPurePipe as ɵv, FieldViewComboPurePipe as ɵx, FieldViewCompleterPurePipe as ɵk, FieldViewDatePurePipe as ɵi, FieldViewDecimalPurePipe as ɵbe, FieldViewTexPurePipe as ɵg, FieldViewTimePurePipe as ɵj, NumberFormatPurePipe as ɵbc, NumberPurePipe as ɵbb, FilterPipe as ɵf, IdentPipe as ɵbh, MessageUnreadPipe as ɵbg, FieldService as ɵb, IndexeddbService as ɵca, MessageService as ɵbp, RtsBackendService as ɵc, SearchService as ɵbq };
//# sourceMappingURL=beyond-util.es5.js.map



//////////////////
// WEBPACK FOOTER
// ./beyond-util/beyond-util.es5.js
// module id = ./beyond-util/beyond-util.es5.js
// module chunks = main